
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iHLZT", function(module, exports) {

var $l6Xaz = parcelRequire("l6Xaz");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jOLle = parcelRequire("jOLle");

class $e83174e39025394c$export$f9f620dab3aaf022 extends (0, $jOLle.ResourceRecorder) {
    reset() {
        super.reset();
        this.includeSuperBatch = false;
        this.includeConnect = false;
        this.connectResource = '';
    }
    includeSuperBatchResources() {
        this.includeSuperBatch = true;
    }
    includeConnectWebResources() {
        // Connect web resources always need superbatch, so we need to include both if we're including connect
        this.includeSuperBatchResources();
        this.includeConnect = true;
    }
    get() {
        if (!this.includeSuperBatch) return '';
        if (!this.isJS) return this.resource;
        return this.includeConnect && ((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) ? this.resource : (0, $l6Xaz.deferScript)(this.resource);
    }
    addConnectResource(connectResource) {
        // Ensure that we include connect web resources in the response if they're detected
        if (!this.includeConnect && window?.__SSR_REACT_STREAMING__ && ((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false))) this.includeConnectWebResources();
        if (this.connectResource) this.connectResource += '\n';
        this.connectResource += connectResource;
    }
    getConnect() {
        // connect always need superbatch.
        return !!this.get() && this.includeConnect && ((0, $9wGTI.fg)('content_early_connect_iframe_initialization') || (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) ? this.connectResource : '';
    }
    constructor(isJS){
        super();
        this.includeSuperBatch = void 0;
        this.includeConnect = void 0;
        this.connectResource = void 0;
        this.isJS = void 0;
        this.includeConnect = false;
        this.connectResource = '';
        this.isJS = isJS;
        this.includeSuperBatch = false;
    }
}


const $d217b2863263cd45$export$7e0fa12f001c7621 = new (0, $e83174e39025394c$export$f9f620dab3aaf022)(false);
const $d217b2863263cd45$export$373af14cb13ff346 = new (0, $e83174e39025394c$export$f9f620dab3aaf022)(true);
module.exports["superbatchCSSRecorder"] = $d217b2863263cd45$export$7e0fa12f001c7621;
module.exports["superbatchJSRecorder"] = $d217b2863263cd45$export$373af14cb13ff346;

});

parcelRegister("f9opb", function(module, exports) {
/**
 * @generated SignedSource<<ca848bf8c0377a45e318debe14f3c620>>
 * @relayHash f23f9719f1b77dead3e8e70f71b74ffc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a597c2c953ee32518c39f4f633fa9089963a1412adaf62365eedeac79d6d0e5
const $9ba28f7bc5b6ec04$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSSR"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "preloadLabels"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "number"
    }, v9 = {
        "kind": "ScalarField",
        "name": "value"
    }, v10 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v8 /*: any*/ 
        ]
    }, v11 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ]
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "representation"
    }, v13 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "js"
            },
            {
                "kind": "ScalarField",
                "name": "css"
            }
        ]
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "background"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v19 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v20 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v21 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v24 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v25 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "confRev"
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-published",
                                        "editor",
                                        "import-source",
                                        "imported-page-modified-date"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v11 /*: any*/ ,
                            "storageKey": "properties(keys:[\"cover-picture-id-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
                        },
                        {
                            "condition": "useNewContentTopper",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "pageTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "page-title-property-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "properties(key:\"page-title-property-published\")"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "condition": "useNewContentTopper",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "coverPictureWidth"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isSSR",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToFormattedBody",
                                    "kind": "LinkedField",
                                    "name": "macroRenderedOutput",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "FormattedBody",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "concreteType": "WebResourceDependencies",
                                                    "kind": "LinkedField",
                                                    "name": "webresource",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "dynamic",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "WebResourceDependencies",
                                            "kind": "LinkedField",
                                            "name": "webresource",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SuperBatchWebResources",
                                                    "kind": "LinkedField",
                                                    "name": "superbatch",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ 
                                                },
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "appearancePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "content-appearance-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v11 /*: any*/ ,
                            "storageKey": "properties(key:\"content-appearance-published\")"
                        },
                        {
                            "condition": "preloadLabels",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "orderBy",
                                            "value": {
                                                "direction": "ASCENDING",
                                                "sortField": "LABELLING_CREATIONDATE"
                                            }
                                        }
                                    ],
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "prefix"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                },
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetType"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v6 /*: any*/ ,
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                },
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "lookAndFeel",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentLookAndFeel",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScreenLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "screen",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "LayerScreenLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "layer",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "width"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "height"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "gutterTop"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "gutterRight"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "gutterBottom"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "gutterLeft"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContainerLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "padding"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "borderRadius"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentBlogUnifiedQuery",
            "selections": v26 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentBlogUnifiedQuery",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "f23f9719f1b77dead3e8e70f71b74ffc",
            "id": "6a597c2c953ee32518c39f4f633fa9089963a1412adaf62365eedeac79d6d0e5",
            "metadata": {},
            "name": "ContentBlogUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentBlogUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false){content(id:$contentId,version:$versionOverride){nodes{id,status,type,subType,title,space{id,key,alias},version{confRev,number},properties(keys:[\"cover-picture-id-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},metadata{lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},body{dynamic{representation,value,content{version{number},id},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}}\n      operations@include(if:$preloadLabels){operation,targetType}}},space(key:$spaceKey){id,theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$9ba28f7bc5b6ec04$var$node.hash = "8a525496e6de4a8c3a8b803986f2ff9c";
var $9ba28f7bc5b6ec04$export$2e2bcd8739ae039 = $9ba28f7bc5b6ec04$var$node;
module.exports["default"] = $9ba28f7bc5b6ec04$export$2e2bcd8739ae039;

});

parcelRegister("jgc4t", function(module, exports) {
/**
 * @generated SignedSource<<558daa336f37a45cf8c51db66687182a>>
 * @relayHash cd23865b41513285c6d6d49de5a843b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54d0eb14ee09e2860c98ebaef917e7c6703b62f43981ac06a31c0422bceda6c5
const $0d7670aa3e217d31$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSSR"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "preloadLabels"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "number"
    }, v9 = {
        "kind": "ScalarField",
        "name": "value"
    }, v10 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v8 /*: any*/ 
        ]
    }, v11 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ 
            ]
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "representation"
    }, v13 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "js"
            },
            {
                "kind": "ScalarField",
                "name": "css"
            }
        ]
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "background"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v19 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v20 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v21 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v24 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v25 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "confRev"
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-published",
                                        "emoji-title-published",
                                        "editor",
                                        "import-source",
                                        "imported-page-modified-date"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v11 /*: any*/ ,
                            "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
                        },
                        {
                            "condition": "useNewContentTopper",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "pageTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "page-title-property-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v11 /*: any*/ ,
                                    "storageKey": "properties(key:\"page-title-property-published\")"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "condition": "useNewContentTopper",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "coverPictureWidth"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isSSR",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToFormattedBody",
                                    "kind": "LinkedField",
                                    "name": "macroRenderedOutput",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "FormattedBody",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "concreteType": "WebResourceDependencies",
                                                    "kind": "LinkedField",
                                                    "name": "webresource",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "dynamic",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "WebResourceDependencies",
                                            "kind": "LinkedField",
                                            "name": "webresource",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SuperBatchWebResources",
                                                    "kind": "LinkedField",
                                                    "name": "superbatch",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ 
                                                },
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "appearancePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "content-appearance-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v11 /*: any*/ ,
                            "storageKey": "properties(key:\"content-appearance-published\")"
                        },
                        {
                            "condition": "preloadLabels",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "orderBy",
                                            "value": {
                                                "direction": "ASCENDING",
                                                "sortField": "LABELLING_CREATIONDATE"
                                            }
                                        }
                                    ],
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "label"
                                                },
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "prefix"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                },
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetType"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v6 /*: any*/ ,
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                },
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "lookAndFeel",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentLookAndFeel",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScreenLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "screen",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "concreteType": "LayerScreenLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "layer",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "width"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "height"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "gutterTop"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "gutterRight"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "gutterBottom"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "gutterLeft"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContainerLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "padding"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "borderRadius"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentUnifiedQuery",
            "selections": v26 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentUnifiedQuery",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "cd23865b41513285c6d6d49de5a843b3",
            "id": "54d0eb14ee09e2860c98ebaef917e7c6703b62f43981ac06a31c0422bceda6c5",
            "metadata": {},
            "name": "ContentUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false)@allowHigherTimeout{content(id:$contentId,version:$versionOverride){nodes{id,status,type,subType,title,space{id,key,alias},version{confRev,number},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},metadata{lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},body{dynamic{representation,value,content{version{number},id},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}}\n      operations@include(if:$preloadLabels){operation,targetType}}},space(key:$spaceKey){id,theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$0d7670aa3e217d31$var$node.hash = "eba1a55eeff9fde81bf5185d674eb51b";
var $0d7670aa3e217d31$export$2e2bcd8739ae039 = $0d7670aa3e217d31$var$node;
module.exports["default"] = $0d7670aa3e217d31$export$2e2bcd8739ae039;

});

parcelRegister("4JC0x", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $98c2a7811aa5a89d$export$fe853ff85807a350 = new Map();
let $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
const $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState = (0, $2XqLN.default)(()=>{
    const rootQueryList = window?.__APOLLO_STATE__?.ROOT_QUERY || {};
    return Object.keys(rootQueryList).filter((query)=>query.startsWith('macroBodyRenderer'));
});
function $98c2a7811aa5a89d$var$isMacroPreloaded(macroId) {
    const preloadedMacros = $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState();
    return preloadedMacros.some((preloaded)=>preloaded.includes(macroId));
}
const $98c2a7811aa5a89d$export$1441f92d09a5c3ee = ()=>window.__SSR_RENDERED__ && !!window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
function $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl() {
    const cacheMismatches = $98c2a7811aa5a89d$var$getPreloadCacheMismatches();
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (cacheMismatches.length == 0 && (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0)) return;
    const failedMacros = {};
    function addFailed(reason, macroId, extensionKey) {
        failedMacros[macroId] = {
            reason: reason,
            extensionKey: extensionKey
        };
    }
    Object.entries(reportedFails).forEach(([keyAndId, reason])=>{
        if (keyAndId === 'general') return;
        const [extensionKey, macroId] = keyAndId.split(':');
        if (reason === 'timeout') {
            if ($98c2a7811aa5a89d$var$isMacroPreloaded(macroId)) addFailed('falseTimeouts', macroId, extensionKey);
            else addFailed('trueTimeouts', macroId, extensionKey);
        } else addFailed(reason, macroId, extensionKey);
    });
    cacheMismatches.forEach(([macroId, extensionKey])=>addFailed('cacheMismatch', macroId, extensionKey));
    return failedMacros;
}
function $98c2a7811aa5a89d$export$622ff65a4d6eaaaf() {
    if (!$98c2a7811aa5a89d$export$576fafc5561e06f5) $98c2a7811aa5a89d$export$576fafc5561e06f5 = {
        value: $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl()
    };
    return $98c2a7811aa5a89d$export$576fafc5561e06f5.value;
}
function $98c2a7811aa5a89d$export$de5406af81980582() {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
}
function $98c2a7811aa5a89d$export$3288a79f0c713f52(macroId) {
    const failedMacros = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf();
    return failedMacros?.[macroId]?.reason;
}
function $98c2a7811aa5a89d$export$34734b475a3fd7b9() {
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0) return;
    return reportedFails?.['general'];
}
function $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd(macroId, extensionKey) {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
    $98c2a7811aa5a89d$export$fe853ff85807a350.set(macroId, extensionKey || '');
    window['__MISSING_DATA_MACROS__'] = window['__MISSING_DATA_MACROS__'] || [];
    window['__MISSING_DATA_MACROS__'].push(macroId);
}
function $98c2a7811aa5a89d$var$getPreloadCacheMismatches() {
    return [
        ...$98c2a7811aa5a89d$export$fe853ff85807a350
    ].filter(([macroId])=>$98c2a7811aa5a89d$var$isMacroPreloaded(macroId));
}
module.exports["macrosPreloadPerformed"] = $98c2a7811aa5a89d$export$1441f92d09a5c3ee;
module.exports["getPreloadFailedMacros"] = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf;
module.exports["getPreloadFailures"] = $98c2a7811aa5a89d$export$3288a79f0c713f52;
module.exports["getGeneralFailures"] = $98c2a7811aa5a89d$export$34734b475a3fd7b9;
module.exports["markMissingMacroData"] = $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd;

});

parcelRegister("19aF3", function(module, exports) {
function $87dd746ae26ba9c8$export$139d5ccee31f82f4(...args) {
    if (!window) return;
    if (!window.require) return;
    return window.require.apply(window, args);
}
module.exports["globalRequire"] = $87dd746ae26ba9c8$export$139d5ccee31f82f4;

});

parcelRegister("6AplS", function(module, exports) {
var $b31733134ac815c5$export$83d89fbfd8236492;
var $b31733134ac815c5$export$e07e737eb4e4eeba;
var $b31733134ac815c5$export$eab97d15b1788b8d;
var $b31733134ac815c5$export$8e388a857ed0c062;
var $b31733134ac815c5$export$50c32ca09add9a32;
'use strict';
var $31447649b066984b$exports = {};
$31447649b066984b$exports = "5.0.5";


var $1f2bc7e7745d853e$exports = {};
$parcel$export($1f2bc7e7745d853e$exports, "compress", () => $1f2bc7e7745d853e$export$80908c17a05abbe5, (v) => $1f2bc7e7745d853e$export$80908c17a05abbe5 = v);
$parcel$export($1f2bc7e7745d853e$exports, "specificity", () => $1f2bc7e7745d853e$export$37de5b62848a0d8, (v) => $1f2bc7e7745d853e$export$37de5b62848a0d8 = v);
$parcel$export($1f2bc7e7745d853e$exports, "find", () => $1f2bc7e7745d853e$export$71aa6c912b956294, (v) => $1f2bc7e7745d853e$export$71aa6c912b956294 = v);
$parcel$export($1f2bc7e7745d853e$exports, "findAll", () => $1f2bc7e7745d853e$export$18200ea6c8035394, (v) => $1f2bc7e7745d853e$export$18200ea6c8035394 = v);
$parcel$export($1f2bc7e7745d853e$exports, "findLast", () => $1f2bc7e7745d853e$export$296de88ccac4bedb, (v) => $1f2bc7e7745d853e$export$296de88ccac4bedb = v);
$parcel$export($1f2bc7e7745d853e$exports, "fromPlainObject", () => $1f2bc7e7745d853e$export$208fdd74c481bdd3, (v) => $1f2bc7e7745d853e$export$208fdd74c481bdd3 = v);
$parcel$export($1f2bc7e7745d853e$exports, "generate", () => $1f2bc7e7745d853e$export$80d376111cc09ad7, (v) => $1f2bc7e7745d853e$export$80d376111cc09ad7 = v);
$parcel$export($1f2bc7e7745d853e$exports, "lexer", () => $1f2bc7e7745d853e$export$43feed32102720d2, (v) => $1f2bc7e7745d853e$export$43feed32102720d2 = v);
$parcel$export($1f2bc7e7745d853e$exports, "parse", () => $1f2bc7e7745d853e$export$98e6a39c04603d36, (v) => $1f2bc7e7745d853e$export$98e6a39c04603d36 = v);
$parcel$export($1f2bc7e7745d853e$exports, "toPlainObject", () => $1f2bc7e7745d853e$export$8530f7b85295aab2, (v) => $1f2bc7e7745d853e$export$8530f7b85295aab2 = v);
$parcel$export($1f2bc7e7745d853e$exports, "tokenize", () => $1f2bc7e7745d853e$export$660b2ee2d4fb4eff, (v) => $1f2bc7e7745d853e$export$660b2ee2d4fb4eff = v);
$parcel$export($1f2bc7e7745d853e$exports, "walk", () => $1f2bc7e7745d853e$export$588732934346abbf, (v) => $1f2bc7e7745d853e$export$588732934346abbf = v);
var $1f2bc7e7745d853e$export$80908c17a05abbe5;
var $1f2bc7e7745d853e$export$37de5b62848a0d8;
var $1f2bc7e7745d853e$export$71aa6c912b956294;
var $1f2bc7e7745d853e$export$18200ea6c8035394;
var $1f2bc7e7745d853e$export$296de88ccac4bedb;
var $1f2bc7e7745d853e$export$208fdd74c481bdd3;
var $1f2bc7e7745d853e$export$80d376111cc09ad7;
var $1f2bc7e7745d853e$export$43feed32102720d2;
var $1f2bc7e7745d853e$export$98e6a39c04603d36;
var $1f2bc7e7745d853e$export$8530f7b85295aab2;
var $1f2bc7e7745d853e$export$660b2ee2d4fb4eff;
var $1f2bc7e7745d853e$export$588732934346abbf;
'use strict';
var $4e097574aea5443c$export$83d89fbfd8236492;
var $4e097574aea5443c$export$ef7698fd92a0afb9;
var $4e097574aea5443c$export$54c2e3dc7acea9f5;
var $4e097574aea5443c$export$6168dc8908a6c652;
var $4e097574aea5443c$export$1d94185c187dec3;
var $4e097574aea5443c$export$9cd59f9826255e47;
var $4e097574aea5443c$export$15cf667f7f91c461;
var $4e097574aea5443c$export$2e81050496d0e63e;
var $4e097574aea5443c$export$d541bacb2bda4494;
var $4e097574aea5443c$export$5150dd39c4b2a5da;
var $4e097574aea5443c$export$7b66c250b210a314;
var $4e097574aea5443c$export$22b082955e083ec3;
var $4e097574aea5443c$export$128fa18b7194ef;
var $4e097574aea5443c$export$a60b91545d7e19fc;
var $4e097574aea5443c$export$a5f6079b5a0c262e;
var $4e097574aea5443c$export$b55edb69cfa7ac57;
var $4e097574aea5443c$export$542413421c3f8a82;
var $4e097574aea5443c$export$71aa6c912b956294;
var $4e097574aea5443c$export$18200ea6c8035394;
var $4e097574aea5443c$export$296de88ccac4bedb;
var $4e097574aea5443c$export$7a5058c6b79333e0;
var $4e097574aea5443c$export$208fdd74c481bdd3;
var $4e097574aea5443c$export$80d376111cc09ad7;
var $4e097574aea5443c$export$43feed32102720d2;
var $4e097574aea5443c$export$98e6a39c04603d36;
var $4e097574aea5443c$export$8530f7b85295aab2;
var $4e097574aea5443c$export$660b2ee2d4fb4eff;
var $4e097574aea5443c$export$588732934346abbf;
'use strict';
var $d6be594cc9af5262$exports = {};
'use strict';
var $92105e36fb3855b0$exports = {};
'use strict';
var $14ef1a69abba2f52$export$21bfcb60d1b5ccac;
var $14ef1a69abba2f52$export$d273d1be20da6de2;
var $14ef1a69abba2f52$export$f8b4878501aa4a62;
var $14ef1a69abba2f52$export$b0b2bd2d1777c179;
var $14ef1a69abba2f52$export$521ef26a3002003b;
var $14ef1a69abba2f52$export$e20ebb298016f6;
var $14ef1a69abba2f52$export$c06e3ee3b4d233fa;
var $14ef1a69abba2f52$export$4d299b491347818a;
var $14ef1a69abba2f52$export$a918ca49ff4337a3;
var $14ef1a69abba2f52$export$c940ece961bc43c6;
var $14ef1a69abba2f52$export$c1a09112320b1603;
var $14ef1a69abba2f52$export$f3890eeaf6851387;
var $14ef1a69abba2f52$export$ab85ecd77ce6a5cd;
var $14ef1a69abba2f52$export$331e9b6bdecaac5f;
var $14ef1a69abba2f52$export$ccdce7304ac66390;
var $14ef1a69abba2f52$export$b5a25f132cb53de6;
var $14ef1a69abba2f52$export$cd363bb53c2bb;
var $14ef1a69abba2f52$export$fffa67e515d04022;
var $14ef1a69abba2f52$export$d11913f8a6922aea;
var $14ef1a69abba2f52$export$186d8b1f99e2bfec;
var $14ef1a69abba2f52$export$773d33972c6279ed;
var $14ef1a69abba2f52$export$72f933344f701f30;
var $14ef1a69abba2f52$export$bedd8b9b04d9dbd;
var $14ef1a69abba2f52$export$89b8e0fa65f6a914;
var $14ef1a69abba2f52$export$59d795186a5d3f58;
var $14ef1a69abba2f52$export$fb98946286ab4c97;
var $14ef1a69abba2f52$export$a60b91545d7e19fc;
var $14ef1a69abba2f52$export$bbf58a4a05c6b6e2;
var $14ef1a69abba2f52$export$2f591833f7f1b967;
var $14ef1a69abba2f52$export$48d90b0d2444a844;
var $14ef1a69abba2f52$export$deba3a5f607eb19;
var $14ef1a69abba2f52$export$90f8a5e44c6cc5e3;
var $14ef1a69abba2f52$export$4b3b0ba223857b61;
var $14ef1a69abba2f52$export$da737789103788ca;
var $14ef1a69abba2f52$export$727d9dbc4fbb948f;
var $14ef1a69abba2f52$export$2a81dc4d1a2f9334;
var $14ef1a69abba2f52$export$56b48cc5d7560ffb;
var $14ef1a69abba2f52$export$79c5d5217943d6a7;
var $14ef1a69abba2f52$export$25a7e820fbcd58b9;
var $14ef1a69abba2f52$export$998d7ff9801e90bb;
var $14ef1a69abba2f52$export$45a677ea7cb6d5c8;
var $14ef1a69abba2f52$export$c6b40e80adfef3ae;
var $14ef1a69abba2f52$export$386c40f28a3efd99;
var $14ef1a69abba2f52$export$b7ed17c2edb4d953;
var $14ef1a69abba2f52$export$598e9af52cb9b904;
var $14ef1a69abba2f52$export$35784e2518402c99;
var $14ef1a69abba2f52$export$352e2c1d24776bfb;
var $14ef1a69abba2f52$export$3c52dd84024ae72c;
var $14ef1a69abba2f52$export$6902610076fb2dc1;
var $14ef1a69abba2f52$export$5bf4b3d0861be8d9;
var $14ef1a69abba2f52$export$349fae4425f20458;
var $14ef1a69abba2f52$export$1cf8ac3f090cf48a;
var $14ef1a69abba2f52$export$e314ae15c0f41984;
var $14ef1a69abba2f52$export$b817115b8219186a;
var $14ef1a69abba2f52$export$5ed93187f4ce070a;
var $14ef1a69abba2f52$export$e9aed36b506f417c;
var $14ef1a69abba2f52$export$5bd0595948d7ed9;
var $14ef1a69abba2f52$export$c4eb8307a0331d71;
var $14ef1a69abba2f52$export$2e282c3c0c638f20;
var $14ef1a69abba2f52$export$a5f6079b5a0c262e;
var $14ef1a69abba2f52$export$a1e9ec249d80652c;
var $14ef1a69abba2f52$export$b55edb69cfa7ac57;
var $14ef1a69abba2f52$export$660b2ee2d4fb4eff;
'use strict';
var $926ff4544e512db5$exports = {};
$parcel$export($926ff4544e512db5$exports, "AtKeyword", () => $926ff4544e512db5$export$21bfcb60d1b5ccac, (v) => $926ff4544e512db5$export$21bfcb60d1b5ccac = v);
$parcel$export($926ff4544e512db5$exports, "BadString", () => $926ff4544e512db5$export$d273d1be20da6de2, (v) => $926ff4544e512db5$export$d273d1be20da6de2 = v);
$parcel$export($926ff4544e512db5$exports, "BadUrl", () => $926ff4544e512db5$export$f8b4878501aa4a62, (v) => $926ff4544e512db5$export$f8b4878501aa4a62 = v);
$parcel$export($926ff4544e512db5$exports, "CDC", () => $926ff4544e512db5$export$b0b2bd2d1777c179, (v) => $926ff4544e512db5$export$b0b2bd2d1777c179 = v);
$parcel$export($926ff4544e512db5$exports, "CDO", () => $926ff4544e512db5$export$521ef26a3002003b, (v) => $926ff4544e512db5$export$521ef26a3002003b = v);
$parcel$export($926ff4544e512db5$exports, "Colon", () => $926ff4544e512db5$export$e20ebb298016f6, (v) => $926ff4544e512db5$export$e20ebb298016f6 = v);
$parcel$export($926ff4544e512db5$exports, "Comma", () => $926ff4544e512db5$export$c06e3ee3b4d233fa, (v) => $926ff4544e512db5$export$c06e3ee3b4d233fa = v);
$parcel$export($926ff4544e512db5$exports, "Comment", () => $926ff4544e512db5$export$4d299b491347818a, (v) => $926ff4544e512db5$export$4d299b491347818a = v);
$parcel$export($926ff4544e512db5$exports, "Delim", () => $926ff4544e512db5$export$a918ca49ff4337a3, (v) => $926ff4544e512db5$export$a918ca49ff4337a3 = v);
$parcel$export($926ff4544e512db5$exports, "Dimension", () => $926ff4544e512db5$export$c940ece961bc43c6, (v) => $926ff4544e512db5$export$c940ece961bc43c6 = v);
$parcel$export($926ff4544e512db5$exports, "EOF", () => $926ff4544e512db5$export$c1a09112320b1603, (v) => $926ff4544e512db5$export$c1a09112320b1603 = v);
$parcel$export($926ff4544e512db5$exports, "Function", () => $926ff4544e512db5$export$f3890eeaf6851387, (v) => $926ff4544e512db5$export$f3890eeaf6851387 = v);
$parcel$export($926ff4544e512db5$exports, "Hash", () => $926ff4544e512db5$export$ab85ecd77ce6a5cd, (v) => $926ff4544e512db5$export$ab85ecd77ce6a5cd = v);
$parcel$export($926ff4544e512db5$exports, "Ident", () => $926ff4544e512db5$export$331e9b6bdecaac5f, (v) => $926ff4544e512db5$export$331e9b6bdecaac5f = v);
$parcel$export($926ff4544e512db5$exports, "LeftCurlyBracket", () => $926ff4544e512db5$export$ccdce7304ac66390, (v) => $926ff4544e512db5$export$ccdce7304ac66390 = v);
$parcel$export($926ff4544e512db5$exports, "LeftParenthesis", () => $926ff4544e512db5$export$b5a25f132cb53de6, (v) => $926ff4544e512db5$export$b5a25f132cb53de6 = v);
$parcel$export($926ff4544e512db5$exports, "LeftSquareBracket", () => $926ff4544e512db5$export$cd363bb53c2bb, (v) => $926ff4544e512db5$export$cd363bb53c2bb = v);
$parcel$export($926ff4544e512db5$exports, "Number", () => $926ff4544e512db5$export$fffa67e515d04022, (v) => $926ff4544e512db5$export$fffa67e515d04022 = v);
$parcel$export($926ff4544e512db5$exports, "Percentage", () => $926ff4544e512db5$export$d11913f8a6922aea, (v) => $926ff4544e512db5$export$d11913f8a6922aea = v);
$parcel$export($926ff4544e512db5$exports, "RightCurlyBracket", () => $926ff4544e512db5$export$186d8b1f99e2bfec, (v) => $926ff4544e512db5$export$186d8b1f99e2bfec = v);
$parcel$export($926ff4544e512db5$exports, "RightParenthesis", () => $926ff4544e512db5$export$773d33972c6279ed, (v) => $926ff4544e512db5$export$773d33972c6279ed = v);
$parcel$export($926ff4544e512db5$exports, "RightSquareBracket", () => $926ff4544e512db5$export$72f933344f701f30, (v) => $926ff4544e512db5$export$72f933344f701f30 = v);
$parcel$export($926ff4544e512db5$exports, "Semicolon", () => $926ff4544e512db5$export$bedd8b9b04d9dbd, (v) => $926ff4544e512db5$export$bedd8b9b04d9dbd = v);
$parcel$export($926ff4544e512db5$exports, "String", () => $926ff4544e512db5$export$89b8e0fa65f6a914, (v) => $926ff4544e512db5$export$89b8e0fa65f6a914 = v);
$parcel$export($926ff4544e512db5$exports, "Url", () => $926ff4544e512db5$export$59d795186a5d3f58, (v) => $926ff4544e512db5$export$59d795186a5d3f58 = v);
$parcel$export($926ff4544e512db5$exports, "WhiteSpace", () => $926ff4544e512db5$export$fb98946286ab4c97, (v) => $926ff4544e512db5$export$fb98946286ab4c97 = v);
var $926ff4544e512db5$export$21bfcb60d1b5ccac;
var $926ff4544e512db5$export$d273d1be20da6de2;
var $926ff4544e512db5$export$f8b4878501aa4a62;
var $926ff4544e512db5$export$b0b2bd2d1777c179;
var $926ff4544e512db5$export$521ef26a3002003b;
var $926ff4544e512db5$export$e20ebb298016f6;
var $926ff4544e512db5$export$c06e3ee3b4d233fa;
var $926ff4544e512db5$export$4d299b491347818a;
var $926ff4544e512db5$export$a918ca49ff4337a3;
var $926ff4544e512db5$export$c940ece961bc43c6;
var $926ff4544e512db5$export$c1a09112320b1603;
var $926ff4544e512db5$export$f3890eeaf6851387;
var $926ff4544e512db5$export$ab85ecd77ce6a5cd;
var $926ff4544e512db5$export$331e9b6bdecaac5f;
var $926ff4544e512db5$export$ccdce7304ac66390;
var $926ff4544e512db5$export$b5a25f132cb53de6;
var $926ff4544e512db5$export$cd363bb53c2bb;
var $926ff4544e512db5$export$fffa67e515d04022;
var $926ff4544e512db5$export$d11913f8a6922aea;
var $926ff4544e512db5$export$186d8b1f99e2bfec;
var $926ff4544e512db5$export$773d33972c6279ed;
var $926ff4544e512db5$export$72f933344f701f30;
var $926ff4544e512db5$export$bedd8b9b04d9dbd;
var $926ff4544e512db5$export$89b8e0fa65f6a914;
var $926ff4544e512db5$export$59d795186a5d3f58;
var $926ff4544e512db5$export$fb98946286ab4c97;
'use strict';
// CSS Syntax Module Level 3
// https://www.w3.org/TR/css-syntax-3/
const $926ff4544e512db5$var$EOF = 0; // <EOF-token>
const $926ff4544e512db5$var$Ident = 1; // <ident-token>
const $926ff4544e512db5$var$Function = 2; // <function-token>
const $926ff4544e512db5$var$AtKeyword = 3; // <at-keyword-token>
const $926ff4544e512db5$var$Hash = 4; // <hash-token>
const $926ff4544e512db5$var$String = 5; // <string-token>
const $926ff4544e512db5$var$BadString = 6; // <bad-string-token>
const $926ff4544e512db5$var$Url = 7; // <url-token>
const $926ff4544e512db5$var$BadUrl = 8; // <bad-url-token>
const $926ff4544e512db5$var$Delim = 9; // <delim-token>
const $926ff4544e512db5$var$Number = 10; // <number-token>
const $926ff4544e512db5$var$Percentage = 11; // <percentage-token>
const $926ff4544e512db5$var$Dimension = 12; // <dimension-token>
const $926ff4544e512db5$var$WhiteSpace = 13; // <whitespace-token>
const $926ff4544e512db5$var$CDO = 14; // <CDO-token>
const $926ff4544e512db5$var$CDC = 15; // <CDC-token>
const $926ff4544e512db5$var$Colon = 16; // <colon-token>     :
const $926ff4544e512db5$var$Semicolon = 17; // <semicolon-token> ;
const $926ff4544e512db5$var$Comma = 18; // <comma-token>     ,
const $926ff4544e512db5$var$LeftSquareBracket = 19; // <[-token>
const $926ff4544e512db5$var$RightSquareBracket = 20; // <]-token>
const $926ff4544e512db5$var$LeftParenthesis = 21; // <(-token>
const $926ff4544e512db5$var$RightParenthesis = 22; // <)-token>
const $926ff4544e512db5$var$LeftCurlyBracket = 23; // <{-token>
const $926ff4544e512db5$var$RightCurlyBracket = 24; // <}-token>
const $926ff4544e512db5$var$Comment = 25;
$926ff4544e512db5$export$21bfcb60d1b5ccac = $926ff4544e512db5$var$AtKeyword;
$926ff4544e512db5$export$d273d1be20da6de2 = $926ff4544e512db5$var$BadString;
$926ff4544e512db5$export$f8b4878501aa4a62 = $926ff4544e512db5$var$BadUrl;
$926ff4544e512db5$export$b0b2bd2d1777c179 = $926ff4544e512db5$var$CDC;
$926ff4544e512db5$export$521ef26a3002003b = $926ff4544e512db5$var$CDO;
$926ff4544e512db5$export$e20ebb298016f6 = $926ff4544e512db5$var$Colon;
$926ff4544e512db5$export$c06e3ee3b4d233fa = $926ff4544e512db5$var$Comma;
$926ff4544e512db5$export$4d299b491347818a = $926ff4544e512db5$var$Comment;
$926ff4544e512db5$export$a918ca49ff4337a3 = $926ff4544e512db5$var$Delim;
$926ff4544e512db5$export$c940ece961bc43c6 = $926ff4544e512db5$var$Dimension;
$926ff4544e512db5$export$c1a09112320b1603 = $926ff4544e512db5$var$EOF;
$926ff4544e512db5$export$f3890eeaf6851387 = $926ff4544e512db5$var$Function;
$926ff4544e512db5$export$ab85ecd77ce6a5cd = $926ff4544e512db5$var$Hash;
$926ff4544e512db5$export$331e9b6bdecaac5f = $926ff4544e512db5$var$Ident;
$926ff4544e512db5$export$ccdce7304ac66390 = $926ff4544e512db5$var$LeftCurlyBracket;
$926ff4544e512db5$export$b5a25f132cb53de6 = $926ff4544e512db5$var$LeftParenthesis;
$926ff4544e512db5$export$cd363bb53c2bb = $926ff4544e512db5$var$LeftSquareBracket;
$926ff4544e512db5$export$fffa67e515d04022 = $926ff4544e512db5$var$Number;
$926ff4544e512db5$export$d11913f8a6922aea = $926ff4544e512db5$var$Percentage;
$926ff4544e512db5$export$186d8b1f99e2bfec = $926ff4544e512db5$var$RightCurlyBracket;
$926ff4544e512db5$export$773d33972c6279ed = $926ff4544e512db5$var$RightParenthesis;
$926ff4544e512db5$export$72f933344f701f30 = $926ff4544e512db5$var$RightSquareBracket;
$926ff4544e512db5$export$bedd8b9b04d9dbd = $926ff4544e512db5$var$Semicolon;
$926ff4544e512db5$export$89b8e0fa65f6a914 = $926ff4544e512db5$var$String;
$926ff4544e512db5$export$59d795186a5d3f58 = $926ff4544e512db5$var$Url;
$926ff4544e512db5$export$fb98946286ab4c97 = $926ff4544e512db5$var$WhiteSpace;


var $401d24d35b6b69df$export$bbf58a4a05c6b6e2;
var $401d24d35b6b69df$export$2f591833f7f1b967;
var $401d24d35b6b69df$export$48d90b0d2444a844;
var $401d24d35b6b69df$export$deba3a5f607eb19;
var $401d24d35b6b69df$export$90f8a5e44c6cc5e3;
var $401d24d35b6b69df$export$4b3b0ba223857b61;
var $401d24d35b6b69df$export$da737789103788ca;
var $401d24d35b6b69df$export$727d9dbc4fbb948f;
var $401d24d35b6b69df$export$2a81dc4d1a2f9334;
var $401d24d35b6b69df$export$56b48cc5d7560ffb;
var $401d24d35b6b69df$export$79c5d5217943d6a7;
var $401d24d35b6b69df$export$25a7e820fbcd58b9;
var $401d24d35b6b69df$export$998d7ff9801e90bb;
var $401d24d35b6b69df$export$45a677ea7cb6d5c8;
var $401d24d35b6b69df$export$c6b40e80adfef3ae;
var $401d24d35b6b69df$export$386c40f28a3efd99;
var $401d24d35b6b69df$export$b7ed17c2edb4d953;
var $401d24d35b6b69df$export$598e9af52cb9b904;
var $401d24d35b6b69df$export$35784e2518402c99;
var $401d24d35b6b69df$export$352e2c1d24776bfb;
var $401d24d35b6b69df$export$3c52dd84024ae72c;
'use strict';
const $401d24d35b6b69df$var$EOF = 0;
// https://drafts.csswg.org/css-syntax-3/
// § 4.2. Definitions
// digit
// A code point between U+0030 DIGIT ZERO (0) and U+0039 DIGIT NINE (9).
function $401d24d35b6b69df$var$isDigit(code) {
    return code >= 0x0030 && code <= 0x0039;
}
// hex digit
// A digit, or a code point between U+0041 LATIN CAPITAL LETTER A (A) and U+0046 LATIN CAPITAL LETTER F (F),
// or a code point between U+0061 LATIN SMALL LETTER A (a) and U+0066 LATIN SMALL LETTER F (f).
function $401d24d35b6b69df$var$isHexDigit(code) {
    return $401d24d35b6b69df$var$isDigit(code) || // 0 .. 9
    code >= 0x0041 && code <= 0x0046 || // A .. F
    code >= 0x0061 && code <= 0x0066 // a .. f
    ;
}
// uppercase letter
// A code point between U+0041 LATIN CAPITAL LETTER A (A) and U+005A LATIN CAPITAL LETTER Z (Z).
function $401d24d35b6b69df$var$isUppercaseLetter(code) {
    return code >= 0x0041 && code <= 0x005A;
}
// lowercase letter
// A code point between U+0061 LATIN SMALL LETTER A (a) and U+007A LATIN SMALL LETTER Z (z).
function $401d24d35b6b69df$var$isLowercaseLetter(code) {
    return code >= 0x0061 && code <= 0x007A;
}
// letter
// An uppercase letter or a lowercase letter.
function $401d24d35b6b69df$var$isLetter(code) {
    return $401d24d35b6b69df$var$isUppercaseLetter(code) || $401d24d35b6b69df$var$isLowercaseLetter(code);
}
// non-ASCII code point
// A code point with a value equal to or greater than U+0080 <control>.
function $401d24d35b6b69df$var$isNonAscii(code) {
    return code >= 0x0080;
}
// name-start code point
// A letter, a non-ASCII code point, or U+005F LOW LINE (_).
function $401d24d35b6b69df$var$isNameStart(code) {
    return $401d24d35b6b69df$var$isLetter(code) || $401d24d35b6b69df$var$isNonAscii(code) || code === 0x005F;
}
// name code point
// A name-start code point, a digit, or U+002D HYPHEN-MINUS (-).
function $401d24d35b6b69df$var$isName(code) {
    return $401d24d35b6b69df$var$isNameStart(code) || $401d24d35b6b69df$var$isDigit(code) || code === 0x002D;
}
// non-printable code point
// A code point between U+0000 NULL and U+0008 BACKSPACE, or U+000B LINE TABULATION,
// or a code point between U+000E SHIFT OUT and U+001F INFORMATION SEPARATOR ONE, or U+007F DELETE.
function $401d24d35b6b69df$var$isNonPrintable(code) {
    return code >= 0x0000 && code <= 0x0008 || code === 0x000B || code >= 0x000E && code <= 0x001F || code === 0x007F;
}
// newline
// U+000A LINE FEED. Note that U+000D CARRIAGE RETURN and U+000C FORM FEED are not included in this definition,
// as they are converted to U+000A LINE FEED during preprocessing.
// TODO: we doesn't do a preprocessing, so check a code point for U+000D CARRIAGE RETURN and U+000C FORM FEED
function $401d24d35b6b69df$var$isNewline(code) {
    return code === 0x000A || code === 0x000D || code === 0x000C;
}
// whitespace
// A newline, U+0009 CHARACTER TABULATION, or U+0020 SPACE.
function $401d24d35b6b69df$var$isWhiteSpace(code) {
    return $401d24d35b6b69df$var$isNewline(code) || code === 0x0020 || code === 0x0009;
}
// § 4.3.8. Check if two code points are a valid escape
function $401d24d35b6b69df$var$isValidEscape(first, second) {
    // If the first code point is not U+005C REVERSE SOLIDUS (\), return false.
    if (first !== 0x005C) return false;
    // Otherwise, if the second code point is a newline or EOF, return false.
    if ($401d24d35b6b69df$var$isNewline(second) || second === $401d24d35b6b69df$var$EOF) return false;
    // Otherwise, return true.
    return true;
}
// § 4.3.9. Check if three code points would start an identifier
function $401d24d35b6b69df$var$isIdentifierStart(first, second, third) {
    // Look at the first code point:
    // U+002D HYPHEN-MINUS
    if (first === 0x002D) // If the second code point is a name-start code point or a U+002D HYPHEN-MINUS,
    // or the second and third code points are a valid escape, return true. Otherwise, return false.
    return $401d24d35b6b69df$var$isNameStart(second) || second === 0x002D || $401d24d35b6b69df$var$isValidEscape(second, third);
    // name-start code point
    if ($401d24d35b6b69df$var$isNameStart(first)) // Return true.
    return true;
    // U+005C REVERSE SOLIDUS (\)
    if (first === 0x005C) // If the first and second code points are a valid escape, return true. Otherwise, return false.
    return $401d24d35b6b69df$var$isValidEscape(first, second);
    // anything else
    // Return false.
    return false;
}
// § 4.3.10. Check if three code points would start a number
function $401d24d35b6b69df$var$isNumberStart(first, second, third) {
    // Look at the first code point:
    // U+002B PLUS SIGN (+)
    // U+002D HYPHEN-MINUS (-)
    if (first === 0x002B || first === 0x002D) {
        // If the second code point is a digit, return true.
        if ($401d24d35b6b69df$var$isDigit(second)) return 2;
        // Otherwise, if the second code point is a U+002E FULL STOP (.)
        // and the third code point is a digit, return true.
        // Otherwise, return false.
        return second === 0x002E && $401d24d35b6b69df$var$isDigit(third) ? 3 : 0;
    }
    // U+002E FULL STOP (.)
    if (first === 0x002E) // If the second code point is a digit, return true. Otherwise, return false.
    return $401d24d35b6b69df$var$isDigit(second) ? 2 : 0;
    // digit
    if ($401d24d35b6b69df$var$isDigit(first)) // Return true.
    return 1;
    // anything else
    // Return false.
    return 0;
}
//
// Misc
//
// detect BOM (https://en.wikipedia.org/wiki/Byte_order_mark)
function $401d24d35b6b69df$var$isBOM(code) {
    // UTF-16BE
    if (code === 0xFEFF) return 1;
    // UTF-16LE
    if (code === 0xFFFE) return 1;
    return 0;
}
// Fast code category
// Only ASCII code points has a special meaning, that's why we define a maps for 0..127 codes only
const $401d24d35b6b69df$var$CATEGORY = new Array(0x80);
const $401d24d35b6b69df$var$EofCategory = 0x80;
const $401d24d35b6b69df$var$WhiteSpaceCategory = 0x82;
const $401d24d35b6b69df$var$DigitCategory = 0x83;
const $401d24d35b6b69df$var$NameStartCategory = 0x84;
const $401d24d35b6b69df$var$NonPrintableCategory = 0x85;
for(let i = 0; i < $401d24d35b6b69df$var$CATEGORY.length; i++)$401d24d35b6b69df$var$CATEGORY[i] = $401d24d35b6b69df$var$isWhiteSpace(i) && $401d24d35b6b69df$var$WhiteSpaceCategory || $401d24d35b6b69df$var$isDigit(i) && $401d24d35b6b69df$var$DigitCategory || $401d24d35b6b69df$var$isNameStart(i) && $401d24d35b6b69df$var$NameStartCategory || $401d24d35b6b69df$var$isNonPrintable(i) && $401d24d35b6b69df$var$NonPrintableCategory || i || $401d24d35b6b69df$var$EofCategory;
function $401d24d35b6b69df$var$charCodeCategory(code) {
    return code < 0x80 ? $401d24d35b6b69df$var$CATEGORY[code] : $401d24d35b6b69df$var$NameStartCategory;
}
$401d24d35b6b69df$export$bbf58a4a05c6b6e2 = $401d24d35b6b69df$var$DigitCategory;
$401d24d35b6b69df$export$2f591833f7f1b967 = $401d24d35b6b69df$var$EofCategory;
$401d24d35b6b69df$export$48d90b0d2444a844 = $401d24d35b6b69df$var$NameStartCategory;
$401d24d35b6b69df$export$deba3a5f607eb19 = $401d24d35b6b69df$var$NonPrintableCategory;
$401d24d35b6b69df$export$90f8a5e44c6cc5e3 = $401d24d35b6b69df$var$WhiteSpaceCategory;
$401d24d35b6b69df$export$4b3b0ba223857b61 = $401d24d35b6b69df$var$charCodeCategory;
$401d24d35b6b69df$export$da737789103788ca = $401d24d35b6b69df$var$isBOM;
$401d24d35b6b69df$export$727d9dbc4fbb948f = $401d24d35b6b69df$var$isDigit;
$401d24d35b6b69df$export$2a81dc4d1a2f9334 = $401d24d35b6b69df$var$isHexDigit;
$401d24d35b6b69df$export$56b48cc5d7560ffb = $401d24d35b6b69df$var$isIdentifierStart;
$401d24d35b6b69df$export$79c5d5217943d6a7 = $401d24d35b6b69df$var$isLetter;
$401d24d35b6b69df$export$25a7e820fbcd58b9 = $401d24d35b6b69df$var$isLowercaseLetter;
$401d24d35b6b69df$export$998d7ff9801e90bb = $401d24d35b6b69df$var$isName;
$401d24d35b6b69df$export$45a677ea7cb6d5c8 = $401d24d35b6b69df$var$isNameStart;
$401d24d35b6b69df$export$c6b40e80adfef3ae = $401d24d35b6b69df$var$isNewline;
$401d24d35b6b69df$export$386c40f28a3efd99 = $401d24d35b6b69df$var$isNonAscii;
$401d24d35b6b69df$export$b7ed17c2edb4d953 = $401d24d35b6b69df$var$isNonPrintable;
$401d24d35b6b69df$export$598e9af52cb9b904 = $401d24d35b6b69df$var$isNumberStart;
$401d24d35b6b69df$export$35784e2518402c99 = $401d24d35b6b69df$var$isUppercaseLetter;
$401d24d35b6b69df$export$352e2c1d24776bfb = $401d24d35b6b69df$var$isValidEscape;
$401d24d35b6b69df$export$3c52dd84024ae72c = $401d24d35b6b69df$var$isWhiteSpace;


var $96eb8038f2b3ef39$export$6902610076fb2dc1;
var $96eb8038f2b3ef39$export$5bf4b3d0861be8d9;
var $96eb8038f2b3ef39$export$349fae4425f20458;
var $96eb8038f2b3ef39$export$1cf8ac3f090cf48a;
var $96eb8038f2b3ef39$export$e314ae15c0f41984;
var $96eb8038f2b3ef39$export$b817115b8219186a;
var $96eb8038f2b3ef39$export$5ed93187f4ce070a;
var $96eb8038f2b3ef39$export$e9aed36b506f417c;
var $96eb8038f2b3ef39$export$5bd0595948d7ed9;
var $96eb8038f2b3ef39$export$c4eb8307a0331d71;
var $96eb8038f2b3ef39$export$2e282c3c0c638f20;
'use strict';

function $96eb8038f2b3ef39$var$getCharCode(source, offset) {
    return offset < source.length ? source.charCodeAt(offset) : 0;
}
function $96eb8038f2b3ef39$var$getNewlineLength(source, offset, code) {
    if (code === 13 /* \r */  && $96eb8038f2b3ef39$var$getCharCode(source, offset + 1) === 10 /* \n */ ) return 2;
    return 1;
}
function $96eb8038f2b3ef39$var$cmpChar(testStr, offset, referenceCode) {
    let code = testStr.charCodeAt(offset);
    // code.toLowerCase() for A..Z
    if ($401d24d35b6b69df$export$35784e2518402c99(code)) code = code | 32;
    return code === referenceCode;
}
function $96eb8038f2b3ef39$var$cmpStr(testStr, start, end, referenceStr) {
    if (end - start !== referenceStr.length) return false;
    if (start < 0 || end > testStr.length) return false;
    for(let i = start; i < end; i++){
        const referenceCode = referenceStr.charCodeAt(i - start);
        let testCode = testStr.charCodeAt(i);
        // testCode.toLowerCase() for A..Z
        if ($401d24d35b6b69df$export$35784e2518402c99(testCode)) testCode = testCode | 32;
        if (testCode !== referenceCode) return false;
    }
    return true;
}
function $96eb8038f2b3ef39$var$findWhiteSpaceStart(source, offset) {
    for(; offset >= 0; offset--){
        if (!$401d24d35b6b69df$export$3c52dd84024ae72c(source.charCodeAt(offset))) break;
    }
    return offset + 1;
}
function $96eb8038f2b3ef39$var$findWhiteSpaceEnd(source, offset) {
    for(; offset < source.length; offset++){
        if (!$401d24d35b6b69df$export$3c52dd84024ae72c(source.charCodeAt(offset))) break;
    }
    return offset;
}
function $96eb8038f2b3ef39$var$findDecimalNumberEnd(source, offset) {
    for(; offset < source.length; offset++){
        if (!$401d24d35b6b69df$export$727d9dbc4fbb948f(source.charCodeAt(offset))) break;
    }
    return offset;
}
// § 4.3.7. Consume an escaped code point
function $96eb8038f2b3ef39$var$consumeEscaped(source, offset) {
    // It assumes that the U+005C REVERSE SOLIDUS (\) has already been consumed and
    // that the next input code point has already been verified to be part of a valid escape.
    offset += 2;
    // hex digit
    if ($401d24d35b6b69df$export$2a81dc4d1a2f9334($96eb8038f2b3ef39$var$getCharCode(source, offset - 1))) {
        // Consume as many hex digits as possible, but no more than 5.
        // Note that this means 1-6 hex digits have been consumed in total.
        for(const maxOffset = Math.min(source.length, offset + 5); offset < maxOffset; offset++){
            if (!$401d24d35b6b69df$export$2a81dc4d1a2f9334($96eb8038f2b3ef39$var$getCharCode(source, offset))) break;
        }
        // If the next input code point is whitespace, consume it as well.
        const code = $96eb8038f2b3ef39$var$getCharCode(source, offset);
        if ($401d24d35b6b69df$export$3c52dd84024ae72c(code)) offset += $96eb8038f2b3ef39$var$getNewlineLength(source, offset, code);
    }
    return offset;
}
// §4.3.11. Consume a name
// Note: This algorithm does not do the verification of the first few code points that are necessary
// to ensure the returned code points would constitute an <ident-token>. If that is the intended use,
// ensure that the stream starts with an identifier before calling this algorithm.
function $96eb8038f2b3ef39$var$consumeName(source, offset) {
    // Let result initially be an empty string.
    // Repeatedly consume the next input code point from the stream:
    for(; offset < source.length; offset++){
        const code = source.charCodeAt(offset);
        // name code point
        if ($401d24d35b6b69df$export$998d7ff9801e90bb(code)) continue;
        // the stream starts with a valid escape
        if ($401d24d35b6b69df$export$352e2c1d24776bfb(code, $96eb8038f2b3ef39$var$getCharCode(source, offset + 1))) {
            // Consume an escaped code point. Append the returned code point to result.
            offset = $96eb8038f2b3ef39$var$consumeEscaped(source, offset) - 1;
            continue;
        }
        break;
    }
    return offset;
}
// §4.3.12. Consume a number
function $96eb8038f2b3ef39$var$consumeNumber(source, offset) {
    let code = source.charCodeAt(offset);
    // 2. If the next input code point is U+002B PLUS SIGN (+) or U+002D HYPHEN-MINUS (-),
    // consume it and append it to repr.
    if (code === 0x002B || code === 0x002D) code = source.charCodeAt(offset += 1);
    // 3. While the next input code point is a digit, consume it and append it to repr.
    if ($401d24d35b6b69df$export$727d9dbc4fbb948f(code)) {
        offset = $96eb8038f2b3ef39$var$findDecimalNumberEnd(source, offset + 1);
        code = source.charCodeAt(offset);
    }
    // 4. If the next 2 input code points are U+002E FULL STOP (.) followed by a digit, then:
    if (code === 0x002E && $401d24d35b6b69df$export$727d9dbc4fbb948f(source.charCodeAt(offset + 1))) {
        // 4.1 Consume them.
        // 4.2 Append them to repr.
        offset += 2;
        // 4.3 Set type to "number".
        // TODO
        // 4.4 While the next input code point is a digit, consume it and append it to repr.
        offset = $96eb8038f2b3ef39$var$findDecimalNumberEnd(source, offset);
    }
    // 5. If the next 2 or 3 input code points are U+0045 LATIN CAPITAL LETTER E (E)
    // or U+0065 LATIN SMALL LETTER E (e), ... , followed by a digit, then:
    if ($96eb8038f2b3ef39$var$cmpChar(source, offset, 101 /* e */ )) {
        let sign = 0;
        code = source.charCodeAt(offset + 1);
        // ... optionally followed by U+002D HYPHEN-MINUS (-) or U+002B PLUS SIGN (+) ...
        if (code === 0x002D || code === 0x002B) {
            sign = 1;
            code = source.charCodeAt(offset + 2);
        }
        // ... followed by a digit
        if ($401d24d35b6b69df$export$727d9dbc4fbb948f(code)) // 5.1 Consume them.
        // 5.2 Append them to repr.
        // 5.3 Set type to "number".
        // TODO
        // 5.4 While the next input code point is a digit, consume it and append it to repr.
        offset = $96eb8038f2b3ef39$var$findDecimalNumberEnd(source, offset + 1 + sign + 1);
    }
    return offset;
}
// § 4.3.14. Consume the remnants of a bad url
// ... its sole use is to consume enough of the input stream to reach a recovery point
// where normal tokenizing can resume.
function $96eb8038f2b3ef39$var$consumeBadUrlRemnants(source, offset) {
    // Repeatedly consume the next input code point from the stream:
    for(; offset < source.length; offset++){
        const code = source.charCodeAt(offset);
        // U+0029 RIGHT PARENTHESIS ())
        // EOF
        if (code === 0x0029) {
            // Return.
            offset++;
            break;
        }
        if ($401d24d35b6b69df$export$352e2c1d24776bfb(code, $96eb8038f2b3ef39$var$getCharCode(source, offset + 1))) // Consume an escaped code point.
        // Note: This allows an escaped right parenthesis ("\)") to be encountered
        // without ending the <bad-url-token>. This is otherwise identical to
        // the "anything else" clause.
        offset = $96eb8038f2b3ef39$var$consumeEscaped(source, offset);
    }
    return offset;
}
// § 4.3.7. Consume an escaped code point
// Note: This algorithm assumes that escaped is valid without leading U+005C REVERSE SOLIDUS (\)
function $96eb8038f2b3ef39$var$decodeEscaped(escaped) {
    // Single char escaped that's not a hex digit
    if (escaped.length === 1 && !$401d24d35b6b69df$export$2a81dc4d1a2f9334(escaped.charCodeAt(0))) return escaped[0];
    // Interpret the hex digits as a hexadecimal number.
    let code = parseInt(escaped, 16);
    if (code === 0 || // If this number is zero,
    code >= 0xD800 && code <= 0xDFFF || // or is for a surrogate,
    code > 0x10FFFF // or is greater than the maximum allowed code point
    ) // ... return U+FFFD REPLACEMENT CHARACTER
    code = 0xFFFD;
    // Otherwise, return the code point with that value.
    return String.fromCodePoint(code);
}
$96eb8038f2b3ef39$export$6902610076fb2dc1 = $96eb8038f2b3ef39$var$cmpChar;
$96eb8038f2b3ef39$export$5bf4b3d0861be8d9 = $96eb8038f2b3ef39$var$cmpStr;
$96eb8038f2b3ef39$export$349fae4425f20458 = $96eb8038f2b3ef39$var$consumeBadUrlRemnants;
$96eb8038f2b3ef39$export$1cf8ac3f090cf48a = $96eb8038f2b3ef39$var$consumeEscaped;
$96eb8038f2b3ef39$export$e314ae15c0f41984 = $96eb8038f2b3ef39$var$consumeName;
$96eb8038f2b3ef39$export$b817115b8219186a = $96eb8038f2b3ef39$var$consumeNumber;
$96eb8038f2b3ef39$export$5ed93187f4ce070a = $96eb8038f2b3ef39$var$decodeEscaped;
$96eb8038f2b3ef39$export$e9aed36b506f417c = $96eb8038f2b3ef39$var$findDecimalNumberEnd;
$96eb8038f2b3ef39$export$5bd0595948d7ed9 = $96eb8038f2b3ef39$var$findWhiteSpaceEnd;
$96eb8038f2b3ef39$export$c4eb8307a0331d71 = $96eb8038f2b3ef39$var$findWhiteSpaceStart;
$96eb8038f2b3ef39$export$2e282c3c0c638f20 = $96eb8038f2b3ef39$var$getNewlineLength;


var $9730c97b105b5f1f$exports = {};
'use strict';
const $9730c97b105b5f1f$var$tokenNames = [
    'EOF-token',
    'ident-token',
    'function-token',
    'at-keyword-token',
    'hash-token',
    'string-token',
    'bad-string-token',
    'url-token',
    'bad-url-token',
    'delim-token',
    'number-token',
    'percentage-token',
    'dimension-token',
    'whitespace-token',
    'CDO-token',
    'CDC-token',
    'colon-token',
    'semicolon-token',
    'comma-token',
    '[-token',
    ']-token',
    '(-token',
    ')-token',
    '{-token',
    '}-token'
];
$9730c97b105b5f1f$exports = $9730c97b105b5f1f$var$tokenNames;


var $9a577b8cb9f70475$export$a1e9ec249d80652c;
'use strict';
var $d5e41cd31076da80$export$cb41ea972ba24ee8;
'use strict';
const $d5e41cd31076da80$var$MIN_SIZE = 16384;
function $d5e41cd31076da80$var$adoptBuffer(buffer = null, size) {
    if (buffer === null || buffer.length < size) return new Uint32Array(Math.max(size + 1024, $d5e41cd31076da80$var$MIN_SIZE));
    return buffer;
}
$d5e41cd31076da80$export$cb41ea972ba24ee8 = $d5e41cd31076da80$var$adoptBuffer;



const $9a577b8cb9f70475$var$N = 10;
const $9a577b8cb9f70475$var$F = 12;
const $9a577b8cb9f70475$var$R = 13;
function $9a577b8cb9f70475$var$computeLinesAndColumns(host) {
    const source = host.source;
    const sourceLength = source.length;
    const startOffset = source.length > 0 ? $401d24d35b6b69df$export$da737789103788ca(source.charCodeAt(0)) : 0;
    const lines = $d5e41cd31076da80$export$cb41ea972ba24ee8(host.lines, sourceLength);
    const columns = $d5e41cd31076da80$export$cb41ea972ba24ee8(host.columns, sourceLength);
    let line = host.startLine;
    let column = host.startColumn;
    for(let i = startOffset; i < sourceLength; i++){
        const code = source.charCodeAt(i);
        lines[i] = line;
        columns[i] = column++;
        if (code === $9a577b8cb9f70475$var$N || code === $9a577b8cb9f70475$var$R || code === $9a577b8cb9f70475$var$F) {
            if (code === $9a577b8cb9f70475$var$R && i + 1 < sourceLength && source.charCodeAt(i + 1) === $9a577b8cb9f70475$var$N) {
                i++;
                lines[i] = line;
                columns[i] = column;
            }
            line++;
            column = 1;
        }
    }
    lines[sourceLength] = line;
    columns[sourceLength] = column;
    host.lines = lines;
    host.columns = columns;
    host.computed = true;
}
class $9a577b8cb9f70475$var$OffsetToLocation {
    setSource(source, startOffset = 0, startLine = 1, startColumn = 1) {
        this.source = source;
        this.startOffset = startOffset;
        this.startLine = startLine;
        this.startColumn = startColumn;
        this.computed = false;
    }
    getLocation(offset, filename) {
        if (!this.computed) $9a577b8cb9f70475$var$computeLinesAndColumns(this);
        return {
            source: filename,
            offset: this.startOffset + offset,
            line: this.lines[offset],
            column: this.columns[offset]
        };
    }
    getLocationRange(start, end, filename) {
        if (!this.computed) $9a577b8cb9f70475$var$computeLinesAndColumns(this);
        return {
            source: filename,
            start: {
                offset: this.startOffset + start,
                line: this.lines[start],
                column: this.columns[start]
            },
            end: {
                offset: this.startOffset + end,
                line: this.lines[end],
                column: this.columns[end]
            }
        };
    }
    constructor(){
        this.lines = null;
        this.columns = null;
        this.computed = false;
    }
}
$9a577b8cb9f70475$export$a1e9ec249d80652c = $9a577b8cb9f70475$var$OffsetToLocation;


var $88761db79c6a77c6$export$b55edb69cfa7ac57;
'use strict';




const $88761db79c6a77c6$var$OFFSET_MASK = 0x00FFFFFF;
const $88761db79c6a77c6$var$TYPE_SHIFT = 24;
const $88761db79c6a77c6$var$balancePair = new Map([
    [
        $926ff4544e512db5$export$f3890eeaf6851387,
        $926ff4544e512db5$export$773d33972c6279ed
    ],
    [
        $926ff4544e512db5$export$b5a25f132cb53de6,
        $926ff4544e512db5$export$773d33972c6279ed
    ],
    [
        $926ff4544e512db5$export$cd363bb53c2bb,
        $926ff4544e512db5$export$72f933344f701f30
    ],
    [
        $926ff4544e512db5$export$ccdce7304ac66390,
        $926ff4544e512db5$export$186d8b1f99e2bfec
    ]
]);
class $88761db79c6a77c6$var$TokenStream {
    reset() {
        this.eof = false;
        this.tokenIndex = -1;
        this.tokenType = 0;
        this.tokenStart = this.firstCharOffset;
        this.tokenEnd = this.firstCharOffset;
    }
    setSource(source = '', tokenize = ()=>{}) {
        source = String(source || '');
        const sourceLength = source.length;
        const offsetAndType = $d5e41cd31076da80$export$cb41ea972ba24ee8(this.offsetAndType, source.length + 1); // +1 because of eof-token
        const balance = $d5e41cd31076da80$export$cb41ea972ba24ee8(this.balance, source.length + 1);
        let tokenCount = 0;
        let balanceCloseType = 0;
        let balanceStart = 0;
        let firstCharOffset = -1;
        // capture buffers
        this.offsetAndType = null;
        this.balance = null;
        tokenize(source, (type, start, end)=>{
            switch(type){
                default:
                    balance[tokenCount] = sourceLength;
                    break;
                case balanceCloseType:
                    {
                        let balancePrev = balanceStart & $88761db79c6a77c6$var$OFFSET_MASK;
                        balanceStart = balance[balancePrev];
                        balanceCloseType = balanceStart >> $88761db79c6a77c6$var$TYPE_SHIFT;
                        balance[tokenCount] = balancePrev;
                        balance[balancePrev++] = tokenCount;
                        for(; balancePrev < tokenCount; balancePrev++)if (balance[balancePrev] === sourceLength) balance[balancePrev] = tokenCount;
                        break;
                    }
                case $926ff4544e512db5$export$b5a25f132cb53de6:
                case $926ff4544e512db5$export$f3890eeaf6851387:
                case $926ff4544e512db5$export$cd363bb53c2bb:
                case $926ff4544e512db5$export$ccdce7304ac66390:
                    balance[tokenCount] = balanceStart;
                    balanceCloseType = $88761db79c6a77c6$var$balancePair.get(type);
                    balanceStart = balanceCloseType << $88761db79c6a77c6$var$TYPE_SHIFT | tokenCount;
                    break;
            }
            offsetAndType[tokenCount++] = type << $88761db79c6a77c6$var$TYPE_SHIFT | end;
            if (firstCharOffset === -1) firstCharOffset = start;
        });
        // finalize buffers
        offsetAndType[tokenCount] = $926ff4544e512db5$export$c1a09112320b1603 << $88761db79c6a77c6$var$TYPE_SHIFT | sourceLength; // <EOF-token>
        balance[tokenCount] = sourceLength;
        balance[sourceLength] = sourceLength; // prevents false positive balance match with any token
        while(balanceStart !== 0){
            const balancePrev = balanceStart & $88761db79c6a77c6$var$OFFSET_MASK;
            balanceStart = balance[balancePrev];
            balance[balancePrev] = sourceLength;
        }
        this.source = source;
        this.firstCharOffset = firstCharOffset === -1 ? 0 : firstCharOffset;
        this.tokenCount = tokenCount;
        this.offsetAndType = offsetAndType;
        this.balance = balance;
        this.reset();
        this.next();
    }
    lookupType(offset) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return this.offsetAndType[offset] >> $88761db79c6a77c6$var$TYPE_SHIFT;
        return $926ff4544e512db5$export$c1a09112320b1603;
    }
    lookupOffset(offset) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return this.offsetAndType[offset - 1] & $88761db79c6a77c6$var$OFFSET_MASK;
        return this.source.length;
    }
    lookupValue(offset, referenceStr) {
        offset += this.tokenIndex;
        if (offset < this.tokenCount) return $96eb8038f2b3ef39$export$5bf4b3d0861be8d9(this.source, this.offsetAndType[offset - 1] & $88761db79c6a77c6$var$OFFSET_MASK, this.offsetAndType[offset] & $88761db79c6a77c6$var$OFFSET_MASK, referenceStr);
        return false;
    }
    getTokenStart(tokenIndex) {
        if (tokenIndex === this.tokenIndex) return this.tokenStart;
        if (tokenIndex > 0) return tokenIndex < this.tokenCount ? this.offsetAndType[tokenIndex - 1] & $88761db79c6a77c6$var$OFFSET_MASK : this.offsetAndType[this.tokenCount] & $88761db79c6a77c6$var$OFFSET_MASK;
        return this.firstCharOffset;
    }
    substrToCursor(start) {
        return this.source.substring(start, this.tokenStart);
    }
    isBalanceEdge(pos) {
        return this.balance[this.tokenIndex] < pos;
    }
    isDelim(code, offset) {
        if (offset) return this.lookupType(offset) === $926ff4544e512db5$export$a918ca49ff4337a3 && this.source.charCodeAt(this.lookupOffset(offset)) === code;
        return this.tokenType === $926ff4544e512db5$export$a918ca49ff4337a3 && this.source.charCodeAt(this.tokenStart) === code;
    }
    skip(tokenCount) {
        let next = this.tokenIndex + tokenCount;
        if (next < this.tokenCount) {
            this.tokenIndex = next;
            this.tokenStart = this.offsetAndType[next - 1] & $88761db79c6a77c6$var$OFFSET_MASK;
            next = this.offsetAndType[next];
            this.tokenType = next >> $88761db79c6a77c6$var$TYPE_SHIFT;
            this.tokenEnd = next & $88761db79c6a77c6$var$OFFSET_MASK;
        } else {
            this.tokenIndex = this.tokenCount;
            this.next();
        }
    }
    next() {
        let next = this.tokenIndex + 1;
        if (next < this.tokenCount) {
            this.tokenIndex = next;
            this.tokenStart = this.tokenEnd;
            next = this.offsetAndType[next];
            this.tokenType = next >> $88761db79c6a77c6$var$TYPE_SHIFT;
            this.tokenEnd = next & $88761db79c6a77c6$var$OFFSET_MASK;
        } else {
            this.eof = true;
            this.tokenIndex = this.tokenCount;
            this.tokenType = $926ff4544e512db5$export$c1a09112320b1603;
            this.tokenStart = this.tokenEnd = this.source.length;
        }
    }
    skipSC() {
        while(this.tokenType === $926ff4544e512db5$export$fb98946286ab4c97 || this.tokenType === $926ff4544e512db5$export$4d299b491347818a)this.next();
    }
    skipUntilBalanced(startToken, stopConsume) {
        let cursor = startToken;
        let balanceEnd;
        let offset;
        loop: for(; cursor < this.tokenCount; cursor++){
            balanceEnd = this.balance[cursor];
            // stop scanning on balance edge that points to offset before start token
            if (balanceEnd < startToken) break loop;
            offset = cursor > 0 ? this.offsetAndType[cursor - 1] & $88761db79c6a77c6$var$OFFSET_MASK : this.firstCharOffset;
            // check stop condition
            switch(stopConsume(this.source.charCodeAt(offset))){
                case 1:
                    break loop;
                case 2:
                    cursor++;
                    break loop;
                default:
                    // fast forward to the end of balanced block
                    if (this.balance[balanceEnd] === cursor) cursor = balanceEnd;
            }
        }
        this.skip(cursor - this.tokenIndex);
    }
    forEachToken(fn) {
        for(let i = 0, offset = this.firstCharOffset; i < this.tokenCount; i++){
            const start = offset;
            const item = this.offsetAndType[i];
            const end = item & $88761db79c6a77c6$var$OFFSET_MASK;
            const type = item >> $88761db79c6a77c6$var$TYPE_SHIFT;
            offset = end;
            fn(type, start, end, i);
        }
    }
    dump() {
        const tokens = new Array(this.tokenCount);
        this.forEachToken((type, start, end, index)=>{
            tokens[index] = {
                idx: index,
                type: $9730c97b105b5f1f$exports[type],
                chunk: this.source.substring(start, end),
                balance: this.balance[index]
            };
        });
        return tokens;
    }
    constructor(source, tokenize){
        this.setSource(source, tokenize);
    }
}
$88761db79c6a77c6$export$b55edb69cfa7ac57 = $88761db79c6a77c6$var$TokenStream;


function $14ef1a69abba2f52$var$tokenize(source, onToken) {
    function getCharCode(offset) {
        return offset < sourceLength ? source.charCodeAt(offset) : 0;
    }
    // § 4.3.3. Consume a numeric token
    function consumeNumericToken() {
        // Consume a number and let number be the result.
        offset = $96eb8038f2b3ef39$export$b817115b8219186a(source, offset);
        // If the next 3 input code points would start an identifier, then:
        if ($401d24d35b6b69df$export$56b48cc5d7560ffb(getCharCode(offset), getCharCode(offset + 1), getCharCode(offset + 2))) {
            // Create a <dimension-token> with the same value and type flag as number, and a unit set initially to the empty string.
            // Consume a name. Set the <dimension-token>’s unit to the returned value.
            // Return the <dimension-token>.
            type = $926ff4544e512db5$exports.Dimension;
            offset = $96eb8038f2b3ef39$export$e314ae15c0f41984(source, offset);
            return;
        }
        // Otherwise, if the next input code point is U+0025 PERCENTAGE SIGN (%), consume it.
        if (getCharCode(offset) === 0x0025) {
            // Create a <percentage-token> with the same value as number, and return it.
            type = $926ff4544e512db5$exports.Percentage;
            offset++;
            return;
        }
        // Otherwise, create a <number-token> with the same value and type flag as number, and return it.
        type = $926ff4544e512db5$exports.Number;
    }
    // § 4.3.4. Consume an ident-like token
    function consumeIdentLikeToken() {
        const nameStartOffset = offset;
        // Consume a name, and let string be the result.
        offset = $96eb8038f2b3ef39$export$e314ae15c0f41984(source, offset);
        // If string’s value is an ASCII case-insensitive match for "url",
        // and the next input code point is U+0028 LEFT PARENTHESIS ((), consume it.
        if ($96eb8038f2b3ef39$export$5bf4b3d0861be8d9(source, nameStartOffset, offset, 'url') && getCharCode(offset) === 0x0028) {
            // While the next two input code points are whitespace, consume the next input code point.
            offset = $96eb8038f2b3ef39$export$5bd0595948d7ed9(source, offset + 1);
            // If the next one or two input code points are U+0022 QUOTATION MARK ("), U+0027 APOSTROPHE ('),
            // or whitespace followed by U+0022 QUOTATION MARK (") or U+0027 APOSTROPHE ('),
            // then create a <function-token> with its value set to string and return it.
            if (getCharCode(offset) === 0x0022 || getCharCode(offset) === 0x0027) {
                type = $926ff4544e512db5$exports.Function;
                offset = nameStartOffset + 4;
                return;
            }
            // Otherwise, consume a url token, and return it.
            consumeUrlToken();
            return;
        }
        // Otherwise, if the next input code point is U+0028 LEFT PARENTHESIS ((), consume it.
        // Create a <function-token> with its value set to string and return it.
        if (getCharCode(offset) === 0x0028) {
            type = $926ff4544e512db5$exports.Function;
            offset++;
            return;
        }
        // Otherwise, create an <ident-token> with its value set to string and return it.
        type = $926ff4544e512db5$exports.Ident;
    }
    // § 4.3.5. Consume a string token
    function consumeStringToken(endingCodePoint) {
        // This algorithm may be called with an ending code point, which denotes the code point
        // that ends the string. If an ending code point is not specified,
        // the current input code point is used.
        if (!endingCodePoint) endingCodePoint = getCharCode(offset++);
        // Initially create a <string-token> with its value set to the empty string.
        type = $926ff4544e512db5$exports.String;
        // Repeatedly consume the next input code point from the stream:
        for(; offset < source.length; offset++){
            const code = source.charCodeAt(offset);
            switch($401d24d35b6b69df$export$4b3b0ba223857b61(code)){
                // ending code point
                case endingCodePoint:
                    // Return the <string-token>.
                    offset++;
                    return;
                // EOF
                // case EofCategory:
                // This is a parse error. Return the <string-token>.
                // return;
                // newline
                case $401d24d35b6b69df$export$90f8a5e44c6cc5e3:
                    if ($401d24d35b6b69df$export$c6b40e80adfef3ae(code)) {
                        // This is a parse error. Reconsume the current input code point,
                        // create a <bad-string-token>, and return it.
                        offset += $96eb8038f2b3ef39$export$2e282c3c0c638f20(source, offset, code);
                        type = $926ff4544e512db5$exports.BadString;
                        return;
                    }
                    break;
                // U+005C REVERSE SOLIDUS (\)
                case 0x005C:
                    // If the next input code point is EOF, do nothing.
                    if (offset === source.length - 1) break;
                    const nextCode = getCharCode(offset + 1);
                    // Otherwise, if the next input code point is a newline, consume it.
                    if ($401d24d35b6b69df$export$c6b40e80adfef3ae(nextCode)) offset += $96eb8038f2b3ef39$export$2e282c3c0c638f20(source, offset + 1, nextCode);
                    else if ($401d24d35b6b69df$export$352e2c1d24776bfb(code, nextCode)) // Otherwise, (the stream starts with a valid escape) consume
                    // an escaped code point and append the returned code point to
                    // the <string-token>’s value.
                    offset = $96eb8038f2b3ef39$export$1cf8ac3f090cf48a(source, offset) - 1;
                    break;
            }
        }
    }
    // § 4.3.6. Consume a url token
    // Note: This algorithm assumes that the initial "url(" has already been consumed.
    // This algorithm also assumes that it’s being called to consume an "unquoted" value, like url(foo).
    // A quoted value, like url("foo"), is parsed as a <function-token>. Consume an ident-like token
    // automatically handles this distinction; this algorithm shouldn’t be called directly otherwise.
    function consumeUrlToken() {
        // Initially create a <url-token> with its value set to the empty string.
        type = $926ff4544e512db5$exports.Url;
        // Consume as much whitespace as possible.
        offset = $96eb8038f2b3ef39$export$5bd0595948d7ed9(source, offset);
        // Repeatedly consume the next input code point from the stream:
        for(; offset < source.length; offset++){
            const code = source.charCodeAt(offset);
            switch($401d24d35b6b69df$export$4b3b0ba223857b61(code)){
                // U+0029 RIGHT PARENTHESIS ())
                case 0x0029:
                    // Return the <url-token>.
                    offset++;
                    return;
                // EOF
                // case EofCategory:
                // This is a parse error. Return the <url-token>.
                // return;
                // whitespace
                case $401d24d35b6b69df$export$90f8a5e44c6cc5e3:
                    // Consume as much whitespace as possible.
                    offset = $96eb8038f2b3ef39$export$5bd0595948d7ed9(source, offset);
                    // If the next input code point is U+0029 RIGHT PARENTHESIS ()) or EOF,
                    // consume it and return the <url-token>
                    // (if EOF was encountered, this is a parse error);
                    if (getCharCode(offset) === 0x0029 || offset >= source.length) {
                        if (offset < source.length) offset++;
                        return;
                    }
                    // otherwise, consume the remnants of a bad url, create a <bad-url-token>,
                    // and return it.
                    offset = $96eb8038f2b3ef39$export$349fae4425f20458(source, offset);
                    type = $926ff4544e512db5$exports.BadUrl;
                    return;
                // U+0022 QUOTATION MARK (")
                // U+0027 APOSTROPHE (')
                // U+0028 LEFT PARENTHESIS (()
                // non-printable code point
                case 0x0022:
                case 0x0027:
                case 0x0028:
                case $401d24d35b6b69df$export$deba3a5f607eb19:
                    // This is a parse error. Consume the remnants of a bad url,
                    // create a <bad-url-token>, and return it.
                    offset = $96eb8038f2b3ef39$export$349fae4425f20458(source, offset);
                    type = $926ff4544e512db5$exports.BadUrl;
                    return;
                // U+005C REVERSE SOLIDUS (\)
                case 0x005C:
                    // If the stream starts with a valid escape, consume an escaped code point and
                    // append the returned code point to the <url-token>’s value.
                    if ($401d24d35b6b69df$export$352e2c1d24776bfb(code, getCharCode(offset + 1))) {
                        offset = $96eb8038f2b3ef39$export$1cf8ac3f090cf48a(source, offset) - 1;
                        break;
                    }
                    // Otherwise, this is a parse error. Consume the remnants of a bad url,
                    // create a <bad-url-token>, and return it.
                    offset = $96eb8038f2b3ef39$export$349fae4425f20458(source, offset);
                    type = $926ff4544e512db5$exports.BadUrl;
                    return;
            }
        }
    }
    // ensure source is a string
    source = String(source || '');
    const sourceLength = source.length;
    let start = $401d24d35b6b69df$export$da737789103788ca(getCharCode(0));
    let offset = start;
    let type;
    // https://drafts.csswg.org/css-syntax-3/#consume-token
    // § 4.3.1. Consume a token
    while(offset < sourceLength){
        const code = source.charCodeAt(offset);
        switch($401d24d35b6b69df$export$4b3b0ba223857b61(code)){
            // whitespace
            case $401d24d35b6b69df$export$90f8a5e44c6cc5e3:
                // Consume as much whitespace as possible. Return a <whitespace-token>.
                type = $926ff4544e512db5$exports.WhiteSpace;
                offset = $96eb8038f2b3ef39$export$5bd0595948d7ed9(source, offset + 1);
                break;
            // U+0022 QUOTATION MARK (")
            case 0x0022:
                // Consume a string token and return it.
                consumeStringToken();
                break;
            // U+0023 NUMBER SIGN (#)
            case 0x0023:
                // If the next input code point is a name code point or the next two input code points are a valid escape, then:
                if ($401d24d35b6b69df$export$998d7ff9801e90bb(getCharCode(offset + 1)) || $401d24d35b6b69df$export$352e2c1d24776bfb(getCharCode(offset + 1), getCharCode(offset + 2))) {
                    // Create a <hash-token>.
                    type = $926ff4544e512db5$exports.Hash;
                    // If the next 3 input code points would start an identifier, set the <hash-token>’s type flag to "id".
                    // if (isIdentifierStart(getCharCode(offset + 1), getCharCode(offset + 2), getCharCode(offset + 3))) {
                    //     // TODO: set id flag
                    // }
                    // Consume a name, and set the <hash-token>’s value to the returned string.
                    offset = $96eb8038f2b3ef39$export$e314ae15c0f41984(source, offset + 1);
                // Return the <hash-token>.
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $926ff4544e512db5$exports.Delim;
                    offset++;
                }
                break;
            // U+0027 APOSTROPHE (')
            case 0x0027:
                // Consume a string token and return it.
                consumeStringToken();
                break;
            // U+0028 LEFT PARENTHESIS (()
            case 0x0028:
                // Return a <(-token>.
                type = $926ff4544e512db5$exports.LeftParenthesis;
                offset++;
                break;
            // U+0029 RIGHT PARENTHESIS ())
            case 0x0029:
                // Return a <)-token>.
                type = $926ff4544e512db5$exports.RightParenthesis;
                offset++;
                break;
            // U+002B PLUS SIGN (+)
            case 0x002B:
                // If the input stream starts with a number, ...
                if ($401d24d35b6b69df$export$598e9af52cb9b904(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $926ff4544e512db5$exports.Delim;
                    offset++;
                }
                break;
            // U+002C COMMA (,)
            case 0x002C:
                // Return a <comma-token>.
                type = $926ff4544e512db5$exports.Comma;
                offset++;
                break;
            // U+002D HYPHEN-MINUS (-)
            case 0x002D:
                // If the input stream starts with a number, reconsume the current input code point, consume a numeric token, and return it.
                if ($401d24d35b6b69df$export$598e9af52cb9b904(code, getCharCode(offset + 1), getCharCode(offset + 2))) consumeNumericToken();
                else {
                    // Otherwise, if the next 2 input code points are U+002D HYPHEN-MINUS U+003E GREATER-THAN SIGN (->), consume them and return a <CDC-token>.
                    if (getCharCode(offset + 1) === 0x002D && getCharCode(offset + 2) === 0x003E) {
                        type = $926ff4544e512db5$exports.CDC;
                        offset = offset + 3;
                    } else // Otherwise, if the input stream starts with an identifier, ...
                    if ($401d24d35b6b69df$export$56b48cc5d7560ffb(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume an ident-like token, and return it.
                    consumeIdentLikeToken();
                    else {
                        // Otherwise, return a <delim-token> with its value set to the current input code point.
                        type = $926ff4544e512db5$exports.Delim;
                        offset++;
                    }
                }
                break;
            // U+002E FULL STOP (.)
            case 0x002E:
                // If the input stream starts with a number, ...
                if ($401d24d35b6b69df$export$598e9af52cb9b904(code, getCharCode(offset + 1), getCharCode(offset + 2))) // ... reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $926ff4544e512db5$exports.Delim;
                    offset++;
                }
                break;
            // U+002F SOLIDUS (/)
            case 0x002F:
                // If the next two input code point are U+002F SOLIDUS (/) followed by a U+002A ASTERISK (*),
                if (getCharCode(offset + 1) === 0x002A) {
                    // ... consume them and all following code points up to and including the first U+002A ASTERISK (*)
                    // followed by a U+002F SOLIDUS (/), or up to an EOF code point.
                    type = $926ff4544e512db5$exports.Comment;
                    offset = source.indexOf('*/', offset + 2);
                    offset = offset === -1 ? source.length : offset + 2;
                } else {
                    type = $926ff4544e512db5$exports.Delim;
                    offset++;
                }
                break;
            // U+003A COLON (:)
            case 0x003A:
                // Return a <colon-token>.
                type = $926ff4544e512db5$exports.Colon;
                offset++;
                break;
            // U+003B SEMICOLON (;)
            case 0x003B:
                // Return a <semicolon-token>.
                type = $926ff4544e512db5$exports.Semicolon;
                offset++;
                break;
            // U+003C LESS-THAN SIGN (<)
            case 0x003C:
                // If the next 3 input code points are U+0021 EXCLAMATION MARK U+002D HYPHEN-MINUS U+002D HYPHEN-MINUS (!--), ...
                if (getCharCode(offset + 1) === 0x0021 && getCharCode(offset + 2) === 0x002D && getCharCode(offset + 3) === 0x002D) {
                    // ... consume them and return a <CDO-token>.
                    type = $926ff4544e512db5$exports.CDO;
                    offset = offset + 4;
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $926ff4544e512db5$exports.Delim;
                    offset++;
                }
                break;
            // U+0040 COMMERCIAL AT (@)
            case 0x0040:
                // If the next 3 input code points would start an identifier, ...
                if ($401d24d35b6b69df$export$56b48cc5d7560ffb(getCharCode(offset + 1), getCharCode(offset + 2), getCharCode(offset + 3))) {
                    // ... consume a name, create an <at-keyword-token> with its value set to the returned value, and return it.
                    type = $926ff4544e512db5$exports.AtKeyword;
                    offset = $96eb8038f2b3ef39$export$e314ae15c0f41984(source, offset + 1);
                } else {
                    // Otherwise, return a <delim-token> with its value set to the current input code point.
                    type = $926ff4544e512db5$exports.Delim;
                    offset++;
                }
                break;
            // U+005B LEFT SQUARE BRACKET ([)
            case 0x005B:
                // Return a <[-token>.
                type = $926ff4544e512db5$exports.LeftSquareBracket;
                offset++;
                break;
            // U+005C REVERSE SOLIDUS (\)
            case 0x005C:
                // If the input stream starts with a valid escape, ...
                if ($401d24d35b6b69df$export$352e2c1d24776bfb(code, getCharCode(offset + 1))) // ... reconsume the current input code point, consume an ident-like token, and return it.
                consumeIdentLikeToken();
                else {
                    // Otherwise, this is a parse error. Return a <delim-token> with its value set to the current input code point.
                    type = $926ff4544e512db5$exports.Delim;
                    offset++;
                }
                break;
            // U+005D RIGHT SQUARE BRACKET (])
            case 0x005D:
                // Return a <]-token>.
                type = $926ff4544e512db5$exports.RightSquareBracket;
                offset++;
                break;
            // U+007B LEFT CURLY BRACKET ({)
            case 0x007B:
                // Return a <{-token>.
                type = $926ff4544e512db5$exports.LeftCurlyBracket;
                offset++;
                break;
            // U+007D RIGHT CURLY BRACKET (})
            case 0x007D:
                // Return a <}-token>.
                type = $926ff4544e512db5$exports.RightCurlyBracket;
                offset++;
                break;
            // digit
            case $401d24d35b6b69df$export$bbf58a4a05c6b6e2:
                // Reconsume the current input code point, consume a numeric token, and return it.
                consumeNumericToken();
                break;
            // name-start code point
            case $401d24d35b6b69df$export$48d90b0d2444a844:
                // Reconsume the current input code point, consume an ident-like token, and return it.
                consumeIdentLikeToken();
                break;
            // EOF
            // case EofCategory:
            // Return an <EOF-token>.
            // break;
            // anything else
            default:
                // Return a <delim-token> with its value set to the current input code point.
                type = $926ff4544e512db5$exports.Delim;
                offset++;
        }
        // put token to stream
        onToken(type, start, start = offset);
    }
}
$14ef1a69abba2f52$export$21bfcb60d1b5ccac = $926ff4544e512db5$exports.AtKeyword;
$14ef1a69abba2f52$export$d273d1be20da6de2 = $926ff4544e512db5$exports.BadString;
$14ef1a69abba2f52$export$f8b4878501aa4a62 = $926ff4544e512db5$exports.BadUrl;
$14ef1a69abba2f52$export$b0b2bd2d1777c179 = $926ff4544e512db5$exports.CDC;
$14ef1a69abba2f52$export$521ef26a3002003b = $926ff4544e512db5$exports.CDO;
$14ef1a69abba2f52$export$e20ebb298016f6 = $926ff4544e512db5$exports.Colon;
$14ef1a69abba2f52$export$c06e3ee3b4d233fa = $926ff4544e512db5$exports.Comma;
$14ef1a69abba2f52$export$4d299b491347818a = $926ff4544e512db5$exports.Comment;
$14ef1a69abba2f52$export$a918ca49ff4337a3 = $926ff4544e512db5$exports.Delim;
$14ef1a69abba2f52$export$c940ece961bc43c6 = $926ff4544e512db5$exports.Dimension;
$14ef1a69abba2f52$export$c1a09112320b1603 = $926ff4544e512db5$exports.EOF;
$14ef1a69abba2f52$export$f3890eeaf6851387 = $926ff4544e512db5$exports.Function;
$14ef1a69abba2f52$export$ab85ecd77ce6a5cd = $926ff4544e512db5$exports.Hash;
$14ef1a69abba2f52$export$331e9b6bdecaac5f = $926ff4544e512db5$exports.Ident;
$14ef1a69abba2f52$export$ccdce7304ac66390 = $926ff4544e512db5$exports.LeftCurlyBracket;
$14ef1a69abba2f52$export$b5a25f132cb53de6 = $926ff4544e512db5$exports.LeftParenthesis;
$14ef1a69abba2f52$export$cd363bb53c2bb = $926ff4544e512db5$exports.LeftSquareBracket;
$14ef1a69abba2f52$export$fffa67e515d04022 = $926ff4544e512db5$exports.Number;
$14ef1a69abba2f52$export$d11913f8a6922aea = $926ff4544e512db5$exports.Percentage;
$14ef1a69abba2f52$export$186d8b1f99e2bfec = $926ff4544e512db5$exports.RightCurlyBracket;
$14ef1a69abba2f52$export$773d33972c6279ed = $926ff4544e512db5$exports.RightParenthesis;
$14ef1a69abba2f52$export$72f933344f701f30 = $926ff4544e512db5$exports.RightSquareBracket;
$14ef1a69abba2f52$export$bedd8b9b04d9dbd = $926ff4544e512db5$exports.Semicolon;
$14ef1a69abba2f52$export$89b8e0fa65f6a914 = $926ff4544e512db5$exports.String;
$14ef1a69abba2f52$export$59d795186a5d3f58 = $926ff4544e512db5$exports.Url;
$14ef1a69abba2f52$export$fb98946286ab4c97 = $926ff4544e512db5$exports.WhiteSpace;
$14ef1a69abba2f52$export$a60b91545d7e19fc = $926ff4544e512db5$exports;
$14ef1a69abba2f52$export$bbf58a4a05c6b6e2 = $401d24d35b6b69df$export$bbf58a4a05c6b6e2;
$14ef1a69abba2f52$export$2f591833f7f1b967 = $401d24d35b6b69df$export$2f591833f7f1b967;
$14ef1a69abba2f52$export$48d90b0d2444a844 = $401d24d35b6b69df$export$48d90b0d2444a844;
$14ef1a69abba2f52$export$deba3a5f607eb19 = $401d24d35b6b69df$export$deba3a5f607eb19;
$14ef1a69abba2f52$export$90f8a5e44c6cc5e3 = $401d24d35b6b69df$export$90f8a5e44c6cc5e3;
$14ef1a69abba2f52$export$4b3b0ba223857b61 = $401d24d35b6b69df$export$4b3b0ba223857b61;
$14ef1a69abba2f52$export$da737789103788ca = $401d24d35b6b69df$export$da737789103788ca;
$14ef1a69abba2f52$export$727d9dbc4fbb948f = $401d24d35b6b69df$export$727d9dbc4fbb948f;
$14ef1a69abba2f52$export$2a81dc4d1a2f9334 = $401d24d35b6b69df$export$2a81dc4d1a2f9334;
$14ef1a69abba2f52$export$56b48cc5d7560ffb = $401d24d35b6b69df$export$56b48cc5d7560ffb;
$14ef1a69abba2f52$export$79c5d5217943d6a7 = $401d24d35b6b69df$export$79c5d5217943d6a7;
$14ef1a69abba2f52$export$25a7e820fbcd58b9 = $401d24d35b6b69df$export$25a7e820fbcd58b9;
$14ef1a69abba2f52$export$998d7ff9801e90bb = $401d24d35b6b69df$export$998d7ff9801e90bb;
$14ef1a69abba2f52$export$45a677ea7cb6d5c8 = $401d24d35b6b69df$export$45a677ea7cb6d5c8;
$14ef1a69abba2f52$export$c6b40e80adfef3ae = $401d24d35b6b69df$export$c6b40e80adfef3ae;
$14ef1a69abba2f52$export$386c40f28a3efd99 = $401d24d35b6b69df$export$386c40f28a3efd99;
$14ef1a69abba2f52$export$b7ed17c2edb4d953 = $401d24d35b6b69df$export$b7ed17c2edb4d953;
$14ef1a69abba2f52$export$598e9af52cb9b904 = $401d24d35b6b69df$export$598e9af52cb9b904;
$14ef1a69abba2f52$export$35784e2518402c99 = $401d24d35b6b69df$export$35784e2518402c99;
$14ef1a69abba2f52$export$352e2c1d24776bfb = $401d24d35b6b69df$export$352e2c1d24776bfb;
$14ef1a69abba2f52$export$3c52dd84024ae72c = $401d24d35b6b69df$export$3c52dd84024ae72c;
$14ef1a69abba2f52$export$6902610076fb2dc1 = $96eb8038f2b3ef39$export$6902610076fb2dc1;
$14ef1a69abba2f52$export$5bf4b3d0861be8d9 = $96eb8038f2b3ef39$export$5bf4b3d0861be8d9;
$14ef1a69abba2f52$export$349fae4425f20458 = $96eb8038f2b3ef39$export$349fae4425f20458;
$14ef1a69abba2f52$export$1cf8ac3f090cf48a = $96eb8038f2b3ef39$export$1cf8ac3f090cf48a;
$14ef1a69abba2f52$export$e314ae15c0f41984 = $96eb8038f2b3ef39$export$e314ae15c0f41984;
$14ef1a69abba2f52$export$b817115b8219186a = $96eb8038f2b3ef39$export$b817115b8219186a;
$14ef1a69abba2f52$export$5ed93187f4ce070a = $96eb8038f2b3ef39$export$5ed93187f4ce070a;
$14ef1a69abba2f52$export$e9aed36b506f417c = $96eb8038f2b3ef39$export$e9aed36b506f417c;
$14ef1a69abba2f52$export$5bd0595948d7ed9 = $96eb8038f2b3ef39$export$5bd0595948d7ed9;
$14ef1a69abba2f52$export$c4eb8307a0331d71 = $96eb8038f2b3ef39$export$c4eb8307a0331d71;
$14ef1a69abba2f52$export$2e282c3c0c638f20 = $96eb8038f2b3ef39$export$2e282c3c0c638f20;
$14ef1a69abba2f52$export$a5f6079b5a0c262e = $9730c97b105b5f1f$exports;
$14ef1a69abba2f52$export$a1e9ec249d80652c = $9a577b8cb9f70475$export$a1e9ec249d80652c;
$14ef1a69abba2f52$export$b55edb69cfa7ac57 = $88761db79c6a77c6$export$b55edb69cfa7ac57;
$14ef1a69abba2f52$export$660b2ee2d4fb4eff = $14ef1a69abba2f52$var$tokenize;


var $c805037aeb82e0c4$export$88a1156fad04455f;
'use strict';
var $22e84e429477a95a$export$54c2e3dc7acea9f5;
'use strict';
//
//                              list
//                            ┌──────┐
//             ┌──────────────┼─head │
//             │              │ tail─┼──────────────┐
//             │              └──────┘              │
//             ▼                                    ▼
//            item        item        item        item
//          ┌──────┐    ┌──────┐    ┌──────┐    ┌──────┐
//  null ◀──┼─prev │◀───┼─prev │◀───┼─prev │◀───┼─prev │
//          │ next─┼───▶│ next─┼───▶│ next─┼───▶│ next─┼──▶ null
//          ├──────┤    ├──────┤    ├──────┤    ├──────┤
//          │ data │    │ data │    │ data │    │ data │
//          └──────┘    └──────┘    └──────┘    └──────┘
//
let $22e84e429477a95a$var$releasedCursors = null;
class $22e84e429477a95a$var$List {
    static createItem(data) {
        return {
            prev: null,
            next: null,
            data: data
        };
    }
    createItem(data) {
        return $22e84e429477a95a$var$List.createItem(data);
    }
    // cursor helpers
    allocateCursor(prev, next) {
        let cursor;
        if ($22e84e429477a95a$var$releasedCursors !== null) {
            cursor = $22e84e429477a95a$var$releasedCursors;
            $22e84e429477a95a$var$releasedCursors = $22e84e429477a95a$var$releasedCursors.cursor;
            cursor.prev = prev;
            cursor.next = next;
            cursor.cursor = this.cursor;
        } else cursor = {
            prev: prev,
            next: next,
            cursor: this.cursor
        };
        this.cursor = cursor;
        return cursor;
    }
    releaseCursor() {
        const { cursor: cursor } = this;
        this.cursor = cursor.cursor;
        cursor.prev = null;
        cursor.next = null;
        cursor.cursor = $22e84e429477a95a$var$releasedCursors;
        $22e84e429477a95a$var$releasedCursors = cursor;
    }
    updateCursors(prevOld, prevNew, nextOld, nextNew) {
        let { cursor: cursor } = this;
        while(cursor !== null){
            if (cursor.prev === prevOld) cursor.prev = prevNew;
            if (cursor.next === nextOld) cursor.next = nextNew;
            cursor = cursor.cursor;
        }
    }
    *[Symbol.iterator]() {
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)yield cursor.data;
    }
    // getters
    get size() {
        let size = 0;
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)size++;
        return size;
    }
    get isEmpty() {
        return this.head === null;
    }
    get first() {
        return this.head && this.head.data;
    }
    get last() {
        return this.tail && this.tail.data;
    }
    // convertors
    fromArray(array) {
        let cursor = null;
        this.head = null;
        for (let data of array){
            const item = $22e84e429477a95a$var$List.createItem(data);
            if (cursor !== null) cursor.next = item;
            else this.head = item;
            item.prev = cursor;
            cursor = item;
        }
        this.tail = cursor;
        return this;
    }
    toArray() {
        return [
            ...this
        ];
    }
    toJSON() {
        return [
            ...this
        ];
    }
    // array-like methods
    forEach(fn, thisArg = this) {
        // push cursor
        const cursor = this.allocateCursor(null, this.head);
        while(cursor.next !== null){
            const item = cursor.next;
            cursor.next = item.next;
            fn.call(thisArg, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
    }
    forEachRight(fn, thisArg = this) {
        // push cursor
        const cursor = this.allocateCursor(this.tail, null);
        while(cursor.prev !== null){
            const item = cursor.prev;
            cursor.prev = item.prev;
            fn.call(thisArg, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
    }
    reduce(fn, initialValue, thisArg = this) {
        // push cursor
        let cursor = this.allocateCursor(null, this.head);
        let acc = initialValue;
        let item;
        while(cursor.next !== null){
            item = cursor.next;
            cursor.next = item.next;
            acc = fn.call(thisArg, acc, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
        return acc;
    }
    reduceRight(fn, initialValue, thisArg = this) {
        // push cursor
        let cursor = this.allocateCursor(this.tail, null);
        let acc = initialValue;
        let item;
        while(cursor.prev !== null){
            item = cursor.prev;
            cursor.prev = item.prev;
            acc = fn.call(thisArg, acc, item.data, item, this);
        }
        // pop cursor
        this.releaseCursor();
        return acc;
    }
    some(fn, thisArg = this) {
        for(let cursor = this.head; cursor !== null; cursor = cursor.next){
            if (fn.call(thisArg, cursor.data, cursor, this)) return true;
        }
        return false;
    }
    map(fn, thisArg = this) {
        const result = new $22e84e429477a95a$var$List();
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)result.appendData(fn.call(thisArg, cursor.data, cursor, this));
        return result;
    }
    filter(fn, thisArg = this) {
        const result = new $22e84e429477a95a$var$List();
        for(let cursor = this.head; cursor !== null; cursor = cursor.next)if (fn.call(thisArg, cursor.data, cursor, this)) result.appendData(cursor.data);
        return result;
    }
    nextUntil(start, fn, thisArg = this) {
        if (start === null) return;
        // push cursor
        const cursor = this.allocateCursor(null, start);
        while(cursor.next !== null){
            const item = cursor.next;
            cursor.next = item.next;
            if (fn.call(thisArg, item.data, item, this)) break;
        }
        // pop cursor
        this.releaseCursor();
    }
    prevUntil(start, fn, thisArg = this) {
        if (start === null) return;
        // push cursor
        const cursor = this.allocateCursor(start, null);
        while(cursor.prev !== null){
            const item = cursor.prev;
            cursor.prev = item.prev;
            if (fn.call(thisArg, item.data, item, this)) break;
        }
        // pop cursor
        this.releaseCursor();
    }
    // mutation
    clear() {
        this.head = null;
        this.tail = null;
    }
    copy() {
        const result = new $22e84e429477a95a$var$List();
        for (let data of this)result.appendData(data);
        return result;
    }
    prepend(item) {
        //      head
        //    ^
        // item
        this.updateCursors(null, item, this.head, item);
        // insert to the beginning of the list
        if (this.head !== null) {
            // new item <- first item
            this.head.prev = item;
            // new item -> first item
            item.next = this.head;
        } else // if list has no head, then it also has no tail
        // in this case tail points to the new item
        this.tail = item;
        // head always points to new item
        this.head = item;
        return this;
    }
    prependData(data) {
        return this.prepend($22e84e429477a95a$var$List.createItem(data));
    }
    append(item) {
        return this.insert(item);
    }
    appendData(data) {
        return this.insert($22e84e429477a95a$var$List.createItem(data));
    }
    insert(item, before = null) {
        if (before !== null) {
            // prev   before
            //      ^
            //     item
            this.updateCursors(before.prev, item, before, item);
            if (before.prev === null) {
                // insert to the beginning of list
                if (this.head !== before) throw new Error('before doesn\'t belong to list');
                // since head points to before therefore list doesn't empty
                // no need to check tail
                this.head = item;
                before.prev = item;
                item.next = before;
                this.updateCursors(null, item);
            } else {
                // insert between two items
                before.prev.next = item;
                item.prev = before.prev;
                before.prev = item;
                item.next = before;
            }
        } else {
            // tail
            //      ^
            //      item
            this.updateCursors(this.tail, item, null, item);
            // insert to the ending of the list
            if (this.tail !== null) {
                // last item -> new item
                this.tail.next = item;
                // last item <- new item
                item.prev = this.tail;
            } else // if list has no tail, then it also has no head
            // in this case head points to new item
            this.head = item;
            // tail always points to new item
            this.tail = item;
        }
        return this;
    }
    insertData(data, before) {
        return this.insert($22e84e429477a95a$var$List.createItem(data), before);
    }
    remove(item) {
        //      item
        //       ^
        // prev     next
        this.updateCursors(item, item.prev, item, item.next);
        if (item.prev !== null) item.prev.next = item.next;
        else {
            if (this.head !== item) throw new Error('item doesn\'t belong to list');
            this.head = item.next;
        }
        if (item.next !== null) item.next.prev = item.prev;
        else {
            if (this.tail !== item) throw new Error('item doesn\'t belong to list');
            this.tail = item.prev;
        }
        item.prev = null;
        item.next = null;
        return item;
    }
    push(data) {
        this.insert($22e84e429477a95a$var$List.createItem(data));
    }
    pop() {
        return this.tail !== null ? this.remove(this.tail) : null;
    }
    unshift(data) {
        this.prepend($22e84e429477a95a$var$List.createItem(data));
    }
    shift() {
        return this.head !== null ? this.remove(this.head) : null;
    }
    prependList(list) {
        return this.insertList(list, this.head);
    }
    appendList(list) {
        return this.insertList(list);
    }
    insertList(list, before) {
        // ignore empty lists
        if (list.head === null) return this;
        if (before !== undefined && before !== null) {
            this.updateCursors(before.prev, list.tail, before, list.head);
            // insert in the middle of dist list
            if (before.prev !== null) {
                // before.prev <-> list.head
                before.prev.next = list.head;
                list.head.prev = before.prev;
            } else this.head = list.head;
            before.prev = list.tail;
            list.tail.next = before;
        } else {
            this.updateCursors(this.tail, list.tail, null, list.head);
            // insert to end of the list
            if (this.tail !== null) {
                // if destination list has a tail, then it also has a head,
                // but head doesn't change
                // dest tail -> source head
                this.tail.next = list.head;
                // dest tail <- source head
                list.head.prev = this.tail;
            } else // if list has no a tail, then it also has no a head
            // in this case points head to new item
            this.head = list.head;
            // tail always start point to new item
            this.tail = list.tail;
        }
        list.head = null;
        list.tail = null;
        return this;
    }
    replace(oldItem, newItemOrList) {
        if ('head' in newItemOrList) this.insertList(newItemOrList, oldItem);
        else this.insert(newItemOrList, oldItem);
        this.remove(oldItem);
    }
    constructor(){
        this.head = null;
        this.tail = null;
        this.cursor = null;
    }
}
$22e84e429477a95a$export$54c2e3dc7acea9f5 = $22e84e429477a95a$var$List;


var $7bcccf9978dd5aa6$export$f21cea08b0dd60e8;
'use strict';
var $fc5d5637c2ee7573$export$435492119a21bab3;
'use strict';
function $fc5d5637c2ee7573$var$createCustomError(name, message) {
    // use Object.create(), because some VMs prevent setting line/column otherwise
    // (iOS Safari 10 even throws an exception)
    const error = Object.create(SyntaxError.prototype);
    const errorStack = new Error();
    return Object.assign(error, {
        name: name,
        message: message,
        get stack () {
            return (errorStack.stack || '').replace(/^(.+\n){1,3}/, `${name}: ${message}\n`);
        }
    });
}
$fc5d5637c2ee7573$export$435492119a21bab3 = $fc5d5637c2ee7573$var$createCustomError;


const $7bcccf9978dd5aa6$var$MAX_LINE_LENGTH = 100;
const $7bcccf9978dd5aa6$var$OFFSET_CORRECTION = 60;
const $7bcccf9978dd5aa6$var$TAB_REPLACEMENT = '    ';
function $7bcccf9978dd5aa6$var$sourceFragment({ source: source, line: line, column: column }, extraLines) {
    function processLines(start, end) {
        return lines.slice(start, end).map((line, idx)=>String(start + idx + 1).padStart(maxNumLength) + ' |' + line).join('\n');
    }
    const lines = source.split(/\r\n?|\n|\f/);
    const startLine = Math.max(1, line - extraLines) - 1;
    const endLine = Math.min(line + extraLines, lines.length + 1);
    const maxNumLength = Math.max(4, String(endLine).length) + 1;
    let cutLeft = 0;
    // column correction according to replaced tab before column
    column += ($7bcccf9978dd5aa6$var$TAB_REPLACEMENT.length - 1) * (lines[line - 1].substr(0, column - 1).match(/\t/g) || []).length;
    if (column > $7bcccf9978dd5aa6$var$MAX_LINE_LENGTH) {
        cutLeft = column - $7bcccf9978dd5aa6$var$OFFSET_CORRECTION + 3;
        column = $7bcccf9978dd5aa6$var$OFFSET_CORRECTION - 2;
    }
    for(let i = startLine; i <= endLine; i++)if (i >= 0 && i < lines.length) {
        lines[i] = lines[i].replace(/\t/g, $7bcccf9978dd5aa6$var$TAB_REPLACEMENT);
        lines[i] = (cutLeft > 0 && lines[i].length > cutLeft ? '\u2026' : '') + lines[i].substr(cutLeft, $7bcccf9978dd5aa6$var$MAX_LINE_LENGTH - 2) + (lines[i].length > cutLeft + $7bcccf9978dd5aa6$var$MAX_LINE_LENGTH - 1 ? '\u2026' : '');
    }
    return [
        processLines(startLine, line),
        new Array(column + maxNumLength + 2).join('-') + '^',
        processLines(line, endLine)
    ].filter(Boolean).join('\n');
}
function $7bcccf9978dd5aa6$var$SyntaxError(message, source, offset, line, column) {
    const error = Object.assign($fc5d5637c2ee7573$export$435492119a21bab3('SyntaxError', message), {
        source: source,
        offset: offset,
        line: line,
        column: column,
        sourceFragment (extraLines) {
            return $7bcccf9978dd5aa6$var$sourceFragment({
                source: source,
                line: line,
                column: column
            }, isNaN(extraLines) ? 0 : extraLines);
        },
        get formattedMessage () {
            return `Parse error: ${message}\n` + $7bcccf9978dd5aa6$var$sourceFragment({
                source: source,
                line: line,
                column: column
            }, 2);
        }
    });
    return error;
}
$7bcccf9978dd5aa6$export$f21cea08b0dd60e8 = $7bcccf9978dd5aa6$var$SyntaxError;



var $5e26ca7028be7418$export$edc1450f8a1049b2;
'use strict';

function $5e26ca7028be7418$var$readSequence(recognizer) {
    const children = this.createList();
    let space = false;
    const context = {
        recognizer: recognizer
    };
    while(!this.eof){
        switch(this.tokenType){
            case $926ff4544e512db5$export$4d299b491347818a:
                this.next();
                continue;
            case $926ff4544e512db5$export$fb98946286ab4c97:
                space = true;
                this.next();
                continue;
        }
        let child = recognizer.getNode.call(this, context);
        if (child === undefined) break;
        if (space) {
            if (recognizer.onWhiteSpace) recognizer.onWhiteSpace.call(this, child, children, context);
            space = false;
        }
        children.push(child);
    }
    if (space && recognizer.onWhiteSpace) recognizer.onWhiteSpace.call(this, null, children, context);
    return children;
}
$5e26ca7028be7418$export$edc1450f8a1049b2 = $5e26ca7028be7418$var$readSequence;







const $c805037aeb82e0c4$var$NOOP = ()=>{};
const $c805037aeb82e0c4$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
const $c805037aeb82e0c4$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $c805037aeb82e0c4$var$SEMICOLON = 0x003B; // U+003B SEMICOLON (;)
const $c805037aeb82e0c4$var$LEFTCURLYBRACKET = 0x007B; // U+007B LEFT CURLY BRACKET ({)
const $c805037aeb82e0c4$var$NULL = 0;
function $c805037aeb82e0c4$var$createParseContext(name) {
    return function() {
        return this[name]();
    };
}
function $c805037aeb82e0c4$var$fetchParseValues(dict) {
    const result = Object.create(null);
    for(const name in dict){
        const item = dict[name];
        const fn = item.parse || item;
        if (fn) result[name] = fn;
    }
    return result;
}
function $c805037aeb82e0c4$var$processConfig(config) {
    const parseConfig = {
        context: Object.create(null),
        scope: Object.assign(Object.create(null), config.scope),
        atrule: $c805037aeb82e0c4$var$fetchParseValues(config.atrule),
        pseudo: $c805037aeb82e0c4$var$fetchParseValues(config.pseudo),
        node: $c805037aeb82e0c4$var$fetchParseValues(config.node)
    };
    for(const name in config.parseContext)switch(typeof config.parseContext[name]){
        case 'function':
            parseConfig.context[name] = config.parseContext[name];
            break;
        case 'string':
            parseConfig.context[name] = $c805037aeb82e0c4$var$createParseContext(config.parseContext[name]);
            break;
    }
    return {
        config: parseConfig,
        ...parseConfig,
        ...parseConfig.node
    };
}
function $c805037aeb82e0c4$var$createParser(config) {
    let source = '';
    let filename = '<unknown>';
    let needPositions = false;
    let onParseError = $c805037aeb82e0c4$var$NOOP;
    let onParseErrorThrow = false;
    const locationMap = new $9a577b8cb9f70475$export$a1e9ec249d80652c();
    const parser = Object.assign(new $88761db79c6a77c6$export$b55edb69cfa7ac57(), $c805037aeb82e0c4$var$processConfig(config || {}), {
        parseAtrulePrelude: true,
        parseRulePrelude: true,
        parseValue: true,
        parseCustomProperty: false,
        readSequence: $5e26ca7028be7418$export$edc1450f8a1049b2,
        consumeUntilBalanceEnd: ()=>0,
        consumeUntilLeftCurlyBracket (code) {
            return code === $c805037aeb82e0c4$var$LEFTCURLYBRACKET ? 1 : 0;
        },
        consumeUntilLeftCurlyBracketOrSemicolon (code) {
            return code === $c805037aeb82e0c4$var$LEFTCURLYBRACKET || code === $c805037aeb82e0c4$var$SEMICOLON ? 1 : 0;
        },
        consumeUntilExclamationMarkOrSemicolon (code) {
            return code === $c805037aeb82e0c4$var$EXCLAMATIONMARK || code === $c805037aeb82e0c4$var$SEMICOLON ? 1 : 0;
        },
        consumeUntilSemicolonIncluded (code) {
            return code === $c805037aeb82e0c4$var$SEMICOLON ? 2 : 0;
        },
        createList () {
            return new $22e84e429477a95a$export$54c2e3dc7acea9f5();
        },
        createSingleNodeList (node) {
            return new $22e84e429477a95a$export$54c2e3dc7acea9f5().appendData(node);
        },
        getFirstListNode (list) {
            return list && list.first;
        },
        getLastListNode (list) {
            return list && list.last;
        },
        parseWithFallback (consumer, fallback) {
            const startToken = this.tokenIndex;
            try {
                return consumer.call(this);
            } catch (e) {
                if (onParseErrorThrow) throw e;
                const fallbackNode = fallback.call(this, startToken);
                onParseErrorThrow = true;
                onParseError(e, fallbackNode);
                onParseErrorThrow = false;
                return fallbackNode;
            }
        },
        lookupNonWSType (offset) {
            let type;
            do {
                type = this.lookupType(offset++);
                if (type !== $926ff4544e512db5$export$fb98946286ab4c97) return type;
            }while (type !== $c805037aeb82e0c4$var$NULL);
            return $c805037aeb82e0c4$var$NULL;
        },
        charCodeAt (offset) {
            return offset >= 0 && offset < source.length ? source.charCodeAt(offset) : 0;
        },
        substring (offsetStart, offsetEnd) {
            return source.substring(offsetStart, offsetEnd);
        },
        substrToCursor (start) {
            return this.source.substring(start, this.tokenStart);
        },
        cmpChar (offset, charCode) {
            return $96eb8038f2b3ef39$export$6902610076fb2dc1(source, offset, charCode);
        },
        cmpStr (offsetStart, offsetEnd, str) {
            return $96eb8038f2b3ef39$export$5bf4b3d0861be8d9(source, offsetStart, offsetEnd, str);
        },
        consume (tokenType) {
            const start = this.tokenStart;
            this.eat(tokenType);
            return this.substrToCursor(start);
        },
        consumeFunctionName () {
            const name = source.substring(this.tokenStart, this.tokenEnd - 1);
            this.eat($926ff4544e512db5$export$f3890eeaf6851387);
            return name;
        },
        consumeNumber (type) {
            const number = source.substring(this.tokenStart, $96eb8038f2b3ef39$export$b817115b8219186a(source, this.tokenStart));
            this.eat(type);
            return number;
        },
        eat (tokenType) {
            if (this.tokenType !== tokenType) {
                const tokenName = $9730c97b105b5f1f$exports[tokenType].slice(0, -6).replace(/-/g, ' ').replace(/^./, (m)=>m.toUpperCase());
                let message = `${/[[\](){}]/.test(tokenName) ? `"${tokenName}"` : tokenName} is expected`;
                let offset = this.tokenStart;
                // tweak message and offset
                switch(tokenType){
                    case $926ff4544e512db5$export$331e9b6bdecaac5f:
                        // when identifier is expected but there is a function or url
                        if (this.tokenType === $926ff4544e512db5$export$f3890eeaf6851387 || this.tokenType === $926ff4544e512db5$export$59d795186a5d3f58) {
                            offset = this.tokenEnd - 1;
                            message = 'Identifier is expected but function found';
                        } else message = 'Identifier is expected';
                        break;
                    case $926ff4544e512db5$export$ab85ecd77ce6a5cd:
                        if (this.isDelim($c805037aeb82e0c4$var$NUMBERSIGN)) {
                            this.next();
                            offset++;
                            message = 'Name is expected';
                        }
                        break;
                    case $926ff4544e512db5$export$d11913f8a6922aea:
                        if (this.tokenType === $926ff4544e512db5$export$fffa67e515d04022) {
                            offset = this.tokenEnd;
                            message = 'Percent sign is expected';
                        }
                        break;
                }
                this.error(message, offset);
            }
            this.next();
        },
        eatIdent (name) {
            if (this.tokenType !== $926ff4544e512db5$export$331e9b6bdecaac5f || this.lookupValue(0, name) === false) this.error(`Identifier "${name}" is expected`);
            this.next();
        },
        eatDelim (code) {
            if (!this.isDelim(code)) this.error(`Delim "${String.fromCharCode(code)}" is expected`);
            this.next();
        },
        getLocation (start, end) {
            if (needPositions) return locationMap.getLocationRange(start, end, filename);
            return null;
        },
        getLocationFromList (list) {
            if (needPositions) {
                const head = this.getFirstListNode(list);
                const tail = this.getLastListNode(list);
                return locationMap.getLocationRange(head !== null ? head.loc.start.offset - locationMap.startOffset : this.tokenStart, tail !== null ? tail.loc.end.offset - locationMap.startOffset : this.tokenStart, filename);
            }
            return null;
        },
        error (message, offset) {
            const location = typeof offset !== 'undefined' && offset < source.length ? locationMap.getLocation(offset) : this.eof ? locationMap.getLocation($96eb8038f2b3ef39$export$c4eb8307a0331d71(source, source.length - 1)) : locationMap.getLocation(this.tokenStart);
            throw new $7bcccf9978dd5aa6$export$f21cea08b0dd60e8(message || 'Unexpected input', source, location.offset, location.line, location.column);
        }
    });
    const parse = function(source_, options) {
        source = source_;
        options = options || {};
        parser.setSource(source, $14ef1a69abba2f52$export$660b2ee2d4fb4eff);
        locationMap.setSource(source, options.offset, options.line, options.column);
        filename = options.filename || '<unknown>';
        needPositions = Boolean(options.positions);
        onParseError = typeof options.onParseError === 'function' ? options.onParseError : $c805037aeb82e0c4$var$NOOP;
        onParseErrorThrow = false;
        parser.parseAtrulePrelude = 'parseAtrulePrelude' in options ? Boolean(options.parseAtrulePrelude) : true;
        parser.parseRulePrelude = 'parseRulePrelude' in options ? Boolean(options.parseRulePrelude) : true;
        parser.parseValue = 'parseValue' in options ? Boolean(options.parseValue) : true;
        parser.parseCustomProperty = 'parseCustomProperty' in options ? Boolean(options.parseCustomProperty) : false;
        const { context: context = 'default', onComment: onComment } = options;
        if (context in parser.context === false) throw new Error('Unknown context `' + context + '`');
        if (typeof onComment === 'function') parser.forEachToken((type, start, end)=>{
            if (type === $926ff4544e512db5$export$4d299b491347818a) {
                const loc = parser.getLocation(start, end);
                const value = $96eb8038f2b3ef39$export$5bf4b3d0861be8d9(source, end - 2, end, '*/') ? source.slice(start + 2, end - 2) : source.slice(start + 2, end);
                onComment(value, loc);
            }
        });
        const ast = parser.context[context].call(parser, options);
        if (!parser.eof) parser.error();
        return ast;
    };
    return Object.assign(parse, {
        SyntaxError: $7bcccf9978dd5aa6$export$f21cea08b0dd60e8,
        config: parser.config
    });
}
$c805037aeb82e0c4$export$88a1156fad04455f = $c805037aeb82e0c4$var$createParser;


var $fbf1b8636f63a752$export$881f0ad61271ba2;
'use strict';

var $7c87a6be4635dee5$export$36066a35e0efbb1e;
'use strict';
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $c20ea93a0cb84999$export$4d99f7c30e854ff;
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $7ce86df5cc021bed$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $7ce86df5cc021bed$export$2f872c0f2117be69;
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $8ea9ffab7bc8e601$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $8ea9ffab7bc8e601$export$2f872c0f2117be69;
var $8ea9ffab7bc8e601$var$intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
$8ea9ffab7bc8e601$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $8ea9ffab7bc8e601$var$intToCharMap.length) return $8ea9ffab7bc8e601$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$8ea9ffab7bc8e601$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};


// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $7ce86df5cc021bed$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $7ce86df5cc021bed$var$VLQ_BASE = 1 << $7ce86df5cc021bed$var$VLQ_BASE_SHIFT;
// binary: 011111
var $7ce86df5cc021bed$var$VLQ_BASE_MASK = $7ce86df5cc021bed$var$VLQ_BASE - 1;
// binary: 100000
var $7ce86df5cc021bed$var$VLQ_CONTINUATION_BIT = $7ce86df5cc021bed$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $7ce86df5cc021bed$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $7ce86df5cc021bed$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$7ce86df5cc021bed$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $7ce86df5cc021bed$var$toVLQSigned(aValue);
    do {
        digit = vlq & $7ce86df5cc021bed$var$VLQ_BASE_MASK;
        vlq >>>= $7ce86df5cc021bed$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $7ce86df5cc021bed$var$VLQ_CONTINUATION_BIT;
        encoded += $8ea9ffab7bc8e601$export$c564cdbbe6da493(digit);
    }while (vlq > 0);
    return encoded;
};
$7ce86df5cc021bed$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $8ea9ffab7bc8e601$export$2f872c0f2117be69(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $7ce86df5cc021bed$var$VLQ_CONTINUATION_BIT);
        digit &= $7ce86df5cc021bed$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $7ce86df5cc021bed$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $7ce86df5cc021bed$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};



var $bbu3f = parcelRequire("bbu3f");

/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $1df19f1180ff0ecc$export$605bbf5ea7b60ba3;



var $1df19f1180ff0ecc$var$has = Object.prototype.hasOwnProperty;
var $1df19f1180ff0ecc$var$hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $1df19f1180ff0ecc$var$ArraySet() {
    this._array = [];
    this._set = $1df19f1180ff0ecc$var$hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $1df19f1180ff0ecc$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $1df19f1180ff0ecc$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $1df19f1180ff0ecc$var$ArraySet.prototype.size = function ArraySet_size() {
    return $1df19f1180ff0ecc$var$hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $1df19f1180ff0ecc$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $1df19f1180ff0ecc$var$hasNativeMap ? aStr : $bbu3f.toSetString(aStr);
    var isDuplicate = $1df19f1180ff0ecc$var$hasNativeMap ? this.has(aStr) : $1df19f1180ff0ecc$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) {
        if ($1df19f1180ff0ecc$var$hasNativeMap) this._set.set(aStr, idx);
        else this._set[sStr] = idx;
    }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $1df19f1180ff0ecc$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    if ($1df19f1180ff0ecc$var$hasNativeMap) return this._set.has(aStr);
    else {
        var sStr = $bbu3f.toSetString(aStr);
        return $1df19f1180ff0ecc$var$has.call(this._set, sStr);
    }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $1df19f1180ff0ecc$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    if ($1df19f1180ff0ecc$var$hasNativeMap) {
        var idx = this._set.get(aStr);
        if (idx >= 0) return idx;
    } else {
        var sStr = $bbu3f.toSetString(aStr);
        if ($1df19f1180ff0ecc$var$has.call(this._set, sStr)) return this._set[sStr];
    }
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $1df19f1180ff0ecc$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error('No element indexed by ' + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $1df19f1180ff0ecc$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$1df19f1180ff0ecc$export$605bbf5ea7b60ba3 = $1df19f1180ff0ecc$var$ArraySet;


var $c20ea93a0cb84999$require$ArraySet = $1df19f1180ff0ecc$export$605bbf5ea7b60ba3;
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $9c52995ff0e98d77$export$e82e0908843dd951;



/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */ function $9c52995ff0e98d77$var$generatedPositionAfter(mappingA, mappingB) {
    // Optimized for most common case
    var lineA = mappingA.generatedLine;
    var lineB = mappingB.generatedLine;
    var columnA = mappingA.generatedColumn;
    var columnB = mappingB.generatedColumn;
    return lineB > lineA || lineB == lineA && columnB >= columnA || $bbu3f.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */ function $9c52995ff0e98d77$var$MappingList() {
    this._array = [];
    this._sorted = true;
    // Serves as infimum
    this._last = {
        generatedLine: -1,
        generatedColumn: 0
    };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */ $9c52995ff0e98d77$var$MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */ $9c52995ff0e98d77$var$MappingList.prototype.add = function MappingList_add(aMapping) {
    if ($9c52995ff0e98d77$var$generatedPositionAfter(this._last, aMapping)) {
        this._last = aMapping;
        this._array.push(aMapping);
    } else {
        this._sorted = false;
        this._array.push(aMapping);
    }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */ $9c52995ff0e98d77$var$MappingList.prototype.toArray = function MappingList_toArray() {
    if (!this._sorted) {
        this._array.sort($bbu3f.compareByGeneratedPositionsInflated);
        this._sorted = true;
    }
    return this._array;
};
$9c52995ff0e98d77$export$e82e0908843dd951 = $9c52995ff0e98d77$var$MappingList;


var $c20ea93a0cb84999$require$MappingList = $9c52995ff0e98d77$export$e82e0908843dd951;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */ function $c20ea93a0cb84999$var$SourceMapGenerator(aArgs) {
    if (!aArgs) aArgs = {};
    this._file = $bbu3f.getArg(aArgs, 'file', null);
    this._sourceRoot = $bbu3f.getArg(aArgs, 'sourceRoot', null);
    this._skipValidation = $bbu3f.getArg(aArgs, 'skipValidation', false);
    this._ignoreInvalidMapping = $bbu3f.getArg(aArgs, 'ignoreInvalidMapping', false);
    this._sources = new $c20ea93a0cb84999$require$ArraySet();
    this._names = new $c20ea93a0cb84999$require$ArraySet();
    this._mappings = new $c20ea93a0cb84999$require$MappingList();
    this._sourcesContents = null;
}
$c20ea93a0cb84999$var$SourceMapGenerator.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */ $c20ea93a0cb84999$var$SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer, generatorOps) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new $c20ea93a0cb84999$var$SourceMapGenerator(Object.assign(generatorOps || {}, {
        file: aSourceMapConsumer.file,
        sourceRoot: sourceRoot
    }));
    aSourceMapConsumer.eachMapping(function(mapping) {
        var newMapping = {
            generated: {
                line: mapping.generatedLine,
                column: mapping.generatedColumn
            }
        };
        if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) newMapping.source = $bbu3f.relative(sourceRoot, newMapping.source);
            newMapping.original = {
                line: mapping.originalLine,
                column: mapping.originalColumn
            };
            if (mapping.name != null) newMapping.name = mapping.name;
        }
        generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var sourceRelative = sourceFile;
        if (sourceRoot !== null) sourceRelative = $bbu3f.relative(sourceRoot, sourceFile);
        if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) generator.setSourceContent(sourceFile, content);
    });
    return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */ $c20ea93a0cb84999$var$SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
    var generated = $bbu3f.getArg(aArgs, 'generated');
    var original = $bbu3f.getArg(aArgs, 'original', null);
    var source = $bbu3f.getArg(aArgs, 'source', null);
    var name = $bbu3f.getArg(aArgs, 'name', null);
    if (!this._skipValidation) {
        if (this._validateMapping(generated, original, source, name) === false) return;
    }
    if (source != null) {
        source = String(source);
        if (!this._sources.has(source)) this._sources.add(source);
    }
    if (name != null) {
        name = String(name);
        if (!this._names.has(name)) this._names.add(name);
    }
    this._mappings.add({
        generatedLine: generated.line,
        generatedColumn: generated.column,
        originalLine: original != null && original.line,
        originalColumn: original != null && original.column,
        source: source,
        name: name
    });
};
/**
 * Set the source content for a source file.
 */ $c20ea93a0cb84999$var$SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) source = $bbu3f.relative(this._sourceRoot, source);
    if (aSourceContent != null) {
        // Add the source content to the _sourcesContents map.
        // Create a new _sourcesContents map if the property is null.
        if (!this._sourcesContents) this._sourcesContents = Object.create(null);
        this._sourcesContents[$bbu3f.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
        // Remove the source file from the _sourcesContents map.
        // If the _sourcesContents map is empty, set the property to null.
        delete this._sourcesContents[$bbu3f.toSetString(source)];
        if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
    }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */ $c20ea93a0cb84999$var$SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
        if (aSourceMapConsumer.file == null) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
        sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) sourceFile = $bbu3f.relative(sourceRoot, sourceFile);
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new $c20ea93a0cb84999$require$ArraySet();
    var newNames = new $c20ea93a0cb84999$require$ArraySet();
    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function(mapping) {
        if (mapping.source === sourceFile && mapping.originalLine != null) {
            // Check if it can be mapped by the source map, then update the mapping.
            var original = aSourceMapConsumer.originalPositionFor({
                line: mapping.originalLine,
                column: mapping.originalColumn
            });
            if (original.source != null) {
                // Copy mapping
                mapping.source = original.source;
                if (aSourceMapPath != null) mapping.source = $bbu3f.join(aSourceMapPath, mapping.source);
                if (sourceRoot != null) mapping.source = $bbu3f.relative(sourceRoot, mapping.source);
                mapping.originalLine = original.line;
                mapping.originalColumn = original.column;
                if (original.name != null) mapping.name = original.name;
            }
        }
        var source = mapping.source;
        if (source != null && !newSources.has(source)) newSources.add(source);
        var name = mapping.name;
        if (name != null && !newNames.has(name)) newNames.add(name);
    }, this);
    this._sources = newSources;
    this._names = newNames;
    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aSourceMapPath != null) sourceFile = $bbu3f.join(aSourceMapPath, sourceFile);
            if (sourceRoot != null) sourceFile = $bbu3f.relative(sourceRoot, sourceFile);
            this.setSourceContent(sourceFile, content);
        }
    }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */ $c20ea93a0cb84999$var$SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
        var message = "original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.";
        if (this._ignoreInvalidMapping) {
            if (typeof console !== 'undefined' && console.warn) console.warn(message);
            return false;
        } else throw new Error(message);
    }
    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) // Case 1.
    return;
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aOriginal && 'line' in aOriginal && 'column' in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) // Cases 2 and 3.
    return;
    else {
        var message = 'Invalid mapping: ' + JSON.stringify({
            generated: aGenerated,
            source: aSource,
            original: aOriginal,
            name: aName
        });
        if (this._ignoreInvalidMapping) {
            if (typeof console !== 'undefined' && console.warn) console.warn(message);
            return false;
        } else throw new Error(message);
    }
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */ $c20ea93a0cb84999$var$SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;
    var mappings = this._mappings.toArray();
    for(var i = 0, len = mappings.length; i < len; i++){
        mapping = mappings[i];
        next = '';
        if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while(mapping.generatedLine !== previousGeneratedLine){
                next += ';';
                previousGeneratedLine++;
            }
        } else if (i > 0) {
            if (!$bbu3f.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) continue;
            next += ',';
        }
        next += $7ce86df5cc021bed$export$c564cdbbe6da493(mapping.generatedColumn - previousGeneratedColumn);
        previousGeneratedColumn = mapping.generatedColumn;
        if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += $7ce86df5cc021bed$export$c564cdbbe6da493(sourceIdx - previousSource);
            previousSource = sourceIdx;
            // lines are stored 0-based in SourceMap spec version 3
            next += $7ce86df5cc021bed$export$c564cdbbe6da493(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += $7ce86df5cc021bed$export$c564cdbbe6da493(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
                nameIdx = this._names.indexOf(mapping.name);
                next += $7ce86df5cc021bed$export$c564cdbbe6da493(nameIdx - previousName);
                previousName = nameIdx;
            }
        }
        result += next;
    }
    return result;
};
$c20ea93a0cb84999$var$SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function(source) {
        if (!this._sourcesContents) return null;
        if (aSourceRoot != null) source = $bbu3f.relative(aSourceRoot, source);
        var key = $bbu3f.toSetString(source);
        return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
    }, this);
};
/**
 * Externalize the source map.
 */ $c20ea93a0cb84999$var$SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
    var map = {
        version: this._version,
        sources: this._sources.toArray(),
        names: this._names.toArray(),
        mappings: this._serializeMappings()
    };
    if (this._file != null) map.file = this._file;
    if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
    if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    return map;
};
/**
 * Render the source map being generated to a string.
 */ $c20ea93a0cb84999$var$SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
};
$c20ea93a0cb84999$export$4d99f7c30e854ff = $c20ea93a0cb84999$var$SourceMapGenerator;


const $7c87a6be4635dee5$var$trackNodes = new Set([
    'Atrule',
    'Selector',
    'Declaration'
]);
function $7c87a6be4635dee5$var$generateSourceMap(handlers) {
    const map = new $c20ea93a0cb84999$export$4d99f7c30e854ff();
    const generated = {
        line: 1,
        column: 0
    };
    const original = {
        line: 0,
        column: 0
    };
    const activatedGenerated = {
        line: 1,
        column: 0
    };
    const activatedMapping = {
        generated: activatedGenerated
    };
    let line = 1;
    let column = 0;
    let sourceMappingActive = false;
    const origHandlersNode = handlers.node;
    handlers.node = function(node) {
        if (node.loc && node.loc.start && $7c87a6be4635dee5$var$trackNodes.has(node.type)) {
            const nodeLine = node.loc.start.line;
            const nodeColumn = node.loc.start.column - 1;
            if (original.line !== nodeLine || original.column !== nodeColumn) {
                original.line = nodeLine;
                original.column = nodeColumn;
                generated.line = line;
                generated.column = column;
                if (sourceMappingActive) {
                    sourceMappingActive = false;
                    if (generated.line !== activatedGenerated.line || generated.column !== activatedGenerated.column) map.addMapping(activatedMapping);
                }
                sourceMappingActive = true;
                map.addMapping({
                    source: node.loc.source,
                    original: original,
                    generated: generated
                });
            }
        }
        origHandlersNode.call(this, node);
        if (sourceMappingActive && $7c87a6be4635dee5$var$trackNodes.has(node.type)) {
            activatedGenerated.line = line;
            activatedGenerated.column = column;
        }
    };
    const origHandlersEmit = handlers.emit;
    handlers.emit = function(value, type, auto) {
        for(let i = 0; i < value.length; i++)if (value.charCodeAt(i) === 10) {
            line++;
            column = 0;
        } else column++;
        origHandlersEmit(value, type, auto);
    };
    const origHandlersResult = handlers.result;
    handlers.result = function() {
        if (sourceMappingActive) map.addMapping(activatedMapping);
        return {
            css: origHandlersResult(),
            map: map
        };
    };
    return handlers;
}
$7c87a6be4635dee5$export$36066a35e0efbb1e = $7c87a6be4635dee5$var$generateSourceMap;


var $5ba9c1f82edf78e2$exports = {};
$parcel$export($5ba9c1f82edf78e2$exports, "safe", () => $5ba9c1f82edf78e2$export$170b8c323eee7bec, (v) => $5ba9c1f82edf78e2$export$170b8c323eee7bec = v);
$parcel$export($5ba9c1f82edf78e2$exports, "spec", () => $5ba9c1f82edf78e2$export$a40e83dd9f9a97c8, (v) => $5ba9c1f82edf78e2$export$a40e83dd9f9a97c8 = v);
var $5ba9c1f82edf78e2$export$170b8c323eee7bec;
var $5ba9c1f82edf78e2$export$a40e83dd9f9a97c8;
'use strict';

const $5ba9c1f82edf78e2$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $5ba9c1f82edf78e2$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $5ba9c1f82edf78e2$var$code = (type, value)=>{
    if (type === $926ff4544e512db5$export$a918ca49ff4337a3) type = value;
    if (typeof type === 'string') {
        const charCode = type.charCodeAt(0);
        return charCode > 0x7F ? 0x8000 : charCode << 8;
    }
    return type;
};
// https://www.w3.org/TR/css-syntax-3/#serialization
// The only requirement for serialization is that it must "round-trip" with parsing,
// that is, parsing the stylesheet must produce the same data structures as parsing,
// serializing, and parsing again, except for consecutive <whitespace-token>s,
// which may be collapsed into a single token.
const $5ba9c1f82edf78e2$var$specPairs = [
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$59d795186a5d3f58
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$f8b4878501aa4a62
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        '-'
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$b0b2bd2d1777c179
    ],
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$b5a25f132cb53de6
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$59d795186a5d3f58
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$f8b4878501aa4a62
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        '-'
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$b0b2bd2d1777c179
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$59d795186a5d3f58
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$f8b4878501aa4a62
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        '-'
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$b0b2bd2d1777c179
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$59d795186a5d3f58
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$f8b4878501aa4a62
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        '-'
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$b0b2bd2d1777c179
    ],
    [
        '#',
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        '#',
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        '#',
        $926ff4544e512db5$export$59d795186a5d3f58
    ],
    [
        '#',
        $926ff4544e512db5$export$f8b4878501aa4a62
    ],
    [
        '#',
        '-'
    ],
    [
        '#',
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        '#',
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        '#',
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        '#',
        $926ff4544e512db5$export$b0b2bd2d1777c179
    ],
    [
        '-',
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        '-',
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        '-',
        $926ff4544e512db5$export$59d795186a5d3f58
    ],
    [
        '-',
        $926ff4544e512db5$export$f8b4878501aa4a62
    ],
    [
        '-',
        '-'
    ],
    [
        '-',
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        '-',
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        '-',
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        '-',
        $926ff4544e512db5$export$b0b2bd2d1777c179
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        $926ff4544e512db5$export$59d795186a5d3f58
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        $926ff4544e512db5$export$f8b4878501aa4a62
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        '%'
    ],
    [
        $926ff4544e512db5$export$fffa67e515d04022,
        $926ff4544e512db5$export$b0b2bd2d1777c179
    ],
    [
        '@',
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        '@',
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        '@',
        $926ff4544e512db5$export$59d795186a5d3f58
    ],
    [
        '@',
        $926ff4544e512db5$export$f8b4878501aa4a62
    ],
    [
        '@',
        '-'
    ],
    [
        '@',
        $926ff4544e512db5$export$b0b2bd2d1777c179
    ],
    [
        '.',
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        '.',
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        '.',
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        '+',
        $926ff4544e512db5$export$fffa67e515d04022
    ],
    [
        '+',
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        '+',
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        '/',
        '*'
    ]
];
// validate with scripts/generate-safe
const $5ba9c1f82edf78e2$var$safePairs = $5ba9c1f82edf78e2$var$specPairs.concat([
    [
        $926ff4544e512db5$export$331e9b6bdecaac5f,
        $926ff4544e512db5$export$ab85ecd77ce6a5cd
    ],
    [
        $926ff4544e512db5$export$c940ece961bc43c6,
        $926ff4544e512db5$export$ab85ecd77ce6a5cd
    ],
    [
        $926ff4544e512db5$export$ab85ecd77ce6a5cd,
        $926ff4544e512db5$export$ab85ecd77ce6a5cd
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$b5a25f132cb53de6
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$89b8e0fa65f6a914
    ],
    [
        $926ff4544e512db5$export$21bfcb60d1b5ccac,
        $926ff4544e512db5$export$e20ebb298016f6
    ],
    [
        $926ff4544e512db5$export$d11913f8a6922aea,
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        $926ff4544e512db5$export$d11913f8a6922aea,
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        $926ff4544e512db5$export$d11913f8a6922aea,
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        $926ff4544e512db5$export$d11913f8a6922aea,
        '-'
    ],
    [
        $926ff4544e512db5$export$773d33972c6279ed,
        $926ff4544e512db5$export$331e9b6bdecaac5f
    ],
    [
        $926ff4544e512db5$export$773d33972c6279ed,
        $926ff4544e512db5$export$f3890eeaf6851387
    ],
    [
        $926ff4544e512db5$export$773d33972c6279ed,
        $926ff4544e512db5$export$d11913f8a6922aea
    ],
    [
        $926ff4544e512db5$export$773d33972c6279ed,
        $926ff4544e512db5$export$c940ece961bc43c6
    ],
    [
        $926ff4544e512db5$export$773d33972c6279ed,
        $926ff4544e512db5$export$ab85ecd77ce6a5cd
    ],
    [
        $926ff4544e512db5$export$773d33972c6279ed,
        '-'
    ]
]);
function $5ba9c1f82edf78e2$var$createMap(pairs) {
    const isWhiteSpaceRequired = new Set(pairs.map(([prev, next])=>$5ba9c1f82edf78e2$var$code(prev) << 16 | $5ba9c1f82edf78e2$var$code(next)));
    return function(prevCode, type, value) {
        const nextCode = $5ba9c1f82edf78e2$var$code(type, value);
        const nextCharCode = value.charCodeAt(0);
        const emitWs = nextCharCode === $5ba9c1f82edf78e2$var$HYPHENMINUS && type !== $926ff4544e512db5$export$331e9b6bdecaac5f && type !== $926ff4544e512db5$export$f3890eeaf6851387 && type !== $926ff4544e512db5$export$b0b2bd2d1777c179 || nextCharCode === $5ba9c1f82edf78e2$var$PLUSSIGN ? isWhiteSpaceRequired.has(prevCode << 16 | nextCharCode << 8) : isWhiteSpaceRequired.has(prevCode << 16 | nextCode);
        if (emitWs) this.emit(' ', $926ff4544e512db5$export$fb98946286ab4c97, true);
        return nextCode;
    };
}
const $5ba9c1f82edf78e2$var$spec = $5ba9c1f82edf78e2$var$createMap($5ba9c1f82edf78e2$var$specPairs);
const $5ba9c1f82edf78e2$var$safe = $5ba9c1f82edf78e2$var$createMap($5ba9c1f82edf78e2$var$safePairs);
$5ba9c1f82edf78e2$export$170b8c323eee7bec = $5ba9c1f82edf78e2$var$safe;
$5ba9c1f82edf78e2$export$a40e83dd9f9a97c8 = $5ba9c1f82edf78e2$var$spec;



const $fbf1b8636f63a752$var$REVERSESOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
function $fbf1b8636f63a752$var$processChildren(node, delimeter) {
    if (typeof delimeter === 'function') {
        let prev = null;
        node.children.forEach((node)=>{
            if (prev !== null) delimeter.call(this, prev);
            this.node(node);
            prev = node;
        });
        return;
    }
    node.children.forEach(this.node, this);
}
function $fbf1b8636f63a752$var$processChunk(chunk) {
    $14ef1a69abba2f52$export$660b2ee2d4fb4eff(chunk, (type, start, end)=>{
        this.token(type, chunk.slice(start, end));
    });
}
function $fbf1b8636f63a752$var$createGenerator(config) {
    const types$1 = new Map();
    for(let name in config.node){
        const item = config.node[name];
        const fn = item.generate || item;
        if (typeof fn === 'function') types$1.set(name, item.generate || item);
    }
    return function(node, options) {
        let buffer = '';
        let prevCode = 0;
        let handlers = {
            node (node) {
                if (types$1.has(node.type)) types$1.get(node.type).call(publicApi, node);
                else throw new Error('Unknown node type: ' + node.type);
            },
            tokenBefore: $5ba9c1f82edf78e2$exports.safe,
            token (type, value) {
                prevCode = this.tokenBefore(prevCode, type, value);
                this.emit(value, type, false);
                if (type === $926ff4544e512db5$export$a918ca49ff4337a3 && value.charCodeAt(0) === $fbf1b8636f63a752$var$REVERSESOLIDUS) this.emit('\n', $926ff4544e512db5$export$fb98946286ab4c97, true);
            },
            emit (value) {
                buffer += value;
            },
            result () {
                return buffer;
            }
        };
        if (options) {
            if (typeof options.decorator === 'function') handlers = options.decorator(handlers);
            if (options.sourceMap) handlers = $7c87a6be4635dee5$export$36066a35e0efbb1e(handlers);
            if (options.mode in $5ba9c1f82edf78e2$exports) handlers.tokenBefore = $5ba9c1f82edf78e2$exports[options.mode];
        }
        const publicApi = {
            node: (node)=>handlers.node(node),
            children: $fbf1b8636f63a752$var$processChildren,
            token: (type, value)=>handlers.token(type, value),
            tokenize: $fbf1b8636f63a752$var$processChunk
        };
        handlers.node(node);
        return handlers.result();
    };
}
$fbf1b8636f63a752$export$881f0ad61271ba2 = $fbf1b8636f63a752$var$createGenerator;


var $ed05eff50bb2deab$export$270c35c9c0b7b1f9;
'use strict';

function $ed05eff50bb2deab$var$createConvertor(walk) {
    return {
        fromPlainObject (ast) {
            walk(ast, {
                enter (node) {
                    if (node.children && node.children instanceof $22e84e429477a95a$export$54c2e3dc7acea9f5 === false) node.children = new $22e84e429477a95a$export$54c2e3dc7acea9f5().fromArray(node.children);
                }
            });
            return ast;
        },
        toPlainObject (ast) {
            walk(ast, {
                leave (node) {
                    if (node.children && node.children instanceof $22e84e429477a95a$export$54c2e3dc7acea9f5) node.children = node.children.toArray();
                }
            });
            return ast;
        }
    };
}
$ed05eff50bb2deab$export$270c35c9c0b7b1f9 = $ed05eff50bb2deab$var$createConvertor;


var $7dfc4fbfb5b2b3ed$export$774c92c6aec941e8;
'use strict';
const { hasOwnProperty: $7dfc4fbfb5b2b3ed$var$hasOwnProperty } = Object.prototype;
const $7dfc4fbfb5b2b3ed$var$noop = function() {};
function $7dfc4fbfb5b2b3ed$var$ensureFunction(value) {
    return typeof value === 'function' ? value : $7dfc4fbfb5b2b3ed$var$noop;
}
function $7dfc4fbfb5b2b3ed$var$invokeForType(fn, type) {
    return function(node, item, list) {
        if (node.type === type) fn.call(this, node, item, list);
    };
}
function $7dfc4fbfb5b2b3ed$var$getWalkersFromStructure(name, nodeType) {
    const structure = nodeType.structure;
    const walkers = [];
    for(const key in structure){
        if ($7dfc4fbfb5b2b3ed$var$hasOwnProperty.call(structure, key) === false) continue;
        let fieldTypes = structure[key];
        const walker = {
            name: key,
            type: false,
            nullable: false
        };
        if (!Array.isArray(fieldTypes)) fieldTypes = [
            fieldTypes
        ];
        for (const fieldType of fieldTypes){
            if (fieldType === null) walker.nullable = true;
            else if (typeof fieldType === 'string') walker.type = 'node';
            else if (Array.isArray(fieldType)) walker.type = 'list';
        }
        if (walker.type) walkers.push(walker);
    }
    if (walkers.length) return {
        context: nodeType.walkContext,
        fields: walkers
    };
    return null;
}
function $7dfc4fbfb5b2b3ed$var$getTypesFromConfig(config) {
    const types = {};
    for(const name in config.node)if ($7dfc4fbfb5b2b3ed$var$hasOwnProperty.call(config.node, name)) {
        const nodeType = config.node[name];
        if (!nodeType.structure) throw new Error('Missed `structure` field in `' + name + '` node type definition');
        types[name] = $7dfc4fbfb5b2b3ed$var$getWalkersFromStructure(name, nodeType);
    }
    return types;
}
function $7dfc4fbfb5b2b3ed$var$createTypeIterator(config, reverse) {
    const fields = config.fields.slice();
    const contextName = config.context;
    const useContext = typeof contextName === 'string';
    if (reverse) fields.reverse();
    return function(node, context, walk, walkReducer) {
        let prevContextValue;
        if (useContext) {
            prevContextValue = context[contextName];
            context[contextName] = node;
        }
        for (const field of fields){
            const ref = node[field.name];
            if (!field.nullable || ref) {
                if (field.type === 'list') {
                    const breakWalk = reverse ? ref.reduceRight(walkReducer, false) : ref.reduce(walkReducer, false);
                    if (breakWalk) return true;
                } else if (walk(ref)) return true;
            }
        }
        if (useContext) context[contextName] = prevContextValue;
    };
}
function $7dfc4fbfb5b2b3ed$var$createFastTraveralMap({ StyleSheet: StyleSheet, Atrule: Atrule, Rule: Rule, Block: Block, DeclarationList: DeclarationList }) {
    return {
        Atrule: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block
        },
        Rule: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block
        },
        Declaration: {
            StyleSheet: StyleSheet,
            Atrule: Atrule,
            Rule: Rule,
            Block: Block,
            DeclarationList: DeclarationList
        }
    };
}
function $7dfc4fbfb5b2b3ed$var$createWalker(config) {
    const types = $7dfc4fbfb5b2b3ed$var$getTypesFromConfig(config);
    const iteratorsNatural = {};
    const iteratorsReverse = {};
    const breakWalk = Symbol('break-walk');
    const skipNode = Symbol('skip-node');
    for(const name in types)if ($7dfc4fbfb5b2b3ed$var$hasOwnProperty.call(types, name) && types[name] !== null) {
        iteratorsNatural[name] = $7dfc4fbfb5b2b3ed$var$createTypeIterator(types[name], false);
        iteratorsReverse[name] = $7dfc4fbfb5b2b3ed$var$createTypeIterator(types[name], true);
    }
    const fastTraversalIteratorsNatural = $7dfc4fbfb5b2b3ed$var$createFastTraveralMap(iteratorsNatural);
    const fastTraversalIteratorsReverse = $7dfc4fbfb5b2b3ed$var$createFastTraveralMap(iteratorsReverse);
    const walk = function(root, options) {
        function walkNode(node, item, list) {
            const enterRet = enter.call(context, node, item, list);
            if (enterRet === breakWalk) return true;
            if (enterRet === skipNode) return false;
            if (iterators.hasOwnProperty(node.type)) {
                if (iterators[node.type](node, context, walkNode, walkReducer)) return true;
            }
            if (leave.call(context, node, item, list) === breakWalk) return true;
            return false;
        }
        let enter = $7dfc4fbfb5b2b3ed$var$noop;
        let leave = $7dfc4fbfb5b2b3ed$var$noop;
        let iterators = iteratorsNatural;
        let walkReducer = (ret, data, item, list)=>ret || walkNode(data, item, list);
        const context = {
            break: breakWalk,
            skip: skipNode,
            root: root,
            stylesheet: null,
            atrule: null,
            atrulePrelude: null,
            rule: null,
            selector: null,
            block: null,
            declaration: null,
            function: null
        };
        if (typeof options === 'function') enter = options;
        else if (options) {
            enter = $7dfc4fbfb5b2b3ed$var$ensureFunction(options.enter);
            leave = $7dfc4fbfb5b2b3ed$var$ensureFunction(options.leave);
            if (options.reverse) iterators = iteratorsReverse;
            if (options.visit) {
                if (fastTraversalIteratorsNatural.hasOwnProperty(options.visit)) iterators = options.reverse ? fastTraversalIteratorsReverse[options.visit] : fastTraversalIteratorsNatural[options.visit];
                else if (!types.hasOwnProperty(options.visit)) throw new Error('Bad value `' + options.visit + '` for `visit` option (should be: ' + Object.keys(types).sort().join(', ') + ')');
                enter = $7dfc4fbfb5b2b3ed$var$invokeForType(enter, options.visit);
                leave = $7dfc4fbfb5b2b3ed$var$invokeForType(leave, options.visit);
            }
        }
        if (enter === $7dfc4fbfb5b2b3ed$var$noop && leave === $7dfc4fbfb5b2b3ed$var$noop) throw new Error('Neither `enter` nor `leave` walker handler is set or both aren\'t a function');
        walkNode(root);
    };
    walk.break = breakWalk;
    walk.skip = skipNode;
    walk.find = function(ast, fn) {
        let found = null;
        walk(ast, function(node, item, list) {
            if (fn.call(this, node, item, list)) {
                found = node;
                return breakWalk;
            }
        });
        return found;
    };
    walk.findLast = function(ast, fn) {
        let found = null;
        walk(ast, {
            reverse: true,
            enter (node, item, list) {
                if (fn.call(this, node, item, list)) {
                    found = node;
                    return breakWalk;
                }
            }
        });
        return found;
    };
    walk.findAll = function(ast, fn) {
        const found = [];
        walk(ast, function(node, item, list) {
            if (fn.call(this, node, item, list)) found.push(node);
        });
        return found;
    };
    return walk;
}
$7dfc4fbfb5b2b3ed$export$774c92c6aec941e8 = $7dfc4fbfb5b2b3ed$var$createWalker;


var $60f3ad1b8871cde1$export$6168dc8908a6c652;
'use strict';
var $d73ec4ef9b8bacfc$export$c937494ee8e9606d;
var $d73ec4ef9b8bacfc$export$65d073607b1def2;
'use strict';

var $98e942a2f6e618f5$export$80d376111cc09ad7;
'use strict';
function $98e942a2f6e618f5$var$noop(value) {
    return value;
}
function $98e942a2f6e618f5$var$generateMultiplier(multiplier) {
    const { min: min, max: max, comma: comma } = multiplier;
    if (min === 0 && max === 0) return comma ? '#?' : '*';
    if (min === 0 && max === 1) return '?';
    if (min === 1 && max === 0) return comma ? '#' : '+';
    if (min === 1 && max === 1) return '';
    return (comma ? '#' : '') + (min === max ? '{' + min + '}' : '{' + min + ',' + (max !== 0 ? max : '') + '}');
}
function $98e942a2f6e618f5$var$generateTypeOpts(node) {
    switch(node.type){
        case 'Range':
            return ' [' + (node.min === null ? "-\u221E" : node.min) + ',' + (node.max === null ? "\u221E" : node.max) + ']';
        default:
            throw new Error('Unknown node type `' + node.type + '`');
    }
}
function $98e942a2f6e618f5$var$generateSequence(node, decorate, forceBraces, compact) {
    const combinator = node.combinator === ' ' || compact ? node.combinator : ' ' + node.combinator + ' ';
    const result = node.terms.map((term)=>$98e942a2f6e618f5$var$internalGenerate(term, decorate, forceBraces, compact)).join(combinator);
    if (node.explicit || forceBraces) return (compact || result[0] === ',' ? '[' : '[ ') + result + (compact ? ']' : ' ]');
    return result;
}
function $98e942a2f6e618f5$var$internalGenerate(node, decorate, forceBraces, compact) {
    let result;
    switch(node.type){
        case 'Group':
            result = $98e942a2f6e618f5$var$generateSequence(node, decorate, forceBraces, compact) + (node.disallowEmpty ? '!' : '');
            break;
        case 'Multiplier':
            // return since node is a composition
            return $98e942a2f6e618f5$var$internalGenerate(node.term, decorate, forceBraces, compact) + decorate($98e942a2f6e618f5$var$generateMultiplier(node), node);
        case 'Type':
            result = '<' + node.name + (node.opts ? decorate($98e942a2f6e618f5$var$generateTypeOpts(node.opts), node.opts) : '') + '>';
            break;
        case 'Property':
            result = '<\'' + node.name + '\'>';
            break;
        case 'Keyword':
            result = node.name;
            break;
        case 'AtKeyword':
            result = '@' + node.name;
            break;
        case 'Function':
            result = node.name + '(';
            break;
        case 'String':
        case 'Token':
            result = node.value;
            break;
        case 'Comma':
            result = ',';
            break;
        default:
            throw new Error('Unknown node type `' + node.type + '`');
    }
    return decorate(result, node);
}
function $98e942a2f6e618f5$var$generate(node, options) {
    let decorate = $98e942a2f6e618f5$var$noop;
    let forceBraces = false;
    let compact = false;
    if (typeof options === 'function') decorate = options;
    else if (options) {
        forceBraces = Boolean(options.forceBraces);
        compact = Boolean(options.compact);
        if (typeof options.decorate === 'function') decorate = options.decorate;
    }
    return $98e942a2f6e618f5$var$internalGenerate(node, decorate, forceBraces, compact);
}
$98e942a2f6e618f5$export$80d376111cc09ad7 = $98e942a2f6e618f5$var$generate;


const $d73ec4ef9b8bacfc$var$defaultLoc = {
    offset: 0,
    line: 1,
    column: 1
};
function $d73ec4ef9b8bacfc$var$locateMismatch(matchResult, node) {
    const tokens = matchResult.tokens;
    const longestMatch = matchResult.longestMatch;
    const mismatchNode = longestMatch < tokens.length ? tokens[longestMatch].node || null : null;
    const badNode = mismatchNode !== node ? mismatchNode : null;
    let mismatchOffset = 0;
    let mismatchLength = 0;
    let entries = 0;
    let css = '';
    let start;
    let end;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i].value;
        if (i === longestMatch) {
            mismatchLength = token.length;
            mismatchOffset = css.length;
        }
        if (badNode !== null && tokens[i].node === badNode) {
            if (i <= longestMatch) entries++;
            else entries = 0;
        }
        css += token;
    }
    if (longestMatch === tokens.length || entries > 1) {
        start = $d73ec4ef9b8bacfc$var$fromLoc(badNode || node, 'end') || $d73ec4ef9b8bacfc$var$buildLoc($d73ec4ef9b8bacfc$var$defaultLoc, css);
        end = $d73ec4ef9b8bacfc$var$buildLoc(start);
    } else {
        start = $d73ec4ef9b8bacfc$var$fromLoc(badNode, 'start') || $d73ec4ef9b8bacfc$var$buildLoc($d73ec4ef9b8bacfc$var$fromLoc(node, 'start') || $d73ec4ef9b8bacfc$var$defaultLoc, css.slice(0, mismatchOffset));
        end = $d73ec4ef9b8bacfc$var$fromLoc(badNode, 'end') || $d73ec4ef9b8bacfc$var$buildLoc(start, css.substr(mismatchOffset, mismatchLength));
    }
    return {
        css: css,
        mismatchOffset: mismatchOffset,
        mismatchLength: mismatchLength,
        start: start,
        end: end
    };
}
function $d73ec4ef9b8bacfc$var$fromLoc(node, point) {
    const value = node && node.loc && node.loc[point];
    if (value) return 'line' in value ? $d73ec4ef9b8bacfc$var$buildLoc(value) : value;
    return null;
}
function $d73ec4ef9b8bacfc$var$buildLoc({ offset: offset, line: line, column: column }, extra) {
    const loc = {
        offset: offset,
        line: line,
        column: column
    };
    if (extra) {
        const lines = extra.split(/\n|\r\n?|\f/);
        loc.offset += extra.length;
        loc.line += lines.length - 1;
        loc.column = lines.length === 1 ? loc.column + extra.length : lines.pop().length + 1;
    }
    return loc;
}
const $d73ec4ef9b8bacfc$var$SyntaxReferenceError = function(type, referenceName) {
    const error = $fc5d5637c2ee7573$export$435492119a21bab3('SyntaxReferenceError', type + (referenceName ? ' `' + referenceName + '`' : ''));
    error.reference = referenceName;
    return error;
};
const $d73ec4ef9b8bacfc$var$SyntaxMatchError = function(message, syntax, node, matchResult) {
    const error = $fc5d5637c2ee7573$export$435492119a21bab3('SyntaxMatchError', message);
    const { css: css, mismatchOffset: mismatchOffset, mismatchLength: mismatchLength, start: start, end: end } = $d73ec4ef9b8bacfc$var$locateMismatch(matchResult, node);
    error.rawMessage = message;
    error.syntax = syntax ? $98e942a2f6e618f5$export$80d376111cc09ad7(syntax) : '<generic>';
    error.css = css;
    error.mismatchOffset = mismatchOffset;
    error.mismatchLength = mismatchLength;
    error.message = message + '\n' + '  syntax: ' + error.syntax + '\n' + '   value: ' + (css || '<empty string>') + '\n' + '  --------' + new Array(error.mismatchOffset + 1).join('-') + '^';
    Object.assign(error, start);
    error.loc = {
        source: node && node.loc && node.loc.source || '<unknown>',
        start: start,
        end: end
    };
    return error;
};
$d73ec4ef9b8bacfc$export$c937494ee8e9606d = $d73ec4ef9b8bacfc$var$SyntaxMatchError;
$d73ec4ef9b8bacfc$export$65d073607b1def2 = $d73ec4ef9b8bacfc$var$SyntaxReferenceError;


var $ffbc3ade873552d0$export$15cf667f7f91c461;
var $ffbc3ade873552d0$export$2e81050496d0e63e;
var $ffbc3ade873552d0$export$d541bacb2bda4494;
var $ffbc3ade873552d0$export$5150dd39c4b2a5da;
'use strict';
const $ffbc3ade873552d0$var$keywords = new Map();
const $ffbc3ade873552d0$var$properties = new Map();
const $ffbc3ade873552d0$var$HYPHENMINUS = 45; // '-'.charCodeAt()
const $ffbc3ade873552d0$var$keyword = $ffbc3ade873552d0$var$getKeywordDescriptor;
const $ffbc3ade873552d0$var$property = $ffbc3ade873552d0$var$getPropertyDescriptor;
const $ffbc3ade873552d0$var$vendorPrefix = $ffbc3ade873552d0$var$getVendorPrefix;
function $ffbc3ade873552d0$var$isCustomProperty(str, offset) {
    offset = offset || 0;
    return str.length - offset >= 2 && str.charCodeAt(offset) === $ffbc3ade873552d0$var$HYPHENMINUS && str.charCodeAt(offset + 1) === $ffbc3ade873552d0$var$HYPHENMINUS;
}
function $ffbc3ade873552d0$var$getVendorPrefix(str, offset) {
    offset = offset || 0;
    // verdor prefix should be at least 3 chars length
    if (str.length - offset >= 3) // vendor prefix starts with hyper minus following non-hyper minus
    {
        if (str.charCodeAt(offset) === $ffbc3ade873552d0$var$HYPHENMINUS && str.charCodeAt(offset + 1) !== $ffbc3ade873552d0$var$HYPHENMINUS) {
            // vendor prefix should contain a hyper minus at the ending
            const secondDashIndex = str.indexOf('-', offset + 2);
            if (secondDashIndex !== -1) return str.substring(offset, secondDashIndex + 1);
        }
    }
    return '';
}
function $ffbc3ade873552d0$var$getKeywordDescriptor(keyword) {
    if ($ffbc3ade873552d0$var$keywords.has(keyword)) return $ffbc3ade873552d0$var$keywords.get(keyword);
    const name = keyword.toLowerCase();
    let descriptor = $ffbc3ade873552d0$var$keywords.get(name);
    if (descriptor === undefined) {
        const custom = $ffbc3ade873552d0$var$isCustomProperty(name, 0);
        const vendor = !custom ? $ffbc3ade873552d0$var$getVendorPrefix(name, 0) : '';
        descriptor = Object.freeze({
            basename: name.substr(vendor.length),
            name: name,
            prefix: vendor,
            vendor: vendor,
            custom: custom
        });
    }
    $ffbc3ade873552d0$var$keywords.set(keyword, descriptor);
    return descriptor;
}
function $ffbc3ade873552d0$var$getPropertyDescriptor(property) {
    if ($ffbc3ade873552d0$var$properties.has(property)) return $ffbc3ade873552d0$var$properties.get(property);
    let name = property;
    let hack = property[0];
    if (hack === '/') hack = property[1] === '/' ? '//' : '/';
    else if (hack !== '_' && hack !== '*' && hack !== '$' && hack !== '#' && hack !== '+' && hack !== '&') hack = '';
    const custom = $ffbc3ade873552d0$var$isCustomProperty(name, hack.length);
    // re-use result when possible (the same as for lower case)
    if (!custom) {
        name = name.toLowerCase();
        if ($ffbc3ade873552d0$var$properties.has(name)) {
            const descriptor = $ffbc3ade873552d0$var$properties.get(name);
            $ffbc3ade873552d0$var$properties.set(property, descriptor);
            return descriptor;
        }
    }
    const vendor = !custom ? $ffbc3ade873552d0$var$getVendorPrefix(name, hack.length) : '';
    const prefix = name.substr(0, hack.length + vendor.length);
    const descriptor = Object.freeze({
        basename: name.substr(prefix.length),
        name: name.substr(hack.length),
        hack: hack,
        vendor: vendor,
        prefix: prefix,
        custom: custom
    });
    $ffbc3ade873552d0$var$properties.set(property, descriptor);
    return descriptor;
}
$ffbc3ade873552d0$export$15cf667f7f91c461 = $ffbc3ade873552d0$var$isCustomProperty;
$ffbc3ade873552d0$export$2e81050496d0e63e = $ffbc3ade873552d0$var$keyword;
$ffbc3ade873552d0$export$d541bacb2bda4494 = $ffbc3ade873552d0$var$property;
$ffbc3ade873552d0$export$5150dd39c4b2a5da = $ffbc3ade873552d0$var$vendorPrefix;


var $3027806af112199f$export$b3191e0d9e666e2c;
'use strict';
// https://drafts.csswg.org/css-cascade-5/
const $3027806af112199f$var$cssWideKeywords = [
    'initial',
    'inherit',
    'unset',
    'revert',
    'revert-layer'
];
$3027806af112199f$export$b3191e0d9e666e2c = $3027806af112199f$var$cssWideKeywords;


var $6970b5016679ff56$exports = {};
'use strict';

var $ae00e13d3afe0eb2$exports = {};
'use strict';



const $ae00e13d3afe0eb2$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $ae00e13d3afe0eb2$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $ae00e13d3afe0eb2$var$N = 0x006E; // U+006E LATIN SMALL LETTER N (n)
const $ae00e13d3afe0eb2$var$DISALLOW_SIGN = true;
const $ae00e13d3afe0eb2$var$ALLOW_SIGN = false;
function $ae00e13d3afe0eb2$var$isDelim(token, code) {
    return token !== null && token.type === $926ff4544e512db5$export$a918ca49ff4337a3 && token.value.charCodeAt(0) === code;
}
function $ae00e13d3afe0eb2$var$skipSC(token, offset, getNextToken) {
    while(token !== null && (token.type === $926ff4544e512db5$export$fb98946286ab4c97 || token.type === $926ff4544e512db5$export$4d299b491347818a))token = getNextToken(++offset);
    return offset;
}
function $ae00e13d3afe0eb2$var$checkInteger(token, valueOffset, disallowSign, offset) {
    if (!token) return 0;
    const code = token.value.charCodeAt(valueOffset);
    if (code === $ae00e13d3afe0eb2$var$PLUSSIGN || code === $ae00e13d3afe0eb2$var$HYPHENMINUS) {
        if (disallowSign) // Number sign is not allowed
        return 0;
        valueOffset++;
    }
    for(; valueOffset < token.value.length; valueOffset++){
        if (!$401d24d35b6b69df$export$727d9dbc4fbb948f(token.value.charCodeAt(valueOffset))) // Integer is expected
        return 0;
    }
    return offset + 1;
}
// ... <signed-integer>
// ... ['+' | '-'] <signless-integer>
function $ae00e13d3afe0eb2$var$consumeB(token, offset_, getNextToken) {
    let sign = false;
    let offset = $ae00e13d3afe0eb2$var$skipSC(token, offset_, getNextToken);
    token = getNextToken(offset);
    if (token === null) return offset_;
    if (token.type !== $926ff4544e512db5$export$fffa67e515d04022) {
        if ($ae00e13d3afe0eb2$var$isDelim(token, $ae00e13d3afe0eb2$var$PLUSSIGN) || $ae00e13d3afe0eb2$var$isDelim(token, $ae00e13d3afe0eb2$var$HYPHENMINUS)) {
            sign = true;
            offset = $ae00e13d3afe0eb2$var$skipSC(getNextToken(++offset), offset, getNextToken);
            token = getNextToken(offset);
            if (token === null || token.type !== $926ff4544e512db5$export$fffa67e515d04022) return 0;
        } else return offset_;
    }
    if (!sign) {
        const code = token.value.charCodeAt(0);
        if (code !== $ae00e13d3afe0eb2$var$PLUSSIGN && code !== $ae00e13d3afe0eb2$var$HYPHENMINUS) // Number sign is expected
        return 0;
    }
    return $ae00e13d3afe0eb2$var$checkInteger(token, sign ? 0 : 1, sign, offset);
}
// An+B microsyntax https://www.w3.org/TR/css-syntax-3/#anb
function $ae00e13d3afe0eb2$var$anPlusB(token, getNextToken) {
    /* eslint-disable brace-style*/ let offset = 0;
    if (!token) return 0;
    // <integer>
    if (token.type === $926ff4544e512db5$export$fffa67e515d04022) return $ae00e13d3afe0eb2$var$checkInteger(token, 0, $ae00e13d3afe0eb2$var$ALLOW_SIGN, offset); // b
    else if (token.type === $926ff4544e512db5$export$331e9b6bdecaac5f && token.value.charCodeAt(0) === $ae00e13d3afe0eb2$var$HYPHENMINUS) {
        // expect 1st char is N
        if (!$96eb8038f2b3ef39$export$6902610076fb2dc1(token.value, 1, $ae00e13d3afe0eb2$var$N)) return 0;
        switch(token.value.length){
            // -n
            // -n <signed-integer>
            // -n ['+' | '-'] <signless-integer>
            case 2:
                return $ae00e13d3afe0eb2$var$consumeB(getNextToken(++offset), offset, getNextToken);
            // -n- <signless-integer>
            case 3:
                if (token.value.charCodeAt(2) !== $ae00e13d3afe0eb2$var$HYPHENMINUS) return 0;
                offset = $ae00e13d3afe0eb2$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $ae00e13d3afe0eb2$var$checkInteger(token, 0, $ae00e13d3afe0eb2$var$DISALLOW_SIGN, offset);
            // <dashndashdigit-ident>
            default:
                if (token.value.charCodeAt(2) !== $ae00e13d3afe0eb2$var$HYPHENMINUS) return 0;
                return $ae00e13d3afe0eb2$var$checkInteger(token, 3, $ae00e13d3afe0eb2$var$DISALLOW_SIGN, offset);
        }
    } else if (token.type === $926ff4544e512db5$export$331e9b6bdecaac5f || $ae00e13d3afe0eb2$var$isDelim(token, $ae00e13d3afe0eb2$var$PLUSSIGN) && getNextToken(offset + 1).type === $926ff4544e512db5$export$331e9b6bdecaac5f) {
        // just ignore a plus
        if (token.type !== $926ff4544e512db5$export$331e9b6bdecaac5f) token = getNextToken(++offset);
        if (token === null || !$96eb8038f2b3ef39$export$6902610076fb2dc1(token.value, 0, $ae00e13d3afe0eb2$var$N)) return 0;
        switch(token.value.length){
            // '+'? n
            // '+'? n <signed-integer>
            // '+'? n ['+' | '-'] <signless-integer>
            case 1:
                return $ae00e13d3afe0eb2$var$consumeB(getNextToken(++offset), offset, getNextToken);
            // '+'? n- <signless-integer>
            case 2:
                if (token.value.charCodeAt(1) !== $ae00e13d3afe0eb2$var$HYPHENMINUS) return 0;
                offset = $ae00e13d3afe0eb2$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $ae00e13d3afe0eb2$var$checkInteger(token, 0, $ae00e13d3afe0eb2$var$DISALLOW_SIGN, offset);
            // '+'? <ndashdigit-ident>
            default:
                if (token.value.charCodeAt(1) !== $ae00e13d3afe0eb2$var$HYPHENMINUS) return 0;
                return $ae00e13d3afe0eb2$var$checkInteger(token, 2, $ae00e13d3afe0eb2$var$DISALLOW_SIGN, offset);
        }
    } else if (token.type === $926ff4544e512db5$export$c940ece961bc43c6) {
        let code = token.value.charCodeAt(0);
        let sign = code === $ae00e13d3afe0eb2$var$PLUSSIGN || code === $ae00e13d3afe0eb2$var$HYPHENMINUS ? 1 : 0;
        let i = sign;
        for(; i < token.value.length; i++){
            if (!$401d24d35b6b69df$export$727d9dbc4fbb948f(token.value.charCodeAt(i))) break;
        }
        if (i === sign) // Integer is expected
        return 0;
        if (!$96eb8038f2b3ef39$export$6902610076fb2dc1(token.value, i, $ae00e13d3afe0eb2$var$N)) return 0;
        // <n-dimension>
        // <n-dimension> <signed-integer>
        // <n-dimension> ['+' | '-'] <signless-integer>
        if (i + 1 === token.value.length) return $ae00e13d3afe0eb2$var$consumeB(getNextToken(++offset), offset, getNextToken);
        else {
            if (token.value.charCodeAt(i + 1) !== $ae00e13d3afe0eb2$var$HYPHENMINUS) return 0;
            // <ndash-dimension> <signless-integer>
            if (i + 2 === token.value.length) {
                offset = $ae00e13d3afe0eb2$var$skipSC(getNextToken(++offset), offset, getNextToken);
                token = getNextToken(offset);
                return $ae00e13d3afe0eb2$var$checkInteger(token, 0, $ae00e13d3afe0eb2$var$DISALLOW_SIGN, offset);
            } else return $ae00e13d3afe0eb2$var$checkInteger(token, i + 2, $ae00e13d3afe0eb2$var$DISALLOW_SIGN, offset);
        }
    }
    return 0;
}
$ae00e13d3afe0eb2$exports = $ae00e13d3afe0eb2$var$anPlusB;


var $024d0b03538a9f54$exports = {};
'use strict';



const $024d0b03538a9f54$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $024d0b03538a9f54$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $024d0b03538a9f54$var$QUESTIONMARK = 0x003F; // U+003F QUESTION MARK (?)
const $024d0b03538a9f54$var$U = 0x0075; // U+0075 LATIN SMALL LETTER U (u)
function $024d0b03538a9f54$var$isDelim(token, code) {
    return token !== null && token.type === $926ff4544e512db5$export$a918ca49ff4337a3 && token.value.charCodeAt(0) === code;
}
function $024d0b03538a9f54$var$startsWith(token, code) {
    return token.value.charCodeAt(0) === code;
}
function $024d0b03538a9f54$var$hexSequence(token, offset, allowDash) {
    let hexlen = 0;
    for(let pos = offset; pos < token.value.length; pos++){
        const code = token.value.charCodeAt(pos);
        if (code === $024d0b03538a9f54$var$HYPHENMINUS && allowDash && hexlen !== 0) {
            $024d0b03538a9f54$var$hexSequence(token, offset + hexlen + 1, false);
            return 6; // dissallow following question marks
        }
        if (!$401d24d35b6b69df$export$2a81dc4d1a2f9334(code)) return 0; // not a hex digit
        if (++hexlen > 6) return 0; // too many hex digits
    }
    return hexlen;
}
function $024d0b03538a9f54$var$withQuestionMarkSequence(consumed, length, getNextToken) {
    if (!consumed) return 0; // nothing consumed
    while($024d0b03538a9f54$var$isDelim(getNextToken(length), $024d0b03538a9f54$var$QUESTIONMARK)){
        if (++consumed > 6) return 0; // too many question marks
        length++;
    }
    return length;
}
// https://drafts.csswg.org/css-syntax/#urange
// Informally, the <urange> production has three forms:
// U+0001
//      Defines a range consisting of a single code point, in this case the code point "1".
// U+0001-00ff
//      Defines a range of codepoints between the first and the second value, in this case
//      the range between "1" and "ff" (255 in decimal) inclusive.
// U+00??
//      Defines a range of codepoints where the "?" characters range over all hex digits,
//      in this case defining the same as the value U+0000-00ff.
// In each form, a maximum of 6 digits is allowed for each hexadecimal number (if you treat "?" as a hexadecimal digit).
//
// <urange> =
//   u '+' <ident-token> '?'* |
//   u <dimension-token> '?'* |
//   u <number-token> '?'* |
//   u <number-token> <dimension-token> |
//   u <number-token> <number-token> |
//   u '+' '?'+
function $024d0b03538a9f54$var$urange(token, getNextToken) {
    let length = 0;
    // should start with `u` or `U`
    if (token === null || token.type !== $926ff4544e512db5$export$331e9b6bdecaac5f || !$96eb8038f2b3ef39$export$6902610076fb2dc1(token.value, 0, $024d0b03538a9f54$var$U)) return 0;
    token = getNextToken(++length);
    if (token === null) return 0;
    // u '+' <ident-token> '?'*
    // u '+' '?'+
    if ($024d0b03538a9f54$var$isDelim(token, $024d0b03538a9f54$var$PLUSSIGN)) {
        token = getNextToken(++length);
        if (token === null) return 0;
        if (token.type === $926ff4544e512db5$export$331e9b6bdecaac5f) // u '+' <ident-token> '?'*
        return $024d0b03538a9f54$var$withQuestionMarkSequence($024d0b03538a9f54$var$hexSequence(token, 0, true), ++length, getNextToken);
        if ($024d0b03538a9f54$var$isDelim(token, $024d0b03538a9f54$var$QUESTIONMARK)) // u '+' '?'+
        return $024d0b03538a9f54$var$withQuestionMarkSequence(1, ++length, getNextToken);
        // Hex digit or question mark is expected
        return 0;
    }
    // u <number-token> '?'*
    // u <number-token> <dimension-token>
    // u <number-token> <number-token>
    if (token.type === $926ff4544e512db5$export$fffa67e515d04022) {
        const consumedHexLength = $024d0b03538a9f54$var$hexSequence(token, 1, true);
        if (consumedHexLength === 0) return 0;
        token = getNextToken(++length);
        if (token === null) // u <number-token> <eof>
        return length;
        if (token.type === $926ff4544e512db5$export$c940ece961bc43c6 || token.type === $926ff4544e512db5$export$fffa67e515d04022) {
            // u <number-token> <dimension-token>
            // u <number-token> <number-token>
            if (!$024d0b03538a9f54$var$startsWith(token, $024d0b03538a9f54$var$HYPHENMINUS) || !$024d0b03538a9f54$var$hexSequence(token, 1, false)) return 0;
            return length + 1;
        }
        // u <number-token> '?'*
        return $024d0b03538a9f54$var$withQuestionMarkSequence(consumedHexLength, length, getNextToken);
    }
    // u <dimension-token> '?'*
    if (token.type === $926ff4544e512db5$export$c940ece961bc43c6) return $024d0b03538a9f54$var$withQuestionMarkSequence($024d0b03538a9f54$var$hexSequence(token, 1, true), ++length, getNextToken);
    return 0;
}
$024d0b03538a9f54$exports = $024d0b03538a9f54$var$urange;





const $6970b5016679ff56$var$calcFunctionNames = [
    'calc(',
    '-moz-calc(',
    '-webkit-calc('
];
const $6970b5016679ff56$var$balancePair = new Map([
    [
        $926ff4544e512db5$export$f3890eeaf6851387,
        $926ff4544e512db5$export$773d33972c6279ed
    ],
    [
        $926ff4544e512db5$export$b5a25f132cb53de6,
        $926ff4544e512db5$export$773d33972c6279ed
    ],
    [
        $926ff4544e512db5$export$cd363bb53c2bb,
        $926ff4544e512db5$export$72f933344f701f30
    ],
    [
        $926ff4544e512db5$export$ccdce7304ac66390,
        $926ff4544e512db5$export$186d8b1f99e2bfec
    ]
]);
// units
const $6970b5016679ff56$var$LENGTH = [
    // absolute length units https://www.w3.org/TR/css-values-3/#lengths
    'cm',
    'mm',
    'q',
    'in',
    'pt',
    'pc',
    'px',
    // font-relative length units https://drafts.csswg.org/css-values-4/#font-relative-lengths
    'em',
    'rem',
    'ex',
    'rex',
    'cap',
    'rcap',
    'ch',
    'rch',
    'ic',
    'ric',
    'lh',
    'rlh',
    // viewport-percentage lengths https://drafts.csswg.org/css-values-4/#viewport-relative-lengths
    'vw',
    'svw',
    'lvw',
    'dvw',
    'vh',
    'svh',
    'lvh',
    'dvh',
    'vi',
    'svi',
    'lvi',
    'dvi',
    'vb',
    'svb',
    'lvb',
    'dvb',
    'vmin',
    'svmin',
    'lvmin',
    'dvmin',
    'vmax',
    'svmax',
    'lvmax',
    'dvmax',
    // container relative lengths https://drafts.csswg.org/css-contain-3/#container-lengths
    'cqw',
    'cqh',
    'cqi',
    'cqb',
    'cqmin',
    'cqmax'
];
const $6970b5016679ff56$var$ANGLE = [
    'deg',
    'grad',
    'rad',
    'turn'
]; // https://www.w3.org/TR/css-values-3/#angles
const $6970b5016679ff56$var$TIME = [
    's',
    'ms'
]; // https://www.w3.org/TR/css-values-3/#time
const $6970b5016679ff56$var$FREQUENCY = [
    'hz',
    'khz'
]; // https://www.w3.org/TR/css-values-3/#frequency
const $6970b5016679ff56$var$RESOLUTION = [
    'dpi',
    'dpcm',
    'dppx',
    'x'
]; // https://www.w3.org/TR/css-values-3/#resolution
const $6970b5016679ff56$var$FLEX = [
    'fr'
]; // https://drafts.csswg.org/css-grid/#fr-unit
const $6970b5016679ff56$var$DECIBEL = [
    'db'
]; // https://www.w3.org/TR/css3-speech/#mixing-props-voice-volume
const $6970b5016679ff56$var$SEMITONES = [
    'st'
]; // https://www.w3.org/TR/css3-speech/#voice-props-voice-pitch
// safe char code getter
function $6970b5016679ff56$var$charCodeAt(str, index) {
    return index < str.length ? str.charCodeAt(index) : 0;
}
function $6970b5016679ff56$var$eqStr(actual, expected) {
    return $96eb8038f2b3ef39$export$5bf4b3d0861be8d9(actual, 0, actual.length, expected);
}
function $6970b5016679ff56$var$eqStrAny(actual, expected) {
    for(let i = 0; i < expected.length; i++){
        if ($6970b5016679ff56$var$eqStr(actual, expected[i])) return true;
    }
    return false;
}
// IE postfix hack, i.e. 123\0 or 123px\9
function $6970b5016679ff56$var$isPostfixIeHack(str, offset) {
    if (offset !== str.length - 2) return false;
    return $6970b5016679ff56$var$charCodeAt(str, offset) === 0x005C && // U+005C REVERSE SOLIDUS (\)
    $401d24d35b6b69df$export$727d9dbc4fbb948f($6970b5016679ff56$var$charCodeAt(str, offset + 1));
}
function $6970b5016679ff56$var$outOfRange(opts, value, numEnd) {
    if (opts && opts.type === 'Range') {
        const num = Number(numEnd !== undefined && numEnd !== value.length ? value.substr(0, numEnd) : value);
        if (isNaN(num)) return true;
        // FIXME: when opts.min is a string it's a dimension, skip a range validation
        // for now since it requires a type covertation which is not implmented yet
        if (opts.min !== null && num < opts.min && typeof opts.min !== 'string') return true;
        // FIXME: when opts.max is a string it's a dimension, skip a range validation
        // for now since it requires a type covertation which is not implmented yet
        if (opts.max !== null && num > opts.max && typeof opts.max !== 'string') return true;
    }
    return false;
}
function $6970b5016679ff56$var$consumeFunction(token, getNextToken) {
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // balanced token consuming
    scan: do {
        switch(token.type){
            case $926ff4544e512db5$export$186d8b1f99e2bfec:
            case $926ff4544e512db5$export$773d33972c6279ed:
            case $926ff4544e512db5$export$72f933344f701f30:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                if (balanceStash.length === 0) {
                    length++;
                    break scan;
                }
                break;
            case $926ff4544e512db5$export$f3890eeaf6851387:
            case $926ff4544e512db5$export$b5a25f132cb53de6:
            case $926ff4544e512db5$export$cd363bb53c2bb:
            case $926ff4544e512db5$export$ccdce7304ac66390:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $6970b5016679ff56$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// TODO: implement
// can be used wherever <length>, <frequency>, <angle>, <time>, <percentage>, <number>, or <integer> values are allowed
// https://drafts.csswg.org/css-values/#calc-notation
function $6970b5016679ff56$var$calc(next) {
    return function(token, getNextToken, opts) {
        if (token === null) return 0;
        if (token.type === $926ff4544e512db5$export$f3890eeaf6851387 && $6970b5016679ff56$var$eqStrAny(token.value, $6970b5016679ff56$var$calcFunctionNames)) return $6970b5016679ff56$var$consumeFunction(token, getNextToken);
        return next(token, getNextToken, opts);
    };
}
function $6970b5016679ff56$var$tokenType(expectedTokenType) {
    return function(token) {
        if (token === null || token.type !== expectedTokenType) return 0;
        return 1;
    };
}
// =========================
// Complex types
//
// https://drafts.csswg.org/css-values-4/#custom-idents
// 4.2. Author-defined Identifiers: the <custom-ident> type
// Some properties accept arbitrary author-defined identifiers as a component value.
// This generic data type is denoted by <custom-ident>, and represents any valid CSS identifier
// that would not be misinterpreted as a pre-defined keyword in that property’s value definition.
//
// See also: https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident
function $6970b5016679ff56$var$customIdent(token) {
    if (token === null || token.type !== $926ff4544e512db5$export$331e9b6bdecaac5f) return 0;
    const name = token.value.toLowerCase();
    // The CSS-wide keywords are not valid <custom-ident>s
    if ($6970b5016679ff56$var$eqStrAny(name, $3027806af112199f$export$b3191e0d9e666e2c)) return 0;
    // The default keyword is reserved and is also not a valid <custom-ident>
    if ($6970b5016679ff56$var$eqStr(name, 'default')) return 0;
    // TODO: ignore property specific keywords (as described https://developer.mozilla.org/en-US/docs/Web/CSS/custom-ident)
    // Specifications using <custom-ident> must specify clearly what other keywords
    // are excluded from <custom-ident>, if any—for example by saying that any pre-defined keywords
    // in that property’s value definition are excluded. Excluded keywords are excluded
    // in all ASCII case permutations.
    return 1;
}
// https://drafts.csswg.org/css-variables/#typedef-custom-property-name
// A custom property is any property whose name starts with two dashes (U+002D HYPHEN-MINUS), like --foo.
// The <custom-property-name> production corresponds to this: it’s defined as any valid identifier
// that starts with two dashes, except -- itself, which is reserved for future use by CSS.
// NOTE: Current implementation treat `--` as a valid name since most (all?) major browsers treat it as valid.
function $6970b5016679ff56$var$customPropertyName(token) {
    // ... defined as any valid identifier
    if (token === null || token.type !== $926ff4544e512db5$export$331e9b6bdecaac5f) return 0;
    // ... that starts with two dashes (U+002D HYPHEN-MINUS)
    if ($6970b5016679ff56$var$charCodeAt(token.value, 0) !== 0x002D || $6970b5016679ff56$var$charCodeAt(token.value, 1) !== 0x002D) return 0;
    return 1;
}
// https://drafts.csswg.org/css-color-4/#hex-notation
// The syntax of a <hex-color> is a <hash-token> token whose value consists of 3, 4, 6, or 8 hexadecimal digits.
// In other words, a hex color is written as a hash character, "#", followed by some number of digits 0-9 or
// letters a-f (the case of the letters doesn’t matter - #00ff00 is identical to #00FF00).
function $6970b5016679ff56$var$hexColor(token) {
    if (token === null || token.type !== $926ff4544e512db5$export$ab85ecd77ce6a5cd) return 0;
    const length = token.value.length;
    // valid values (length): #rgb (4), #rgba (5), #rrggbb (7), #rrggbbaa (9)
    if (length !== 4 && length !== 5 && length !== 7 && length !== 9) return 0;
    for(let i = 1; i < length; i++){
        if (!$401d24d35b6b69df$export$2a81dc4d1a2f9334($6970b5016679ff56$var$charCodeAt(token.value, i))) return 0;
    }
    return 1;
}
function $6970b5016679ff56$var$idSelector(token) {
    if (token === null || token.type !== $926ff4544e512db5$export$ab85ecd77ce6a5cd) return 0;
    if (!$401d24d35b6b69df$export$56b48cc5d7560ffb($6970b5016679ff56$var$charCodeAt(token.value, 1), $6970b5016679ff56$var$charCodeAt(token.value, 2), $6970b5016679ff56$var$charCodeAt(token.value, 3))) return 0;
    return 1;
}
// https://drafts.csswg.org/css-syntax/#any-value
// It represents the entirety of what a valid declaration can have as its value.
function $6970b5016679ff56$var$declarationValue(token, getNextToken) {
    if (!token) return 0;
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // The <declaration-value> production matches any sequence of one or more tokens,
    // so long as the sequence does not contain ...
    scan: do {
        switch(token.type){
            // ... <bad-string-token>, <bad-url-token>,
            case $926ff4544e512db5$export$d273d1be20da6de2:
            case $926ff4544e512db5$export$f8b4878501aa4a62:
                break scan;
            // ... unmatched <)-token>, <]-token>, or <}-token>,
            case $926ff4544e512db5$export$186d8b1f99e2bfec:
            case $926ff4544e512db5$export$773d33972c6279ed:
            case $926ff4544e512db5$export$72f933344f701f30:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                break;
            // ... or top-level <semicolon-token> tokens
            case $926ff4544e512db5$export$bedd8b9b04d9dbd:
                if (balanceCloseType === 0) break scan;
                break;
            // ... or <delim-token> tokens with a value of "!"
            case $926ff4544e512db5$export$a918ca49ff4337a3:
                if (balanceCloseType === 0 && token.value === '!') break scan;
                break;
            case $926ff4544e512db5$export$f3890eeaf6851387:
            case $926ff4544e512db5$export$b5a25f132cb53de6:
            case $926ff4544e512db5$export$cd363bb53c2bb:
            case $926ff4544e512db5$export$ccdce7304ac66390:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $6970b5016679ff56$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// https://drafts.csswg.org/css-syntax/#any-value
// The <any-value> production is identical to <declaration-value>, but also
// allows top-level <semicolon-token> tokens and <delim-token> tokens
// with a value of "!". It represents the entirety of what valid CSS can be in any context.
function $6970b5016679ff56$var$anyValue(token, getNextToken) {
    if (!token) return 0;
    let balanceCloseType = 0;
    let balanceStash = [];
    let length = 0;
    // The <any-value> production matches any sequence of one or more tokens,
    // so long as the sequence ...
    scan: do {
        switch(token.type){
            // ... does not contain <bad-string-token>, <bad-url-token>,
            case $926ff4544e512db5$export$d273d1be20da6de2:
            case $926ff4544e512db5$export$f8b4878501aa4a62:
                break scan;
            // ... unmatched <)-token>, <]-token>, or <}-token>,
            case $926ff4544e512db5$export$186d8b1f99e2bfec:
            case $926ff4544e512db5$export$773d33972c6279ed:
            case $926ff4544e512db5$export$72f933344f701f30:
                if (token.type !== balanceCloseType) break scan;
                balanceCloseType = balanceStash.pop();
                break;
            case $926ff4544e512db5$export$f3890eeaf6851387:
            case $926ff4544e512db5$export$b5a25f132cb53de6:
            case $926ff4544e512db5$export$cd363bb53c2bb:
            case $926ff4544e512db5$export$ccdce7304ac66390:
                balanceStash.push(balanceCloseType);
                balanceCloseType = $6970b5016679ff56$var$balancePair.get(token.type);
                break;
        }
        length++;
    }while (token = getNextToken(length));
    return length;
}
// =========================
// Dimensions
//
function $6970b5016679ff56$var$dimension(type) {
    if (type) type = new Set(type);
    return function(token, getNextToken, opts) {
        if (token === null || token.type !== $926ff4544e512db5$export$c940ece961bc43c6) return 0;
        const numberEnd = $96eb8038f2b3ef39$export$b817115b8219186a(token.value, 0);
        // check unit
        if (type !== null) {
            // check for IE postfix hack, i.e. 123px\0 or 123px\9
            const reverseSolidusOffset = token.value.indexOf('\\', numberEnd);
            const unit = reverseSolidusOffset === -1 || !$6970b5016679ff56$var$isPostfixIeHack(token.value, reverseSolidusOffset) ? token.value.substr(numberEnd) : token.value.substring(numberEnd, reverseSolidusOffset);
            if (type.has(unit.toLowerCase()) === false) return 0;
        }
        // check range if specified
        if ($6970b5016679ff56$var$outOfRange(opts, token.value, numberEnd)) return 0;
        return 1;
    };
}
// =========================
// Percentage
//
// §5.5. Percentages: the <percentage> type
// https://drafts.csswg.org/css-values-4/#percentages
function $6970b5016679ff56$var$percentage(token, getNextToken, opts) {
    // ... corresponds to the <percentage-token> production
    if (token === null || token.type !== $926ff4544e512db5$export$d11913f8a6922aea) return 0;
    // check range if specified
    if ($6970b5016679ff56$var$outOfRange(opts, token.value, token.value.length - 1)) return 0;
    return 1;
}
// =========================
// Numeric
//
// https://drafts.csswg.org/css-values-4/#numbers
// The value <zero> represents a literal number with the value 0. Expressions that merely
// evaluate to a <number> with the value 0 (for example, calc(0)) do not match <zero>;
// only literal <number-token>s do.
function $6970b5016679ff56$var$zero(next) {
    if (typeof next !== 'function') next = function() {
        return 0;
    };
    return function(token, getNextToken, opts) {
        if (token !== null && token.type === $926ff4544e512db5$export$fffa67e515d04022) {
            if (Number(token.value) === 0) return 1;
        }
        return next(token, getNextToken, opts);
    };
}
// § 5.3. Real Numbers: the <number> type
// https://drafts.csswg.org/css-values-4/#numbers
// Number values are denoted by <number>, and represent real numbers, possibly with a fractional component.
// ... It corresponds to the <number-token> production
function $6970b5016679ff56$var$number(token, getNextToken, opts) {
    if (token === null) return 0;
    const numberEnd = $96eb8038f2b3ef39$export$b817115b8219186a(token.value, 0);
    const isNumber = numberEnd === token.value.length;
    if (!isNumber && !$6970b5016679ff56$var$isPostfixIeHack(token.value, numberEnd)) return 0;
    // check range if specified
    if ($6970b5016679ff56$var$outOfRange(opts, token.value, numberEnd)) return 0;
    return 1;
}
// §5.2. Integers: the <integer> type
// https://drafts.csswg.org/css-values-4/#integers
function $6970b5016679ff56$var$integer(token, getNextToken, opts) {
    // ... corresponds to a subset of the <number-token> production
    if (token === null || token.type !== $926ff4544e512db5$export$fffa67e515d04022) return 0;
    // The first digit of an integer may be immediately preceded by `-` or `+` to indicate the integer’s sign.
    let i = $6970b5016679ff56$var$charCodeAt(token.value, 0) === 0x002B || // U+002B PLUS SIGN (+)
    $6970b5016679ff56$var$charCodeAt(token.value, 0) === 0x002D ? 1 : 0; // U+002D HYPHEN-MINUS (-)
    // When written literally, an integer is one or more decimal digits 0 through 9 ...
    for(; i < token.value.length; i++){
        if (!$401d24d35b6b69df$export$727d9dbc4fbb948f($6970b5016679ff56$var$charCodeAt(token.value, i))) return 0;
    }
    // check range if specified
    if ($6970b5016679ff56$var$outOfRange(opts, token.value, i)) return 0;
    return 1;
}
const $6970b5016679ff56$var$genericSyntaxes = {
    // token types
    'ident-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$331e9b6bdecaac5f),
    'function-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$f3890eeaf6851387),
    'at-keyword-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$21bfcb60d1b5ccac),
    'hash-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$ab85ecd77ce6a5cd),
    'string-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$89b8e0fa65f6a914),
    'bad-string-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$d273d1be20da6de2),
    'url-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$59d795186a5d3f58),
    'bad-url-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$f8b4878501aa4a62),
    'delim-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$a918ca49ff4337a3),
    'number-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$fffa67e515d04022),
    'percentage-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$d11913f8a6922aea),
    'dimension-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$c940ece961bc43c6),
    'whitespace-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$fb98946286ab4c97),
    'CDO-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$521ef26a3002003b),
    'CDC-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$b0b2bd2d1777c179),
    'colon-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$e20ebb298016f6),
    'semicolon-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$bedd8b9b04d9dbd),
    'comma-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$c06e3ee3b4d233fa),
    '[-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$cd363bb53c2bb),
    ']-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$72f933344f701f30),
    '(-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$b5a25f132cb53de6),
    ')-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$773d33972c6279ed),
    '{-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$ccdce7304ac66390),
    '}-token': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$186d8b1f99e2bfec),
    // token type aliases
    'string': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$89b8e0fa65f6a914),
    'ident': $6970b5016679ff56$var$tokenType($926ff4544e512db5$export$331e9b6bdecaac5f),
    // complex types
    'custom-ident': $6970b5016679ff56$var$customIdent,
    'custom-property-name': $6970b5016679ff56$var$customPropertyName,
    'hex-color': $6970b5016679ff56$var$hexColor,
    'id-selector': $6970b5016679ff56$var$idSelector,
    'an-plus-b': $ae00e13d3afe0eb2$exports,
    'urange': $024d0b03538a9f54$exports,
    'declaration-value': $6970b5016679ff56$var$declarationValue,
    'any-value': $6970b5016679ff56$var$anyValue,
    // dimensions
    'dimension': $6970b5016679ff56$var$calc($6970b5016679ff56$var$dimension(null)),
    'angle': $6970b5016679ff56$var$calc($6970b5016679ff56$var$dimension($6970b5016679ff56$var$ANGLE)),
    'decibel': $6970b5016679ff56$var$calc($6970b5016679ff56$var$dimension($6970b5016679ff56$var$DECIBEL)),
    'frequency': $6970b5016679ff56$var$calc($6970b5016679ff56$var$dimension($6970b5016679ff56$var$FREQUENCY)),
    'flex': $6970b5016679ff56$var$calc($6970b5016679ff56$var$dimension($6970b5016679ff56$var$FLEX)),
    'length': $6970b5016679ff56$var$calc($6970b5016679ff56$var$zero($6970b5016679ff56$var$dimension($6970b5016679ff56$var$LENGTH))),
    'resolution': $6970b5016679ff56$var$calc($6970b5016679ff56$var$dimension($6970b5016679ff56$var$RESOLUTION)),
    'semitones': $6970b5016679ff56$var$calc($6970b5016679ff56$var$dimension($6970b5016679ff56$var$SEMITONES)),
    'time': $6970b5016679ff56$var$calc($6970b5016679ff56$var$dimension($6970b5016679ff56$var$TIME)),
    // percentage
    'percentage': $6970b5016679ff56$var$calc($6970b5016679ff56$var$percentage),
    // numeric
    'zero': $6970b5016679ff56$var$zero(),
    'number': $6970b5016679ff56$var$calc($6970b5016679ff56$var$number),
    'integer': $6970b5016679ff56$var$calc($6970b5016679ff56$var$integer)
};
$6970b5016679ff56$exports = $6970b5016679ff56$var$genericSyntaxes;


var $f4f2f510479ed97e$exports = {};
'use strict';

const $f4f2f510479ed97e$var$astToTokens = {
    decorator (handlers) {
        const tokens = [];
        let curNode = null;
        return {
            ...handlers,
            node (node) {
                const tmp = curNode;
                curNode = node;
                handlers.node.call(this, node);
                curNode = tmp;
            },
            emit (value, type, auto) {
                tokens.push({
                    type: type,
                    value: value,
                    node: auto ? null : curNode
                });
            },
            result () {
                return tokens;
            }
        };
    }
};
function $f4f2f510479ed97e$var$stringToTokens(str) {
    const tokens = [];
    $14ef1a69abba2f52$export$660b2ee2d4fb4eff(str, (type, start, end)=>tokens.push({
            type: type,
            value: str.slice(start, end),
            node: null
        }));
    return tokens;
}
function $f4f2f510479ed97e$var$prepareTokens(value, syntax) {
    if (typeof value === 'string') return $f4f2f510479ed97e$var$stringToTokens(value);
    return syntax.generate(value, $f4f2f510479ed97e$var$astToTokens);
}
$f4f2f510479ed97e$exports = $f4f2f510479ed97e$var$prepareTokens;


var $d693f041d3953071$export$d962e73e7bcd24c;
var $d693f041d3953071$export$5a1a83be8f503735;
var $d693f041d3953071$export$dfbc42837bfccec4;
var $d693f041d3953071$export$41c88d779c06859d;
'use strict';
var $34919e392962fcd2$export$98e6a39c04603d36;
'use strict';
var $53fdd2bfce3ac26a$export$55e8b082af4aa63e;
'use strict';
var $33d51d9401bbcbe5$export$f21cea08b0dd60e8;
'use strict';

function $33d51d9401bbcbe5$var$SyntaxError(message, input, offset) {
    return Object.assign($fc5d5637c2ee7573$export$435492119a21bab3('SyntaxError', message), {
        input: input,
        offset: offset,
        rawMessage: message,
        message: message + '\n' + '  ' + input + '\n' + '--' + new Array((offset || input.length) + 1).join('-') + '^'
    });
}
$33d51d9401bbcbe5$export$f21cea08b0dd60e8 = $33d51d9401bbcbe5$var$SyntaxError;


const $53fdd2bfce3ac26a$var$TAB = 9;
const $53fdd2bfce3ac26a$var$N = 10;
const $53fdd2bfce3ac26a$var$F = 12;
const $53fdd2bfce3ac26a$var$R = 13;
const $53fdd2bfce3ac26a$var$SPACE = 32;
class $53fdd2bfce3ac26a$var$Tokenizer {
    charCodeAt(pos) {
        return pos < this.str.length ? this.str.charCodeAt(pos) : 0;
    }
    charCode() {
        return this.charCodeAt(this.pos);
    }
    nextCharCode() {
        return this.charCodeAt(this.pos + 1);
    }
    nextNonWsCode(pos) {
        return this.charCodeAt(this.findWsEnd(pos));
    }
    findWsEnd(pos) {
        for(; pos < this.str.length; pos++){
            const code = this.str.charCodeAt(pos);
            if (code !== $53fdd2bfce3ac26a$var$R && code !== $53fdd2bfce3ac26a$var$N && code !== $53fdd2bfce3ac26a$var$F && code !== $53fdd2bfce3ac26a$var$SPACE && code !== $53fdd2bfce3ac26a$var$TAB) break;
        }
        return pos;
    }
    substringToPos(end) {
        return this.str.substring(this.pos, this.pos = end);
    }
    eat(code) {
        if (this.charCode() !== code) this.error('Expect `' + String.fromCharCode(code) + '`');
        this.pos++;
    }
    peek() {
        return this.pos < this.str.length ? this.str.charAt(this.pos++) : '';
    }
    error(message) {
        throw new $33d51d9401bbcbe5$export$f21cea08b0dd60e8(message, this.str, this.pos);
    }
    constructor(str){
        this.str = str;
        this.pos = 0;
    }
}
$53fdd2bfce3ac26a$export$55e8b082af4aa63e = $53fdd2bfce3ac26a$var$Tokenizer;


const $34919e392962fcd2$var$TAB = 9;
const $34919e392962fcd2$var$N = 10;
const $34919e392962fcd2$var$F = 12;
const $34919e392962fcd2$var$R = 13;
const $34919e392962fcd2$var$SPACE = 32;
const $34919e392962fcd2$var$EXCLAMATIONMARK = 33; // !
const $34919e392962fcd2$var$NUMBERSIGN = 35; // #
const $34919e392962fcd2$var$AMPERSAND = 38; // &
const $34919e392962fcd2$var$APOSTROPHE = 39; // '
const $34919e392962fcd2$var$LEFTPARENTHESIS = 40; // (
const $34919e392962fcd2$var$RIGHTPARENTHESIS = 41; // )
const $34919e392962fcd2$var$ASTERISK = 42; // *
const $34919e392962fcd2$var$PLUSSIGN = 43; // +
const $34919e392962fcd2$var$COMMA = 44; // ,
const $34919e392962fcd2$var$HYPERMINUS = 45; // -
const $34919e392962fcd2$var$LESSTHANSIGN = 60; // <
const $34919e392962fcd2$var$GREATERTHANSIGN = 62; // >
const $34919e392962fcd2$var$QUESTIONMARK = 63; // ?
const $34919e392962fcd2$var$COMMERCIALAT = 64; // @
const $34919e392962fcd2$var$LEFTSQUAREBRACKET = 91; // [
const $34919e392962fcd2$var$RIGHTSQUAREBRACKET = 93; // ]
const $34919e392962fcd2$var$LEFTCURLYBRACKET = 123; // {
const $34919e392962fcd2$var$VERTICALLINE = 124; // |
const $34919e392962fcd2$var$RIGHTCURLYBRACKET = 125; // }
const $34919e392962fcd2$var$INFINITY = 8734; // ∞
const $34919e392962fcd2$var$NAME_CHAR = new Uint8Array(128).map((_, idx)=>/[a-zA-Z0-9\-]/.test(String.fromCharCode(idx)) ? 1 : 0);
const $34919e392962fcd2$var$COMBINATOR_PRECEDENCE = {
    ' ': 1,
    '&&': 2,
    '||': 3,
    '|': 4
};
function $34919e392962fcd2$var$scanSpaces(tokenizer) {
    return tokenizer.substringToPos(tokenizer.findWsEnd(tokenizer.pos));
}
function $34919e392962fcd2$var$scanWord(tokenizer) {
    let end = tokenizer.pos;
    for(; end < tokenizer.str.length; end++){
        const code = tokenizer.str.charCodeAt(end);
        if (code >= 128 || $34919e392962fcd2$var$NAME_CHAR[code] === 0) break;
    }
    if (tokenizer.pos === end) tokenizer.error('Expect a keyword');
    return tokenizer.substringToPos(end);
}
function $34919e392962fcd2$var$scanNumber(tokenizer) {
    let end = tokenizer.pos;
    for(; end < tokenizer.str.length; end++){
        const code = tokenizer.str.charCodeAt(end);
        if (code < 48 || code > 57) break;
    }
    if (tokenizer.pos === end) tokenizer.error('Expect a number');
    return tokenizer.substringToPos(end);
}
function $34919e392962fcd2$var$scanString(tokenizer) {
    const end = tokenizer.str.indexOf('\'', tokenizer.pos + 1);
    if (end === -1) {
        tokenizer.pos = tokenizer.str.length;
        tokenizer.error('Expect an apostrophe');
    }
    return tokenizer.substringToPos(end + 1);
}
function $34919e392962fcd2$var$readMultiplierRange(tokenizer) {
    let min = null;
    let max = null;
    tokenizer.eat($34919e392962fcd2$var$LEFTCURLYBRACKET);
    min = $34919e392962fcd2$var$scanNumber(tokenizer);
    if (tokenizer.charCode() === $34919e392962fcd2$var$COMMA) {
        tokenizer.pos++;
        if (tokenizer.charCode() !== $34919e392962fcd2$var$RIGHTCURLYBRACKET) max = $34919e392962fcd2$var$scanNumber(tokenizer);
    } else max = min;
    tokenizer.eat($34919e392962fcd2$var$RIGHTCURLYBRACKET);
    return {
        min: Number(min),
        max: max ? Number(max) : 0
    };
}
function $34919e392962fcd2$var$readMultiplier(tokenizer) {
    let range = null;
    let comma = false;
    switch(tokenizer.charCode()){
        case $34919e392962fcd2$var$ASTERISK:
            tokenizer.pos++;
            range = {
                min: 0,
                max: 0
            };
            break;
        case $34919e392962fcd2$var$PLUSSIGN:
            tokenizer.pos++;
            range = {
                min: 1,
                max: 0
            };
            break;
        case $34919e392962fcd2$var$QUESTIONMARK:
            tokenizer.pos++;
            range = {
                min: 0,
                max: 1
            };
            break;
        case $34919e392962fcd2$var$NUMBERSIGN:
            tokenizer.pos++;
            comma = true;
            if (tokenizer.charCode() === $34919e392962fcd2$var$LEFTCURLYBRACKET) range = $34919e392962fcd2$var$readMultiplierRange(tokenizer);
            else if (tokenizer.charCode() === $34919e392962fcd2$var$QUESTIONMARK) {
                // https://www.w3.org/TR/css-values-4/#component-multipliers
                // > the # and ? multipliers may be stacked as #?
                // In this case just treat "#?" as a single multiplier
                // { min: 0, max: 0, comma: true }
                tokenizer.pos++;
                range = {
                    min: 0,
                    max: 0
                };
            } else range = {
                min: 1,
                max: 0
            };
            break;
        case $34919e392962fcd2$var$LEFTCURLYBRACKET:
            range = $34919e392962fcd2$var$readMultiplierRange(tokenizer);
            break;
        default:
            return null;
    }
    return {
        type: 'Multiplier',
        comma: comma,
        min: range.min,
        max: range.max,
        term: null
    };
}
function $34919e392962fcd2$var$maybeMultiplied(tokenizer, node) {
    const multiplier = $34919e392962fcd2$var$readMultiplier(tokenizer);
    if (multiplier !== null) {
        multiplier.term = node;
        // https://www.w3.org/TR/css-values-4/#component-multipliers
        // > The + and # multipliers may be stacked as +#;
        // Represent "+#" as nested multipliers:
        // { ...<multiplier #>,
        //   term: {
        //     ...<multipler +>,
        //     term: node
        //   }
        // }
        if (tokenizer.charCode() === $34919e392962fcd2$var$NUMBERSIGN && tokenizer.charCodeAt(tokenizer.pos - 1) === $34919e392962fcd2$var$PLUSSIGN) return $34919e392962fcd2$var$maybeMultiplied(tokenizer, multiplier);
        return multiplier;
    }
    return node;
}
function $34919e392962fcd2$var$maybeToken(tokenizer) {
    const ch = tokenizer.peek();
    if (ch === '') return null;
    return {
        type: 'Token',
        value: ch
    };
}
function $34919e392962fcd2$var$readProperty(tokenizer) {
    let name;
    tokenizer.eat($34919e392962fcd2$var$LESSTHANSIGN);
    tokenizer.eat($34919e392962fcd2$var$APOSTROPHE);
    name = $34919e392962fcd2$var$scanWord(tokenizer);
    tokenizer.eat($34919e392962fcd2$var$APOSTROPHE);
    tokenizer.eat($34919e392962fcd2$var$GREATERTHANSIGN);
    return $34919e392962fcd2$var$maybeMultiplied(tokenizer, {
        type: 'Property',
        name: name
    });
}
// https://drafts.csswg.org/css-values-3/#numeric-ranges
// 4.1. Range Restrictions and Range Definition Notation
//
// Range restrictions can be annotated in the numeric type notation using CSS bracketed
// range notation—[min,max]—within the angle brackets, after the identifying keyword,
// indicating a closed range between (and including) min and max.
// For example, <integer [0, 10]> indicates an integer between 0 and 10, inclusive.
function $34919e392962fcd2$var$readTypeRange(tokenizer) {
    // use null for Infinity to make AST format JSON serializable/deserializable
    let min = null; // -Infinity
    let max = null; // Infinity
    let sign = 1;
    tokenizer.eat($34919e392962fcd2$var$LEFTSQUAREBRACKET);
    if (tokenizer.charCode() === $34919e392962fcd2$var$HYPERMINUS) {
        tokenizer.peek();
        sign = -1;
    }
    if (sign == -1 && tokenizer.charCode() === $34919e392962fcd2$var$INFINITY) tokenizer.peek();
    else {
        min = sign * Number($34919e392962fcd2$var$scanNumber(tokenizer));
        if ($34919e392962fcd2$var$NAME_CHAR[tokenizer.charCode()] !== 0) min += $34919e392962fcd2$var$scanWord(tokenizer);
    }
    $34919e392962fcd2$var$scanSpaces(tokenizer);
    tokenizer.eat($34919e392962fcd2$var$COMMA);
    $34919e392962fcd2$var$scanSpaces(tokenizer);
    if (tokenizer.charCode() === $34919e392962fcd2$var$INFINITY) tokenizer.peek();
    else {
        sign = 1;
        if (tokenizer.charCode() === $34919e392962fcd2$var$HYPERMINUS) {
            tokenizer.peek();
            sign = -1;
        }
        max = sign * Number($34919e392962fcd2$var$scanNumber(tokenizer));
        if ($34919e392962fcd2$var$NAME_CHAR[tokenizer.charCode()] !== 0) max += $34919e392962fcd2$var$scanWord(tokenizer);
    }
    tokenizer.eat($34919e392962fcd2$var$RIGHTSQUAREBRACKET);
    return {
        type: 'Range',
        min: min,
        max: max
    };
}
function $34919e392962fcd2$var$readType(tokenizer) {
    let name;
    let opts = null;
    tokenizer.eat($34919e392962fcd2$var$LESSTHANSIGN);
    name = $34919e392962fcd2$var$scanWord(tokenizer);
    if (tokenizer.charCode() === $34919e392962fcd2$var$LEFTPARENTHESIS && tokenizer.nextCharCode() === $34919e392962fcd2$var$RIGHTPARENTHESIS) {
        tokenizer.pos += 2;
        name += '()';
    }
    if (tokenizer.charCodeAt(tokenizer.findWsEnd(tokenizer.pos)) === $34919e392962fcd2$var$LEFTSQUAREBRACKET) {
        $34919e392962fcd2$var$scanSpaces(tokenizer);
        opts = $34919e392962fcd2$var$readTypeRange(tokenizer);
    }
    tokenizer.eat($34919e392962fcd2$var$GREATERTHANSIGN);
    return $34919e392962fcd2$var$maybeMultiplied(tokenizer, {
        type: 'Type',
        name: name,
        opts: opts
    });
}
function $34919e392962fcd2$var$readKeywordOrFunction(tokenizer) {
    const name = $34919e392962fcd2$var$scanWord(tokenizer);
    if (tokenizer.charCode() === $34919e392962fcd2$var$LEFTPARENTHESIS) {
        tokenizer.pos++;
        return {
            type: 'Function',
            name: name
        };
    }
    return $34919e392962fcd2$var$maybeMultiplied(tokenizer, {
        type: 'Keyword',
        name: name
    });
}
function $34919e392962fcd2$var$regroupTerms(terms, combinators) {
    function createGroup(terms, combinator) {
        return {
            type: 'Group',
            terms: terms,
            combinator: combinator,
            disallowEmpty: false,
            explicit: false
        };
    }
    let combinator;
    combinators = Object.keys(combinators).sort((a, b)=>$34919e392962fcd2$var$COMBINATOR_PRECEDENCE[a] - $34919e392962fcd2$var$COMBINATOR_PRECEDENCE[b]);
    while(combinators.length > 0){
        combinator = combinators.shift();
        let i = 0;
        let subgroupStart = 0;
        for(; i < terms.length; i++){
            const term = terms[i];
            if (term.type === 'Combinator') {
                if (term.value === combinator) {
                    if (subgroupStart === -1) subgroupStart = i - 1;
                    terms.splice(i, 1);
                    i--;
                } else {
                    if (subgroupStart !== -1 && i - subgroupStart > 1) {
                        terms.splice(subgroupStart, i - subgroupStart, createGroup(terms.slice(subgroupStart, i), combinator));
                        i = subgroupStart + 1;
                    }
                    subgroupStart = -1;
                }
            }
        }
        if (subgroupStart !== -1 && combinators.length) terms.splice(subgroupStart, i - subgroupStart, createGroup(terms.slice(subgroupStart, i), combinator));
    }
    return combinator;
}
function $34919e392962fcd2$var$readImplicitGroup(tokenizer) {
    const terms = [];
    const combinators = {};
    let token;
    let prevToken = null;
    let prevTokenPos = tokenizer.pos;
    while(token = $34919e392962fcd2$var$peek(tokenizer))if (token.type !== 'Spaces') {
        if (token.type === 'Combinator') {
            // check for combinator in group beginning and double combinator sequence
            if (prevToken === null || prevToken.type === 'Combinator') {
                tokenizer.pos = prevTokenPos;
                tokenizer.error('Unexpected combinator');
            }
            combinators[token.value] = true;
        } else if (prevToken !== null && prevToken.type !== 'Combinator') {
            combinators[' '] = true; // a b
            terms.push({
                type: 'Combinator',
                value: ' '
            });
        }
        terms.push(token);
        prevToken = token;
        prevTokenPos = tokenizer.pos;
    }
    // check for combinator in group ending
    if (prevToken !== null && prevToken.type === 'Combinator') {
        tokenizer.pos -= prevTokenPos;
        tokenizer.error('Unexpected combinator');
    }
    return {
        type: 'Group',
        terms: terms,
        combinator: $34919e392962fcd2$var$regroupTerms(terms, combinators) || ' ',
        disallowEmpty: false,
        explicit: false
    };
}
function $34919e392962fcd2$var$readGroup(tokenizer) {
    let result;
    tokenizer.eat($34919e392962fcd2$var$LEFTSQUAREBRACKET);
    result = $34919e392962fcd2$var$readImplicitGroup(tokenizer);
    tokenizer.eat($34919e392962fcd2$var$RIGHTSQUAREBRACKET);
    result.explicit = true;
    if (tokenizer.charCode() === $34919e392962fcd2$var$EXCLAMATIONMARK) {
        tokenizer.pos++;
        result.disallowEmpty = true;
    }
    return result;
}
function $34919e392962fcd2$var$peek(tokenizer) {
    let code = tokenizer.charCode();
    if (code < 128 && $34919e392962fcd2$var$NAME_CHAR[code] === 1) return $34919e392962fcd2$var$readKeywordOrFunction(tokenizer);
    switch(code){
        case $34919e392962fcd2$var$RIGHTSQUAREBRACKET:
            break;
        case $34919e392962fcd2$var$LEFTSQUAREBRACKET:
            return $34919e392962fcd2$var$maybeMultiplied(tokenizer, $34919e392962fcd2$var$readGroup(tokenizer));
        case $34919e392962fcd2$var$LESSTHANSIGN:
            return tokenizer.nextCharCode() === $34919e392962fcd2$var$APOSTROPHE ? $34919e392962fcd2$var$readProperty(tokenizer) : $34919e392962fcd2$var$readType(tokenizer);
        case $34919e392962fcd2$var$VERTICALLINE:
            return {
                type: 'Combinator',
                value: tokenizer.substringToPos(tokenizer.pos + (tokenizer.nextCharCode() === $34919e392962fcd2$var$VERTICALLINE ? 2 : 1))
            };
        case $34919e392962fcd2$var$AMPERSAND:
            tokenizer.pos++;
            tokenizer.eat($34919e392962fcd2$var$AMPERSAND);
            return {
                type: 'Combinator',
                value: '&&'
            };
        case $34919e392962fcd2$var$COMMA:
            tokenizer.pos++;
            return {
                type: 'Comma'
            };
        case $34919e392962fcd2$var$APOSTROPHE:
            return $34919e392962fcd2$var$maybeMultiplied(tokenizer, {
                type: 'String',
                value: $34919e392962fcd2$var$scanString(tokenizer)
            });
        case $34919e392962fcd2$var$SPACE:
        case $34919e392962fcd2$var$TAB:
        case $34919e392962fcd2$var$N:
        case $34919e392962fcd2$var$R:
        case $34919e392962fcd2$var$F:
            return {
                type: 'Spaces',
                value: $34919e392962fcd2$var$scanSpaces(tokenizer)
            };
        case $34919e392962fcd2$var$COMMERCIALAT:
            code = tokenizer.nextCharCode();
            if (code < 128 && $34919e392962fcd2$var$NAME_CHAR[code] === 1) {
                tokenizer.pos++;
                return {
                    type: 'AtKeyword',
                    name: $34919e392962fcd2$var$scanWord(tokenizer)
                };
            }
            return $34919e392962fcd2$var$maybeToken(tokenizer);
        case $34919e392962fcd2$var$ASTERISK:
        case $34919e392962fcd2$var$PLUSSIGN:
        case $34919e392962fcd2$var$QUESTIONMARK:
        case $34919e392962fcd2$var$NUMBERSIGN:
        case $34919e392962fcd2$var$EXCLAMATIONMARK:
            break;
        case $34919e392962fcd2$var$LEFTCURLYBRACKET:
            // LEFTCURLYBRACKET is allowed since mdn/data uses it w/o quoting
            // check next char isn't a number, because it's likely a disjoined multiplier
            code = tokenizer.nextCharCode();
            if (code < 48 || code > 57) return $34919e392962fcd2$var$maybeToken(tokenizer);
            break;
        default:
            return $34919e392962fcd2$var$maybeToken(tokenizer);
    }
}
function $34919e392962fcd2$var$parse(source) {
    const tokenizer$1 = new $53fdd2bfce3ac26a$export$55e8b082af4aa63e(source);
    const result = $34919e392962fcd2$var$readImplicitGroup(tokenizer$1);
    if (tokenizer$1.pos !== source.length) tokenizer$1.error('Unexpected input');
    // reduce redundant groups with single group term
    if (result.terms.length === 1 && result.terms[0].type === 'Group') return result.terms[0];
    return result;
}
$34919e392962fcd2$export$98e6a39c04603d36 = $34919e392962fcd2$var$parse;


const $d693f041d3953071$var$MATCH = {
    type: 'Match'
};
const $d693f041d3953071$var$MISMATCH = {
    type: 'Mismatch'
};
const $d693f041d3953071$var$DISALLOW_EMPTY = {
    type: 'DisallowEmpty'
};
const $d693f041d3953071$var$LEFTPARENTHESIS = 40; // (
const $d693f041d3953071$var$RIGHTPARENTHESIS = 41; // )
function $d693f041d3953071$var$createCondition(match, thenBranch, elseBranch) {
    // reduce node count
    if (thenBranch === $d693f041d3953071$var$MATCH && elseBranch === $d693f041d3953071$var$MISMATCH) return match;
    if (match === $d693f041d3953071$var$MATCH && thenBranch === $d693f041d3953071$var$MATCH && elseBranch === $d693f041d3953071$var$MATCH) return match;
    if (match.type === 'If' && match.else === $d693f041d3953071$var$MISMATCH && thenBranch === $d693f041d3953071$var$MATCH) {
        thenBranch = match.then;
        match = match.match;
    }
    return {
        type: 'If',
        match: match,
        then: thenBranch,
        else: elseBranch
    };
}
function $d693f041d3953071$var$isFunctionType(name) {
    return name.length > 2 && name.charCodeAt(name.length - 2) === $d693f041d3953071$var$LEFTPARENTHESIS && name.charCodeAt(name.length - 1) === $d693f041d3953071$var$RIGHTPARENTHESIS;
}
function $d693f041d3953071$var$isEnumCapatible(term) {
    return term.type === 'Keyword' || term.type === 'AtKeyword' || term.type === 'Function' || term.type === 'Type' && $d693f041d3953071$var$isFunctionType(term.name);
}
function $d693f041d3953071$var$buildGroupMatchGraph(combinator, terms, atLeastOneTermMatched) {
    switch(combinator){
        case ' ':
            {
                // Juxtaposing components means that all of them must occur, in the given order.
                //
                // a b c
                // =
                // match a
                //   then match b
                //     then match c
                //       then MATCH
                //       else MISMATCH
                //     else MISMATCH
                //   else MISMATCH
                let result = $d693f041d3953071$var$MATCH;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    result = $d693f041d3953071$var$createCondition(term, result, $d693f041d3953071$var$MISMATCH);
                }
                return result;
            }
        case '|':
            {
                // A bar (|) separates two or more alternatives: exactly one of them must occur.
                //
                // a | b | c
                // =
                // match a
                //   then MATCH
                //   else match b
                //     then MATCH
                //     else match c
                //       then MATCH
                //       else MISMATCH
                let result = $d693f041d3953071$var$MISMATCH;
                let map = null;
                for(let i = terms.length - 1; i >= 0; i--){
                    let term = terms[i];
                    // reduce sequence of keywords into a Enum
                    if ($d693f041d3953071$var$isEnumCapatible(term)) {
                        if (map === null && i > 0 && $d693f041d3953071$var$isEnumCapatible(terms[i - 1])) {
                            map = Object.create(null);
                            result = $d693f041d3953071$var$createCondition({
                                type: 'Enum',
                                map: map
                            }, $d693f041d3953071$var$MATCH, result);
                        }
                        if (map !== null) {
                            const key = ($d693f041d3953071$var$isFunctionType(term.name) ? term.name.slice(0, -1) : term.name).toLowerCase();
                            if (key in map === false) {
                                map[key] = term;
                                continue;
                            }
                        }
                    }
                    map = null;
                    // create a new conditonal node
                    result = $d693f041d3953071$var$createCondition(term, $d693f041d3953071$var$MATCH, result);
                }
                return result;
            }
        case '&&':
            {
                // A double ampersand (&&) separates two or more components,
                // all of which must occur, in any order.
                // Use MatchOnce for groups with a large number of terms,
                // since &&-groups produces at least N!-node trees
                if (terms.length > 5) return {
                    type: 'MatchOnce',
                    terms: terms,
                    all: true
                };
                // Use a combination tree for groups with small number of terms
                //
                // a && b && c
                // =
                // match a
                //   then [b && c]
                //   else match b
                //     then [a && c]
                //     else match c
                //       then [a && b]
                //       else MISMATCH
                //
                // a && b
                // =
                // match a
                //   then match b
                //     then MATCH
                //     else MISMATCH
                //   else match b
                //     then match a
                //       then MATCH
                //       else MISMATCH
                //     else MISMATCH
                let result = $d693f041d3953071$var$MISMATCH;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    let thenClause;
                    if (terms.length > 1) thenClause = $d693f041d3953071$var$buildGroupMatchGraph(combinator, terms.filter(function(newGroupTerm) {
                        return newGroupTerm !== term;
                    }), false);
                    else thenClause = $d693f041d3953071$var$MATCH;
                    result = $d693f041d3953071$var$createCondition(term, thenClause, result);
                }
                return result;
            }
        case '||':
            {
                // A double bar (||) separates two or more options:
                // one or more of them must occur, in any order.
                // Use MatchOnce for groups with a large number of terms,
                // since ||-groups produces at least N!-node trees
                if (terms.length > 5) return {
                    type: 'MatchOnce',
                    terms: terms,
                    all: false
                };
                // Use a combination tree for groups with small number of terms
                //
                // a || b || c
                // =
                // match a
                //   then [b || c]
                //   else match b
                //     then [a || c]
                //     else match c
                //       then [a || b]
                //       else MISMATCH
                //
                // a || b
                // =
                // match a
                //   then match b
                //     then MATCH
                //     else MATCH
                //   else match b
                //     then match a
                //       then MATCH
                //       else MATCH
                //     else MISMATCH
                let result = atLeastOneTermMatched ? $d693f041d3953071$var$MATCH : $d693f041d3953071$var$MISMATCH;
                for(let i = terms.length - 1; i >= 0; i--){
                    const term = terms[i];
                    let thenClause;
                    if (terms.length > 1) thenClause = $d693f041d3953071$var$buildGroupMatchGraph(combinator, terms.filter(function(newGroupTerm) {
                        return newGroupTerm !== term;
                    }), true);
                    else thenClause = $d693f041d3953071$var$MATCH;
                    result = $d693f041d3953071$var$createCondition(term, thenClause, result);
                }
                return result;
            }
    }
}
function $d693f041d3953071$var$buildMultiplierMatchGraph(node) {
    let result = $d693f041d3953071$var$MATCH;
    let matchTerm = $d693f041d3953071$var$buildMatchGraphInternal(node.term);
    if (node.max === 0) {
        // disable repeating of empty match to prevent infinite loop
        matchTerm = $d693f041d3953071$var$createCondition(matchTerm, $d693f041d3953071$var$DISALLOW_EMPTY, $d693f041d3953071$var$MISMATCH);
        // an occurrence count is not limited, make a cycle;
        // to collect more terms on each following matching mismatch
        result = $d693f041d3953071$var$createCondition(matchTerm, null, $d693f041d3953071$var$MISMATCH);
        result.then = $d693f041d3953071$var$createCondition($d693f041d3953071$var$MATCH, $d693f041d3953071$var$MATCH, result // make a loop
        );
        if (node.comma) result.then.else = $d693f041d3953071$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $d693f041d3953071$var$MISMATCH);
    } else // create a match node chain for [min .. max] interval with optional matches
    for(let i = node.min || 1; i <= node.max; i++){
        if (node.comma && result !== $d693f041d3953071$var$MATCH) result = $d693f041d3953071$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $d693f041d3953071$var$MISMATCH);
        result = $d693f041d3953071$var$createCondition(matchTerm, $d693f041d3953071$var$createCondition($d693f041d3953071$var$MATCH, $d693f041d3953071$var$MATCH, result), $d693f041d3953071$var$MISMATCH);
    }
    if (node.min === 0) // allow zero match
    result = $d693f041d3953071$var$createCondition($d693f041d3953071$var$MATCH, $d693f041d3953071$var$MATCH, result);
    else // create a match node chain to collect [0 ... min - 1] required matches
    for(let i = 0; i < node.min - 1; i++){
        if (node.comma && result !== $d693f041d3953071$var$MATCH) result = $d693f041d3953071$var$createCondition({
            type: 'Comma',
            syntax: node
        }, result, $d693f041d3953071$var$MISMATCH);
        result = $d693f041d3953071$var$createCondition(matchTerm, result, $d693f041d3953071$var$MISMATCH);
    }
    return result;
}
function $d693f041d3953071$var$buildMatchGraphInternal(node) {
    if (typeof node === 'function') return {
        type: 'Generic',
        fn: node
    };
    switch(node.type){
        case 'Group':
            {
                let result = $d693f041d3953071$var$buildGroupMatchGraph(node.combinator, node.terms.map($d693f041d3953071$var$buildMatchGraphInternal), false);
                if (node.disallowEmpty) result = $d693f041d3953071$var$createCondition(result, $d693f041d3953071$var$DISALLOW_EMPTY, $d693f041d3953071$var$MISMATCH);
                return result;
            }
        case 'Multiplier':
            return $d693f041d3953071$var$buildMultiplierMatchGraph(node);
        case 'Type':
        case 'Property':
            return {
                type: node.type,
                name: node.name,
                syntax: node
            };
        case 'Keyword':
            return {
                type: node.type,
                name: node.name.toLowerCase(),
                syntax: node
            };
        case 'AtKeyword':
            return {
                type: node.type,
                name: '@' + node.name.toLowerCase(),
                syntax: node
            };
        case 'Function':
            return {
                type: node.type,
                name: node.name.toLowerCase() + '(',
                syntax: node
            };
        case 'String':
            // convert a one char length String to a Token
            if (node.value.length === 3) return {
                type: 'Token',
                value: node.value.charAt(1),
                syntax: node
            };
            // otherwise use it as is
            return {
                type: node.type,
                value: node.value.substr(1, node.value.length - 2).replace(/\\'/g, '\''),
                syntax: node
            };
        case 'Token':
            return {
                type: node.type,
                value: node.value,
                syntax: node
            };
        case 'Comma':
            return {
                type: node.type,
                syntax: node
            };
        default:
            throw new Error('Unknown node type:', node.type);
    }
}
function $d693f041d3953071$var$buildMatchGraph(syntaxTree, ref) {
    if (typeof syntaxTree === 'string') syntaxTree = $34919e392962fcd2$export$98e6a39c04603d36(syntaxTree);
    return {
        type: 'MatchGraph',
        match: $d693f041d3953071$var$buildMatchGraphInternal(syntaxTree),
        syntax: ref || null,
        source: syntaxTree
    };
}
$d693f041d3953071$export$d962e73e7bcd24c = $d693f041d3953071$var$DISALLOW_EMPTY;
$d693f041d3953071$export$5a1a83be8f503735 = $d693f041d3953071$var$MATCH;
$d693f041d3953071$export$dfbc42837bfccec4 = $d693f041d3953071$var$MISMATCH;
$d693f041d3953071$export$41c88d779c06859d = $d693f041d3953071$var$buildMatchGraph;


var $e8299441c95c2dd1$export$b15baef7e00e9fac;
var $e8299441c95c2dd1$export$575ec9525823c563;
'use strict';


const { hasOwnProperty: $e8299441c95c2dd1$var$hasOwnProperty } = Object.prototype;
const $e8299441c95c2dd1$var$STUB = 0;
const $e8299441c95c2dd1$var$TOKEN = 1;
const $e8299441c95c2dd1$var$OPEN_SYNTAX = 2;
const $e8299441c95c2dd1$var$CLOSE_SYNTAX = 3;
const $e8299441c95c2dd1$var$EXIT_REASON_MATCH = 'Match';
const $e8299441c95c2dd1$var$EXIT_REASON_MISMATCH = 'Mismatch';
const $e8299441c95c2dd1$var$EXIT_REASON_ITERATION_LIMIT = 'Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)';
const $e8299441c95c2dd1$var$ITERATION_LIMIT = 15000;
function $e8299441c95c2dd1$var$reverseList(list) {
    let prev = null;
    let next = null;
    let item = list;
    while(item !== null){
        next = item.prev;
        item.prev = prev;
        prev = item;
        item = next;
    }
    return prev;
}
function $e8299441c95c2dd1$var$areStringsEqualCaseInsensitive(testStr, referenceStr) {
    if (testStr.length !== referenceStr.length) return false;
    for(let i = 0; i < testStr.length; i++){
        const referenceCode = referenceStr.charCodeAt(i);
        let testCode = testStr.charCodeAt(i);
        // testCode.toLowerCase() for U+0041 LATIN CAPITAL LETTER A (A) .. U+005A LATIN CAPITAL LETTER Z (Z).
        if (testCode >= 0x0041 && testCode <= 0x005A) testCode = testCode | 32;
        if (testCode !== referenceCode) return false;
    }
    return true;
}
function $e8299441c95c2dd1$var$isContextEdgeDelim(token) {
    if (token.type !== $926ff4544e512db5$export$a918ca49ff4337a3) return false;
    // Fix matching for unicode-range: U+30??, U+FF00-FF9F
    // Probably we need to check out previous match instead
    return token.value !== '?';
}
function $e8299441c95c2dd1$var$isCommaContextStart(token) {
    if (token === null) return true;
    return token.type === $926ff4544e512db5$export$c06e3ee3b4d233fa || token.type === $926ff4544e512db5$export$f3890eeaf6851387 || token.type === $926ff4544e512db5$export$b5a25f132cb53de6 || token.type === $926ff4544e512db5$export$cd363bb53c2bb || token.type === $926ff4544e512db5$export$ccdce7304ac66390 || $e8299441c95c2dd1$var$isContextEdgeDelim(token);
}
function $e8299441c95c2dd1$var$isCommaContextEnd(token) {
    if (token === null) return true;
    return token.type === $926ff4544e512db5$export$773d33972c6279ed || token.type === $926ff4544e512db5$export$72f933344f701f30 || token.type === $926ff4544e512db5$export$186d8b1f99e2bfec || token.type === $926ff4544e512db5$export$a918ca49ff4337a3 && token.value === '/';
}
function $e8299441c95c2dd1$var$internalMatch(tokens, state, syntaxes) {
    function moveToNextToken() {
        do {
            tokenIndex++;
            token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
        }while (token !== null && (token.type === $926ff4544e512db5$export$fb98946286ab4c97 || token.type === $926ff4544e512db5$export$4d299b491347818a));
    }
    function getNextToken(offset) {
        const nextIndex = tokenIndex + offset;
        return nextIndex < tokens.length ? tokens[nextIndex] : null;
    }
    function stateSnapshotFromSyntax(nextState, prev) {
        return {
            nextState: nextState,
            matchStack: matchStack,
            syntaxStack: syntaxStack,
            thenStack: thenStack,
            tokenIndex: tokenIndex,
            prev: prev
        };
    }
    function pushThenStack(nextState) {
        thenStack = {
            nextState: nextState,
            matchStack: matchStack,
            syntaxStack: syntaxStack,
            prev: thenStack
        };
    }
    function pushElseStack(nextState) {
        elseStack = stateSnapshotFromSyntax(nextState, elseStack);
    }
    function addTokenToMatch() {
        matchStack = {
            type: $e8299441c95c2dd1$var$TOKEN,
            syntax: state.syntax,
            token: token,
            prev: matchStack
        };
        moveToNextToken();
        syntaxStash = null;
        if (tokenIndex > longestMatch) longestMatch = tokenIndex;
    }
    function openSyntax() {
        syntaxStack = {
            syntax: state.syntax,
            opts: state.syntax.opts || syntaxStack !== null && syntaxStack.opts || null,
            prev: syntaxStack
        };
        matchStack = {
            type: $e8299441c95c2dd1$var$OPEN_SYNTAX,
            syntax: state.syntax,
            token: matchStack.token,
            prev: matchStack
        };
    }
    function closeSyntax() {
        if (matchStack.type === $e8299441c95c2dd1$var$OPEN_SYNTAX) matchStack = matchStack.prev;
        else matchStack = {
            type: $e8299441c95c2dd1$var$CLOSE_SYNTAX,
            syntax: syntaxStack.syntax,
            token: matchStack.token,
            prev: matchStack
        };
        syntaxStack = syntaxStack.prev;
    }
    let syntaxStack = null;
    let thenStack = null;
    let elseStack = null;
    // null – stashing allowed, nothing stashed
    // false – stashing disabled, nothing stashed
    // anithing else – fail stashable syntaxes, some syntax stashed
    let syntaxStash = null;
    let iterationCount = 0; // count iterations and prevent infinite loop
    let exitReason = null;
    let token = null;
    let tokenIndex = -1;
    let longestMatch = 0;
    let matchStack = {
        type: $e8299441c95c2dd1$var$STUB,
        syntax: null,
        token: null,
        prev: null
    };
    moveToNextToken();
    while(exitReason === null && ++iterationCount < $e8299441c95c2dd1$var$ITERATION_LIMIT)// function mapList(list, fn) {
    //     const result = [];
    //     while (list) {
    //         result.unshift(fn(list));
    //         list = list.prev;
    //     }
    //     return result;
    // }
    // console.log('--\n',
    //     '#' + iterationCount,
    //     require('util').inspect({
    //         match: mapList(matchStack, x => x.type === TOKEN ? x.token && x.token.value : x.syntax ? ({ [OPEN_SYNTAX]: '<', [CLOSE_SYNTAX]: '</' }[x.type] || x.type) + '!' + x.syntax.name : null),
    //         token: token && token.value,
    //         tokenIndex,
    //         syntax: syntax.type + (syntax.id ? ' #' + syntax.id : '')
    //     }, { depth: null })
    // );
    switch(state.type){
        case 'Match':
            if (thenStack === null) {
                // turn to MISMATCH when some tokens left unmatched
                if (token !== null) // doesn't mismatch if just one token left and it's an IE hack
                {
                    if (tokenIndex !== tokens.length - 1 || token.value !== '\\0' && token.value !== '\\9') {
                        state = $d693f041d3953071$export$dfbc42837bfccec4;
                        break;
                    }
                }
                // break the main loop, return a result - MATCH
                exitReason = $e8299441c95c2dd1$var$EXIT_REASON_MATCH;
                break;
            }
            // go to next syntax (`then` branch)
            state = thenStack.nextState;
            // check match is not empty
            if (state === $d693f041d3953071$export$d962e73e7bcd24c) {
                if (thenStack.matchStack === matchStack) {
                    state = $d693f041d3953071$export$dfbc42837bfccec4;
                    break;
                } else state = $d693f041d3953071$export$5a1a83be8f503735;
            }
            // close syntax if needed
            while(thenStack.syntaxStack !== syntaxStack)closeSyntax();
            // pop stack
            thenStack = thenStack.prev;
            break;
        case 'Mismatch':
            // when some syntax is stashed
            if (syntaxStash !== null && syntaxStash !== false) // there is no else branches or a branch reduce match stack
            {
                if (elseStack === null || tokenIndex > elseStack.tokenIndex) {
                    // restore state from the stash
                    elseStack = syntaxStash;
                    syntaxStash = false; // disable stashing
                }
            } else if (elseStack === null) {
                // no else branches -> break the main loop
                // return a result - MISMATCH
                exitReason = $e8299441c95c2dd1$var$EXIT_REASON_MISMATCH;
                break;
            }
            // go to next syntax (`else` branch)
            state = elseStack.nextState;
            // restore all the rest stack states
            thenStack = elseStack.thenStack;
            syntaxStack = elseStack.syntaxStack;
            matchStack = elseStack.matchStack;
            tokenIndex = elseStack.tokenIndex;
            token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
            // pop stack
            elseStack = elseStack.prev;
            break;
        case 'MatchGraph':
            state = state.match;
            break;
        case 'If':
            // IMPORTANT: else stack push must go first,
            // since it stores the state of thenStack before changes
            if (state.else !== $d693f041d3953071$export$dfbc42837bfccec4) pushElseStack(state.else);
            if (state.then !== $d693f041d3953071$export$5a1a83be8f503735) pushThenStack(state.then);
            state = state.match;
            break;
        case 'MatchOnce':
            state = {
                type: 'MatchOnceBuffer',
                syntax: state,
                index: 0,
                mask: 0
            };
            break;
        case 'MatchOnceBuffer':
            {
                const terms = state.syntax.terms;
                if (state.index === terms.length) {
                    // no matches at all or it's required all terms to be matched
                    if (state.mask === 0 || state.syntax.all) {
                        state = $d693f041d3953071$export$dfbc42837bfccec4;
                        break;
                    }
                    // a partial match is ok
                    state = $d693f041d3953071$export$5a1a83be8f503735;
                    break;
                }
                // all terms are matched
                if (state.mask === (1 << terms.length) - 1) {
                    state = $d693f041d3953071$export$5a1a83be8f503735;
                    break;
                }
                for(; state.index < terms.length; state.index++){
                    const matchFlag = 1 << state.index;
                    if ((state.mask & matchFlag) === 0) {
                        // IMPORTANT: else stack push must go first,
                        // since it stores the state of thenStack before changes
                        pushElseStack(state);
                        pushThenStack({
                            type: 'AddMatchOnce',
                            syntax: state.syntax,
                            mask: state.mask | matchFlag
                        });
                        // match
                        state = terms[state.index++];
                        break;
                    }
                }
                break;
            }
        case 'AddMatchOnce':
            state = {
                type: 'MatchOnceBuffer',
                syntax: state.syntax,
                index: 0,
                mask: state.mask
            };
            break;
        case 'Enum':
            if (token !== null) {
                let name = token.value.toLowerCase();
                // drop \0 and \9 hack from keyword name
                if (name.indexOf('\\') !== -1) name = name.replace(/\\[09].*$/, '');
                if ($e8299441c95c2dd1$var$hasOwnProperty.call(state.map, name)) {
                    state = state.map[name];
                    break;
                }
            }
            state = $d693f041d3953071$export$dfbc42837bfccec4;
            break;
        case 'Generic':
            {
                const opts = syntaxStack !== null ? syntaxStack.opts : null;
                const lastTokenIndex = tokenIndex + Math.floor(state.fn(token, getNextToken, opts));
                if (!isNaN(lastTokenIndex) && lastTokenIndex > tokenIndex) {
                    while(tokenIndex < lastTokenIndex)addTokenToMatch();
                    state = $d693f041d3953071$export$5a1a83be8f503735;
                } else state = $d693f041d3953071$export$dfbc42837bfccec4;
                break;
            }
        case 'Type':
        case 'Property':
            {
                const syntaxDict = state.type === 'Type' ? 'types' : 'properties';
                const dictSyntax = $e8299441c95c2dd1$var$hasOwnProperty.call(syntaxes, syntaxDict) ? syntaxes[syntaxDict][state.name] : null;
                if (!dictSyntax || !dictSyntax.match) throw new Error('Bad syntax reference: ' + (state.type === 'Type' ? '<' + state.name + '>' : '<\'' + state.name + '\'>'));
                // stash a syntax for types with low priority
                if (syntaxStash !== false && token !== null && state.type === 'Type') {
                    const lowPriorityMatching = // https://drafts.csswg.org/css-values-4/#custom-idents
                    // When parsing positionally-ambiguous keywords in a property value, a <custom-ident> production
                    // can only claim the keyword if no other unfulfilled production can claim it.
                    state.name === 'custom-ident' && token.type === $926ff4544e512db5$export$331e9b6bdecaac5f || // https://drafts.csswg.org/css-values-4/#lengths
                    // ... if a `0` could be parsed as either a <number> or a <length> in a property (such as line-height),
                    // it must parse as a <number>
                    state.name === 'length' && token.value === '0';
                    if (lowPriorityMatching) {
                        if (syntaxStash === null) syntaxStash = stateSnapshotFromSyntax(state, elseStack);
                        state = $d693f041d3953071$export$dfbc42837bfccec4;
                        break;
                    }
                }
                openSyntax();
                state = dictSyntax.match;
                break;
            }
        case 'Keyword':
            {
                const name = state.name;
                if (token !== null) {
                    let keywordName = token.value;
                    // drop \0 and \9 hack from keyword name
                    if (keywordName.indexOf('\\') !== -1) keywordName = keywordName.replace(/\\[09].*$/, '');
                    if ($e8299441c95c2dd1$var$areStringsEqualCaseInsensitive(keywordName, name)) {
                        addTokenToMatch();
                        state = $d693f041d3953071$export$5a1a83be8f503735;
                        break;
                    }
                }
                state = $d693f041d3953071$export$dfbc42837bfccec4;
                break;
            }
        case 'AtKeyword':
        case 'Function':
            if (token !== null && $e8299441c95c2dd1$var$areStringsEqualCaseInsensitive(token.value, state.name)) {
                addTokenToMatch();
                state = $d693f041d3953071$export$5a1a83be8f503735;
                break;
            }
            state = $d693f041d3953071$export$dfbc42837bfccec4;
            break;
        case 'Token':
            if (token !== null && token.value === state.value) {
                addTokenToMatch();
                state = $d693f041d3953071$export$5a1a83be8f503735;
                break;
            }
            state = $d693f041d3953071$export$dfbc42837bfccec4;
            break;
        case 'Comma':
            if (token !== null && token.type === $926ff4544e512db5$export$c06e3ee3b4d233fa) {
                if ($e8299441c95c2dd1$var$isCommaContextStart(matchStack.token)) state = $d693f041d3953071$export$dfbc42837bfccec4;
                else {
                    addTokenToMatch();
                    state = $e8299441c95c2dd1$var$isCommaContextEnd(token) ? $d693f041d3953071$export$dfbc42837bfccec4 : $d693f041d3953071$export$5a1a83be8f503735;
                }
            } else state = $e8299441c95c2dd1$var$isCommaContextStart(matchStack.token) || $e8299441c95c2dd1$var$isCommaContextEnd(token) ? $d693f041d3953071$export$5a1a83be8f503735 : $d693f041d3953071$export$dfbc42837bfccec4;
            break;
        case 'String':
            let string = '';
            let lastTokenIndex = tokenIndex;
            for(; lastTokenIndex < tokens.length && string.length < state.value.length; lastTokenIndex++)string += tokens[lastTokenIndex].value;
            if ($e8299441c95c2dd1$var$areStringsEqualCaseInsensitive(string, state.value)) {
                while(tokenIndex < lastTokenIndex)addTokenToMatch();
                state = $d693f041d3953071$export$5a1a83be8f503735;
            } else state = $d693f041d3953071$export$dfbc42837bfccec4;
            break;
        default:
            throw new Error('Unknown node type: ' + state.type);
    }
    switch(exitReason){
        case null:
            console.warn('[csstree-match] BREAK after ' + $e8299441c95c2dd1$var$ITERATION_LIMIT + ' iterations');
            exitReason = $e8299441c95c2dd1$var$EXIT_REASON_ITERATION_LIMIT;
            matchStack = null;
            break;
        case $e8299441c95c2dd1$var$EXIT_REASON_MATCH:
            while(syntaxStack !== null)closeSyntax();
            break;
        default:
            matchStack = null;
    }
    return {
        tokens: tokens,
        reason: exitReason,
        iterations: iterationCount,
        match: matchStack,
        longestMatch: longestMatch
    };
}
function $e8299441c95c2dd1$var$matchAsList(tokens, matchGraph, syntaxes) {
    const matchResult = $e8299441c95c2dd1$var$internalMatch(tokens, matchGraph, syntaxes || {});
    if (matchResult.match !== null) {
        let item = $e8299441c95c2dd1$var$reverseList(matchResult.match).prev;
        matchResult.match = [];
        while(item !== null){
            switch(item.type){
                case $e8299441c95c2dd1$var$OPEN_SYNTAX:
                case $e8299441c95c2dd1$var$CLOSE_SYNTAX:
                    matchResult.match.push({
                        type: item.type,
                        syntax: item.syntax
                    });
                    break;
                default:
                    matchResult.match.push({
                        token: item.token.value,
                        node: item.token.node
                    });
                    break;
            }
            item = item.prev;
        }
    }
    return matchResult;
}
function $e8299441c95c2dd1$var$matchAsTree(tokens, matchGraph, syntaxes) {
    const matchResult = $e8299441c95c2dd1$var$internalMatch(tokens, matchGraph, syntaxes || {});
    if (matchResult.match === null) return matchResult;
    let item = matchResult.match;
    let host = matchResult.match = {
        syntax: matchGraph.syntax || null,
        match: []
    };
    const hostStack = [
        host
    ];
    // revert a list and start with 2nd item since 1st is a stub item
    item = $e8299441c95c2dd1$var$reverseList(item).prev;
    // build a tree
    while(item !== null){
        switch(item.type){
            case $e8299441c95c2dd1$var$OPEN_SYNTAX:
                host.match.push(host = {
                    syntax: item.syntax,
                    match: []
                });
                hostStack.push(host);
                break;
            case $e8299441c95c2dd1$var$CLOSE_SYNTAX:
                hostStack.pop();
                host = hostStack[hostStack.length - 1];
                break;
            default:
                host.match.push({
                    syntax: item.syntax || null,
                    token: item.token.value,
                    node: item.token.node
                });
        }
        item = item.prev;
    }
    return matchResult;
}
$e8299441c95c2dd1$export$b15baef7e00e9fac = $e8299441c95c2dd1$var$matchAsList;
$e8299441c95c2dd1$export$575ec9525823c563 = $e8299441c95c2dd1$var$matchAsTree;


var $4d7d8b935a644aef$exports = {};
$parcel$export($4d7d8b935a644aef$exports, "getTrace", () => $4d7d8b935a644aef$export$4f813bbe73196350, (v) => $4d7d8b935a644aef$export$4f813bbe73196350 = v);
$parcel$export($4d7d8b935a644aef$exports, "isKeyword", () => $4d7d8b935a644aef$export$384ccb3991bcb643, (v) => $4d7d8b935a644aef$export$384ccb3991bcb643 = v);
$parcel$export($4d7d8b935a644aef$exports, "isProperty", () => $4d7d8b935a644aef$export$dc0811f98246bcff, (v) => $4d7d8b935a644aef$export$dc0811f98246bcff = v);
$parcel$export($4d7d8b935a644aef$exports, "isType", () => $4d7d8b935a644aef$export$26b9f946b448f23e, (v) => $4d7d8b935a644aef$export$26b9f946b448f23e = v);
var $4d7d8b935a644aef$export$4f813bbe73196350;
var $4d7d8b935a644aef$export$384ccb3991bcb643;
var $4d7d8b935a644aef$export$dc0811f98246bcff;
var $4d7d8b935a644aef$export$26b9f946b448f23e;
'use strict';
function $4d7d8b935a644aef$var$getTrace(node) {
    function shouldPutToTrace(syntax) {
        if (syntax === null) return false;
        return syntax.type === 'Type' || syntax.type === 'Property' || syntax.type === 'Keyword';
    }
    function hasMatch(matchNode) {
        if (Array.isArray(matchNode.match)) {
            // use for-loop for better perfomance
            for(let i = 0; i < matchNode.match.length; i++)if (hasMatch(matchNode.match[i])) {
                if (shouldPutToTrace(matchNode.syntax)) result.unshift(matchNode.syntax);
                return true;
            }
        } else if (matchNode.node === node) {
            result = shouldPutToTrace(matchNode.syntax) ? [
                matchNode.syntax
            ] : [];
            return true;
        }
        return false;
    }
    let result = null;
    if (this.matched !== null) hasMatch(this.matched);
    return result;
}
function $4d7d8b935a644aef$var$isType(node, type) {
    return $4d7d8b935a644aef$var$testNode(this, node, (match)=>match.type === 'Type' && match.name === type);
}
function $4d7d8b935a644aef$var$isProperty(node, property) {
    return $4d7d8b935a644aef$var$testNode(this, node, (match)=>match.type === 'Property' && match.name === property);
}
function $4d7d8b935a644aef$var$isKeyword(node) {
    return $4d7d8b935a644aef$var$testNode(this, node, (match)=>match.type === 'Keyword');
}
function $4d7d8b935a644aef$var$testNode(match, node, fn) {
    const trace = $4d7d8b935a644aef$var$getTrace.call(match, node);
    if (trace === null) return false;
    return trace.some(fn);
}
$4d7d8b935a644aef$export$4f813bbe73196350 = $4d7d8b935a644aef$var$getTrace;
$4d7d8b935a644aef$export$384ccb3991bcb643 = $4d7d8b935a644aef$var$isKeyword;
$4d7d8b935a644aef$export$dc0811f98246bcff = $4d7d8b935a644aef$var$isProperty;
$4d7d8b935a644aef$export$26b9f946b448f23e = $4d7d8b935a644aef$var$isType;


var $186ba1c1b660b56d$export$2c0817d7096f698;
'use strict';

function $186ba1c1b660b56d$var$getFirstMatchNode(matchNode) {
    if ('node' in matchNode) return matchNode.node;
    return $186ba1c1b660b56d$var$getFirstMatchNode(matchNode.match[0]);
}
function $186ba1c1b660b56d$var$getLastMatchNode(matchNode) {
    if ('node' in matchNode) return matchNode.node;
    return $186ba1c1b660b56d$var$getLastMatchNode(matchNode.match[matchNode.match.length - 1]);
}
function $186ba1c1b660b56d$var$matchFragments(lexer, ast, match, type, name) {
    function findFragments(matchNode) {
        if (matchNode.syntax !== null && matchNode.syntax.type === type && matchNode.syntax.name === name) {
            const start = $186ba1c1b660b56d$var$getFirstMatchNode(matchNode);
            const end = $186ba1c1b660b56d$var$getLastMatchNode(matchNode);
            lexer.syntax.walk(ast, function(node, item, list) {
                if (node === start) {
                    const nodes = new $22e84e429477a95a$export$54c2e3dc7acea9f5();
                    do {
                        nodes.appendData(item.data);
                        if (item.data === end) break;
                        item = item.next;
                    }while (item !== null);
                    fragments.push({
                        parent: list,
                        nodes: nodes
                    });
                }
            });
        }
        if (Array.isArray(matchNode.match)) matchNode.match.forEach(findFragments);
    }
    const fragments = [];
    if (match.matched !== null) findFragments(match.matched);
    return fragments;
}
$186ba1c1b660b56d$export$2c0817d7096f698 = $186ba1c1b660b56d$var$matchFragments;


var $ff82621029bc7643$export$2e9edb38e02d3c76;
'use strict';

const { hasOwnProperty: $ff82621029bc7643$var$hasOwnProperty } = Object.prototype;
function $ff82621029bc7643$var$isValidNumber(value) {
    // Number.isInteger(value) && value >= 0
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value && value >= 0;
}
function $ff82621029bc7643$var$isValidLocation(loc) {
    return Boolean(loc) && $ff82621029bc7643$var$isValidNumber(loc.offset) && $ff82621029bc7643$var$isValidNumber(loc.line) && $ff82621029bc7643$var$isValidNumber(loc.column);
}
function $ff82621029bc7643$var$createNodeStructureChecker(type, fields) {
    return function checkNode(node, warn) {
        if (!node || node.constructor !== Object) return warn(node, 'Type of node should be an Object');
        for(let key in node){
            let valid = true;
            if ($ff82621029bc7643$var$hasOwnProperty.call(node, key) === false) continue;
            if (key === 'type') {
                if (node.type !== type) warn(node, 'Wrong node type `' + node.type + '`, expected `' + type + '`');
            } else if (key === 'loc') {
                if (node.loc === null) continue;
                else if (node.loc && node.loc.constructor === Object) {
                    if (typeof node.loc.source !== 'string') key += '.source';
                    else if (!$ff82621029bc7643$var$isValidLocation(node.loc.start)) key += '.start';
                    else if (!$ff82621029bc7643$var$isValidLocation(node.loc.end)) key += '.end';
                    else continue;
                }
                valid = false;
            } else if (fields.hasOwnProperty(key)) {
                valid = false;
                for(let i = 0; !valid && i < fields[key].length; i++){
                    const fieldType = fields[key][i];
                    switch(fieldType){
                        case String:
                            valid = typeof node[key] === 'string';
                            break;
                        case Boolean:
                            valid = typeof node[key] === 'boolean';
                            break;
                        case null:
                            valid = node[key] === null;
                            break;
                        default:
                            if (typeof fieldType === 'string') valid = node[key] && node[key].type === fieldType;
                            else if (Array.isArray(fieldType)) valid = node[key] instanceof $22e84e429477a95a$export$54c2e3dc7acea9f5;
                    }
                }
            } else warn(node, 'Unknown field `' + key + '` for ' + type + ' node type');
            if (!valid) warn(node, 'Bad value for `' + type + '.' + key + '`');
        }
        for(const key in fields)if ($ff82621029bc7643$var$hasOwnProperty.call(fields, key) && $ff82621029bc7643$var$hasOwnProperty.call(node, key) === false) warn(node, 'Field `' + type + '.' + key + '` is missed');
    };
}
function $ff82621029bc7643$var$processStructure(name, nodeType) {
    const structure = nodeType.structure;
    const fields = {
        type: String,
        loc: true
    };
    const docs = {
        type: '"' + name + '"'
    };
    for(const key in structure){
        if ($ff82621029bc7643$var$hasOwnProperty.call(structure, key) === false) continue;
        const docsTypes = [];
        const fieldTypes = fields[key] = Array.isArray(structure[key]) ? structure[key].slice() : [
            structure[key]
        ];
        for(let i = 0; i < fieldTypes.length; i++){
            const fieldType = fieldTypes[i];
            if (fieldType === String || fieldType === Boolean) docsTypes.push(fieldType.name);
            else if (fieldType === null) docsTypes.push('null');
            else if (typeof fieldType === 'string') docsTypes.push('<' + fieldType + '>');
            else if (Array.isArray(fieldType)) docsTypes.push('List'); // TODO: use type enum
            else throw new Error('Wrong value `' + fieldType + '` in `' + name + '.' + key + '` structure definition');
        }
        docs[key] = docsTypes.join(' | ');
    }
    return {
        docs: docs,
        check: $ff82621029bc7643$var$createNodeStructureChecker(name, fields)
    };
}
function $ff82621029bc7643$var$getStructureFromConfig(config) {
    const structure = {};
    if (config.node) {
        for(const name in config.node)if ($ff82621029bc7643$var$hasOwnProperty.call(config.node, name)) {
            const nodeType = config.node[name];
            if (nodeType.structure) structure[name] = $ff82621029bc7643$var$processStructure(name, nodeType);
            else throw new Error('Missed `structure` field in `' + name + '` node type definition');
        }
    }
    return structure;
}
$ff82621029bc7643$export$2e9edb38e02d3c76 = $ff82621029bc7643$var$getStructureFromConfig;




var $40c4f52b975be836$export$588732934346abbf;
'use strict';
const $40c4f52b975be836$var$noop = function() {};
function $40c4f52b975be836$var$ensureFunction(value) {
    return typeof value === 'function' ? value : $40c4f52b975be836$var$noop;
}
function $40c4f52b975be836$var$walk(node, options, context) {
    function walk(node) {
        enter.call(context, node);
        switch(node.type){
            case 'Group':
                node.terms.forEach(walk);
                break;
            case 'Multiplier':
                walk(node.term);
                break;
            case 'Type':
            case 'Property':
            case 'Keyword':
            case 'AtKeyword':
            case 'Function':
            case 'String':
            case 'Token':
            case 'Comma':
                break;
            default:
                throw new Error('Unknown type: ' + node.type);
        }
        leave.call(context, node);
    }
    let enter = $40c4f52b975be836$var$noop;
    let leave = $40c4f52b975be836$var$noop;
    if (typeof options === 'function') enter = options;
    else if (options) {
        enter = $40c4f52b975be836$var$ensureFunction(options.enter);
        leave = $40c4f52b975be836$var$ensureFunction(options.leave);
    }
    if (enter === $40c4f52b975be836$var$noop && leave === $40c4f52b975be836$var$noop) throw new Error('Neither `enter` nor `leave` walker handler is set or both aren\'t a function');
    walk(node);
}
$40c4f52b975be836$export$588732934346abbf = $40c4f52b975be836$var$walk;


const $60f3ad1b8871cde1$var$cssWideKeywordsSyntax = $d693f041d3953071$export$41c88d779c06859d($3027806af112199f$export$b3191e0d9e666e2c.join(' | '));
function $60f3ad1b8871cde1$var$dumpMapSyntax(map, compact, syntaxAsAst) {
    const result = {};
    for(const name in map)if (map[name].syntax) result[name] = syntaxAsAst ? map[name].syntax : $98e942a2f6e618f5$export$80d376111cc09ad7(map[name].syntax, {
        compact: compact
    });
    return result;
}
function $60f3ad1b8871cde1$var$dumpAtruleMapSyntax(map, compact, syntaxAsAst) {
    const result = {};
    for (const [name, atrule] of Object.entries(map))result[name] = {
        prelude: atrule.prelude && (syntaxAsAst ? atrule.prelude.syntax : $98e942a2f6e618f5$export$80d376111cc09ad7(atrule.prelude.syntax, {
            compact: compact
        })),
        descriptors: atrule.descriptors && $60f3ad1b8871cde1$var$dumpMapSyntax(atrule.descriptors, compact, syntaxAsAst)
    };
    return result;
}
function $60f3ad1b8871cde1$var$valueHasVar(tokens) {
    for(let i = 0; i < tokens.length; i++){
        if (tokens[i].value.toLowerCase() === 'var(') return true;
    }
    return false;
}
function $60f3ad1b8871cde1$var$buildMatchResult(matched, error, iterations) {
    return {
        matched: matched,
        iterations: iterations,
        error: error,
        ...$4d7d8b935a644aef$exports
    };
}
function $60f3ad1b8871cde1$var$matchSyntax(lexer, syntax, value, useCssWideKeywords) {
    const tokens = $f4f2f510479ed97e$exports(value, lexer.syntax);
    let result;
    if ($60f3ad1b8871cde1$var$valueHasVar(tokens)) return $60f3ad1b8871cde1$var$buildMatchResult(null, new Error('Matching for a tree with var() is not supported'));
    if (useCssWideKeywords) result = $e8299441c95c2dd1$export$575ec9525823c563(tokens, lexer.cssWideKeywordsSyntax, lexer);
    if (!useCssWideKeywords || !result.match) {
        result = $e8299441c95c2dd1$export$575ec9525823c563(tokens, syntax.match, lexer);
        if (!result.match) return $60f3ad1b8871cde1$var$buildMatchResult(null, new $d73ec4ef9b8bacfc$export$c937494ee8e9606d(result.reason, syntax.syntax, value, result), result.iterations);
    }
    return $60f3ad1b8871cde1$var$buildMatchResult(result.match, null, result.iterations);
}
class $60f3ad1b8871cde1$var$Lexer {
    checkStructure(ast) {
        function collectWarning(node, message) {
            warns.push({
                node: node,
                message: message
            });
        }
        const structure = this.structure;
        const warns = [];
        this.syntax.walk(ast, function(node) {
            if (structure.hasOwnProperty(node.type)) structure[node.type].check(node, collectWarning);
            else collectWarning(node, 'Unknown node type `' + node.type + '`');
        });
        return warns.length ? warns : false;
    }
    createDescriptor(syntax, type, name, parent = null) {
        const ref = {
            type: type,
            name: name
        };
        const descriptor = {
            type: type,
            name: name,
            parent: parent,
            serializable: typeof syntax === 'string' || syntax && typeof syntax.type === 'string',
            syntax: null,
            match: null
        };
        if (typeof syntax === 'function') descriptor.match = $d693f041d3953071$export$41c88d779c06859d(syntax, ref);
        else {
            if (typeof syntax === 'string') // lazy parsing on first access
            Object.defineProperty(descriptor, 'syntax', {
                get () {
                    Object.defineProperty(descriptor, 'syntax', {
                        value: $34919e392962fcd2$export$98e6a39c04603d36(syntax)
                    });
                    return descriptor.syntax;
                }
            });
            else descriptor.syntax = syntax;
            // lazy graph build on first access
            Object.defineProperty(descriptor, 'match', {
                get () {
                    Object.defineProperty(descriptor, 'match', {
                        value: $d693f041d3953071$export$41c88d779c06859d(descriptor.syntax, ref)
                    });
                    return descriptor.match;
                }
            });
        }
        return descriptor;
    }
    addAtrule_(name, syntax) {
        if (!syntax) return;
        this.atrules[name] = {
            type: 'Atrule',
            name: name,
            prelude: syntax.prelude ? this.createDescriptor(syntax.prelude, 'AtrulePrelude', name) : null,
            descriptors: syntax.descriptors ? Object.keys(syntax.descriptors).reduce((map, descName)=>{
                map[descName] = this.createDescriptor(syntax.descriptors[descName], 'AtruleDescriptor', descName, name);
                return map;
            }, Object.create(null)) : null
        };
    }
    addProperty_(name, syntax) {
        if (!syntax) return;
        this.properties[name] = this.createDescriptor(syntax, 'Property', name);
    }
    addType_(name, syntax) {
        if (!syntax) return;
        this.types[name] = this.createDescriptor(syntax, 'Type', name);
    }
    checkAtruleName(atruleName) {
        if (!this.getAtrule(atruleName)) return new $d73ec4ef9b8bacfc$export$65d073607b1def2('Unknown at-rule', '@' + atruleName);
    }
    checkAtrulePrelude(atruleName, prelude) {
        const error = this.checkAtruleName(atruleName);
        if (error) return error;
        const atrule = this.getAtrule(atruleName);
        if (!atrule.prelude && prelude) return new SyntaxError('At-rule `@' + atruleName + '` should not contain a prelude');
        if (atrule.prelude && !prelude) {
            if (!$60f3ad1b8871cde1$var$matchSyntax(this, atrule.prelude, '', false).matched) return new SyntaxError('At-rule `@' + atruleName + '` should contain a prelude');
        }
    }
    checkAtruleDescriptorName(atruleName, descriptorName) {
        const error$1 = this.checkAtruleName(atruleName);
        if (error$1) return error$1;
        const atrule = this.getAtrule(atruleName);
        const descriptor = $ffbc3ade873552d0$export$2e81050496d0e63e(descriptorName);
        if (!atrule.descriptors) return new SyntaxError('At-rule `@' + atruleName + '` has no known descriptors');
        if (!atrule.descriptors[descriptor.name] && !atrule.descriptors[descriptor.basename]) return new $d73ec4ef9b8bacfc$export$65d073607b1def2('Unknown at-rule descriptor', descriptorName);
    }
    checkPropertyName(propertyName) {
        if (!this.getProperty(propertyName)) return new $d73ec4ef9b8bacfc$export$65d073607b1def2('Unknown property', propertyName);
    }
    matchAtrulePrelude(atruleName, prelude) {
        const error = this.checkAtrulePrelude(atruleName, prelude);
        if (error) return $60f3ad1b8871cde1$var$buildMatchResult(null, error);
        const atrule = this.getAtrule(atruleName);
        if (!atrule.prelude) return $60f3ad1b8871cde1$var$buildMatchResult(null, null);
        return $60f3ad1b8871cde1$var$matchSyntax(this, atrule.prelude, prelude || '', false);
    }
    matchAtruleDescriptor(atruleName, descriptorName, value) {
        const error = this.checkAtruleDescriptorName(atruleName, descriptorName);
        if (error) return $60f3ad1b8871cde1$var$buildMatchResult(null, error);
        const atrule = this.getAtrule(atruleName);
        const descriptor = $ffbc3ade873552d0$export$2e81050496d0e63e(descriptorName);
        return $60f3ad1b8871cde1$var$matchSyntax(this, atrule.descriptors[descriptor.name] || atrule.descriptors[descriptor.basename], value, false);
    }
    matchDeclaration(node) {
        if (node.type !== 'Declaration') return $60f3ad1b8871cde1$var$buildMatchResult(null, new Error('Not a Declaration node'));
        return this.matchProperty(node.property, node.value);
    }
    matchProperty(propertyName, value) {
        // don't match syntax for a custom property at the moment
        if ($ffbc3ade873552d0$export$d541bacb2bda4494(propertyName).custom) return $60f3ad1b8871cde1$var$buildMatchResult(null, new Error('Lexer matching doesn\'t applicable for custom properties'));
        const error = this.checkPropertyName(propertyName);
        if (error) return $60f3ad1b8871cde1$var$buildMatchResult(null, error);
        return $60f3ad1b8871cde1$var$matchSyntax(this, this.getProperty(propertyName), value, true);
    }
    matchType(typeName, value) {
        const typeSyntax = this.getType(typeName);
        if (!typeSyntax) return $60f3ad1b8871cde1$var$buildMatchResult(null, new $d73ec4ef9b8bacfc$export$65d073607b1def2('Unknown type', typeName));
        return $60f3ad1b8871cde1$var$matchSyntax(this, typeSyntax, value, false);
    }
    match(syntax, value) {
        if (typeof syntax !== 'string' && (!syntax || !syntax.type)) return $60f3ad1b8871cde1$var$buildMatchResult(null, new $d73ec4ef9b8bacfc$export$65d073607b1def2('Bad syntax'));
        if (typeof syntax === 'string' || !syntax.match) syntax = this.createDescriptor(syntax, 'Type', 'anonymous');
        return $60f3ad1b8871cde1$var$matchSyntax(this, syntax, value, false);
    }
    findValueFragments(propertyName, value, type, name) {
        return $186ba1c1b660b56d$export$2c0817d7096f698(this, value, this.matchProperty(propertyName, value), type, name);
    }
    findDeclarationValueFragments(declaration, type, name) {
        return $186ba1c1b660b56d$export$2c0817d7096f698(this, declaration.value, this.matchDeclaration(declaration), type, name);
    }
    findAllFragments(ast, type, name) {
        const result = [];
        this.syntax.walk(ast, {
            visit: 'Declaration',
            enter: (declaration)=>{
                result.push.apply(result, this.findDeclarationValueFragments(declaration, type, name));
            }
        });
        return result;
    }
    getAtrule(atruleName, fallbackBasename = true) {
        const atrule = $ffbc3ade873552d0$export$2e81050496d0e63e(atruleName);
        const atruleEntry = atrule.vendor && fallbackBasename ? this.atrules[atrule.name] || this.atrules[atrule.basename] : this.atrules[atrule.name];
        return atruleEntry || null;
    }
    getAtrulePrelude(atruleName, fallbackBasename = true) {
        const atrule = this.getAtrule(atruleName, fallbackBasename);
        return atrule && atrule.prelude || null;
    }
    getAtruleDescriptor(atruleName, name) {
        return this.atrules.hasOwnProperty(atruleName) && this.atrules.declarators ? this.atrules[atruleName].declarators[name] || null : null;
    }
    getProperty(propertyName, fallbackBasename = true) {
        const property = $ffbc3ade873552d0$export$d541bacb2bda4494(propertyName);
        const propertyEntry = property.vendor && fallbackBasename ? this.properties[property.name] || this.properties[property.basename] : this.properties[property.name];
        return propertyEntry || null;
    }
    getType(name) {
        return hasOwnProperty.call(this.types, name) ? this.types[name] : null;
    }
    validate() {
        function validate(syntax, name, broken, descriptor) {
            if (broken.has(name)) return broken.get(name);
            broken.set(name, false);
            if (descriptor.syntax !== null) $40c4f52b975be836$export$588732934346abbf(descriptor.syntax, function(node) {
                if (node.type !== 'Type' && node.type !== 'Property') return;
                const map = node.type === 'Type' ? syntax.types : syntax.properties;
                const brokenMap = node.type === 'Type' ? brokenTypes : brokenProperties;
                if (!hasOwnProperty.call(map, node.name) || validate(syntax, node.name, brokenMap, map[node.name])) broken.set(name, true);
            }, this);
        }
        let brokenTypes = new Map();
        let brokenProperties = new Map();
        for(const key in this.types)validate(this, key, brokenTypes, this.types[key]);
        for(const key in this.properties)validate(this, key, brokenProperties, this.properties[key]);
        brokenTypes = [
            ...brokenTypes.keys()
        ].filter((name)=>brokenTypes.get(name));
        brokenProperties = [
            ...brokenProperties.keys()
        ].filter((name)=>brokenProperties.get(name));
        if (brokenTypes.length || brokenProperties.length) return {
            types: brokenTypes,
            properties: brokenProperties
        };
        return null;
    }
    dump(syntaxAsAst, pretty) {
        return {
            generic: this.generic,
            types: $60f3ad1b8871cde1$var$dumpMapSyntax(this.types, !pretty, syntaxAsAst),
            properties: $60f3ad1b8871cde1$var$dumpMapSyntax(this.properties, !pretty, syntaxAsAst),
            atrules: $60f3ad1b8871cde1$var$dumpAtruleMapSyntax(this.atrules, !pretty, syntaxAsAst)
        };
    }
    toString() {
        return JSON.stringify(this.dump());
    }
    constructor(config, syntax, structure$1){
        this.cssWideKeywordsSyntax = $60f3ad1b8871cde1$var$cssWideKeywordsSyntax;
        this.syntax = syntax;
        this.generic = false;
        this.atrules = Object.create(null);
        this.properties = Object.create(null);
        this.types = Object.create(null);
        this.structure = structure$1 || $ff82621029bc7643$export$2e9edb38e02d3c76(config);
        if (config) {
            if (config.types) for(const name in config.types)this.addType_(name, config.types[name]);
            if (config.generic) {
                this.generic = true;
                for(const name in $6970b5016679ff56$exports)this.addType_(name, $6970b5016679ff56$exports[name]);
            }
            if (config.atrules) for(const name in config.atrules)this.addAtrule_(name, config.atrules[name]);
            if (config.properties) for(const name in config.properties)this.addProperty_(name, config.properties[name]);
        }
    }
}
$60f3ad1b8871cde1$export$6168dc8908a6c652 = $60f3ad1b8871cde1$var$Lexer;


var $2adaa91f0b2628be$exports = {};
'use strict';
const { hasOwnProperty: $2adaa91f0b2628be$var$hasOwnProperty } = Object.prototype;
const $2adaa91f0b2628be$var$shape = {
    generic: true,
    types: $2adaa91f0b2628be$var$appendOrAssign,
    atrules: {
        prelude: $2adaa91f0b2628be$var$appendOrAssignOrNull,
        descriptors: $2adaa91f0b2628be$var$appendOrAssignOrNull
    },
    properties: $2adaa91f0b2628be$var$appendOrAssign,
    parseContext: $2adaa91f0b2628be$var$assign,
    scope: $2adaa91f0b2628be$var$deepAssign,
    atrule: [
        'parse'
    ],
    pseudo: [
        'parse'
    ],
    node: [
        'name',
        'structure',
        'parse',
        'generate',
        'walkContext'
    ]
};
function $2adaa91f0b2628be$var$isObject(value) {
    return value && value.constructor === Object;
}
function $2adaa91f0b2628be$var$copy(value) {
    return $2adaa91f0b2628be$var$isObject(value) ? {
        ...value
    } : value;
}
function $2adaa91f0b2628be$var$assign(dest, src) {
    return Object.assign(dest, src);
}
function $2adaa91f0b2628be$var$deepAssign(dest, src) {
    for(const key in src)if ($2adaa91f0b2628be$var$hasOwnProperty.call(src, key)) {
        if ($2adaa91f0b2628be$var$isObject(dest[key])) $2adaa91f0b2628be$var$deepAssign(dest[key], src[key]);
        else dest[key] = $2adaa91f0b2628be$var$copy(src[key]);
    }
    return dest;
}
function $2adaa91f0b2628be$var$append(a, b) {
    if (typeof b === 'string' && /^\s*\|/.test(b)) return typeof a === 'string' ? a + b : b.replace(/^\s*\|\s*/, '');
    return b || null;
}
function $2adaa91f0b2628be$var$appendOrAssign(a, b) {
    if (typeof b === 'string') return $2adaa91f0b2628be$var$append(a, b);
    const result = {
        ...a
    };
    for(let key in b)if ($2adaa91f0b2628be$var$hasOwnProperty.call(b, key)) result[key] = $2adaa91f0b2628be$var$append($2adaa91f0b2628be$var$hasOwnProperty.call(a, key) ? a[key] : undefined, b[key]);
    return result;
}
function $2adaa91f0b2628be$var$appendOrAssignOrNull(a, b) {
    const result = $2adaa91f0b2628be$var$appendOrAssign(a, b);
    return !$2adaa91f0b2628be$var$isObject(result) || Object.keys(result).length ? result : null;
}
function $2adaa91f0b2628be$var$mix(dest, src, shape) {
    for(const key in shape){
        if ($2adaa91f0b2628be$var$hasOwnProperty.call(shape, key) === false) continue;
        if (shape[key] === true) {
            if ($2adaa91f0b2628be$var$hasOwnProperty.call(src, key)) dest[key] = $2adaa91f0b2628be$var$copy(src[key]);
        } else if (shape[key]) {
            if (typeof shape[key] === 'function') {
                const fn = shape[key];
                dest[key] = fn({}, dest[key]);
                dest[key] = fn(dest[key] || {}, src[key]);
            } else if ($2adaa91f0b2628be$var$isObject(shape[key])) {
                const result = {};
                for(let name in dest[key])result[name] = $2adaa91f0b2628be$var$mix({}, dest[key][name], shape[key]);
                for(let name in src[key])result[name] = $2adaa91f0b2628be$var$mix(result[name] || {}, src[key][name], shape[key]);
                dest[key] = result;
            } else if (Array.isArray(shape[key])) {
                const res = {};
                const innerShape = shape[key].reduce(function(s, k) {
                    s[k] = true;
                    return s;
                }, {});
                for (const [name, value] of Object.entries(dest[key] || {})){
                    res[name] = {};
                    if (value) $2adaa91f0b2628be$var$mix(res[name], value, innerShape);
                }
                for(const name in src[key])if ($2adaa91f0b2628be$var$hasOwnProperty.call(src[key], name)) {
                    if (!res[name]) res[name] = {};
                    if (src[key] && src[key][name]) $2adaa91f0b2628be$var$mix(res[name], src[key][name], innerShape);
                }
                dest[key] = res;
            }
        }
    }
    return dest;
}
const $2adaa91f0b2628be$var$mix$1 = (dest, src)=>$2adaa91f0b2628be$var$mix(dest, src, $2adaa91f0b2628be$var$shape);
$2adaa91f0b2628be$exports = $2adaa91f0b2628be$var$mix$1;


function $92105e36fb3855b0$var$createSyntax(config) {
    const parse = $c805037aeb82e0c4$export$88a1156fad04455f(config);
    const walk = $7dfc4fbfb5b2b3ed$export$774c92c6aec941e8(config);
    const generate = $fbf1b8636f63a752$export$881f0ad61271ba2(config);
    const { fromPlainObject: fromPlainObject, toPlainObject: toPlainObject } = $ed05eff50bb2deab$export$270c35c9c0b7b1f9(walk);
    const syntax = {
        lexer: null,
        createLexer: (config)=>new $60f3ad1b8871cde1$export$6168dc8908a6c652(config, syntax, syntax.lexer.structure),
        tokenize: $14ef1a69abba2f52$export$660b2ee2d4fb4eff,
        parse: parse,
        generate: generate,
        walk: walk,
        find: walk.find,
        findLast: walk.findLast,
        findAll: walk.findAll,
        fromPlainObject: fromPlainObject,
        toPlainObject: toPlainObject,
        fork (extension) {
            const base = $2adaa91f0b2628be$exports({}, config); // copy of config
            return $92105e36fb3855b0$var$createSyntax(typeof extension === 'function' ? extension(base, Object.assign) : $2adaa91f0b2628be$exports(base, extension));
        }
    };
    syntax.lexer = new $60f3ad1b8871cde1$export$6168dc8908a6c652({
        generic: true,
        types: config.types,
        atrules: config.atrules,
        properties: config.properties,
        node: config.node
    }, syntax);
    return syntax;
}
const $92105e36fb3855b0$var$createSyntax$1 = (config)=>$92105e36fb3855b0$var$createSyntax($2adaa91f0b2628be$exports({}, config));
$92105e36fb3855b0$exports = $92105e36fb3855b0$var$createSyntax$1;


var $cf6fa3818b31b6ea$exports = {};
'use strict';
var $a47e5819577d822d$exports = {};
$a47e5819577d822d$exports = {
    "generic": true,
    "types": {
        "absolute-size": "xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large",
        "alpha-value": "<number>|<percentage>",
        "angle-percentage": "<angle>|<percentage>",
        "angular-color-hint": "<angle-percentage>",
        "angular-color-stop": "<color>&&<color-stop-angle>?",
        "angular-color-stop-list": "[<angular-color-stop> [, <angular-color-hint>]?]# , <angular-color-stop>",
        "animateable-feature": "scroll-position|contents|<custom-ident>",
        "attachment": "scroll|fixed|local",
        "attr()": "attr( <attr-name> <type-or-unit>? [, <attr-fallback>]? )",
        "attr-matcher": "['~'|'|'|'^'|'$'|'*']? '='",
        "attr-modifier": "i|s",
        "attribute-selector": "'[' <wq-name> ']'|'[' <wq-name> <attr-matcher> [<string-token>|<ident-token>] <attr-modifier>? ']'",
        "auto-repeat": "repeat( [auto-fill|auto-fit] , [<line-names>? <fixed-size>]+ <line-names>? )",
        "auto-track-list": "[<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>? <auto-repeat> [<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>?",
        "baseline-position": "[first|last]? baseline",
        "basic-shape": "<inset()>|<circle()>|<ellipse()>|<polygon()>|<path()>",
        "bg-image": "none|<image>",
        "bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
        "bg-position": "[[left|center|right|top|bottom|<length-percentage>]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]|[center|[left|right] <length-percentage>?]&&[center|[top|bottom] <length-percentage>?]]",
        "bg-size": "[<length-percentage>|auto]{1,2}|cover|contain",
        "blur()": "blur( <length> )",
        "blend-mode": "normal|multiply|screen|overlay|darken|lighten|color-dodge|color-burn|hard-light|soft-light|difference|exclusion|hue|saturation|color|luminosity",
        "box": "border-box|padding-box|content-box",
        "brightness()": "brightness( <number-percentage> )",
        "calc()": "calc( <calc-sum> )",
        "calc-sum": "<calc-product> [['+'|'-'] <calc-product>]*",
        "calc-product": "<calc-value> ['*' <calc-value>|'/' <number>]*",
        "calc-value": "<number>|<dimension>|<percentage>|( <calc-sum> )",
        "cf-final-image": "<image>|<color>",
        "cf-mixing-image": "<percentage>?&&<image>",
        "circle()": "circle( [<shape-radius>]? [at <position>]? )",
        "clamp()": "clamp( <calc-sum>#{3} )",
        "class-selector": "'.' <ident-token>",
        "clip-source": "<url>",
        "color": "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<hex-color>|<named-color>|currentcolor|<deprecated-system-color>",
        "color-stop": "<color-stop-length>|<color-stop-angle>",
        "color-stop-angle": "<angle-percentage>{1,2}",
        "color-stop-length": "<length-percentage>{1,2}",
        "color-stop-list": "[<linear-color-stop> [, <linear-color-hint>]?]# , <linear-color-stop>",
        "combinator": "'>'|'+'|'~'|['||']",
        "common-lig-values": "[common-ligatures|no-common-ligatures]",
        "compat-auto": "searchfield|textarea|push-button|slider-horizontal|checkbox|radio|square-button|menulist|listbox|meter|progress-bar|button",
        "composite-style": "clear|copy|source-over|source-in|source-out|source-atop|destination-over|destination-in|destination-out|destination-atop|xor",
        "compositing-operator": "add|subtract|intersect|exclude",
        "compound-selector": "[<type-selector>? <subclass-selector>* [<pseudo-element-selector> <pseudo-class-selector>*]*]!",
        "compound-selector-list": "<compound-selector>#",
        "complex-selector": "<compound-selector> [<combinator>? <compound-selector>]*",
        "complex-selector-list": "<complex-selector>#",
        "conic-gradient()": "conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
        "contextual-alt-values": "[contextual|no-contextual]",
        "content-distribution": "space-between|space-around|space-evenly|stretch",
        "content-list": "[<string>|contents|<image>|<counter>|<quote>|<target>|<leader()>|<attr()>]+",
        "content-position": "center|start|end|flex-start|flex-end",
        "content-replacement": "<image>",
        "contrast()": "contrast( [<number-percentage>] )",
        "counter": "<counter()>|<counters()>",
        "counter()": "counter( <counter-name> , <counter-style>? )",
        "counter-name": "<custom-ident>",
        "counter-style": "<counter-style-name>|symbols( )",
        "counter-style-name": "<custom-ident>",
        "counters()": "counters( <counter-name> , <string> , <counter-style>? )",
        "cross-fade()": "cross-fade( <cf-mixing-image> , <cf-final-image>? )",
        "cubic-bezier-timing-function": "ease|ease-in|ease-out|ease-in-out|cubic-bezier( <number [0,1]> , <number> , <number [0,1]> , <number> )",
        "deprecated-system-color": "ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonFace|ButtonHighlight|ButtonShadow|ButtonText|CaptionText|GrayText|Highlight|HighlightText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText",
        "discretionary-lig-values": "[discretionary-ligatures|no-discretionary-ligatures]",
        "display-box": "contents|none",
        "display-inside": "flow|flow-root|table|flex|grid|ruby",
        "display-internal": "table-row-group|table-header-group|table-footer-group|table-row|table-cell|table-column-group|table-column|table-caption|ruby-base|ruby-text|ruby-base-container|ruby-text-container",
        "display-legacy": "inline-block|inline-list-item|inline-table|inline-flex|inline-grid",
        "display-listitem": "<display-outside>?&&[flow|flow-root]?&&list-item",
        "display-outside": "block|inline|run-in",
        "drop-shadow()": "drop-shadow( <length>{2,3} <color>? )",
        "east-asian-variant-values": "[jis78|jis83|jis90|jis04|simplified|traditional]",
        "east-asian-width-values": "[full-width|proportional-width]",
        "element()": "element( <custom-ident> , [first|start|last|first-except]? )|element( <id-selector> )",
        "ellipse()": "ellipse( [<shape-radius>{2}]? [at <position>]? )",
        "ending-shape": "circle|ellipse",
        "env()": "env( <custom-ident> , <declaration-value>? )",
        "explicit-track-list": "[<line-names>? <track-size>]+ <line-names>?",
        "family-name": "<string>|<custom-ident>+",
        "feature-tag-value": "<string> [<integer>|on|off]?",
        "feature-type": "@stylistic|@historical-forms|@styleset|@character-variant|@swash|@ornaments|@annotation",
        "feature-value-block": "<feature-type> '{' <feature-value-declaration-list> '}'",
        "feature-value-block-list": "<feature-value-block>+",
        "feature-value-declaration": "<custom-ident> : <integer>+ ;",
        "feature-value-declaration-list": "<feature-value-declaration>",
        "feature-value-name": "<custom-ident>",
        "fill-rule": "nonzero|evenodd",
        "filter-function": "<blur()>|<brightness()>|<contrast()>|<drop-shadow()>|<grayscale()>|<hue-rotate()>|<invert()>|<opacity()>|<saturate()>|<sepia()>",
        "filter-function-list": "[<filter-function>|<url>]+",
        "final-bg-layer": "<'background-color'>||<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
        "fit-content()": "fit-content( [<length>|<percentage>] )",
        "fixed-breadth": "<length-percentage>",
        "fixed-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <fixed-size>]+ <line-names>? )",
        "fixed-size": "<fixed-breadth>|minmax( <fixed-breadth> , <track-breadth> )|minmax( <inflexible-breadth> , <fixed-breadth> )",
        "font-stretch-absolute": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded|<percentage>",
        "font-variant-css21": "[normal|small-caps]",
        "font-weight-absolute": "normal|bold|<number [1,1000]>",
        "frequency-percentage": "<frequency>|<percentage>",
        "general-enclosed": "[<function-token> <any-value> )]|( <ident> <any-value> )",
        "generic-family": "serif|sans-serif|cursive|fantasy|monospace|-apple-system",
        "generic-name": "serif|sans-serif|cursive|fantasy|monospace",
        "geometry-box": "<shape-box>|fill-box|stroke-box|view-box",
        "gradient": "<linear-gradient()>|<repeating-linear-gradient()>|<radial-gradient()>|<repeating-radial-gradient()>|<conic-gradient()>|<repeating-conic-gradient()>|<-legacy-gradient>",
        "grayscale()": "grayscale( <number-percentage> )",
        "grid-line": "auto|<custom-ident>|[<integer>&&<custom-ident>?]|[span&&[<integer>||<custom-ident>]]",
        "historical-lig-values": "[historical-ligatures|no-historical-ligatures]",
        "hsl()": "hsl( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsl( <hue> , <percentage> , <percentage> , <alpha-value>? )",
        "hsla()": "hsla( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsla( <hue> , <percentage> , <percentage> , <alpha-value>? )",
        "hue": "<number>|<angle>",
        "hue-rotate()": "hue-rotate( <angle> )",
        "hwb()": "hwb( [<hue>|none] [<percentage>|none] [<percentage>|none] [/ [<alpha-value>|none]]? )",
        "image": "<url>|<image()>|<image-set()>|<element()>|<paint()>|<cross-fade()>|<gradient>",
        "image()": "image( <image-tags>? [<image-src>? , <color>?]! )",
        "image-set()": "image-set( <image-set-option># )",
        "image-set-option": "[<image>|<string>] [<resolution>||type( <string> )]",
        "image-src": "<url>|<string>",
        "image-tags": "ltr|rtl",
        "inflexible-breadth": "<length>|<percentage>|min-content|max-content|auto",
        "inset()": "inset( <length-percentage>{1,4} [round <'border-radius'>]? )",
        "invert()": "invert( <number-percentage> )",
        "keyframes-name": "<custom-ident>|<string>",
        "keyframe-block": "<keyframe-selector># { <declaration-list> }",
        "keyframe-block-list": "<keyframe-block>+",
        "keyframe-selector": "from|to|<percentage>",
        "layer()": "layer( <layer-name> )",
        "layer-name": "<ident> ['.' <ident>]*",
        "leader()": "leader( <leader-type> )",
        "leader-type": "dotted|solid|space|<string>",
        "length-percentage": "<length>|<percentage>",
        "line-names": "'[' <custom-ident>* ']'",
        "line-name-list": "[<line-names>|<name-repeat>]+",
        "line-style": "none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset",
        "line-width": "<length>|thin|medium|thick",
        "linear-color-hint": "<length-percentage>",
        "linear-color-stop": "<color> <color-stop-length>?",
        "linear-gradient()": "linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
        "mask-layer": "<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||<geometry-box>||[<geometry-box>|no-clip]||<compositing-operator>||<masking-mode>",
        "mask-position": "[<length-percentage>|left|center|right] [<length-percentage>|top|center|bottom]?",
        "mask-reference": "none|<image>|<mask-source>",
        "mask-source": "<url>",
        "masking-mode": "alpha|luminance|match-source",
        "matrix()": "matrix( <number>#{6} )",
        "matrix3d()": "matrix3d( <number>#{16} )",
        "max()": "max( <calc-sum># )",
        "media-and": "<media-in-parens> [and <media-in-parens>]+",
        "media-condition": "<media-not>|<media-and>|<media-or>|<media-in-parens>",
        "media-condition-without-or": "<media-not>|<media-and>|<media-in-parens>",
        "media-feature": "( [<mf-plain>|<mf-boolean>|<mf-range>] )",
        "media-in-parens": "( <media-condition> )|<media-feature>|<general-enclosed>",
        "media-not": "not <media-in-parens>",
        "media-or": "<media-in-parens> [or <media-in-parens>]+",
        "media-query": "<media-condition>|[not|only]? <media-type> [and <media-condition-without-or>]?",
        "media-query-list": "<media-query>#",
        "media-type": "<ident>",
        "mf-boolean": "<mf-name>",
        "mf-name": "<ident>",
        "mf-plain": "<mf-name> : <mf-value>",
        "mf-range": "<mf-name> ['<'|'>']? '='? <mf-value>|<mf-value> ['<'|'>']? '='? <mf-name>|<mf-value> '<' '='? <mf-name> '<' '='? <mf-value>|<mf-value> '>' '='? <mf-name> '>' '='? <mf-value>",
        "mf-value": "<number>|<dimension>|<ident>|<ratio>",
        "min()": "min( <calc-sum># )",
        "minmax()": "minmax( [<length>|<percentage>|min-content|max-content|auto] , [<length>|<percentage>|<flex>|min-content|max-content|auto] )",
        "name-repeat": "repeat( [<integer [1,\u221E]>|auto-fill] , <line-names>+ )",
        "named-color": "transparent|aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen|<-non-standard-color>",
        "namespace-prefix": "<ident>",
        "ns-prefix": "[<ident-token>|'*']? '|'",
        "number-percentage": "<number>|<percentage>",
        "numeric-figure-values": "[lining-nums|oldstyle-nums]",
        "numeric-fraction-values": "[diagonal-fractions|stacked-fractions]",
        "numeric-spacing-values": "[proportional-nums|tabular-nums]",
        "nth": "<an-plus-b>|even|odd",
        "opacity()": "opacity( [<number-percentage>] )",
        "overflow-position": "unsafe|safe",
        "outline-radius": "<length>|<percentage>",
        "page-body": "<declaration>? [; <page-body>]?|<page-margin-box> <page-body>",
        "page-margin-box": "<page-margin-box-type> '{' <declaration-list> '}'",
        "page-margin-box-type": "@top-left-corner|@top-left|@top-center|@top-right|@top-right-corner|@bottom-left-corner|@bottom-left|@bottom-center|@bottom-right|@bottom-right-corner|@left-top|@left-middle|@left-bottom|@right-top|@right-middle|@right-bottom",
        "page-selector-list": "[<page-selector>#]?",
        "page-selector": "<pseudo-page>+|<ident> <pseudo-page>*",
        "page-size": "A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger",
        "path()": "path( [<fill-rule> ,]? <string> )",
        "paint()": "paint( <ident> , <declaration-value>? )",
        "perspective()": "perspective( <length> )",
        "polygon()": "polygon( <fill-rule>? , [<length-percentage> <length-percentage>]# )",
        "position": "[[left|center|right]||[top|center|bottom]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]?|[[left|right] <length-percentage>]&&[[top|bottom] <length-percentage>]]",
        "pseudo-class-selector": "':' <ident-token>|':' <function-token> <any-value> ')'",
        "pseudo-element-selector": "':' <pseudo-class-selector>",
        "pseudo-page": ": [left|right|first|blank]",
        "quote": "open-quote|close-quote|no-open-quote|no-close-quote",
        "radial-gradient()": "radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
        "relative-selector": "<combinator>? <complex-selector>",
        "relative-selector-list": "<relative-selector>#",
        "relative-size": "larger|smaller",
        "repeat-style": "repeat-x|repeat-y|[repeat|space|round|no-repeat]{1,2}",
        "repeating-conic-gradient()": "repeating-conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
        "repeating-linear-gradient()": "repeating-linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
        "repeating-radial-gradient()": "repeating-radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
        "rgb()": "rgb( <percentage>{3} [/ <alpha-value>]? )|rgb( <number>{3} [/ <alpha-value>]? )|rgb( <percentage>#{3} , <alpha-value>? )|rgb( <number>#{3} , <alpha-value>? )",
        "rgba()": "rgba( <percentage>{3} [/ <alpha-value>]? )|rgba( <number>{3} [/ <alpha-value>]? )|rgba( <percentage>#{3} , <alpha-value>? )|rgba( <number>#{3} , <alpha-value>? )",
        "rotate()": "rotate( [<angle>|<zero>] )",
        "rotate3d()": "rotate3d( <number> , <number> , <number> , [<angle>|<zero>] )",
        "rotateX()": "rotateX( [<angle>|<zero>] )",
        "rotateY()": "rotateY( [<angle>|<zero>] )",
        "rotateZ()": "rotateZ( [<angle>|<zero>] )",
        "saturate()": "saturate( <number-percentage> )",
        "scale()": "scale( <number> , <number>? )",
        "scale3d()": "scale3d( <number> , <number> , <number> )",
        "scaleX()": "scaleX( <number> )",
        "scaleY()": "scaleY( <number> )",
        "scaleZ()": "scaleZ( <number> )",
        "self-position": "center|start|end|self-start|self-end|flex-start|flex-end",
        "shape-radius": "<length-percentage>|closest-side|farthest-side",
        "skew()": "skew( [<angle>|<zero>] , [<angle>|<zero>]? )",
        "skewX()": "skewX( [<angle>|<zero>] )",
        "skewY()": "skewY( [<angle>|<zero>] )",
        "sepia()": "sepia( <number-percentage> )",
        "shadow": "inset?&&<length>{2,4}&&<color>?",
        "shadow-t": "[<length>{2,3}&&<color>?]",
        "shape": "rect( <top> , <right> , <bottom> , <left> )|rect( <top> <right> <bottom> <left> )",
        "shape-box": "<box>|margin-box",
        "side-or-corner": "[left|right]||[top|bottom]",
        "single-animation": "<time>||<easing-function>||<time>||<single-animation-iteration-count>||<single-animation-direction>||<single-animation-fill-mode>||<single-animation-play-state>||[none|<keyframes-name>]",
        "single-animation-direction": "normal|reverse|alternate|alternate-reverse",
        "single-animation-fill-mode": "none|forwards|backwards|both",
        "single-animation-iteration-count": "infinite|<number>",
        "single-animation-play-state": "running|paused",
        "single-animation-timeline": "auto|none|<timeline-name>",
        "single-transition": "[none|<single-transition-property>]||<time>||<easing-function>||<time>",
        "single-transition-property": "all|<custom-ident>",
        "size": "closest-side|farthest-side|closest-corner|farthest-corner|<length>|<length-percentage>{2}",
        "step-position": "jump-start|jump-end|jump-none|jump-both|start|end",
        "step-timing-function": "step-start|step-end|steps( <integer> [, <step-position>]? )",
        "subclass-selector": "<id-selector>|<class-selector>|<attribute-selector>|<pseudo-class-selector>",
        "supports-condition": "not <supports-in-parens>|<supports-in-parens> [and <supports-in-parens>]*|<supports-in-parens> [or <supports-in-parens>]*",
        "supports-in-parens": "( <supports-condition> )|<supports-feature>|<general-enclosed>",
        "supports-feature": "<supports-decl>|<supports-selector-fn>",
        "supports-decl": "( <declaration> )",
        "supports-selector-fn": "selector( <complex-selector> )",
        "symbol": "<string>|<image>|<custom-ident>",
        "target": "<target-counter()>|<target-counters()>|<target-text()>",
        "target-counter()": "target-counter( [<string>|<url>] , <custom-ident> , <counter-style>? )",
        "target-counters()": "target-counters( [<string>|<url>] , <custom-ident> , <string> , <counter-style>? )",
        "target-text()": "target-text( [<string>|<url>] , [content|before|after|first-letter]? )",
        "time-percentage": "<time>|<percentage>",
        "timeline-name": "<custom-ident>|<string>",
        "easing-function": "linear|<cubic-bezier-timing-function>|<step-timing-function>",
        "track-breadth": "<length-percentage>|<flex>|min-content|max-content|auto",
        "track-list": "[<line-names>? [<track-size>|<track-repeat>]]+ <line-names>?",
        "track-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <track-size>]+ <line-names>? )",
        "track-size": "<track-breadth>|minmax( <inflexible-breadth> , <track-breadth> )|fit-content( [<length>|<percentage>] )",
        "transform-function": "<matrix()>|<translate()>|<translateX()>|<translateY()>|<scale()>|<scaleX()>|<scaleY()>|<rotate()>|<skew()>|<skewX()>|<skewY()>|<matrix3d()>|<translate3d()>|<translateZ()>|<scale3d()>|<scaleZ()>|<rotate3d()>|<rotateX()>|<rotateY()>|<rotateZ()>|<perspective()>",
        "transform-list": "<transform-function>+",
        "translate()": "translate( <length-percentage> , <length-percentage>? )",
        "translate3d()": "translate3d( <length-percentage> , <length-percentage> , <length> )",
        "translateX()": "translateX( <length-percentage> )",
        "translateY()": "translateY( <length-percentage> )",
        "translateZ()": "translateZ( <length> )",
        "type-or-unit": "string|color|url|integer|number|length|angle|time|frequency|cap|ch|em|ex|ic|lh|rlh|rem|vb|vi|vw|vh|vmin|vmax|mm|Q|cm|in|pt|pc|px|deg|grad|rad|turn|ms|s|Hz|kHz|%",
        "type-selector": "<wq-name>|<ns-prefix>? '*'",
        "var()": "var( <custom-property-name> , <declaration-value>? )",
        "viewport-length": "auto|<length-percentage>",
        "visual-box": "content-box|padding-box|border-box",
        "wq-name": "<ns-prefix>? <ident-token>",
        "-legacy-gradient": "<-webkit-gradient()>|<-legacy-linear-gradient>|<-legacy-repeating-linear-gradient>|<-legacy-radial-gradient>|<-legacy-repeating-radial-gradient>",
        "-legacy-linear-gradient": "-moz-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-linear-gradient( <-legacy-linear-gradient-arguments> )",
        "-legacy-repeating-linear-gradient": "-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )",
        "-legacy-linear-gradient-arguments": "[<angle>|<side-or-corner>]? , <color-stop-list>",
        "-legacy-radial-gradient": "-moz-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-radial-gradient( <-legacy-radial-gradient-arguments> )",
        "-legacy-repeating-radial-gradient": "-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )",
        "-legacy-radial-gradient-arguments": "[<position> ,]? [[[<-legacy-radial-gradient-shape>||<-legacy-radial-gradient-size>]|[<length>|<percentage>]{2}] ,]? <color-stop-list>",
        "-legacy-radial-gradient-size": "closest-side|closest-corner|farthest-side|farthest-corner|contain|cover",
        "-legacy-radial-gradient-shape": "circle|ellipse",
        "-non-standard-font": "-apple-system-body|-apple-system-headline|-apple-system-subheadline|-apple-system-caption1|-apple-system-caption2|-apple-system-footnote|-apple-system-short-body|-apple-system-short-headline|-apple-system-short-subheadline|-apple-system-short-caption1|-apple-system-short-footnote|-apple-system-tall-body",
        "-non-standard-color": "-moz-ButtonDefault|-moz-ButtonHoverFace|-moz-ButtonHoverText|-moz-CellHighlight|-moz-CellHighlightText|-moz-Combobox|-moz-ComboboxText|-moz-Dialog|-moz-DialogText|-moz-dragtargetzone|-moz-EvenTreeRow|-moz-Field|-moz-FieldText|-moz-html-CellHighlight|-moz-html-CellHighlightText|-moz-mac-accentdarkestshadow|-moz-mac-accentdarkshadow|-moz-mac-accentface|-moz-mac-accentlightesthighlight|-moz-mac-accentlightshadow|-moz-mac-accentregularhighlight|-moz-mac-accentregularshadow|-moz-mac-chrome-active|-moz-mac-chrome-inactive|-moz-mac-focusring|-moz-mac-menuselect|-moz-mac-menushadow|-moz-mac-menutextselect|-moz-MenuHover|-moz-MenuHoverText|-moz-MenuBarText|-moz-MenuBarHoverText|-moz-nativehyperlinktext|-moz-OddTreeRow|-moz-win-communicationstext|-moz-win-mediatext|-moz-activehyperlinktext|-moz-default-background-color|-moz-default-color|-moz-hyperlinktext|-moz-visitedhyperlinktext|-webkit-activelink|-webkit-focus-ring-color|-webkit-link|-webkit-text",
        "-non-standard-image-rendering": "optimize-contrast|-moz-crisp-edges|-o-crisp-edges|-webkit-optimize-contrast",
        "-non-standard-overflow": "-moz-scrollbars-none|-moz-scrollbars-horizontal|-moz-scrollbars-vertical|-moz-hidden-unscrollable",
        "-non-standard-width": "fill-available|min-intrinsic|intrinsic|-moz-available|-moz-fit-content|-moz-min-content|-moz-max-content|-webkit-min-content|-webkit-max-content",
        "-webkit-gradient()": "-webkit-gradient( <-webkit-gradient-type> , <-webkit-gradient-point> [, <-webkit-gradient-point>|, <-webkit-gradient-radius> , <-webkit-gradient-point>] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )",
        "-webkit-gradient-color-stop": "from( <color> )|color-stop( [<number-zero-one>|<percentage>] , <color> )|to( <color> )",
        "-webkit-gradient-point": "[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]",
        "-webkit-gradient-radius": "<length>|<percentage>",
        "-webkit-gradient-type": "linear|radial",
        "-webkit-mask-box-repeat": "repeat|stretch|round",
        "-webkit-mask-clip-style": "border|border-box|padding|padding-box|content|content-box|text",
        "-ms-filter-function-list": "<-ms-filter-function>+",
        "-ms-filter-function": "<-ms-filter-function-progid>|<-ms-filter-function-legacy>",
        "-ms-filter-function-progid": "'progid:' [<ident-token> '.']* [<ident-token>|<function-token> <any-value>? )]",
        "-ms-filter-function-legacy": "<ident-token>|<function-token> <any-value>? )",
        "-ms-filter": "<string>",
        "age": "child|young|old",
        "attr-name": "<wq-name>",
        "attr-fallback": "<any-value>",
        "bg-clip": "<box>|border|text",
        "border-radius": "<length-percentage>{1,2}",
        "bottom": "<length>|auto",
        "generic-voice": "[<age>? <gender> <integer>?]",
        "gender": "male|female|neutral",
        "lab()": "lab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
        "lch()": "lch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
        "left": "<length>|auto",
        "mask-image": "<mask-reference>#",
        "paint": "none|<color>|<url> [none|<color>]?|context-fill|context-stroke",
        "ratio": "<number [0,\u221E]> [/ <number [0,\u221E]>]?",
        "reversed-counter-name": "reversed( <counter-name> )",
        "right": "<length>|auto",
        "svg-length": "<percentage>|<length>|<number>",
        "svg-writing-mode": "lr-tb|rl-tb|tb-rl|lr|rl|tb",
        "top": "<length>|auto",
        "track-group": "'(' [<string>* <track-minmax> <string>*]+ ')' ['[' <positive-integer> ']']?|<track-minmax>",
        "track-list-v0": "[<string>* <track-group> <string>*]+|none",
        "track-minmax": "minmax( <track-breadth> , <track-breadth> )|auto|<track-breadth>|fit-content",
        "x": "<number>",
        "y": "<number>",
        "declaration": "<ident-token> : <declaration-value>? ['!' important]?",
        "declaration-list": "[<declaration>? ';']* <declaration>?",
        "url": "url( <string> <url-modifier>* )|<url-token>",
        "url-modifier": "<ident>|<function-token> <any-value> )",
        "number-zero-one": "<number [0,1]>",
        "number-one-or-greater": "<number [1,\u221E]>",
        "positive-integer": "<integer [0,\u221E]>",
        "-non-standard-display": "-ms-inline-flexbox|-ms-grid|-ms-inline-grid|-webkit-flex|-webkit-inline-flex|-webkit-box|-webkit-inline-box|-moz-inline-stack|-moz-box|-moz-inline-box"
    },
    "properties": {
        "--*": "<declaration-value>",
        "-ms-accelerator": "false|true",
        "-ms-block-progression": "tb|rl|bt|lr",
        "-ms-content-zoom-chaining": "none|chained",
        "-ms-content-zooming": "none|zoom",
        "-ms-content-zoom-limit": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
        "-ms-content-zoom-limit-max": "<percentage>",
        "-ms-content-zoom-limit-min": "<percentage>",
        "-ms-content-zoom-snap": "<'-ms-content-zoom-snap-type'>||<'-ms-content-zoom-snap-points'>",
        "-ms-content-zoom-snap-points": "snapInterval( <percentage> , <percentage> )|snapList( <percentage># )",
        "-ms-content-zoom-snap-type": "none|proximity|mandatory",
        "-ms-filter": "<string>",
        "-ms-flow-from": "[none|<custom-ident>]#",
        "-ms-flow-into": "[none|<custom-ident>]#",
        "-ms-grid-columns": "none|<track-list>|<auto-track-list>",
        "-ms-grid-rows": "none|<track-list>|<auto-track-list>",
        "-ms-high-contrast-adjust": "auto|none",
        "-ms-hyphenate-limit-chars": "auto|<integer>{1,3}",
        "-ms-hyphenate-limit-lines": "no-limit|<integer>",
        "-ms-hyphenate-limit-zone": "<percentage>|<length>",
        "-ms-ime-align": "auto|after",
        "-ms-overflow-style": "auto|none|scrollbar|-ms-autohiding-scrollbar",
        "-ms-scrollbar-3dlight-color": "<color>",
        "-ms-scrollbar-arrow-color": "<color>",
        "-ms-scrollbar-base-color": "<color>",
        "-ms-scrollbar-darkshadow-color": "<color>",
        "-ms-scrollbar-face-color": "<color>",
        "-ms-scrollbar-highlight-color": "<color>",
        "-ms-scrollbar-shadow-color": "<color>",
        "-ms-scrollbar-track-color": "<color>",
        "-ms-scroll-chaining": "chained|none",
        "-ms-scroll-limit": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
        "-ms-scroll-limit-x-max": "auto|<length>",
        "-ms-scroll-limit-x-min": "<length>",
        "-ms-scroll-limit-y-max": "auto|<length>",
        "-ms-scroll-limit-y-min": "<length>",
        "-ms-scroll-rails": "none|railed",
        "-ms-scroll-snap-points-x": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
        "-ms-scroll-snap-points-y": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
        "-ms-scroll-snap-type": "none|proximity|mandatory",
        "-ms-scroll-snap-x": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
        "-ms-scroll-snap-y": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
        "-ms-scroll-translation": "none|vertical-to-horizontal",
        "-ms-text-autospace": "none|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space",
        "-ms-touch-select": "grippers|none",
        "-ms-user-select": "none|element|text",
        "-ms-wrap-flow": "auto|both|start|end|maximum|clear",
        "-ms-wrap-margin": "<length>",
        "-ms-wrap-through": "wrap|none",
        "-moz-appearance": "none|button|button-arrow-down|button-arrow-next|button-arrow-previous|button-arrow-up|button-bevel|button-focus|caret|checkbox|checkbox-container|checkbox-label|checkmenuitem|dualbutton|groupbox|listbox|listitem|menuarrow|menubar|menucheckbox|menuimage|menuitem|menuitemtext|menulist|menulist-button|menulist-text|menulist-textfield|menupopup|menuradio|menuseparator|meterbar|meterchunk|progressbar|progressbar-vertical|progresschunk|progresschunk-vertical|radio|radio-container|radio-label|radiomenuitem|range|range-thumb|resizer|resizerpanel|scale-horizontal|scalethumbend|scalethumb-horizontal|scalethumbstart|scalethumbtick|scalethumb-vertical|scale-vertical|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|separator|sheet|spinner|spinner-downbutton|spinner-textfield|spinner-upbutton|splitter|statusbar|statusbarpanel|tab|tabpanel|tabpanels|tab-scroll-arrow-back|tab-scroll-arrow-forward|textfield|textfield-multiline|toolbar|toolbarbutton|toolbarbutton-dropdown|toolbargripper|toolbox|tooltip|treeheader|treeheadercell|treeheadersortarrow|treeitem|treeline|treetwisty|treetwistyopen|treeview|-moz-mac-unified-toolbar|-moz-win-borderless-glass|-moz-win-browsertabbar-toolbox|-moz-win-communicationstext|-moz-win-communications-toolbox|-moz-win-exclude-glass|-moz-win-glass|-moz-win-mediatext|-moz-win-media-toolbox|-moz-window-button-box|-moz-window-button-box-maximized|-moz-window-button-close|-moz-window-button-maximize|-moz-window-button-minimize|-moz-window-button-restore|-moz-window-frame-bottom|-moz-window-frame-left|-moz-window-frame-right|-moz-window-titlebar|-moz-window-titlebar-maximized",
        "-moz-binding": "<url>|none",
        "-moz-border-bottom-colors": "<color>+|none",
        "-moz-border-left-colors": "<color>+|none",
        "-moz-border-right-colors": "<color>+|none",
        "-moz-border-top-colors": "<color>+|none",
        "-moz-context-properties": "none|[fill|fill-opacity|stroke|stroke-opacity]#",
        "-moz-float-edge": "border-box|content-box|margin-box|padding-box",
        "-moz-force-broken-image-icon": "0|1",
        "-moz-image-region": "<shape>|auto",
        "-moz-orient": "inline|block|horizontal|vertical",
        "-moz-outline-radius": "<outline-radius>{1,4} [/ <outline-radius>{1,4}]?",
        "-moz-outline-radius-bottomleft": "<outline-radius>",
        "-moz-outline-radius-bottomright": "<outline-radius>",
        "-moz-outline-radius-topleft": "<outline-radius>",
        "-moz-outline-radius-topright": "<outline-radius>",
        "-moz-stack-sizing": "ignore|stretch-to-fit",
        "-moz-text-blink": "none|blink",
        "-moz-user-focus": "ignore|normal|select-after|select-before|select-menu|select-same|select-all|none",
        "-moz-user-input": "auto|none|enabled|disabled",
        "-moz-user-modify": "read-only|read-write|write-only",
        "-moz-window-dragging": "drag|no-drag",
        "-moz-window-shadow": "default|menu|tooltip|sheet|none",
        "-webkit-appearance": "none|button|button-bevel|caps-lock-indicator|caret|checkbox|default-button|inner-spin-button|listbox|listitem|media-controls-background|media-controls-fullscreen-background|media-current-time-display|media-enter-fullscreen-button|media-exit-fullscreen-button|media-fullscreen-button|media-mute-button|media-overlay-play-button|media-play-button|media-seek-back-button|media-seek-forward-button|media-slider|media-sliderthumb|media-time-remaining-display|media-toggle-closed-captions-button|media-volume-slider|media-volume-slider-container|media-volume-sliderthumb|menulist|menulist-button|menulist-text|menulist-textfield|meter|progress-bar|progress-bar-value|push-button|radio|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbargripper-horizontal|scrollbargripper-vertical|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|searchfield-cancel-button|searchfield-decoration|searchfield-results-button|searchfield-results-decoration|slider-horizontal|slider-vertical|sliderthumb-horizontal|sliderthumb-vertical|square-button|textarea|textfield|-apple-pay-button",
        "-webkit-border-before": "<'border-width'>||<'border-style'>||<color>",
        "-webkit-border-before-color": "<color>",
        "-webkit-border-before-style": "<'border-style'>",
        "-webkit-border-before-width": "<'border-width'>",
        "-webkit-box-reflect": "[above|below|right|left]? <length>? <image>?",
        "-webkit-line-clamp": "none|<integer>",
        "-webkit-mask": "[<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||[<box>|border|padding|content|text]||[<box>|border|padding|content]]#",
        "-webkit-mask-attachment": "<attachment>#",
        "-webkit-mask-clip": "[<box>|border|padding|content|text]#",
        "-webkit-mask-composite": "<composite-style>#",
        "-webkit-mask-image": "<mask-reference>#",
        "-webkit-mask-origin": "[<box>|border|padding|content]#",
        "-webkit-mask-position": "<position>#",
        "-webkit-mask-position-x": "[<length-percentage>|left|center|right]#",
        "-webkit-mask-position-y": "[<length-percentage>|top|center|bottom]#",
        "-webkit-mask-repeat": "<repeat-style>#",
        "-webkit-mask-repeat-x": "repeat|no-repeat|space|round",
        "-webkit-mask-repeat-y": "repeat|no-repeat|space|round",
        "-webkit-mask-size": "<bg-size>#",
        "-webkit-overflow-scrolling": "auto|touch",
        "-webkit-tap-highlight-color": "<color>",
        "-webkit-text-fill-color": "<color>",
        "-webkit-text-stroke": "<length>||<color>",
        "-webkit-text-stroke-color": "<color>",
        "-webkit-text-stroke-width": "<length>",
        "-webkit-touch-callout": "default|none",
        "-webkit-user-modify": "read-only|read-write|read-write-plaintext-only",
        "accent-color": "auto|<color>",
        "align-content": "normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>",
        "align-items": "normal|stretch|<baseline-position>|[<overflow-position>? <self-position>]",
        "align-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? <self-position>",
        "align-tracks": "[normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>]#",
        "all": "initial|inherit|unset|revert|revert-layer",
        "animation": "<single-animation>#",
        "animation-delay": "<time>#",
        "animation-direction": "<single-animation-direction>#",
        "animation-duration": "<time>#",
        "animation-fill-mode": "<single-animation-fill-mode>#",
        "animation-iteration-count": "<single-animation-iteration-count>#",
        "animation-name": "[none|<keyframes-name>]#",
        "animation-play-state": "<single-animation-play-state>#",
        "animation-timing-function": "<easing-function>#",
        "animation-timeline": "<single-animation-timeline>#",
        "appearance": "none|auto|textfield|menulist-button|<compat-auto>",
        "aspect-ratio": "auto|<ratio>",
        "azimuth": "<angle>|[[left-side|far-left|left|center-left|center|center-right|right|far-right|right-side]||behind]|leftwards|rightwards",
        "backdrop-filter": "none|<filter-function-list>",
        "backface-visibility": "visible|hidden",
        "background": "[<bg-layer> ,]* <final-bg-layer>",
        "background-attachment": "<attachment>#",
        "background-blend-mode": "<blend-mode>#",
        "background-clip": "<bg-clip>#",
        "background-color": "<color>",
        "background-image": "<bg-image>#",
        "background-origin": "<box>#",
        "background-position": "<bg-position>#",
        "background-position-x": "[center|[[left|right|x-start|x-end]? <length-percentage>?]!]#",
        "background-position-y": "[center|[[top|bottom|y-start|y-end]? <length-percentage>?]!]#",
        "background-repeat": "<repeat-style>#",
        "background-size": "<bg-size>#",
        "block-overflow": "clip|ellipsis|<string>",
        "block-size": "<'width'>",
        "border": "<line-width>||<line-style>||<color>",
        "border-block": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-color": "<'border-top-color'>{1,2}",
        "border-block-style": "<'border-top-style'>",
        "border-block-width": "<'border-top-width'>",
        "border-block-end": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-end-color": "<'border-top-color'>",
        "border-block-end-style": "<'border-top-style'>",
        "border-block-end-width": "<'border-top-width'>",
        "border-block-start": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-block-start-color": "<'border-top-color'>",
        "border-block-start-style": "<'border-top-style'>",
        "border-block-start-width": "<'border-top-width'>",
        "border-bottom": "<line-width>||<line-style>||<color>",
        "border-bottom-color": "<'border-top-color'>",
        "border-bottom-left-radius": "<length-percentage>{1,2}",
        "border-bottom-right-radius": "<length-percentage>{1,2}",
        "border-bottom-style": "<line-style>",
        "border-bottom-width": "<line-width>",
        "border-collapse": "collapse|separate",
        "border-color": "<color>{1,4}",
        "border-end-end-radius": "<length-percentage>{1,2}",
        "border-end-start-radius": "<length-percentage>{1,2}",
        "border-image": "<'border-image-source'>||<'border-image-slice'> [/ <'border-image-width'>|/ <'border-image-width'>? / <'border-image-outset'>]?||<'border-image-repeat'>",
        "border-image-outset": "[<length>|<number>]{1,4}",
        "border-image-repeat": "[stretch|repeat|round|space]{1,2}",
        "border-image-slice": "<number-percentage>{1,4}&&fill?",
        "border-image-source": "none|<image>",
        "border-image-width": "[<length-percentage>|<number>|auto]{1,4}",
        "border-inline": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-end": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-color": "<'border-top-color'>{1,2}",
        "border-inline-style": "<'border-top-style'>",
        "border-inline-width": "<'border-top-width'>",
        "border-inline-end-color": "<'border-top-color'>",
        "border-inline-end-style": "<'border-top-style'>",
        "border-inline-end-width": "<'border-top-width'>",
        "border-inline-start": "<'border-top-width'>||<'border-top-style'>||<color>",
        "border-inline-start-color": "<'border-top-color'>",
        "border-inline-start-style": "<'border-top-style'>",
        "border-inline-start-width": "<'border-top-width'>",
        "border-left": "<line-width>||<line-style>||<color>",
        "border-left-color": "<color>",
        "border-left-style": "<line-style>",
        "border-left-width": "<line-width>",
        "border-radius": "<length-percentage>{1,4} [/ <length-percentage>{1,4}]?",
        "border-right": "<line-width>||<line-style>||<color>",
        "border-right-color": "<color>",
        "border-right-style": "<line-style>",
        "border-right-width": "<line-width>",
        "border-spacing": "<length> <length>?",
        "border-start-end-radius": "<length-percentage>{1,2}",
        "border-start-start-radius": "<length-percentage>{1,2}",
        "border-style": "<line-style>{1,4}",
        "border-top": "<line-width>||<line-style>||<color>",
        "border-top-color": "<color>",
        "border-top-left-radius": "<length-percentage>{1,2}",
        "border-top-right-radius": "<length-percentage>{1,2}",
        "border-top-style": "<line-style>",
        "border-top-width": "<line-width>",
        "border-width": "<line-width>{1,4}",
        "bottom": "<length>|<percentage>|auto",
        "box-align": "start|center|end|baseline|stretch",
        "box-decoration-break": "slice|clone",
        "box-direction": "normal|reverse|inherit",
        "box-flex": "<number>",
        "box-flex-group": "<integer>",
        "box-lines": "single|multiple",
        "box-ordinal-group": "<integer>",
        "box-orient": "horizontal|vertical|inline-axis|block-axis|inherit",
        "box-pack": "start|center|end|justify",
        "box-shadow": "none|<shadow>#",
        "box-sizing": "content-box|border-box",
        "break-after": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
        "break-before": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
        "break-inside": "auto|avoid|avoid-page|avoid-column|avoid-region",
        "caption-side": "top|bottom|block-start|block-end|inline-start|inline-end",
        "caret-color": "auto|<color>",
        "clear": "none|left|right|both|inline-start|inline-end",
        "clip": "<shape>|auto",
        "clip-path": "<clip-source>|[<basic-shape>||<geometry-box>]|none",
        "color": "<color>",
        "print-color-adjust": "economy|exact",
        "color-scheme": "normal|[light|dark|<custom-ident>]+&&only?",
        "column-count": "<integer>|auto",
        "column-fill": "auto|balance|balance-all",
        "column-gap": "normal|<length-percentage>",
        "column-rule": "<'column-rule-width'>||<'column-rule-style'>||<'column-rule-color'>",
        "column-rule-color": "<color>",
        "column-rule-style": "<'border-style'>",
        "column-rule-width": "<'border-width'>",
        "column-span": "none|all",
        "column-width": "<length>|auto",
        "columns": "<'column-width'>||<'column-count'>",
        "contain": "none|strict|content|[size||layout||style||paint]",
        "content": "normal|none|[<content-replacement>|<content-list>] [/ [<string>|<counter>]+]?",
        "content-visibility": "visible|auto|hidden",
        "counter-increment": "[<counter-name> <integer>?]+|none",
        "counter-reset": "[<counter-name> <integer>?|<reversed-counter-name> <integer>?]+|none",
        "counter-set": "[<counter-name> <integer>?]+|none",
        "cursor": "[[<url> [<x> <y>]? ,]* [auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing|hand|-webkit-grab|-webkit-grabbing|-webkit-zoom-in|-webkit-zoom-out|-moz-grab|-moz-grabbing|-moz-zoom-in|-moz-zoom-out]]",
        "direction": "ltr|rtl",
        "display": "[<display-outside>||<display-inside>]|<display-listitem>|<display-internal>|<display-box>|<display-legacy>|<-non-standard-display>",
        "empty-cells": "show|hide",
        "filter": "none|<filter-function-list>|<-ms-filter-function-list>",
        "flex": "none|[<'flex-grow'> <'flex-shrink'>?||<'flex-basis'>]",
        "flex-basis": "content|<'width'>",
        "flex-direction": "row|row-reverse|column|column-reverse",
        "flex-flow": "<'flex-direction'>||<'flex-wrap'>",
        "flex-grow": "<number>",
        "flex-shrink": "<number>",
        "flex-wrap": "nowrap|wrap|wrap-reverse",
        "float": "left|right|none|inline-start|inline-end",
        "font": "[[<'font-style'>||<font-variant-css21>||<'font-weight'>||<'font-stretch'>]? <'font-size'> [/ <'line-height'>]? <'font-family'>]|caption|icon|menu|message-box|small-caption|status-bar",
        "font-family": "[<family-name>|<generic-family>]#",
        "font-feature-settings": "normal|<feature-tag-value>#",
        "font-kerning": "auto|normal|none",
        "font-language-override": "normal|<string>",
        "font-optical-sizing": "auto|none",
        "font-variation-settings": "normal|[<string> <number>]#",
        "font-size": "<absolute-size>|<relative-size>|<length-percentage>",
        "font-size-adjust": "none|[ex-height|cap-height|ch-width|ic-width|ic-height]? [from-font|<number>]",
        "font-smooth": "auto|never|always|<absolute-size>|<length>",
        "font-stretch": "<font-stretch-absolute>",
        "font-style": "normal|italic|oblique <angle>?",
        "font-synthesis": "none|[weight||style||small-caps]",
        "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "font-variant-alternates": "normal|[stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )]",
        "font-variant-caps": "normal|small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
        "font-variant-east-asian": "normal|[<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "font-variant-ligatures": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>]",
        "font-variant-numeric": "normal|[<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero]",
        "font-variant-position": "normal|sub|super",
        "font-weight": "<font-weight-absolute>|bolder|lighter",
        "forced-color-adjust": "auto|none",
        "gap": "<'row-gap'> <'column-gap'>?",
        "grid": "<'grid-template'>|<'grid-template-rows'> / [auto-flow&&dense?] <'grid-auto-columns'>?|[auto-flow&&dense?] <'grid-auto-rows'>? / <'grid-template-columns'>",
        "grid-area": "<grid-line> [/ <grid-line>]{0,3}",
        "grid-auto-columns": "<track-size>+",
        "grid-auto-flow": "[row|column]||dense",
        "grid-auto-rows": "<track-size>+",
        "grid-column": "<grid-line> [/ <grid-line>]?",
        "grid-column-end": "<grid-line>",
        "grid-column-gap": "<length-percentage>",
        "grid-column-start": "<grid-line>",
        "grid-gap": "<'grid-row-gap'> <'grid-column-gap'>?",
        "grid-row": "<grid-line> [/ <grid-line>]?",
        "grid-row-end": "<grid-line>",
        "grid-row-gap": "<length-percentage>",
        "grid-row-start": "<grid-line>",
        "grid-template": "none|[<'grid-template-rows'> / <'grid-template-columns'>]|[<line-names>? <string> <track-size>? <line-names>?]+ [/ <explicit-track-list>]?",
        "grid-template-areas": "none|<string>+",
        "grid-template-columns": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
        "grid-template-rows": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
        "hanging-punctuation": "none|[first||[force-end|allow-end]||last]",
        "height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
        "hyphenate-character": "auto|<string>",
        "hyphens": "none|manual|auto",
        "image-orientation": "from-image|<angle>|[<angle>? flip]",
        "image-rendering": "auto|crisp-edges|pixelated|optimizeSpeed|optimizeQuality|<-non-standard-image-rendering>",
        "image-resolution": "[from-image||<resolution>]&&snap?",
        "ime-mode": "auto|normal|active|inactive|disabled",
        "initial-letter": "normal|[<number> <integer>?]",
        "initial-letter-align": "[auto|alphabetic|hanging|ideographic]",
        "inline-size": "<'width'>",
        "input-security": "auto|none",
        "inset": "<'top'>{1,4}",
        "inset-block": "<'top'>{1,2}",
        "inset-block-end": "<'top'>",
        "inset-block-start": "<'top'>",
        "inset-inline": "<'top'>{1,2}",
        "inset-inline-end": "<'top'>",
        "inset-inline-start": "<'top'>",
        "isolation": "auto|isolate",
        "justify-content": "normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]",
        "justify-items": "normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|legacy|legacy&&[left|right|center]",
        "justify-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]",
        "justify-tracks": "[normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]]#",
        "left": "<length>|<percentage>|auto",
        "letter-spacing": "normal|<length-percentage>",
        "line-break": "auto|loose|normal|strict|anywhere",
        "line-clamp": "none|<integer>",
        "line-height": "normal|<number>|<length>|<percentage>",
        "line-height-step": "<length>",
        "list-style": "<'list-style-type'>||<'list-style-position'>||<'list-style-image'>",
        "list-style-image": "<image>|none",
        "list-style-position": "inside|outside",
        "list-style-type": "<counter-style>|<string>|none",
        "margin": "[<length>|<percentage>|auto]{1,4}",
        "margin-block": "<'margin-left'>{1,2}",
        "margin-block-end": "<'margin-left'>",
        "margin-block-start": "<'margin-left'>",
        "margin-bottom": "<length>|<percentage>|auto",
        "margin-inline": "<'margin-left'>{1,2}",
        "margin-inline-end": "<'margin-left'>",
        "margin-inline-start": "<'margin-left'>",
        "margin-left": "<length>|<percentage>|auto",
        "margin-right": "<length>|<percentage>|auto",
        "margin-top": "<length>|<percentage>|auto",
        "margin-trim": "none|in-flow|all",
        "mask": "<mask-layer>#",
        "mask-border": "<'mask-border-source'>||<'mask-border-slice'> [/ <'mask-border-width'>? [/ <'mask-border-outset'>]?]?||<'mask-border-repeat'>||<'mask-border-mode'>",
        "mask-border-mode": "luminance|alpha",
        "mask-border-outset": "[<length>|<number>]{1,4}",
        "mask-border-repeat": "[stretch|repeat|round|space]{1,2}",
        "mask-border-slice": "<number-percentage>{1,4} fill?",
        "mask-border-source": "none|<image>",
        "mask-border-width": "[<length-percentage>|<number>|auto]{1,4}",
        "mask-clip": "[<geometry-box>|no-clip]#",
        "mask-composite": "<compositing-operator>#",
        "mask-image": "<mask-reference>#",
        "mask-mode": "<masking-mode>#",
        "mask-origin": "<geometry-box>#",
        "mask-position": "<position>#",
        "mask-repeat": "<repeat-style>#",
        "mask-size": "<bg-size>#",
        "mask-type": "luminance|alpha",
        "masonry-auto-flow": "[pack|next]||[definite-first|ordered]",
        "math-style": "normal|compact",
        "max-block-size": "<'max-width'>",
        "max-height": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
        "max-inline-size": "<'max-width'>",
        "max-lines": "none|<integer>",
        "max-width": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
        "min-block-size": "<'min-width'>",
        "min-height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
        "min-inline-size": "<'min-width'>",
        "min-width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
        "mix-blend-mode": "<blend-mode>|plus-lighter",
        "object-fit": "fill|contain|cover|none|scale-down",
        "object-position": "<position>",
        "offset": "[<'offset-position'>? [<'offset-path'> [<'offset-distance'>||<'offset-rotate'>]?]?]! [/ <'offset-anchor'>]?",
        "offset-anchor": "auto|<position>",
        "offset-distance": "<length-percentage>",
        "offset-path": "none|ray( [<angle>&&<size>&&contain?] )|<path()>|<url>|[<basic-shape>||<geometry-box>]",
        "offset-position": "auto|<position>",
        "offset-rotate": "[auto|reverse]||<angle>",
        "opacity": "<alpha-value>",
        "order": "<integer>",
        "orphans": "<integer>",
        "outline": "[<'outline-color'>||<'outline-style'>||<'outline-width'>]",
        "outline-color": "<color>|invert",
        "outline-offset": "<length>",
        "outline-style": "auto|<'border-style'>",
        "outline-width": "<line-width>",
        "overflow": "[visible|hidden|clip|scroll|auto]{1,2}|<-non-standard-overflow>",
        "overflow-anchor": "auto|none",
        "overflow-block": "visible|hidden|clip|scroll|auto",
        "overflow-clip-box": "padding-box|content-box",
        "overflow-clip-margin": "<visual-box>||<length [0,\u221E]>",
        "overflow-inline": "visible|hidden|clip|scroll|auto",
        "overflow-wrap": "normal|break-word|anywhere",
        "overflow-x": "visible|hidden|clip|scroll|auto",
        "overflow-y": "visible|hidden|clip|scroll|auto",
        "overscroll-behavior": "[contain|none|auto]{1,2}",
        "overscroll-behavior-block": "contain|none|auto",
        "overscroll-behavior-inline": "contain|none|auto",
        "overscroll-behavior-x": "contain|none|auto",
        "overscroll-behavior-y": "contain|none|auto",
        "padding": "[<length>|<percentage>]{1,4}",
        "padding-block": "<'padding-left'>{1,2}",
        "padding-block-end": "<'padding-left'>",
        "padding-block-start": "<'padding-left'>",
        "padding-bottom": "<length>|<percentage>",
        "padding-inline": "<'padding-left'>{1,2}",
        "padding-inline-end": "<'padding-left'>",
        "padding-inline-start": "<'padding-left'>",
        "padding-left": "<length>|<percentage>",
        "padding-right": "<length>|<percentage>",
        "padding-top": "<length>|<percentage>",
        "page-break-after": "auto|always|avoid|left|right|recto|verso",
        "page-break-before": "auto|always|avoid|left|right|recto|verso",
        "page-break-inside": "auto|avoid",
        "paint-order": "normal|[fill||stroke||markers]",
        "perspective": "none|<length>",
        "perspective-origin": "<position>",
        "place-content": "<'align-content'> <'justify-content'>?",
        "place-items": "<'align-items'> <'justify-items'>?",
        "place-self": "<'align-self'> <'justify-self'>?",
        "pointer-events": "auto|none|visiblePainted|visibleFill|visibleStroke|visible|painted|fill|stroke|all|inherit",
        "position": "static|relative|absolute|sticky|fixed|-webkit-sticky",
        "quotes": "none|auto|[<string> <string>]+",
        "resize": "none|both|horizontal|vertical|block|inline",
        "right": "<length>|<percentage>|auto",
        "rotate": "none|<angle>|[x|y|z|<number>{3}]&&<angle>",
        "row-gap": "normal|<length-percentage>",
        "ruby-align": "start|center|space-between|space-around",
        "ruby-merge": "separate|collapse|auto",
        "ruby-position": "[alternate||[over|under]]|inter-character",
        "scale": "none|<number>{1,3}",
        "scrollbar-color": "auto|<color>{2}",
        "scrollbar-gutter": "auto|stable&&both-edges?",
        "scrollbar-width": "auto|thin|none",
        "scroll-behavior": "auto|smooth",
        "scroll-margin": "<length>{1,4}",
        "scroll-margin-block": "<length>{1,2}",
        "scroll-margin-block-start": "<length>",
        "scroll-margin-block-end": "<length>",
        "scroll-margin-bottom": "<length>",
        "scroll-margin-inline": "<length>{1,2}",
        "scroll-margin-inline-start": "<length>",
        "scroll-margin-inline-end": "<length>",
        "scroll-margin-left": "<length>",
        "scroll-margin-right": "<length>",
        "scroll-margin-top": "<length>",
        "scroll-padding": "[auto|<length-percentage>]{1,4}",
        "scroll-padding-block": "[auto|<length-percentage>]{1,2}",
        "scroll-padding-block-start": "auto|<length-percentage>",
        "scroll-padding-block-end": "auto|<length-percentage>",
        "scroll-padding-bottom": "auto|<length-percentage>",
        "scroll-padding-inline": "[auto|<length-percentage>]{1,2}",
        "scroll-padding-inline-start": "auto|<length-percentage>",
        "scroll-padding-inline-end": "auto|<length-percentage>",
        "scroll-padding-left": "auto|<length-percentage>",
        "scroll-padding-right": "auto|<length-percentage>",
        "scroll-padding-top": "auto|<length-percentage>",
        "scroll-snap-align": "[none|start|end|center]{1,2}",
        "scroll-snap-coordinate": "none|<position>#",
        "scroll-snap-destination": "<position>",
        "scroll-snap-points-x": "none|repeat( <length-percentage> )",
        "scroll-snap-points-y": "none|repeat( <length-percentage> )",
        "scroll-snap-stop": "normal|always",
        "scroll-snap-type": "none|[x|y|block|inline|both] [mandatory|proximity]?",
        "scroll-snap-type-x": "none|mandatory|proximity",
        "scroll-snap-type-y": "none|mandatory|proximity",
        "shape-image-threshold": "<alpha-value>",
        "shape-margin": "<length-percentage>",
        "shape-outside": "none|[<shape-box>||<basic-shape>]|<image>",
        "tab-size": "<integer>|<length>",
        "table-layout": "auto|fixed",
        "text-align": "start|end|left|right|center|justify|match-parent",
        "text-align-last": "auto|start|end|left|right|center|justify",
        "text-combine-upright": "none|all|[digits <integer>?]",
        "text-decoration": "<'text-decoration-line'>||<'text-decoration-style'>||<'text-decoration-color'>||<'text-decoration-thickness'>",
        "text-decoration-color": "<color>",
        "text-decoration-line": "none|[underline||overline||line-through||blink]|spelling-error|grammar-error",
        "text-decoration-skip": "none|[objects||[spaces|[leading-spaces||trailing-spaces]]||edges||box-decoration]",
        "text-decoration-skip-ink": "auto|all|none",
        "text-decoration-style": "solid|double|dotted|dashed|wavy",
        "text-decoration-thickness": "auto|from-font|<length>|<percentage>",
        "text-emphasis": "<'text-emphasis-style'>||<'text-emphasis-color'>",
        "text-emphasis-color": "<color>",
        "text-emphasis-position": "[over|under]&&[right|left]",
        "text-emphasis-style": "none|[[filled|open]||[dot|circle|double-circle|triangle|sesame]]|<string>",
        "text-indent": "<length-percentage>&&hanging?&&each-line?",
        "text-justify": "auto|inter-character|inter-word|none",
        "text-orientation": "mixed|upright|sideways",
        "text-overflow": "[clip|ellipsis|<string>]{1,2}",
        "text-rendering": "auto|optimizeSpeed|optimizeLegibility|geometricPrecision",
        "text-shadow": "none|<shadow-t>#",
        "text-size-adjust": "none|auto|<percentage>",
        "text-transform": "none|capitalize|uppercase|lowercase|full-width|full-size-kana",
        "text-underline-offset": "auto|<length>|<percentage>",
        "text-underline-position": "auto|from-font|[under||[left|right]]",
        "top": "<length>|<percentage>|auto",
        "touch-action": "auto|none|[[pan-x|pan-left|pan-right]||[pan-y|pan-up|pan-down]||pinch-zoom]|manipulation",
        "transform": "none|<transform-list>",
        "transform-box": "content-box|border-box|fill-box|stroke-box|view-box",
        "transform-origin": "[<length-percentage>|left|center|right|top|bottom]|[[<length-percentage>|left|center|right]&&[<length-percentage>|top|center|bottom]] <length>?",
        "transform-style": "flat|preserve-3d",
        "transition": "<single-transition>#",
        "transition-delay": "<time>#",
        "transition-duration": "<time>#",
        "transition-property": "none|<single-transition-property>#",
        "transition-timing-function": "<easing-function>#",
        "translate": "none|<length-percentage> [<length-percentage> <length>?]?",
        "unicode-bidi": "normal|embed|isolate|bidi-override|isolate-override|plaintext|-moz-isolate|-moz-isolate-override|-moz-plaintext|-webkit-isolate|-webkit-isolate-override|-webkit-plaintext",
        "user-select": "auto|text|none|contain|all",
        "vertical-align": "baseline|sub|super|text-top|text-bottom|middle|top|bottom|<percentage>|<length>",
        "visibility": "visible|hidden|collapse",
        "white-space": "normal|pre|nowrap|pre-wrap|pre-line|break-spaces",
        "widows": "<integer>",
        "width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|fill|stretch|intrinsic|-moz-max-content|-webkit-max-content|-moz-fit-content|-webkit-fit-content",
        "will-change": "auto|<animateable-feature>#",
        "word-break": "normal|break-all|keep-all|break-word",
        "word-spacing": "normal|<length>",
        "word-wrap": "normal|break-word",
        "writing-mode": "horizontal-tb|vertical-rl|vertical-lr|sideways-rl|sideways-lr|<svg-writing-mode>",
        "z-index": "auto|<integer>",
        "zoom": "normal|reset|<number>|<percentage>",
        "-moz-background-clip": "padding|border",
        "-moz-border-radius-bottomleft": "<'border-bottom-left-radius'>",
        "-moz-border-radius-bottomright": "<'border-bottom-right-radius'>",
        "-moz-border-radius-topleft": "<'border-top-left-radius'>",
        "-moz-border-radius-topright": "<'border-bottom-right-radius'>",
        "-moz-control-character-visibility": "visible|hidden",
        "-moz-osx-font-smoothing": "auto|grayscale",
        "-moz-user-select": "none|text|all|-moz-none",
        "-ms-flex-align": "start|end|center|baseline|stretch",
        "-ms-flex-item-align": "auto|start|end|center|baseline|stretch",
        "-ms-flex-line-pack": "start|end|center|justify|distribute|stretch",
        "-ms-flex-negative": "<'flex-shrink'>",
        "-ms-flex-pack": "start|end|center|justify|distribute",
        "-ms-flex-order": "<integer>",
        "-ms-flex-positive": "<'flex-grow'>",
        "-ms-flex-preferred-size": "<'flex-basis'>",
        "-ms-interpolation-mode": "nearest-neighbor|bicubic",
        "-ms-grid-column-align": "start|end|center|stretch",
        "-ms-grid-row-align": "start|end|center|stretch",
        "-ms-hyphenate-limit-last": "none|always|column|page|spread",
        "-webkit-background-clip": "[<box>|border|padding|content|text]#",
        "-webkit-column-break-after": "always|auto|avoid",
        "-webkit-column-break-before": "always|auto|avoid",
        "-webkit-column-break-inside": "always|auto|avoid",
        "-webkit-font-smoothing": "auto|none|antialiased|subpixel-antialiased",
        "-webkit-mask-box-image": "[<url>|<gradient>|none] [<length-percentage>{4} <-webkit-mask-box-repeat>{2}]?",
        "-webkit-print-color-adjust": "economy|exact",
        "-webkit-text-security": "none|circle|disc|square",
        "-webkit-user-drag": "none|element|auto",
        "-webkit-user-select": "auto|none|text|all",
        "alignment-baseline": "auto|baseline|before-edge|text-before-edge|middle|central|after-edge|text-after-edge|ideographic|alphabetic|hanging|mathematical",
        "baseline-shift": "baseline|sub|super|<svg-length>",
        "behavior": "<url>+",
        "clip-rule": "nonzero|evenodd",
        "cue": "<'cue-before'> <'cue-after'>?",
        "cue-after": "<url> <decibel>?|none",
        "cue-before": "<url> <decibel>?|none",
        "dominant-baseline": "auto|use-script|no-change|reset-size|ideographic|alphabetic|hanging|mathematical|central|middle|text-after-edge|text-before-edge",
        "fill": "<paint>",
        "fill-opacity": "<number-zero-one>",
        "fill-rule": "nonzero|evenodd",
        "glyph-orientation-horizontal": "<angle>",
        "glyph-orientation-vertical": "<angle>",
        "kerning": "auto|<svg-length>",
        "marker": "none|<url>",
        "marker-end": "none|<url>",
        "marker-mid": "none|<url>",
        "marker-start": "none|<url>",
        "pause": "<'pause-before'> <'pause-after'>?",
        "pause-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "pause-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "rest": "<'rest-before'> <'rest-after'>?",
        "rest-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "rest-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
        "shape-rendering": "auto|optimizeSpeed|crispEdges|geometricPrecision",
        "src": "[<url> [format( <string># )]?|local( <family-name> )]#",
        "speak": "auto|none|normal",
        "speak-as": "normal|spell-out||digits||[literal-punctuation|no-punctuation]",
        "stroke": "<paint>",
        "stroke-dasharray": "none|[<svg-length>+]#",
        "stroke-dashoffset": "<svg-length>",
        "stroke-linecap": "butt|round|square",
        "stroke-linejoin": "miter|round|bevel",
        "stroke-miterlimit": "<number-one-or-greater>",
        "stroke-opacity": "<number-zero-one>",
        "stroke-width": "<svg-length>",
        "text-anchor": "start|middle|end",
        "unicode-range": "<urange>#",
        "voice-balance": "<number>|left|center|right|leftwards|rightwards",
        "voice-duration": "auto|<time>",
        "voice-family": "[[<family-name>|<generic-voice>] ,]* [<family-name>|<generic-voice>]|preserve",
        "voice-pitch": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
        "voice-range": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
        "voice-rate": "[normal|x-slow|slow|medium|fast|x-fast]||<percentage>",
        "voice-stress": "normal|strong|moderate|none|reduced",
        "voice-volume": "silent|[[x-soft|soft|medium|loud|x-loud]||<decibel>]"
    },
    "atrules": {
        "charset": {
            "prelude": "<string>",
            "descriptors": null
        },
        "counter-style": {
            "prelude": "<counter-style-name>",
            "descriptors": {
                "additive-symbols": "[<integer>&&<symbol>]#",
                "fallback": "<counter-style-name>",
                "negative": "<symbol> <symbol>?",
                "pad": "<integer>&&<symbol>",
                "prefix": "<symbol>",
                "range": "[[<integer>|infinite]{2}]#|auto",
                "speak-as": "auto|bullets|numbers|words|spell-out|<counter-style-name>",
                "suffix": "<symbol>",
                "symbols": "<symbol>+",
                "system": "cyclic|numeric|alphabetic|symbolic|additive|[fixed <integer>?]|[extends <counter-style-name>]"
            }
        },
        "document": {
            "prelude": "[<url>|url-prefix( <string> )|domain( <string> )|media-document( <string> )|regexp( <string> )]#",
            "descriptors": null
        },
        "font-face": {
            "prelude": null,
            "descriptors": {
                "ascent-override": "normal|<percentage>",
                "descent-override": "normal|<percentage>",
                "font-display": "[auto|block|swap|fallback|optional]",
                "font-family": "<family-name>",
                "font-feature-settings": "normal|<feature-tag-value>#",
                "font-variation-settings": "normal|[<string> <number>]#",
                "font-stretch": "<font-stretch-absolute>{1,2}",
                "font-style": "normal|italic|oblique <angle>{0,2}",
                "font-weight": "<font-weight-absolute>{1,2}",
                "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
                "line-gap-override": "normal|<percentage>",
                "size-adjust": "<percentage>",
                "src": "[<url> [format( <string># )]?|local( <family-name> )]#",
                "unicode-range": "<urange>#"
            }
        },
        "font-feature-values": {
            "prelude": "<family-name>#",
            "descriptors": null
        },
        "import": {
            "prelude": "[<string>|<url>] [layer|layer( <layer-name> )]? [supports( [<supports-condition>|<declaration>] )]? <media-query-list>?",
            "descriptors": null
        },
        "keyframes": {
            "prelude": "<keyframes-name>",
            "descriptors": null
        },
        "layer": {
            "prelude": "[<layer-name>#|<layer-name>?]",
            "descriptors": null
        },
        "media": {
            "prelude": "<media-query-list>",
            "descriptors": null
        },
        "namespace": {
            "prelude": "<namespace-prefix>? [<string>|<url>]",
            "descriptors": null
        },
        "page": {
            "prelude": "<page-selector-list>",
            "descriptors": {
                "bleed": "auto|<length>",
                "marks": "none|[crop||cross]",
                "size": "<length>{1,2}|auto|[<page-size>||[portrait|landscape]]"
            }
        },
        "property": {
            "prelude": "<custom-property-name>",
            "descriptors": {
                "syntax": "<string>",
                "inherits": "true|false",
                "initial-value": "<string>"
            }
        },
        "scroll-timeline": {
            "prelude": "<timeline-name>",
            "descriptors": null
        },
        "supports": {
            "prelude": "<supports-condition>",
            "descriptors": null
        },
        "viewport": {
            "prelude": null,
            "descriptors": {
                "height": "<viewport-length>{1,2}",
                "max-height": "<viewport-length>",
                "max-width": "<viewport-length>",
                "max-zoom": "auto|<number>|<percentage>",
                "min-height": "<viewport-length>",
                "min-width": "<viewport-length>",
                "min-zoom": "auto|<number>|<percentage>",
                "orientation": "auto|portrait|landscape",
                "user-zoom": "zoom|fixed",
                "viewport-fit": "auto|contain|cover",
                "width": "<viewport-length>{1,2}",
                "zoom": "auto|<number>|<percentage>"
            }
        }
    }
};


var $ec83dd3af9a58624$exports = {};
$parcel$export($ec83dd3af9a58624$exports, "AnPlusB", () => $ec83dd3af9a58624$export$29d22f23fc62deec, (v) => $ec83dd3af9a58624$export$29d22f23fc62deec = v);
$parcel$export($ec83dd3af9a58624$exports, "Atrule", () => $ec83dd3af9a58624$export$b0e869c28ebe2686, (v) => $ec83dd3af9a58624$export$b0e869c28ebe2686 = v);
$parcel$export($ec83dd3af9a58624$exports, "AtrulePrelude", () => $ec83dd3af9a58624$export$a551ca711e9f0de7, (v) => $ec83dd3af9a58624$export$a551ca711e9f0de7 = v);
$parcel$export($ec83dd3af9a58624$exports, "AttributeSelector", () => $ec83dd3af9a58624$export$8170b1e1b2558dd5, (v) => $ec83dd3af9a58624$export$8170b1e1b2558dd5 = v);
$parcel$export($ec83dd3af9a58624$exports, "Block", () => $ec83dd3af9a58624$export$d96a8827a60d6b69, (v) => $ec83dd3af9a58624$export$d96a8827a60d6b69 = v);
$parcel$export($ec83dd3af9a58624$exports, "Brackets", () => $ec83dd3af9a58624$export$27f9608f5b4a4cfa, (v) => $ec83dd3af9a58624$export$27f9608f5b4a4cfa = v);
$parcel$export($ec83dd3af9a58624$exports, "CDC", () => $ec83dd3af9a58624$export$b0b2bd2d1777c179, (v) => $ec83dd3af9a58624$export$b0b2bd2d1777c179 = v);
$parcel$export($ec83dd3af9a58624$exports, "CDO", () => $ec83dd3af9a58624$export$521ef26a3002003b, (v) => $ec83dd3af9a58624$export$521ef26a3002003b = v);
$parcel$export($ec83dd3af9a58624$exports, "ClassSelector", () => $ec83dd3af9a58624$export$208720b1a4408baf, (v) => $ec83dd3af9a58624$export$208720b1a4408baf = v);
$parcel$export($ec83dd3af9a58624$exports, "Combinator", () => $ec83dd3af9a58624$export$3cbfd7ee92c4e2ca, (v) => $ec83dd3af9a58624$export$3cbfd7ee92c4e2ca = v);
$parcel$export($ec83dd3af9a58624$exports, "Comment", () => $ec83dd3af9a58624$export$4d299b491347818a, (v) => $ec83dd3af9a58624$export$4d299b491347818a = v);
$parcel$export($ec83dd3af9a58624$exports, "Declaration", () => $ec83dd3af9a58624$export$48f3d9e786303b67, (v) => $ec83dd3af9a58624$export$48f3d9e786303b67 = v);
$parcel$export($ec83dd3af9a58624$exports, "DeclarationList", () => $ec83dd3af9a58624$export$b8d0a768b241031f, (v) => $ec83dd3af9a58624$export$b8d0a768b241031f = v);
$parcel$export($ec83dd3af9a58624$exports, "Dimension", () => $ec83dd3af9a58624$export$c940ece961bc43c6, (v) => $ec83dd3af9a58624$export$c940ece961bc43c6 = v);
$parcel$export($ec83dd3af9a58624$exports, "Function", () => $ec83dd3af9a58624$export$f3890eeaf6851387, (v) => $ec83dd3af9a58624$export$f3890eeaf6851387 = v);
$parcel$export($ec83dd3af9a58624$exports, "Hash", () => $ec83dd3af9a58624$export$ab85ecd77ce6a5cd, (v) => $ec83dd3af9a58624$export$ab85ecd77ce6a5cd = v);
$parcel$export($ec83dd3af9a58624$exports, "Identifier", () => $ec83dd3af9a58624$export$989167234458594d, (v) => $ec83dd3af9a58624$export$989167234458594d = v);
$parcel$export($ec83dd3af9a58624$exports, "IdSelector", () => $ec83dd3af9a58624$export$31c96e959895721d, (v) => $ec83dd3af9a58624$export$31c96e959895721d = v);
$parcel$export($ec83dd3af9a58624$exports, "MediaFeature", () => $ec83dd3af9a58624$export$a38b0f36e6ad18cf, (v) => $ec83dd3af9a58624$export$a38b0f36e6ad18cf = v);
$parcel$export($ec83dd3af9a58624$exports, "MediaQuery", () => $ec83dd3af9a58624$export$b745838c41029eb3, (v) => $ec83dd3af9a58624$export$b745838c41029eb3 = v);
$parcel$export($ec83dd3af9a58624$exports, "MediaQueryList", () => $ec83dd3af9a58624$export$789660f679e96cab, (v) => $ec83dd3af9a58624$export$789660f679e96cab = v);
$parcel$export($ec83dd3af9a58624$exports, "Nth", () => $ec83dd3af9a58624$export$69f042d6c338d0d, (v) => $ec83dd3af9a58624$export$69f042d6c338d0d = v);
$parcel$export($ec83dd3af9a58624$exports, "Number", () => $ec83dd3af9a58624$export$fffa67e515d04022, (v) => $ec83dd3af9a58624$export$fffa67e515d04022 = v);
$parcel$export($ec83dd3af9a58624$exports, "Operator", () => $ec83dd3af9a58624$export$fa5f90bfb4dbdbcd, (v) => $ec83dd3af9a58624$export$fa5f90bfb4dbdbcd = v);
$parcel$export($ec83dd3af9a58624$exports, "Parentheses", () => $ec83dd3af9a58624$export$f9c1f512ab2b4a4c, (v) => $ec83dd3af9a58624$export$f9c1f512ab2b4a4c = v);
$parcel$export($ec83dd3af9a58624$exports, "Percentage", () => $ec83dd3af9a58624$export$d11913f8a6922aea, (v) => $ec83dd3af9a58624$export$d11913f8a6922aea = v);
$parcel$export($ec83dd3af9a58624$exports, "PseudoClassSelector", () => $ec83dd3af9a58624$export$4a1f3470168c60fe, (v) => $ec83dd3af9a58624$export$4a1f3470168c60fe = v);
$parcel$export($ec83dd3af9a58624$exports, "PseudoElementSelector", () => $ec83dd3af9a58624$export$fcc96471f1c8a2f3, (v) => $ec83dd3af9a58624$export$fcc96471f1c8a2f3 = v);
$parcel$export($ec83dd3af9a58624$exports, "Ratio", () => $ec83dd3af9a58624$export$438ad6fc467f929b, (v) => $ec83dd3af9a58624$export$438ad6fc467f929b = v);
$parcel$export($ec83dd3af9a58624$exports, "Raw", () => $ec83dd3af9a58624$export$6f88fe47d32c9c94, (v) => $ec83dd3af9a58624$export$6f88fe47d32c9c94 = v);
$parcel$export($ec83dd3af9a58624$exports, "Rule", () => $ec83dd3af9a58624$export$f1ff2a90c38ff669, (v) => $ec83dd3af9a58624$export$f1ff2a90c38ff669 = v);
$parcel$export($ec83dd3af9a58624$exports, "Selector", () => $ec83dd3af9a58624$export$d15f4cd5286f9b1e, (v) => $ec83dd3af9a58624$export$d15f4cd5286f9b1e = v);
$parcel$export($ec83dd3af9a58624$exports, "SelectorList", () => $ec83dd3af9a58624$export$d2c5a04859a7aa8c, (v) => $ec83dd3af9a58624$export$d2c5a04859a7aa8c = v);
$parcel$export($ec83dd3af9a58624$exports, "String", () => $ec83dd3af9a58624$export$89b8e0fa65f6a914, (v) => $ec83dd3af9a58624$export$89b8e0fa65f6a914 = v);
$parcel$export($ec83dd3af9a58624$exports, "StyleSheet", () => $ec83dd3af9a58624$export$9d753cd7ae895cce, (v) => $ec83dd3af9a58624$export$9d753cd7ae895cce = v);
$parcel$export($ec83dd3af9a58624$exports, "TypeSelector", () => $ec83dd3af9a58624$export$1cbeb7199b91dfe2, (v) => $ec83dd3af9a58624$export$1cbeb7199b91dfe2 = v);
$parcel$export($ec83dd3af9a58624$exports, "UnicodeRange", () => $ec83dd3af9a58624$export$3f8e011aa996e1b4, (v) => $ec83dd3af9a58624$export$3f8e011aa996e1b4 = v);
$parcel$export($ec83dd3af9a58624$exports, "Url", () => $ec83dd3af9a58624$export$59d795186a5d3f58, (v) => $ec83dd3af9a58624$export$59d795186a5d3f58 = v);
$parcel$export($ec83dd3af9a58624$exports, "Value", () => $ec83dd3af9a58624$export$4c8d1a57a761ef94, (v) => $ec83dd3af9a58624$export$4c8d1a57a761ef94 = v);
$parcel$export($ec83dd3af9a58624$exports, "WhiteSpace", () => $ec83dd3af9a58624$export$fb98946286ab4c97, (v) => $ec83dd3af9a58624$export$fb98946286ab4c97 = v);
var $ec83dd3af9a58624$export$29d22f23fc62deec;
var $ec83dd3af9a58624$export$b0e869c28ebe2686;
var $ec83dd3af9a58624$export$a551ca711e9f0de7;
var $ec83dd3af9a58624$export$8170b1e1b2558dd5;
var $ec83dd3af9a58624$export$d96a8827a60d6b69;
var $ec83dd3af9a58624$export$27f9608f5b4a4cfa;
var $ec83dd3af9a58624$export$b0b2bd2d1777c179;
var $ec83dd3af9a58624$export$521ef26a3002003b;
var $ec83dd3af9a58624$export$208720b1a4408baf;
var $ec83dd3af9a58624$export$3cbfd7ee92c4e2ca;
var $ec83dd3af9a58624$export$4d299b491347818a;
var $ec83dd3af9a58624$export$48f3d9e786303b67;
var $ec83dd3af9a58624$export$b8d0a768b241031f;
var $ec83dd3af9a58624$export$c940ece961bc43c6;
var $ec83dd3af9a58624$export$f3890eeaf6851387;
var $ec83dd3af9a58624$export$ab85ecd77ce6a5cd;
var $ec83dd3af9a58624$export$989167234458594d;
var $ec83dd3af9a58624$export$31c96e959895721d;
var $ec83dd3af9a58624$export$a38b0f36e6ad18cf;
var $ec83dd3af9a58624$export$b745838c41029eb3;
var $ec83dd3af9a58624$export$789660f679e96cab;
var $ec83dd3af9a58624$export$69f042d6c338d0d;
var $ec83dd3af9a58624$export$fffa67e515d04022;
var $ec83dd3af9a58624$export$fa5f90bfb4dbdbcd;
var $ec83dd3af9a58624$export$f9c1f512ab2b4a4c;
var $ec83dd3af9a58624$export$d11913f8a6922aea;
var $ec83dd3af9a58624$export$4a1f3470168c60fe;
var $ec83dd3af9a58624$export$fcc96471f1c8a2f3;
var $ec83dd3af9a58624$export$438ad6fc467f929b;
var $ec83dd3af9a58624$export$6f88fe47d32c9c94;
var $ec83dd3af9a58624$export$f1ff2a90c38ff669;
var $ec83dd3af9a58624$export$d15f4cd5286f9b1e;
var $ec83dd3af9a58624$export$d2c5a04859a7aa8c;
var $ec83dd3af9a58624$export$89b8e0fa65f6a914;
var $ec83dd3af9a58624$export$9d753cd7ae895cce;
var $ec83dd3af9a58624$export$1cbeb7199b91dfe2;
var $ec83dd3af9a58624$export$3f8e011aa996e1b4;
var $ec83dd3af9a58624$export$59d795186a5d3f58;
var $ec83dd3af9a58624$export$4c8d1a57a761ef94;
var $ec83dd3af9a58624$export$fb98946286ab4c97;
'use strict';
var $99d9b650dc26e4b6$exports = {};
$parcel$export($99d9b650dc26e4b6$exports, "generate", () => $99d9b650dc26e4b6$export$80d376111cc09ad7, (v) => $99d9b650dc26e4b6$export$80d376111cc09ad7 = v);
$parcel$export($99d9b650dc26e4b6$exports, "name", () => $99d9b650dc26e4b6$export$a8ff84c12d48cfa6, (v) => $99d9b650dc26e4b6$export$a8ff84c12d48cfa6 = v);
$parcel$export($99d9b650dc26e4b6$exports, "parse", () => $99d9b650dc26e4b6$export$98e6a39c04603d36, (v) => $99d9b650dc26e4b6$export$98e6a39c04603d36 = v);
$parcel$export($99d9b650dc26e4b6$exports, "structure", () => $99d9b650dc26e4b6$export$46a2a563c28afca0, (v) => $99d9b650dc26e4b6$export$46a2a563c28afca0 = v);
var $99d9b650dc26e4b6$export$80d376111cc09ad7;
var $99d9b650dc26e4b6$export$a8ff84c12d48cfa6;
var $99d9b650dc26e4b6$export$98e6a39c04603d36;
var $99d9b650dc26e4b6$export$46a2a563c28afca0;
'use strict';


const $99d9b650dc26e4b6$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $99d9b650dc26e4b6$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $99d9b650dc26e4b6$var$N = 0x006E; // U+006E LATIN SMALL LETTER N (n)
const $99d9b650dc26e4b6$var$DISALLOW_SIGN = true;
const $99d9b650dc26e4b6$var$ALLOW_SIGN = false;
function $99d9b650dc26e4b6$var$checkInteger(offset, disallowSign) {
    let pos = this.tokenStart + offset;
    const code = this.charCodeAt(pos);
    if (code === $99d9b650dc26e4b6$var$PLUSSIGN || code === $99d9b650dc26e4b6$var$HYPHENMINUS) {
        if (disallowSign) this.error('Number sign is not allowed');
        pos++;
    }
    for(; pos < this.tokenEnd; pos++)if (!$401d24d35b6b69df$export$727d9dbc4fbb948f(this.charCodeAt(pos))) this.error('Integer is expected', pos);
}
function $99d9b650dc26e4b6$var$checkTokenIsInteger(disallowSign) {
    return $99d9b650dc26e4b6$var$checkInteger.call(this, 0, disallowSign);
}
function $99d9b650dc26e4b6$var$expectCharCode(offset, code) {
    if (!this.cmpChar(this.tokenStart + offset, code)) {
        let msg = '';
        switch(code){
            case $99d9b650dc26e4b6$var$N:
                msg = 'N is expected';
                break;
            case $99d9b650dc26e4b6$var$HYPHENMINUS:
                msg = 'HyphenMinus is expected';
                break;
        }
        this.error(msg, this.tokenStart + offset);
    }
}
// ... <signed-integer>
// ... ['+' | '-'] <signless-integer>
function $99d9b650dc26e4b6$var$consumeB() {
    let offset = 0;
    let sign = 0;
    let type = this.tokenType;
    while(type === $926ff4544e512db5$export$fb98946286ab4c97 || type === $926ff4544e512db5$export$4d299b491347818a)type = this.lookupType(++offset);
    if (type !== $926ff4544e512db5$export$fffa67e515d04022) {
        if (this.isDelim($99d9b650dc26e4b6$var$PLUSSIGN, offset) || this.isDelim($99d9b650dc26e4b6$var$HYPHENMINUS, offset)) {
            sign = this.isDelim($99d9b650dc26e4b6$var$PLUSSIGN, offset) ? $99d9b650dc26e4b6$var$PLUSSIGN : $99d9b650dc26e4b6$var$HYPHENMINUS;
            do type = this.lookupType(++offset);
            while (type === $926ff4544e512db5$export$fb98946286ab4c97 || type === $926ff4544e512db5$export$4d299b491347818a);
            if (type !== $926ff4544e512db5$export$fffa67e515d04022) {
                this.skip(offset);
                $99d9b650dc26e4b6$var$checkTokenIsInteger.call(this, $99d9b650dc26e4b6$var$DISALLOW_SIGN);
            }
        } else return null;
    }
    if (offset > 0) this.skip(offset);
    if (sign === 0) {
        type = this.charCodeAt(this.tokenStart);
        if (type !== $99d9b650dc26e4b6$var$PLUSSIGN && type !== $99d9b650dc26e4b6$var$HYPHENMINUS) this.error('Number sign is expected');
    }
    $99d9b650dc26e4b6$var$checkTokenIsInteger.call(this, sign !== 0);
    return sign === $99d9b650dc26e4b6$var$HYPHENMINUS ? '-' + this.consume($926ff4544e512db5$export$fffa67e515d04022) : this.consume($926ff4544e512db5$export$fffa67e515d04022);
}
// An+B microsyntax https://www.w3.org/TR/css-syntax-3/#anb
const $99d9b650dc26e4b6$var$name = 'AnPlusB';
const $99d9b650dc26e4b6$var$structure = {
    a: [
        String,
        null
    ],
    b: [
        String,
        null
    ]
};
function $99d9b650dc26e4b6$var$parse() {
    /* eslint-disable brace-style*/ const start = this.tokenStart;
    let a = null;
    let b = null;
    // <integer>
    if (this.tokenType === $926ff4544e512db5$export$fffa67e515d04022) {
        $99d9b650dc26e4b6$var$checkTokenIsInteger.call(this, $99d9b650dc26e4b6$var$ALLOW_SIGN);
        b = this.consume($926ff4544e512db5$export$fffa67e515d04022);
    } else if (this.tokenType === $926ff4544e512db5$export$331e9b6bdecaac5f && this.cmpChar(this.tokenStart, $99d9b650dc26e4b6$var$HYPHENMINUS)) {
        a = '-1';
        $99d9b650dc26e4b6$var$expectCharCode.call(this, 1, $99d9b650dc26e4b6$var$N);
        switch(this.tokenEnd - this.tokenStart){
            // -n
            // -n <signed-integer>
            // -n ['+' | '-'] <signless-integer>
            case 2:
                this.next();
                b = $99d9b650dc26e4b6$var$consumeB.call(this);
                break;
            // -n- <signless-integer>
            case 3:
                $99d9b650dc26e4b6$var$expectCharCode.call(this, 2, $99d9b650dc26e4b6$var$HYPHENMINUS);
                this.next();
                this.skipSC();
                $99d9b650dc26e4b6$var$checkTokenIsInteger.call(this, $99d9b650dc26e4b6$var$DISALLOW_SIGN);
                b = '-' + this.consume($926ff4544e512db5$export$fffa67e515d04022);
                break;
            // <dashndashdigit-ident>
            default:
                $99d9b650dc26e4b6$var$expectCharCode.call(this, 2, $99d9b650dc26e4b6$var$HYPHENMINUS);
                $99d9b650dc26e4b6$var$checkInteger.call(this, 3, $99d9b650dc26e4b6$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(start + 2);
        }
    } else if (this.tokenType === $926ff4544e512db5$export$331e9b6bdecaac5f || this.isDelim($99d9b650dc26e4b6$var$PLUSSIGN) && this.lookupType(1) === $926ff4544e512db5$export$331e9b6bdecaac5f) {
        let sign = 0;
        a = '1';
        // just ignore a plus
        if (this.isDelim($99d9b650dc26e4b6$var$PLUSSIGN)) {
            sign = 1;
            this.next();
        }
        $99d9b650dc26e4b6$var$expectCharCode.call(this, 0, $99d9b650dc26e4b6$var$N);
        switch(this.tokenEnd - this.tokenStart){
            // '+'? n
            // '+'? n <signed-integer>
            // '+'? n ['+' | '-'] <signless-integer>
            case 1:
                this.next();
                b = $99d9b650dc26e4b6$var$consumeB.call(this);
                break;
            // '+'? n- <signless-integer>
            case 2:
                $99d9b650dc26e4b6$var$expectCharCode.call(this, 1, $99d9b650dc26e4b6$var$HYPHENMINUS);
                this.next();
                this.skipSC();
                $99d9b650dc26e4b6$var$checkTokenIsInteger.call(this, $99d9b650dc26e4b6$var$DISALLOW_SIGN);
                b = '-' + this.consume($926ff4544e512db5$export$fffa67e515d04022);
                break;
            // '+'? <ndashdigit-ident>
            default:
                $99d9b650dc26e4b6$var$expectCharCode.call(this, 1, $99d9b650dc26e4b6$var$HYPHENMINUS);
                $99d9b650dc26e4b6$var$checkInteger.call(this, 2, $99d9b650dc26e4b6$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(start + sign + 1);
        }
    } else if (this.tokenType === $926ff4544e512db5$export$c940ece961bc43c6) {
        const code = this.charCodeAt(this.tokenStart);
        const sign = code === $99d9b650dc26e4b6$var$PLUSSIGN || code === $99d9b650dc26e4b6$var$HYPHENMINUS;
        let i = this.tokenStart + sign;
        for(; i < this.tokenEnd; i++){
            if (!$401d24d35b6b69df$export$727d9dbc4fbb948f(this.charCodeAt(i))) break;
        }
        if (i === this.tokenStart + sign) this.error('Integer is expected', this.tokenStart + sign);
        $99d9b650dc26e4b6$var$expectCharCode.call(this, i - this.tokenStart, $99d9b650dc26e4b6$var$N);
        a = this.substring(start, i);
        // <n-dimension>
        // <n-dimension> <signed-integer>
        // <n-dimension> ['+' | '-'] <signless-integer>
        if (i + 1 === this.tokenEnd) {
            this.next();
            b = $99d9b650dc26e4b6$var$consumeB.call(this);
        } else {
            $99d9b650dc26e4b6$var$expectCharCode.call(this, i - this.tokenStart + 1, $99d9b650dc26e4b6$var$HYPHENMINUS);
            // <ndash-dimension> <signless-integer>
            if (i + 2 === this.tokenEnd) {
                this.next();
                this.skipSC();
                $99d9b650dc26e4b6$var$checkTokenIsInteger.call(this, $99d9b650dc26e4b6$var$DISALLOW_SIGN);
                b = '-' + this.consume($926ff4544e512db5$export$fffa67e515d04022);
            } else {
                $99d9b650dc26e4b6$var$checkInteger.call(this, i - this.tokenStart + 2, $99d9b650dc26e4b6$var$DISALLOW_SIGN);
                this.next();
                b = this.substrToCursor(i + 1);
            }
        }
    } else this.error();
    if (a !== null && a.charCodeAt(0) === $99d9b650dc26e4b6$var$PLUSSIGN) a = a.substr(1);
    if (b !== null && b.charCodeAt(0) === $99d9b650dc26e4b6$var$PLUSSIGN) b = b.substr(1);
    return {
        type: 'AnPlusB',
        loc: this.getLocation(start, this.tokenStart),
        a: a,
        b: b
    };
}
function $99d9b650dc26e4b6$var$generate(node) {
    if (node.a) {
        const a = node.a === '+1' && 'n' || node.a === '1' && 'n' || node.a === '-1' && '-n' || node.a + 'n';
        if (node.b) {
            const b = node.b[0] === '-' || node.b[0] === '+' ? node.b : '+' + node.b;
            this.tokenize(a + b);
        } else this.tokenize(a);
    } else this.tokenize(node.b);
}
$99d9b650dc26e4b6$export$80d376111cc09ad7 = $99d9b650dc26e4b6$var$generate;
$99d9b650dc26e4b6$export$a8ff84c12d48cfa6 = $99d9b650dc26e4b6$var$name;
$99d9b650dc26e4b6$export$98e6a39c04603d36 = $99d9b650dc26e4b6$var$parse;
$99d9b650dc26e4b6$export$46a2a563c28afca0 = $99d9b650dc26e4b6$var$structure;


var $fd0f87093eed036b$exports = {};
$parcel$export($fd0f87093eed036b$exports, "generate", () => $fd0f87093eed036b$export$80d376111cc09ad7, (v) => $fd0f87093eed036b$export$80d376111cc09ad7 = v);
$parcel$export($fd0f87093eed036b$exports, "name", () => $fd0f87093eed036b$export$a8ff84c12d48cfa6, (v) => $fd0f87093eed036b$export$a8ff84c12d48cfa6 = v);
$parcel$export($fd0f87093eed036b$exports, "parse", () => $fd0f87093eed036b$export$98e6a39c04603d36, (v) => $fd0f87093eed036b$export$98e6a39c04603d36 = v);
$parcel$export($fd0f87093eed036b$exports, "structure", () => $fd0f87093eed036b$export$46a2a563c28afca0, (v) => $fd0f87093eed036b$export$46a2a563c28afca0 = v);
$parcel$export($fd0f87093eed036b$exports, "walkContext", () => $fd0f87093eed036b$export$f7e0bb689fefb8c2, (v) => $fd0f87093eed036b$export$f7e0bb689fefb8c2 = v);
var $fd0f87093eed036b$export$80d376111cc09ad7;
var $fd0f87093eed036b$export$a8ff84c12d48cfa6;
var $fd0f87093eed036b$export$98e6a39c04603d36;
var $fd0f87093eed036b$export$46a2a563c28afca0;
var $fd0f87093eed036b$export$f7e0bb689fefb8c2;
'use strict';

function $fd0f87093eed036b$var$consumeRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilLeftCurlyBracketOrSemicolon, true);
}
function $fd0f87093eed036b$var$isDeclarationBlockAtrule() {
    for(let offset = 1, type; type = this.lookupType(offset); offset++){
        if (type === $926ff4544e512db5$export$186d8b1f99e2bfec) return true;
        if (type === $926ff4544e512db5$export$ccdce7304ac66390 || type === $926ff4544e512db5$export$21bfcb60d1b5ccac) return false;
    }
    return false;
}
const $fd0f87093eed036b$var$name = 'Atrule';
const $fd0f87093eed036b$var$walkContext = 'atrule';
const $fd0f87093eed036b$var$structure = {
    name: String,
    prelude: [
        'AtrulePrelude',
        'Raw',
        null
    ],
    block: [
        'Block',
        null
    ]
};
function $fd0f87093eed036b$var$parse() {
    const start = this.tokenStart;
    let name;
    let nameLowerCase;
    let prelude = null;
    let block = null;
    this.eat($926ff4544e512db5$export$21bfcb60d1b5ccac);
    name = this.substrToCursor(start + 1);
    nameLowerCase = name.toLowerCase();
    this.skipSC();
    // parse prelude
    if (this.eof === false && this.tokenType !== $926ff4544e512db5$export$ccdce7304ac66390 && this.tokenType !== $926ff4544e512db5$export$bedd8b9b04d9dbd) {
        if (this.parseAtrulePrelude) prelude = this.parseWithFallback(this.AtrulePrelude.bind(this, name), $fd0f87093eed036b$var$consumeRaw);
        else prelude = $fd0f87093eed036b$var$consumeRaw.call(this, this.tokenIndex);
        this.skipSC();
    }
    switch(this.tokenType){
        case $926ff4544e512db5$export$bedd8b9b04d9dbd:
            this.next();
            break;
        case $926ff4544e512db5$export$ccdce7304ac66390:
            if (hasOwnProperty.call(this.atrule, nameLowerCase) && typeof this.atrule[nameLowerCase].block === 'function') block = this.atrule[nameLowerCase].block.call(this);
            else // TODO: should consume block content as Raw?
            block = this.Block($fd0f87093eed036b$var$isDeclarationBlockAtrule.call(this));
            break;
    }
    return {
        type: 'Atrule',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        prelude: prelude,
        block: block
    };
}
function $fd0f87093eed036b$var$generate(node) {
    this.token($926ff4544e512db5$export$21bfcb60d1b5ccac, '@' + node.name);
    if (node.prelude !== null) this.node(node.prelude);
    if (node.block) this.node(node.block);
    else this.token($926ff4544e512db5$export$bedd8b9b04d9dbd, ';');
}
$fd0f87093eed036b$export$80d376111cc09ad7 = $fd0f87093eed036b$var$generate;
$fd0f87093eed036b$export$a8ff84c12d48cfa6 = $fd0f87093eed036b$var$name;
$fd0f87093eed036b$export$98e6a39c04603d36 = $fd0f87093eed036b$var$parse;
$fd0f87093eed036b$export$46a2a563c28afca0 = $fd0f87093eed036b$var$structure;
$fd0f87093eed036b$export$f7e0bb689fefb8c2 = $fd0f87093eed036b$var$walkContext;


var $1a6e0f4f495e21e5$exports = {};
$parcel$export($1a6e0f4f495e21e5$exports, "generate", () => $1a6e0f4f495e21e5$export$80d376111cc09ad7, (v) => $1a6e0f4f495e21e5$export$80d376111cc09ad7 = v);
$parcel$export($1a6e0f4f495e21e5$exports, "name", () => $1a6e0f4f495e21e5$export$a8ff84c12d48cfa6, (v) => $1a6e0f4f495e21e5$export$a8ff84c12d48cfa6 = v);
$parcel$export($1a6e0f4f495e21e5$exports, "parse", () => $1a6e0f4f495e21e5$export$98e6a39c04603d36, (v) => $1a6e0f4f495e21e5$export$98e6a39c04603d36 = v);
$parcel$export($1a6e0f4f495e21e5$exports, "structure", () => $1a6e0f4f495e21e5$export$46a2a563c28afca0, (v) => $1a6e0f4f495e21e5$export$46a2a563c28afca0 = v);
$parcel$export($1a6e0f4f495e21e5$exports, "walkContext", () => $1a6e0f4f495e21e5$export$f7e0bb689fefb8c2, (v) => $1a6e0f4f495e21e5$export$f7e0bb689fefb8c2 = v);
var $1a6e0f4f495e21e5$export$80d376111cc09ad7;
var $1a6e0f4f495e21e5$export$a8ff84c12d48cfa6;
var $1a6e0f4f495e21e5$export$98e6a39c04603d36;
var $1a6e0f4f495e21e5$export$46a2a563c28afca0;
var $1a6e0f4f495e21e5$export$f7e0bb689fefb8c2;
'use strict';

const $1a6e0f4f495e21e5$var$name = 'AtrulePrelude';
const $1a6e0f4f495e21e5$var$walkContext = 'atrulePrelude';
const $1a6e0f4f495e21e5$var$structure = {
    children: [
        []
    ]
};
function $1a6e0f4f495e21e5$var$parse(name) {
    let children = null;
    if (name !== null) name = name.toLowerCase();
    this.skipSC();
    if (hasOwnProperty.call(this.atrule, name) && typeof this.atrule[name].prelude === 'function') // custom consumer
    children = this.atrule[name].prelude.call(this);
    else // default consumer
    children = this.readSequence(this.scope.AtrulePrelude);
    this.skipSC();
    if (this.eof !== true && this.tokenType !== $926ff4544e512db5$export$ccdce7304ac66390 && this.tokenType !== $926ff4544e512db5$export$bedd8b9b04d9dbd) this.error('Semicolon or block is expected');
    return {
        type: 'AtrulePrelude',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $1a6e0f4f495e21e5$var$generate(node) {
    this.children(node);
}
$1a6e0f4f495e21e5$export$80d376111cc09ad7 = $1a6e0f4f495e21e5$var$generate;
$1a6e0f4f495e21e5$export$a8ff84c12d48cfa6 = $1a6e0f4f495e21e5$var$name;
$1a6e0f4f495e21e5$export$98e6a39c04603d36 = $1a6e0f4f495e21e5$var$parse;
$1a6e0f4f495e21e5$export$46a2a563c28afca0 = $1a6e0f4f495e21e5$var$structure;
$1a6e0f4f495e21e5$export$f7e0bb689fefb8c2 = $1a6e0f4f495e21e5$var$walkContext;


var $6a4a944c6364bfde$exports = {};
$parcel$export($6a4a944c6364bfde$exports, "generate", () => $6a4a944c6364bfde$export$80d376111cc09ad7, (v) => $6a4a944c6364bfde$export$80d376111cc09ad7 = v);
$parcel$export($6a4a944c6364bfde$exports, "name", () => $6a4a944c6364bfde$export$a8ff84c12d48cfa6, (v) => $6a4a944c6364bfde$export$a8ff84c12d48cfa6 = v);
$parcel$export($6a4a944c6364bfde$exports, "parse", () => $6a4a944c6364bfde$export$98e6a39c04603d36, (v) => $6a4a944c6364bfde$export$98e6a39c04603d36 = v);
$parcel$export($6a4a944c6364bfde$exports, "structure", () => $6a4a944c6364bfde$export$46a2a563c28afca0, (v) => $6a4a944c6364bfde$export$46a2a563c28afca0 = v);
var $6a4a944c6364bfde$export$80d376111cc09ad7;
var $6a4a944c6364bfde$export$a8ff84c12d48cfa6;
var $6a4a944c6364bfde$export$98e6a39c04603d36;
var $6a4a944c6364bfde$export$46a2a563c28afca0;
'use strict';

const $6a4a944c6364bfde$var$DOLLARSIGN = 0x0024; // U+0024 DOLLAR SIGN ($)
const $6a4a944c6364bfde$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $6a4a944c6364bfde$var$EQUALSSIGN = 0x003D; // U+003D EQUALS SIGN (=)
const $6a4a944c6364bfde$var$CIRCUMFLEXACCENT = 0x005E; // U+005E (^)
const $6a4a944c6364bfde$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
const $6a4a944c6364bfde$var$TILDE = 0x007E; // U+007E TILDE (~)
function $6a4a944c6364bfde$var$getAttributeName() {
    if (this.eof) this.error('Unexpected end of input');
    const start = this.tokenStart;
    let expectIdent = false;
    if (this.isDelim($6a4a944c6364bfde$var$ASTERISK)) {
        expectIdent = true;
        this.next();
    } else if (!this.isDelim($6a4a944c6364bfde$var$VERTICALLINE)) this.eat($926ff4544e512db5$export$331e9b6bdecaac5f);
    if (this.isDelim($6a4a944c6364bfde$var$VERTICALLINE)) {
        if (this.charCodeAt(this.tokenStart + 1) !== $6a4a944c6364bfde$var$EQUALSSIGN) {
            this.next();
            this.eat($926ff4544e512db5$export$331e9b6bdecaac5f);
        } else if (expectIdent) this.error('Identifier is expected', this.tokenEnd);
    } else if (expectIdent) this.error('Vertical line is expected');
    return {
        type: 'Identifier',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start)
    };
}
function $6a4a944c6364bfde$var$getOperator() {
    const start = this.tokenStart;
    const code = this.charCodeAt(start);
    if (code !== $6a4a944c6364bfde$var$EQUALSSIGN && // =
    code !== $6a4a944c6364bfde$var$TILDE && // ~=
    code !== $6a4a944c6364bfde$var$CIRCUMFLEXACCENT && // ^=
    code !== $6a4a944c6364bfde$var$DOLLARSIGN && // $=
    code !== $6a4a944c6364bfde$var$ASTERISK && // *=
    code !== $6a4a944c6364bfde$var$VERTICALLINE // |=
    ) this.error('Attribute selector (=, ~=, ^=, $=, *=, |=) is expected');
    this.next();
    if (code !== $6a4a944c6364bfde$var$EQUALSSIGN) {
        if (!this.isDelim($6a4a944c6364bfde$var$EQUALSSIGN)) this.error('Equal sign is expected');
        this.next();
    }
    return this.substrToCursor(start);
}
// '[' <wq-name> ']'
// '[' <wq-name> <attr-matcher> [ <string-token> | <ident-token> ] <attr-modifier>? ']'
const $6a4a944c6364bfde$var$name = 'AttributeSelector';
const $6a4a944c6364bfde$var$structure = {
    name: 'Identifier',
    matcher: [
        String,
        null
    ],
    value: [
        'String',
        'Identifier',
        null
    ],
    flags: [
        String,
        null
    ]
};
function $6a4a944c6364bfde$var$parse() {
    const start = this.tokenStart;
    let name;
    let matcher = null;
    let value = null;
    let flags = null;
    this.eat($926ff4544e512db5$export$cd363bb53c2bb);
    this.skipSC();
    name = $6a4a944c6364bfde$var$getAttributeName.call(this);
    this.skipSC();
    if (this.tokenType !== $926ff4544e512db5$export$72f933344f701f30) {
        // avoid case `[name i]`
        if (this.tokenType !== $926ff4544e512db5$export$331e9b6bdecaac5f) {
            matcher = $6a4a944c6364bfde$var$getOperator.call(this);
            this.skipSC();
            value = this.tokenType === $926ff4544e512db5$export$89b8e0fa65f6a914 ? this.String() : this.Identifier();
            this.skipSC();
        }
        // attribute flags
        if (this.tokenType === $926ff4544e512db5$export$331e9b6bdecaac5f) {
            flags = this.consume($926ff4544e512db5$export$331e9b6bdecaac5f);
            this.skipSC();
        }
    }
    this.eat($926ff4544e512db5$export$72f933344f701f30);
    return {
        type: 'AttributeSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        matcher: matcher,
        value: value,
        flags: flags
    };
}
function $6a4a944c6364bfde$var$generate(node) {
    this.token($926ff4544e512db5$export$a918ca49ff4337a3, '[');
    this.node(node.name);
    if (node.matcher !== null) {
        this.tokenize(node.matcher);
        this.node(node.value);
    }
    if (node.flags !== null) this.token($926ff4544e512db5$export$331e9b6bdecaac5f, node.flags);
    this.token($926ff4544e512db5$export$a918ca49ff4337a3, ']');
}
$6a4a944c6364bfde$export$80d376111cc09ad7 = $6a4a944c6364bfde$var$generate;
$6a4a944c6364bfde$export$a8ff84c12d48cfa6 = $6a4a944c6364bfde$var$name;
$6a4a944c6364bfde$export$98e6a39c04603d36 = $6a4a944c6364bfde$var$parse;
$6a4a944c6364bfde$export$46a2a563c28afca0 = $6a4a944c6364bfde$var$structure;


var $a56929a80fe5fba4$exports = {};
$parcel$export($a56929a80fe5fba4$exports, "generate", () => $a56929a80fe5fba4$export$80d376111cc09ad7, (v) => $a56929a80fe5fba4$export$80d376111cc09ad7 = v);
$parcel$export($a56929a80fe5fba4$exports, "name", () => $a56929a80fe5fba4$export$a8ff84c12d48cfa6, (v) => $a56929a80fe5fba4$export$a8ff84c12d48cfa6 = v);
$parcel$export($a56929a80fe5fba4$exports, "parse", () => $a56929a80fe5fba4$export$98e6a39c04603d36, (v) => $a56929a80fe5fba4$export$98e6a39c04603d36 = v);
$parcel$export($a56929a80fe5fba4$exports, "structure", () => $a56929a80fe5fba4$export$46a2a563c28afca0, (v) => $a56929a80fe5fba4$export$46a2a563c28afca0 = v);
$parcel$export($a56929a80fe5fba4$exports, "walkContext", () => $a56929a80fe5fba4$export$f7e0bb689fefb8c2, (v) => $a56929a80fe5fba4$export$f7e0bb689fefb8c2 = v);
var $a56929a80fe5fba4$export$80d376111cc09ad7;
var $a56929a80fe5fba4$export$a8ff84c12d48cfa6;
var $a56929a80fe5fba4$export$98e6a39c04603d36;
var $a56929a80fe5fba4$export$46a2a563c28afca0;
var $a56929a80fe5fba4$export$f7e0bb689fefb8c2;
'use strict';

function $a56929a80fe5fba4$var$consumeRaw(startToken) {
    return this.Raw(startToken, null, true);
}
function $a56929a80fe5fba4$var$consumeRule() {
    return this.parseWithFallback(this.Rule, $a56929a80fe5fba4$var$consumeRaw);
}
function $a56929a80fe5fba4$var$consumeRawDeclaration(startToken) {
    return this.Raw(startToken, this.consumeUntilSemicolonIncluded, true);
}
function $a56929a80fe5fba4$var$consumeDeclaration() {
    if (this.tokenType === $926ff4544e512db5$export$bedd8b9b04d9dbd) return $a56929a80fe5fba4$var$consumeRawDeclaration.call(this, this.tokenIndex);
    const node = this.parseWithFallback(this.Declaration, $a56929a80fe5fba4$var$consumeRawDeclaration);
    if (this.tokenType === $926ff4544e512db5$export$bedd8b9b04d9dbd) this.next();
    return node;
}
const $a56929a80fe5fba4$var$name = 'Block';
const $a56929a80fe5fba4$var$walkContext = 'block';
const $a56929a80fe5fba4$var$structure = {
    children: [
        [
            'Atrule',
            'Rule',
            'Declaration'
        ]
    ]
};
function $a56929a80fe5fba4$var$parse(isDeclaration) {
    const consumer = isDeclaration ? $a56929a80fe5fba4$var$consumeDeclaration : $a56929a80fe5fba4$var$consumeRule;
    const start = this.tokenStart;
    let children = this.createList();
    this.eat($926ff4544e512db5$export$ccdce7304ac66390);
    scan: while(!this.eof)switch(this.tokenType){
        case $926ff4544e512db5$export$186d8b1f99e2bfec:
            break scan;
        case $926ff4544e512db5$export$fb98946286ab4c97:
        case $926ff4544e512db5$export$4d299b491347818a:
            this.next();
            break;
        case $926ff4544e512db5$export$21bfcb60d1b5ccac:
            children.push(this.parseWithFallback(this.Atrule, $a56929a80fe5fba4$var$consumeRaw));
            break;
        default:
            children.push(consumer.call(this));
    }
    if (!this.eof) this.eat($926ff4544e512db5$export$186d8b1f99e2bfec);
    return {
        type: 'Block',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $a56929a80fe5fba4$var$generate(node) {
    this.token($926ff4544e512db5$export$ccdce7304ac66390, '{');
    this.children(node, (prev)=>{
        if (prev.type === 'Declaration') this.token($926ff4544e512db5$export$bedd8b9b04d9dbd, ';');
    });
    this.token($926ff4544e512db5$export$186d8b1f99e2bfec, '}');
}
$a56929a80fe5fba4$export$80d376111cc09ad7 = $a56929a80fe5fba4$var$generate;
$a56929a80fe5fba4$export$a8ff84c12d48cfa6 = $a56929a80fe5fba4$var$name;
$a56929a80fe5fba4$export$98e6a39c04603d36 = $a56929a80fe5fba4$var$parse;
$a56929a80fe5fba4$export$46a2a563c28afca0 = $a56929a80fe5fba4$var$structure;
$a56929a80fe5fba4$export$f7e0bb689fefb8c2 = $a56929a80fe5fba4$var$walkContext;


var $bf89e1bb9b85384e$exports = {};
$parcel$export($bf89e1bb9b85384e$exports, "generate", () => $bf89e1bb9b85384e$export$80d376111cc09ad7, (v) => $bf89e1bb9b85384e$export$80d376111cc09ad7 = v);
$parcel$export($bf89e1bb9b85384e$exports, "name", () => $bf89e1bb9b85384e$export$a8ff84c12d48cfa6, (v) => $bf89e1bb9b85384e$export$a8ff84c12d48cfa6 = v);
$parcel$export($bf89e1bb9b85384e$exports, "parse", () => $bf89e1bb9b85384e$export$98e6a39c04603d36, (v) => $bf89e1bb9b85384e$export$98e6a39c04603d36 = v);
$parcel$export($bf89e1bb9b85384e$exports, "structure", () => $bf89e1bb9b85384e$export$46a2a563c28afca0, (v) => $bf89e1bb9b85384e$export$46a2a563c28afca0 = v);
var $bf89e1bb9b85384e$export$80d376111cc09ad7;
var $bf89e1bb9b85384e$export$a8ff84c12d48cfa6;
var $bf89e1bb9b85384e$export$98e6a39c04603d36;
var $bf89e1bb9b85384e$export$46a2a563c28afca0;
'use strict';

const $bf89e1bb9b85384e$var$name = 'Brackets';
const $bf89e1bb9b85384e$var$structure = {
    children: [
        []
    ]
};
function $bf89e1bb9b85384e$var$parse(readSequence, recognizer) {
    const start = this.tokenStart;
    let children = null;
    this.eat($926ff4544e512db5$export$cd363bb53c2bb);
    children = readSequence.call(this, recognizer);
    if (!this.eof) this.eat($926ff4544e512db5$export$72f933344f701f30);
    return {
        type: 'Brackets',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $bf89e1bb9b85384e$var$generate(node) {
    this.token($926ff4544e512db5$export$a918ca49ff4337a3, '[');
    this.children(node);
    this.token($926ff4544e512db5$export$a918ca49ff4337a3, ']');
}
$bf89e1bb9b85384e$export$80d376111cc09ad7 = $bf89e1bb9b85384e$var$generate;
$bf89e1bb9b85384e$export$a8ff84c12d48cfa6 = $bf89e1bb9b85384e$var$name;
$bf89e1bb9b85384e$export$98e6a39c04603d36 = $bf89e1bb9b85384e$var$parse;
$bf89e1bb9b85384e$export$46a2a563c28afca0 = $bf89e1bb9b85384e$var$structure;


var $eaa7aa9b4b73ca52$exports = {};
$parcel$export($eaa7aa9b4b73ca52$exports, "generate", () => $eaa7aa9b4b73ca52$export$80d376111cc09ad7, (v) => $eaa7aa9b4b73ca52$export$80d376111cc09ad7 = v);
$parcel$export($eaa7aa9b4b73ca52$exports, "name", () => $eaa7aa9b4b73ca52$export$a8ff84c12d48cfa6, (v) => $eaa7aa9b4b73ca52$export$a8ff84c12d48cfa6 = v);
$parcel$export($eaa7aa9b4b73ca52$exports, "parse", () => $eaa7aa9b4b73ca52$export$98e6a39c04603d36, (v) => $eaa7aa9b4b73ca52$export$98e6a39c04603d36 = v);
$parcel$export($eaa7aa9b4b73ca52$exports, "structure", () => $eaa7aa9b4b73ca52$export$46a2a563c28afca0, (v) => $eaa7aa9b4b73ca52$export$46a2a563c28afca0 = v);
var $eaa7aa9b4b73ca52$export$80d376111cc09ad7;
var $eaa7aa9b4b73ca52$export$a8ff84c12d48cfa6;
var $eaa7aa9b4b73ca52$export$98e6a39c04603d36;
var $eaa7aa9b4b73ca52$export$46a2a563c28afca0;
'use strict';

const $eaa7aa9b4b73ca52$var$name = 'CDC';
const $eaa7aa9b4b73ca52$var$structure = [];
function $eaa7aa9b4b73ca52$var$parse() {
    const start = this.tokenStart;
    this.eat($926ff4544e512db5$export$b0b2bd2d1777c179); // -->
    return {
        type: 'CDC',
        loc: this.getLocation(start, this.tokenStart)
    };
}
function $eaa7aa9b4b73ca52$var$generate() {
    this.token($926ff4544e512db5$export$b0b2bd2d1777c179, '-->');
}
$eaa7aa9b4b73ca52$export$80d376111cc09ad7 = $eaa7aa9b4b73ca52$var$generate;
$eaa7aa9b4b73ca52$export$a8ff84c12d48cfa6 = $eaa7aa9b4b73ca52$var$name;
$eaa7aa9b4b73ca52$export$98e6a39c04603d36 = $eaa7aa9b4b73ca52$var$parse;
$eaa7aa9b4b73ca52$export$46a2a563c28afca0 = $eaa7aa9b4b73ca52$var$structure;


var $03db947d83d4b4cf$exports = {};
$parcel$export($03db947d83d4b4cf$exports, "generate", () => $03db947d83d4b4cf$export$80d376111cc09ad7, (v) => $03db947d83d4b4cf$export$80d376111cc09ad7 = v);
$parcel$export($03db947d83d4b4cf$exports, "name", () => $03db947d83d4b4cf$export$a8ff84c12d48cfa6, (v) => $03db947d83d4b4cf$export$a8ff84c12d48cfa6 = v);
$parcel$export($03db947d83d4b4cf$exports, "parse", () => $03db947d83d4b4cf$export$98e6a39c04603d36, (v) => $03db947d83d4b4cf$export$98e6a39c04603d36 = v);
$parcel$export($03db947d83d4b4cf$exports, "structure", () => $03db947d83d4b4cf$export$46a2a563c28afca0, (v) => $03db947d83d4b4cf$export$46a2a563c28afca0 = v);
var $03db947d83d4b4cf$export$80d376111cc09ad7;
var $03db947d83d4b4cf$export$a8ff84c12d48cfa6;
var $03db947d83d4b4cf$export$98e6a39c04603d36;
var $03db947d83d4b4cf$export$46a2a563c28afca0;
'use strict';

const $03db947d83d4b4cf$var$name = 'CDO';
const $03db947d83d4b4cf$var$structure = [];
function $03db947d83d4b4cf$var$parse() {
    const start = this.tokenStart;
    this.eat($926ff4544e512db5$export$521ef26a3002003b); // <!--
    return {
        type: 'CDO',
        loc: this.getLocation(start, this.tokenStart)
    };
}
function $03db947d83d4b4cf$var$generate() {
    this.token($926ff4544e512db5$export$521ef26a3002003b, '<!--');
}
$03db947d83d4b4cf$export$80d376111cc09ad7 = $03db947d83d4b4cf$var$generate;
$03db947d83d4b4cf$export$a8ff84c12d48cfa6 = $03db947d83d4b4cf$var$name;
$03db947d83d4b4cf$export$98e6a39c04603d36 = $03db947d83d4b4cf$var$parse;
$03db947d83d4b4cf$export$46a2a563c28afca0 = $03db947d83d4b4cf$var$structure;


var $d308a4f21a3e2a3c$exports = {};
$parcel$export($d308a4f21a3e2a3c$exports, "generate", () => $d308a4f21a3e2a3c$export$80d376111cc09ad7, (v) => $d308a4f21a3e2a3c$export$80d376111cc09ad7 = v);
$parcel$export($d308a4f21a3e2a3c$exports, "name", () => $d308a4f21a3e2a3c$export$a8ff84c12d48cfa6, (v) => $d308a4f21a3e2a3c$export$a8ff84c12d48cfa6 = v);
$parcel$export($d308a4f21a3e2a3c$exports, "parse", () => $d308a4f21a3e2a3c$export$98e6a39c04603d36, (v) => $d308a4f21a3e2a3c$export$98e6a39c04603d36 = v);
$parcel$export($d308a4f21a3e2a3c$exports, "structure", () => $d308a4f21a3e2a3c$export$46a2a563c28afca0, (v) => $d308a4f21a3e2a3c$export$46a2a563c28afca0 = v);
var $d308a4f21a3e2a3c$export$80d376111cc09ad7;
var $d308a4f21a3e2a3c$export$a8ff84c12d48cfa6;
var $d308a4f21a3e2a3c$export$98e6a39c04603d36;
var $d308a4f21a3e2a3c$export$46a2a563c28afca0;
'use strict';

const $d308a4f21a3e2a3c$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
// '.' ident
const $d308a4f21a3e2a3c$var$name = 'ClassSelector';
const $d308a4f21a3e2a3c$var$structure = {
    name: String
};
function $d308a4f21a3e2a3c$var$parse() {
    this.eatDelim($d308a4f21a3e2a3c$var$FULLSTOP);
    return {
        type: 'ClassSelector',
        loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
        name: this.consume($926ff4544e512db5$export$331e9b6bdecaac5f)
    };
}
function $d308a4f21a3e2a3c$var$generate(node) {
    this.token($926ff4544e512db5$export$a918ca49ff4337a3, '.');
    this.token($926ff4544e512db5$export$331e9b6bdecaac5f, node.name);
}
$d308a4f21a3e2a3c$export$80d376111cc09ad7 = $d308a4f21a3e2a3c$var$generate;
$d308a4f21a3e2a3c$export$a8ff84c12d48cfa6 = $d308a4f21a3e2a3c$var$name;
$d308a4f21a3e2a3c$export$98e6a39c04603d36 = $d308a4f21a3e2a3c$var$parse;
$d308a4f21a3e2a3c$export$46a2a563c28afca0 = $d308a4f21a3e2a3c$var$structure;


var $7279f71602175e81$exports = {};
$parcel$export($7279f71602175e81$exports, "generate", () => $7279f71602175e81$export$80d376111cc09ad7, (v) => $7279f71602175e81$export$80d376111cc09ad7 = v);
$parcel$export($7279f71602175e81$exports, "name", () => $7279f71602175e81$export$a8ff84c12d48cfa6, (v) => $7279f71602175e81$export$a8ff84c12d48cfa6 = v);
$parcel$export($7279f71602175e81$exports, "parse", () => $7279f71602175e81$export$98e6a39c04603d36, (v) => $7279f71602175e81$export$98e6a39c04603d36 = v);
$parcel$export($7279f71602175e81$exports, "structure", () => $7279f71602175e81$export$46a2a563c28afca0, (v) => $7279f71602175e81$export$46a2a563c28afca0 = v);
var $7279f71602175e81$export$80d376111cc09ad7;
var $7279f71602175e81$export$a8ff84c12d48cfa6;
var $7279f71602175e81$export$98e6a39c04603d36;
var $7279f71602175e81$export$46a2a563c28afca0;
'use strict';

const $7279f71602175e81$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $7279f71602175e81$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $7279f71602175e81$var$GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
const $7279f71602175e81$var$TILDE = 0x007E; // U+007E TILDE (~)
const $7279f71602175e81$var$name = 'Combinator';
const $7279f71602175e81$var$structure = {
    name: String
};
// + | > | ~ | /deep/
function $7279f71602175e81$var$parse() {
    const start = this.tokenStart;
    let name;
    switch(this.tokenType){
        case $926ff4544e512db5$export$fb98946286ab4c97:
            name = ' ';
            break;
        case $926ff4544e512db5$export$a918ca49ff4337a3:
            switch(this.charCodeAt(this.tokenStart)){
                case $7279f71602175e81$var$GREATERTHANSIGN:
                case $7279f71602175e81$var$PLUSSIGN:
                case $7279f71602175e81$var$TILDE:
                    this.next();
                    break;
                case $7279f71602175e81$var$SOLIDUS:
                    this.next();
                    this.eatIdent('deep');
                    this.eatDelim($7279f71602175e81$var$SOLIDUS);
                    break;
                default:
                    this.error('Combinator is expected');
            }
            name = this.substrToCursor(start);
            break;
    }
    return {
        type: 'Combinator',
        loc: this.getLocation(start, this.tokenStart),
        name: name
    };
}
function $7279f71602175e81$var$generate(node) {
    this.tokenize(node.name);
}
$7279f71602175e81$export$80d376111cc09ad7 = $7279f71602175e81$var$generate;
$7279f71602175e81$export$a8ff84c12d48cfa6 = $7279f71602175e81$var$name;
$7279f71602175e81$export$98e6a39c04603d36 = $7279f71602175e81$var$parse;
$7279f71602175e81$export$46a2a563c28afca0 = $7279f71602175e81$var$structure;


var $db90df25217d7def$exports = {};
$parcel$export($db90df25217d7def$exports, "generate", () => $db90df25217d7def$export$80d376111cc09ad7, (v) => $db90df25217d7def$export$80d376111cc09ad7 = v);
$parcel$export($db90df25217d7def$exports, "name", () => $db90df25217d7def$export$a8ff84c12d48cfa6, (v) => $db90df25217d7def$export$a8ff84c12d48cfa6 = v);
$parcel$export($db90df25217d7def$exports, "parse", () => $db90df25217d7def$export$98e6a39c04603d36, (v) => $db90df25217d7def$export$98e6a39c04603d36 = v);
$parcel$export($db90df25217d7def$exports, "structure", () => $db90df25217d7def$export$46a2a563c28afca0, (v) => $db90df25217d7def$export$46a2a563c28afca0 = v);
var $db90df25217d7def$export$80d376111cc09ad7;
var $db90df25217d7def$export$a8ff84c12d48cfa6;
var $db90df25217d7def$export$98e6a39c04603d36;
var $db90df25217d7def$export$46a2a563c28afca0;
'use strict';

const $db90df25217d7def$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $db90df25217d7def$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $db90df25217d7def$var$name = 'Comment';
const $db90df25217d7def$var$structure = {
    value: String
};
function $db90df25217d7def$var$parse() {
    const start = this.tokenStart;
    let end = this.tokenEnd;
    this.eat($926ff4544e512db5$export$4d299b491347818a);
    if (end - start + 2 >= 2 && this.charCodeAt(end - 2) === $db90df25217d7def$var$ASTERISK && this.charCodeAt(end - 1) === $db90df25217d7def$var$SOLIDUS) end -= 2;
    return {
        type: 'Comment',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substring(start + 2, end)
    };
}
function $db90df25217d7def$var$generate(node) {
    this.token($926ff4544e512db5$export$4d299b491347818a, '/*' + node.value + '*/');
}
$db90df25217d7def$export$80d376111cc09ad7 = $db90df25217d7def$var$generate;
$db90df25217d7def$export$a8ff84c12d48cfa6 = $db90df25217d7def$var$name;
$db90df25217d7def$export$98e6a39c04603d36 = $db90df25217d7def$var$parse;
$db90df25217d7def$export$46a2a563c28afca0 = $db90df25217d7def$var$structure;


var $cba42d248bcc1907$exports = {};
$parcel$export($cba42d248bcc1907$exports, "generate", () => $cba42d248bcc1907$export$80d376111cc09ad7, (v) => $cba42d248bcc1907$export$80d376111cc09ad7 = v);
$parcel$export($cba42d248bcc1907$exports, "name", () => $cba42d248bcc1907$export$a8ff84c12d48cfa6, (v) => $cba42d248bcc1907$export$a8ff84c12d48cfa6 = v);
$parcel$export($cba42d248bcc1907$exports, "parse", () => $cba42d248bcc1907$export$98e6a39c04603d36, (v) => $cba42d248bcc1907$export$98e6a39c04603d36 = v);
$parcel$export($cba42d248bcc1907$exports, "structure", () => $cba42d248bcc1907$export$46a2a563c28afca0, (v) => $cba42d248bcc1907$export$46a2a563c28afca0 = v);
$parcel$export($cba42d248bcc1907$exports, "walkContext", () => $cba42d248bcc1907$export$f7e0bb689fefb8c2, (v) => $cba42d248bcc1907$export$f7e0bb689fefb8c2 = v);
var $cba42d248bcc1907$export$80d376111cc09ad7;
var $cba42d248bcc1907$export$a8ff84c12d48cfa6;
var $cba42d248bcc1907$export$98e6a39c04603d36;
var $cba42d248bcc1907$export$46a2a563c28afca0;
var $cba42d248bcc1907$export$f7e0bb689fefb8c2;
'use strict';


const $cba42d248bcc1907$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
const $cba42d248bcc1907$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $cba42d248bcc1907$var$DOLLARSIGN = 0x0024; // U+0024 DOLLAR SIGN ($)
const $cba42d248bcc1907$var$AMPERSAND = 0x0026; // U+0026 AMPERSAND (&)
const $cba42d248bcc1907$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $cba42d248bcc1907$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $cba42d248bcc1907$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
function $cba42d248bcc1907$var$consumeValueRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilExclamationMarkOrSemicolon, true);
}
function $cba42d248bcc1907$var$consumeCustomPropertyRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilExclamationMarkOrSemicolon, false);
}
function $cba42d248bcc1907$var$consumeValue() {
    const startValueToken = this.tokenIndex;
    const value = this.Value();
    if (value.type !== 'Raw' && this.eof === false && this.tokenType !== $926ff4544e512db5$export$bedd8b9b04d9dbd && this.isDelim($cba42d248bcc1907$var$EXCLAMATIONMARK) === false && this.isBalanceEdge(startValueToken) === false) this.error();
    return value;
}
const $cba42d248bcc1907$var$name = 'Declaration';
const $cba42d248bcc1907$var$walkContext = 'declaration';
const $cba42d248bcc1907$var$structure = {
    important: [
        Boolean,
        String
    ],
    property: String,
    value: [
        'Value',
        'Raw'
    ]
};
function $cba42d248bcc1907$var$parse() {
    const start = this.tokenStart;
    const startToken = this.tokenIndex;
    const property = $cba42d248bcc1907$var$readProperty.call(this);
    const customProperty = $ffbc3ade873552d0$export$15cf667f7f91c461(property);
    const parseValue = customProperty ? this.parseCustomProperty : this.parseValue;
    const consumeRaw = customProperty ? $cba42d248bcc1907$var$consumeCustomPropertyRaw : $cba42d248bcc1907$var$consumeValueRaw;
    let important = false;
    let value;
    this.skipSC();
    this.eat($926ff4544e512db5$export$e20ebb298016f6);
    const valueStart = this.tokenIndex;
    if (!customProperty) this.skipSC();
    if (parseValue) value = this.parseWithFallback($cba42d248bcc1907$var$consumeValue, consumeRaw);
    else value = consumeRaw.call(this, this.tokenIndex);
    if (customProperty && value.type === 'Value' && value.children.isEmpty) {
        for(let offset = valueStart - this.tokenIndex; offset <= 0; offset++)if (this.lookupType(offset) === $926ff4544e512db5$export$fb98946286ab4c97) {
            value.children.appendData({
                type: 'WhiteSpace',
                loc: null,
                value: ' '
            });
            break;
        }
    }
    if (this.isDelim($cba42d248bcc1907$var$EXCLAMATIONMARK)) {
        important = $cba42d248bcc1907$var$getImportant.call(this);
        this.skipSC();
    }
    // Do not include semicolon to range per spec
    // https://drafts.csswg.org/css-syntax/#declaration-diagram
    if (this.eof === false && this.tokenType !== $926ff4544e512db5$export$bedd8b9b04d9dbd && this.isBalanceEdge(startToken) === false) this.error();
    return {
        type: 'Declaration',
        loc: this.getLocation(start, this.tokenStart),
        important: important,
        property: property,
        value: value
    };
}
function $cba42d248bcc1907$var$generate(node) {
    this.token($926ff4544e512db5$export$331e9b6bdecaac5f, node.property);
    this.token($926ff4544e512db5$export$e20ebb298016f6, ':');
    this.node(node.value);
    if (node.important) {
        this.token($926ff4544e512db5$export$a918ca49ff4337a3, '!');
        this.token($926ff4544e512db5$export$331e9b6bdecaac5f, node.important === true ? 'important' : node.important);
    }
}
function $cba42d248bcc1907$var$readProperty() {
    const start = this.tokenStart;
    // hacks
    if (this.tokenType === $926ff4544e512db5$export$a918ca49ff4337a3) switch(this.charCodeAt(this.tokenStart)){
        case $cba42d248bcc1907$var$ASTERISK:
        case $cba42d248bcc1907$var$DOLLARSIGN:
        case $cba42d248bcc1907$var$PLUSSIGN:
        case $cba42d248bcc1907$var$NUMBERSIGN:
        case $cba42d248bcc1907$var$AMPERSAND:
            this.next();
            break;
        // TODO: not sure we should support this hack
        case $cba42d248bcc1907$var$SOLIDUS:
            this.next();
            if (this.isDelim($cba42d248bcc1907$var$SOLIDUS)) this.next();
            break;
    }
    if (this.tokenType === $926ff4544e512db5$export$ab85ecd77ce6a5cd) this.eat($926ff4544e512db5$export$ab85ecd77ce6a5cd);
    else this.eat($926ff4544e512db5$export$331e9b6bdecaac5f);
    return this.substrToCursor(start);
}
// ! ws* important
function $cba42d248bcc1907$var$getImportant() {
    this.eat($926ff4544e512db5$export$a918ca49ff4337a3);
    this.skipSC();
    const important = this.consume($926ff4544e512db5$export$331e9b6bdecaac5f);
    // store original value in case it differ from `important`
    // for better original source restoring and hacks like `!ie` support
    return important === 'important' ? true : important;
}
$cba42d248bcc1907$export$80d376111cc09ad7 = $cba42d248bcc1907$var$generate;
$cba42d248bcc1907$export$a8ff84c12d48cfa6 = $cba42d248bcc1907$var$name;
$cba42d248bcc1907$export$98e6a39c04603d36 = $cba42d248bcc1907$var$parse;
$cba42d248bcc1907$export$46a2a563c28afca0 = $cba42d248bcc1907$var$structure;
$cba42d248bcc1907$export$f7e0bb689fefb8c2 = $cba42d248bcc1907$var$walkContext;


var $0e086e8c57e8deab$exports = {};
$parcel$export($0e086e8c57e8deab$exports, "generate", () => $0e086e8c57e8deab$export$80d376111cc09ad7, (v) => $0e086e8c57e8deab$export$80d376111cc09ad7 = v);
$parcel$export($0e086e8c57e8deab$exports, "name", () => $0e086e8c57e8deab$export$a8ff84c12d48cfa6, (v) => $0e086e8c57e8deab$export$a8ff84c12d48cfa6 = v);
$parcel$export($0e086e8c57e8deab$exports, "parse", () => $0e086e8c57e8deab$export$98e6a39c04603d36, (v) => $0e086e8c57e8deab$export$98e6a39c04603d36 = v);
$parcel$export($0e086e8c57e8deab$exports, "structure", () => $0e086e8c57e8deab$export$46a2a563c28afca0, (v) => $0e086e8c57e8deab$export$46a2a563c28afca0 = v);
var $0e086e8c57e8deab$export$80d376111cc09ad7;
var $0e086e8c57e8deab$export$a8ff84c12d48cfa6;
var $0e086e8c57e8deab$export$98e6a39c04603d36;
var $0e086e8c57e8deab$export$46a2a563c28afca0;
'use strict';

function $0e086e8c57e8deab$var$consumeRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilSemicolonIncluded, true);
}
const $0e086e8c57e8deab$var$name = 'DeclarationList';
const $0e086e8c57e8deab$var$structure = {
    children: [
        [
            'Declaration'
        ]
    ]
};
function $0e086e8c57e8deab$var$parse() {
    const children = this.createList();
    while(!this.eof)switch(this.tokenType){
        case $926ff4544e512db5$export$fb98946286ab4c97:
        case $926ff4544e512db5$export$4d299b491347818a:
        case $926ff4544e512db5$export$bedd8b9b04d9dbd:
            this.next();
            break;
        default:
            children.push(this.parseWithFallback(this.Declaration, $0e086e8c57e8deab$var$consumeRaw));
    }
    return {
        type: 'DeclarationList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $0e086e8c57e8deab$var$generate(node) {
    this.children(node, (prev)=>{
        if (prev.type === 'Declaration') this.token($926ff4544e512db5$export$bedd8b9b04d9dbd, ';');
    });
}
$0e086e8c57e8deab$export$80d376111cc09ad7 = $0e086e8c57e8deab$var$generate;
$0e086e8c57e8deab$export$a8ff84c12d48cfa6 = $0e086e8c57e8deab$var$name;
$0e086e8c57e8deab$export$98e6a39c04603d36 = $0e086e8c57e8deab$var$parse;
$0e086e8c57e8deab$export$46a2a563c28afca0 = $0e086e8c57e8deab$var$structure;


var $5451298cec146216$exports = {};
$parcel$export($5451298cec146216$exports, "generate", () => $5451298cec146216$export$80d376111cc09ad7, (v) => $5451298cec146216$export$80d376111cc09ad7 = v);
$parcel$export($5451298cec146216$exports, "name", () => $5451298cec146216$export$a8ff84c12d48cfa6, (v) => $5451298cec146216$export$a8ff84c12d48cfa6 = v);
$parcel$export($5451298cec146216$exports, "parse", () => $5451298cec146216$export$98e6a39c04603d36, (v) => $5451298cec146216$export$98e6a39c04603d36 = v);
$parcel$export($5451298cec146216$exports, "structure", () => $5451298cec146216$export$46a2a563c28afca0, (v) => $5451298cec146216$export$46a2a563c28afca0 = v);
var $5451298cec146216$export$80d376111cc09ad7;
var $5451298cec146216$export$a8ff84c12d48cfa6;
var $5451298cec146216$export$98e6a39c04603d36;
var $5451298cec146216$export$46a2a563c28afca0;
'use strict';

const $5451298cec146216$var$name = 'Dimension';
const $5451298cec146216$var$structure = {
    value: String,
    unit: String
};
function $5451298cec146216$var$parse() {
    const start = this.tokenStart;
    const value = this.consumeNumber($926ff4544e512db5$export$c940ece961bc43c6);
    return {
        type: 'Dimension',
        loc: this.getLocation(start, this.tokenStart),
        value: value,
        unit: this.substring(start + value.length, this.tokenStart)
    };
}
function $5451298cec146216$var$generate(node) {
    this.token($926ff4544e512db5$export$c940ece961bc43c6, node.value + node.unit);
}
$5451298cec146216$export$80d376111cc09ad7 = $5451298cec146216$var$generate;
$5451298cec146216$export$a8ff84c12d48cfa6 = $5451298cec146216$var$name;
$5451298cec146216$export$98e6a39c04603d36 = $5451298cec146216$var$parse;
$5451298cec146216$export$46a2a563c28afca0 = $5451298cec146216$var$structure;


var $36f4bb9e2a32a1da$exports = {};
$parcel$export($36f4bb9e2a32a1da$exports, "generate", () => $36f4bb9e2a32a1da$export$80d376111cc09ad7, (v) => $36f4bb9e2a32a1da$export$80d376111cc09ad7 = v);
$parcel$export($36f4bb9e2a32a1da$exports, "name", () => $36f4bb9e2a32a1da$export$a8ff84c12d48cfa6, (v) => $36f4bb9e2a32a1da$export$a8ff84c12d48cfa6 = v);
$parcel$export($36f4bb9e2a32a1da$exports, "parse", () => $36f4bb9e2a32a1da$export$98e6a39c04603d36, (v) => $36f4bb9e2a32a1da$export$98e6a39c04603d36 = v);
$parcel$export($36f4bb9e2a32a1da$exports, "structure", () => $36f4bb9e2a32a1da$export$46a2a563c28afca0, (v) => $36f4bb9e2a32a1da$export$46a2a563c28afca0 = v);
$parcel$export($36f4bb9e2a32a1da$exports, "walkContext", () => $36f4bb9e2a32a1da$export$f7e0bb689fefb8c2, (v) => $36f4bb9e2a32a1da$export$f7e0bb689fefb8c2 = v);
var $36f4bb9e2a32a1da$export$80d376111cc09ad7;
var $36f4bb9e2a32a1da$export$a8ff84c12d48cfa6;
var $36f4bb9e2a32a1da$export$98e6a39c04603d36;
var $36f4bb9e2a32a1da$export$46a2a563c28afca0;
var $36f4bb9e2a32a1da$export$f7e0bb689fefb8c2;
'use strict';

const $36f4bb9e2a32a1da$var$name = 'Function';
const $36f4bb9e2a32a1da$var$walkContext = 'function';
const $36f4bb9e2a32a1da$var$structure = {
    name: String,
    children: [
        []
    ]
};
// <function-token> <sequence> )
function $36f4bb9e2a32a1da$var$parse(readSequence, recognizer) {
    const start = this.tokenStart;
    const name = this.consumeFunctionName();
    const nameLowerCase = name.toLowerCase();
    let children;
    children = recognizer.hasOwnProperty(nameLowerCase) ? recognizer[nameLowerCase].call(this, recognizer) : readSequence.call(this, recognizer);
    if (!this.eof) this.eat($926ff4544e512db5$export$773d33972c6279ed);
    return {
        type: 'Function',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $36f4bb9e2a32a1da$var$generate(node) {
    this.token($926ff4544e512db5$export$f3890eeaf6851387, node.name + '(');
    this.children(node);
    this.token($926ff4544e512db5$export$773d33972c6279ed, ')');
}
$36f4bb9e2a32a1da$export$80d376111cc09ad7 = $36f4bb9e2a32a1da$var$generate;
$36f4bb9e2a32a1da$export$a8ff84c12d48cfa6 = $36f4bb9e2a32a1da$var$name;
$36f4bb9e2a32a1da$export$98e6a39c04603d36 = $36f4bb9e2a32a1da$var$parse;
$36f4bb9e2a32a1da$export$46a2a563c28afca0 = $36f4bb9e2a32a1da$var$structure;
$36f4bb9e2a32a1da$export$f7e0bb689fefb8c2 = $36f4bb9e2a32a1da$var$walkContext;


var $d582d94e39da803c$exports = {};
$parcel$export($d582d94e39da803c$exports, "generate", () => $d582d94e39da803c$export$80d376111cc09ad7, (v) => $d582d94e39da803c$export$80d376111cc09ad7 = v);
$parcel$export($d582d94e39da803c$exports, "name", () => $d582d94e39da803c$export$a8ff84c12d48cfa6, (v) => $d582d94e39da803c$export$a8ff84c12d48cfa6 = v);
$parcel$export($d582d94e39da803c$exports, "parse", () => $d582d94e39da803c$export$98e6a39c04603d36, (v) => $d582d94e39da803c$export$98e6a39c04603d36 = v);
$parcel$export($d582d94e39da803c$exports, "structure", () => $d582d94e39da803c$export$46a2a563c28afca0, (v) => $d582d94e39da803c$export$46a2a563c28afca0 = v);
$parcel$export($d582d94e39da803c$exports, "xxx", () => $d582d94e39da803c$export$78cbacf5ba6edce7, (v) => $d582d94e39da803c$export$78cbacf5ba6edce7 = v);
var $d582d94e39da803c$export$80d376111cc09ad7;
var $d582d94e39da803c$export$a8ff84c12d48cfa6;
var $d582d94e39da803c$export$98e6a39c04603d36;
var $d582d94e39da803c$export$46a2a563c28afca0;
var $d582d94e39da803c$export$78cbacf5ba6edce7;
'use strict';

// '#' ident
const $d582d94e39da803c$var$xxx = 'XXX';
const $d582d94e39da803c$var$name = 'Hash';
const $d582d94e39da803c$var$structure = {
    value: String
};
function $d582d94e39da803c$var$parse() {
    const start = this.tokenStart;
    this.eat($926ff4544e512db5$export$ab85ecd77ce6a5cd);
    return {
        type: 'Hash',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start + 1)
    };
}
function $d582d94e39da803c$var$generate(node) {
    this.token($926ff4544e512db5$export$ab85ecd77ce6a5cd, '#' + node.value);
}
$d582d94e39da803c$export$80d376111cc09ad7 = $d582d94e39da803c$var$generate;
$d582d94e39da803c$export$a8ff84c12d48cfa6 = $d582d94e39da803c$var$name;
$d582d94e39da803c$export$98e6a39c04603d36 = $d582d94e39da803c$var$parse;
$d582d94e39da803c$export$46a2a563c28afca0 = $d582d94e39da803c$var$structure;
$d582d94e39da803c$export$78cbacf5ba6edce7 = $d582d94e39da803c$var$xxx;


var $c4e2cd839b327e68$exports = {};
$parcel$export($c4e2cd839b327e68$exports, "generate", () => $c4e2cd839b327e68$export$80d376111cc09ad7, (v) => $c4e2cd839b327e68$export$80d376111cc09ad7 = v);
$parcel$export($c4e2cd839b327e68$exports, "name", () => $c4e2cd839b327e68$export$a8ff84c12d48cfa6, (v) => $c4e2cd839b327e68$export$a8ff84c12d48cfa6 = v);
$parcel$export($c4e2cd839b327e68$exports, "parse", () => $c4e2cd839b327e68$export$98e6a39c04603d36, (v) => $c4e2cd839b327e68$export$98e6a39c04603d36 = v);
$parcel$export($c4e2cd839b327e68$exports, "structure", () => $c4e2cd839b327e68$export$46a2a563c28afca0, (v) => $c4e2cd839b327e68$export$46a2a563c28afca0 = v);
var $c4e2cd839b327e68$export$80d376111cc09ad7;
var $c4e2cd839b327e68$export$a8ff84c12d48cfa6;
var $c4e2cd839b327e68$export$98e6a39c04603d36;
var $c4e2cd839b327e68$export$46a2a563c28afca0;
'use strict';

const $c4e2cd839b327e68$var$name = 'Identifier';
const $c4e2cd839b327e68$var$structure = {
    name: String
};
function $c4e2cd839b327e68$var$parse() {
    return {
        type: 'Identifier',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        name: this.consume($926ff4544e512db5$export$331e9b6bdecaac5f)
    };
}
function $c4e2cd839b327e68$var$generate(node) {
    this.token($926ff4544e512db5$export$331e9b6bdecaac5f, node.name);
}
$c4e2cd839b327e68$export$80d376111cc09ad7 = $c4e2cd839b327e68$var$generate;
$c4e2cd839b327e68$export$a8ff84c12d48cfa6 = $c4e2cd839b327e68$var$name;
$c4e2cd839b327e68$export$98e6a39c04603d36 = $c4e2cd839b327e68$var$parse;
$c4e2cd839b327e68$export$46a2a563c28afca0 = $c4e2cd839b327e68$var$structure;


var $f4c0ccbed8fbd0e7$exports = {};
$parcel$export($f4c0ccbed8fbd0e7$exports, "generate", () => $f4c0ccbed8fbd0e7$export$80d376111cc09ad7, (v) => $f4c0ccbed8fbd0e7$export$80d376111cc09ad7 = v);
$parcel$export($f4c0ccbed8fbd0e7$exports, "name", () => $f4c0ccbed8fbd0e7$export$a8ff84c12d48cfa6, (v) => $f4c0ccbed8fbd0e7$export$a8ff84c12d48cfa6 = v);
$parcel$export($f4c0ccbed8fbd0e7$exports, "parse", () => $f4c0ccbed8fbd0e7$export$98e6a39c04603d36, (v) => $f4c0ccbed8fbd0e7$export$98e6a39c04603d36 = v);
$parcel$export($f4c0ccbed8fbd0e7$exports, "structure", () => $f4c0ccbed8fbd0e7$export$46a2a563c28afca0, (v) => $f4c0ccbed8fbd0e7$export$46a2a563c28afca0 = v);
var $f4c0ccbed8fbd0e7$export$80d376111cc09ad7;
var $f4c0ccbed8fbd0e7$export$a8ff84c12d48cfa6;
var $f4c0ccbed8fbd0e7$export$98e6a39c04603d36;
var $f4c0ccbed8fbd0e7$export$46a2a563c28afca0;
'use strict';

const $f4c0ccbed8fbd0e7$var$name = 'IdSelector';
const $f4c0ccbed8fbd0e7$var$structure = {
    name: String
};
function $f4c0ccbed8fbd0e7$var$parse() {
    const start = this.tokenStart;
    // TODO: check value is an ident
    this.eat($926ff4544e512db5$export$ab85ecd77ce6a5cd);
    return {
        type: 'IdSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start + 1)
    };
}
function $f4c0ccbed8fbd0e7$var$generate(node) {
    // Using Delim instead of Hash is a hack to avoid for a whitespace between ident and id-selector
    // in safe mode (e.g. "a#id"), because IE11 doesn't allow a sequence <ident-token> <hash-token>
    // without a whitespace in values (e.g. "1px solid#000")
    this.token($926ff4544e512db5$export$a918ca49ff4337a3, '#' + node.name);
}
$f4c0ccbed8fbd0e7$export$80d376111cc09ad7 = $f4c0ccbed8fbd0e7$var$generate;
$f4c0ccbed8fbd0e7$export$a8ff84c12d48cfa6 = $f4c0ccbed8fbd0e7$var$name;
$f4c0ccbed8fbd0e7$export$98e6a39c04603d36 = $f4c0ccbed8fbd0e7$var$parse;
$f4c0ccbed8fbd0e7$export$46a2a563c28afca0 = $f4c0ccbed8fbd0e7$var$structure;


var $eefd2500d36c6130$exports = {};
$parcel$export($eefd2500d36c6130$exports, "generate", () => $eefd2500d36c6130$export$80d376111cc09ad7, (v) => $eefd2500d36c6130$export$80d376111cc09ad7 = v);
$parcel$export($eefd2500d36c6130$exports, "name", () => $eefd2500d36c6130$export$a8ff84c12d48cfa6, (v) => $eefd2500d36c6130$export$a8ff84c12d48cfa6 = v);
$parcel$export($eefd2500d36c6130$exports, "parse", () => $eefd2500d36c6130$export$98e6a39c04603d36, (v) => $eefd2500d36c6130$export$98e6a39c04603d36 = v);
$parcel$export($eefd2500d36c6130$exports, "structure", () => $eefd2500d36c6130$export$46a2a563c28afca0, (v) => $eefd2500d36c6130$export$46a2a563c28afca0 = v);
var $eefd2500d36c6130$export$80d376111cc09ad7;
var $eefd2500d36c6130$export$a8ff84c12d48cfa6;
var $eefd2500d36c6130$export$98e6a39c04603d36;
var $eefd2500d36c6130$export$46a2a563c28afca0;
'use strict';

const $eefd2500d36c6130$var$name = 'MediaFeature';
const $eefd2500d36c6130$var$structure = {
    name: String,
    value: [
        'Identifier',
        'Number',
        'Dimension',
        'Ratio',
        null
    ]
};
function $eefd2500d36c6130$var$parse() {
    const start = this.tokenStart;
    let name;
    let value = null;
    this.eat($926ff4544e512db5$export$b5a25f132cb53de6);
    this.skipSC();
    name = this.consume($926ff4544e512db5$export$331e9b6bdecaac5f);
    this.skipSC();
    if (this.tokenType !== $926ff4544e512db5$export$773d33972c6279ed) {
        this.eat($926ff4544e512db5$export$e20ebb298016f6);
        this.skipSC();
        switch(this.tokenType){
            case $926ff4544e512db5$export$fffa67e515d04022:
                if (this.lookupNonWSType(1) === $926ff4544e512db5$export$a918ca49ff4337a3) value = this.Ratio();
                else value = this.Number();
                break;
            case $926ff4544e512db5$export$c940ece961bc43c6:
                value = this.Dimension();
                break;
            case $926ff4544e512db5$export$331e9b6bdecaac5f:
                value = this.Identifier();
                break;
            default:
                this.error('Number, dimension, ratio or identifier is expected');
        }
        this.skipSC();
    }
    this.eat($926ff4544e512db5$export$773d33972c6279ed);
    return {
        type: 'MediaFeature',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        value: value
    };
}
function $eefd2500d36c6130$var$generate(node) {
    this.token($926ff4544e512db5$export$b5a25f132cb53de6, '(');
    this.token($926ff4544e512db5$export$331e9b6bdecaac5f, node.name);
    if (node.value !== null) {
        this.token($926ff4544e512db5$export$e20ebb298016f6, ':');
        this.node(node.value);
    }
    this.token($926ff4544e512db5$export$773d33972c6279ed, ')');
}
$eefd2500d36c6130$export$80d376111cc09ad7 = $eefd2500d36c6130$var$generate;
$eefd2500d36c6130$export$a8ff84c12d48cfa6 = $eefd2500d36c6130$var$name;
$eefd2500d36c6130$export$98e6a39c04603d36 = $eefd2500d36c6130$var$parse;
$eefd2500d36c6130$export$46a2a563c28afca0 = $eefd2500d36c6130$var$structure;


var $4fa1fa8572359f69$exports = {};
$parcel$export($4fa1fa8572359f69$exports, "generate", () => $4fa1fa8572359f69$export$80d376111cc09ad7, (v) => $4fa1fa8572359f69$export$80d376111cc09ad7 = v);
$parcel$export($4fa1fa8572359f69$exports, "name", () => $4fa1fa8572359f69$export$a8ff84c12d48cfa6, (v) => $4fa1fa8572359f69$export$a8ff84c12d48cfa6 = v);
$parcel$export($4fa1fa8572359f69$exports, "parse", () => $4fa1fa8572359f69$export$98e6a39c04603d36, (v) => $4fa1fa8572359f69$export$98e6a39c04603d36 = v);
$parcel$export($4fa1fa8572359f69$exports, "structure", () => $4fa1fa8572359f69$export$46a2a563c28afca0, (v) => $4fa1fa8572359f69$export$46a2a563c28afca0 = v);
var $4fa1fa8572359f69$export$80d376111cc09ad7;
var $4fa1fa8572359f69$export$a8ff84c12d48cfa6;
var $4fa1fa8572359f69$export$98e6a39c04603d36;
var $4fa1fa8572359f69$export$46a2a563c28afca0;
'use strict';

const $4fa1fa8572359f69$var$name = 'MediaQuery';
const $4fa1fa8572359f69$var$structure = {
    children: [
        [
            'Identifier',
            'MediaFeature',
            'WhiteSpace'
        ]
    ]
};
function $4fa1fa8572359f69$var$parse() {
    const children = this.createList();
    let child = null;
    this.skipSC();
    scan: while(!this.eof){
        switch(this.tokenType){
            case $926ff4544e512db5$export$4d299b491347818a:
            case $926ff4544e512db5$export$fb98946286ab4c97:
                this.next();
                continue;
            case $926ff4544e512db5$export$331e9b6bdecaac5f:
                child = this.Identifier();
                break;
            case $926ff4544e512db5$export$b5a25f132cb53de6:
                child = this.MediaFeature();
                break;
            default:
                break scan;
        }
        children.push(child);
    }
    if (child === null) this.error('Identifier or parenthesis is expected');
    return {
        type: 'MediaQuery',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $4fa1fa8572359f69$var$generate(node) {
    this.children(node);
}
$4fa1fa8572359f69$export$80d376111cc09ad7 = $4fa1fa8572359f69$var$generate;
$4fa1fa8572359f69$export$a8ff84c12d48cfa6 = $4fa1fa8572359f69$var$name;
$4fa1fa8572359f69$export$98e6a39c04603d36 = $4fa1fa8572359f69$var$parse;
$4fa1fa8572359f69$export$46a2a563c28afca0 = $4fa1fa8572359f69$var$structure;


var $d9c170cb81a09b3c$exports = {};
$parcel$export($d9c170cb81a09b3c$exports, "generate", () => $d9c170cb81a09b3c$export$80d376111cc09ad7, (v) => $d9c170cb81a09b3c$export$80d376111cc09ad7 = v);
$parcel$export($d9c170cb81a09b3c$exports, "name", () => $d9c170cb81a09b3c$export$a8ff84c12d48cfa6, (v) => $d9c170cb81a09b3c$export$a8ff84c12d48cfa6 = v);
$parcel$export($d9c170cb81a09b3c$exports, "parse", () => $d9c170cb81a09b3c$export$98e6a39c04603d36, (v) => $d9c170cb81a09b3c$export$98e6a39c04603d36 = v);
$parcel$export($d9c170cb81a09b3c$exports, "structure", () => $d9c170cb81a09b3c$export$46a2a563c28afca0, (v) => $d9c170cb81a09b3c$export$46a2a563c28afca0 = v);
var $d9c170cb81a09b3c$export$80d376111cc09ad7;
var $d9c170cb81a09b3c$export$a8ff84c12d48cfa6;
var $d9c170cb81a09b3c$export$98e6a39c04603d36;
var $d9c170cb81a09b3c$export$46a2a563c28afca0;
'use strict';

const $d9c170cb81a09b3c$var$name = 'MediaQueryList';
const $d9c170cb81a09b3c$var$structure = {
    children: [
        [
            'MediaQuery'
        ]
    ]
};
function $d9c170cb81a09b3c$var$parse() {
    const children = this.createList();
    this.skipSC();
    while(!this.eof){
        children.push(this.MediaQuery());
        if (this.tokenType !== $926ff4544e512db5$export$c06e3ee3b4d233fa) break;
        this.next();
    }
    return {
        type: 'MediaQueryList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $d9c170cb81a09b3c$var$generate(node) {
    this.children(node, ()=>this.token($926ff4544e512db5$export$c06e3ee3b4d233fa, ','));
}
$d9c170cb81a09b3c$export$80d376111cc09ad7 = $d9c170cb81a09b3c$var$generate;
$d9c170cb81a09b3c$export$a8ff84c12d48cfa6 = $d9c170cb81a09b3c$var$name;
$d9c170cb81a09b3c$export$98e6a39c04603d36 = $d9c170cb81a09b3c$var$parse;
$d9c170cb81a09b3c$export$46a2a563c28afca0 = $d9c170cb81a09b3c$var$structure;


var $662407265d143d7e$exports = {};
$parcel$export($662407265d143d7e$exports, "generate", () => $662407265d143d7e$export$80d376111cc09ad7, (v) => $662407265d143d7e$export$80d376111cc09ad7 = v);
$parcel$export($662407265d143d7e$exports, "name", () => $662407265d143d7e$export$a8ff84c12d48cfa6, (v) => $662407265d143d7e$export$a8ff84c12d48cfa6 = v);
$parcel$export($662407265d143d7e$exports, "parse", () => $662407265d143d7e$export$98e6a39c04603d36, (v) => $662407265d143d7e$export$98e6a39c04603d36 = v);
$parcel$export($662407265d143d7e$exports, "structure", () => $662407265d143d7e$export$46a2a563c28afca0, (v) => $662407265d143d7e$export$46a2a563c28afca0 = v);
var $662407265d143d7e$export$80d376111cc09ad7;
var $662407265d143d7e$export$a8ff84c12d48cfa6;
var $662407265d143d7e$export$98e6a39c04603d36;
var $662407265d143d7e$export$46a2a563c28afca0;
'use strict';

const $662407265d143d7e$var$name = 'Nth';
const $662407265d143d7e$var$structure = {
    nth: [
        'AnPlusB',
        'Identifier'
    ],
    selector: [
        'SelectorList',
        null
    ]
};
function $662407265d143d7e$var$parse() {
    this.skipSC();
    const start = this.tokenStart;
    let end = start;
    let selector = null;
    let nth;
    if (this.lookupValue(0, 'odd') || this.lookupValue(0, 'even')) nth = this.Identifier();
    else nth = this.AnPlusB();
    end = this.tokenStart;
    this.skipSC();
    if (this.lookupValue(0, 'of')) {
        this.next();
        selector = this.SelectorList();
        end = this.tokenStart;
    }
    return {
        type: 'Nth',
        loc: this.getLocation(start, end),
        nth: nth,
        selector: selector
    };
}
function $662407265d143d7e$var$generate(node) {
    this.node(node.nth);
    if (node.selector !== null) {
        this.token($926ff4544e512db5$export$331e9b6bdecaac5f, 'of');
        this.node(node.selector);
    }
}
$662407265d143d7e$export$80d376111cc09ad7 = $662407265d143d7e$var$generate;
$662407265d143d7e$export$a8ff84c12d48cfa6 = $662407265d143d7e$var$name;
$662407265d143d7e$export$98e6a39c04603d36 = $662407265d143d7e$var$parse;
$662407265d143d7e$export$46a2a563c28afca0 = $662407265d143d7e$var$structure;


var $488e8a5e1132bc56$exports = {};
$parcel$export($488e8a5e1132bc56$exports, "generate", () => $488e8a5e1132bc56$export$80d376111cc09ad7, (v) => $488e8a5e1132bc56$export$80d376111cc09ad7 = v);
$parcel$export($488e8a5e1132bc56$exports, "name", () => $488e8a5e1132bc56$export$a8ff84c12d48cfa6, (v) => $488e8a5e1132bc56$export$a8ff84c12d48cfa6 = v);
$parcel$export($488e8a5e1132bc56$exports, "parse", () => $488e8a5e1132bc56$export$98e6a39c04603d36, (v) => $488e8a5e1132bc56$export$98e6a39c04603d36 = v);
$parcel$export($488e8a5e1132bc56$exports, "structure", () => $488e8a5e1132bc56$export$46a2a563c28afca0, (v) => $488e8a5e1132bc56$export$46a2a563c28afca0 = v);
var $488e8a5e1132bc56$export$80d376111cc09ad7;
var $488e8a5e1132bc56$export$a8ff84c12d48cfa6;
var $488e8a5e1132bc56$export$98e6a39c04603d36;
var $488e8a5e1132bc56$export$46a2a563c28afca0;
'use strict';

const $488e8a5e1132bc56$var$name = 'Number';
const $488e8a5e1132bc56$var$structure = {
    value: String
};
function $488e8a5e1132bc56$var$parse() {
    return {
        type: 'Number',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: this.consume($926ff4544e512db5$export$fffa67e515d04022)
    };
}
function $488e8a5e1132bc56$var$generate(node) {
    this.token($926ff4544e512db5$export$fffa67e515d04022, node.value);
}
$488e8a5e1132bc56$export$80d376111cc09ad7 = $488e8a5e1132bc56$var$generate;
$488e8a5e1132bc56$export$a8ff84c12d48cfa6 = $488e8a5e1132bc56$var$name;
$488e8a5e1132bc56$export$98e6a39c04603d36 = $488e8a5e1132bc56$var$parse;
$488e8a5e1132bc56$export$46a2a563c28afca0 = $488e8a5e1132bc56$var$structure;


var $fc461b869396c1f6$exports = {};
$parcel$export($fc461b869396c1f6$exports, "generate", () => $fc461b869396c1f6$export$80d376111cc09ad7, (v) => $fc461b869396c1f6$export$80d376111cc09ad7 = v);
$parcel$export($fc461b869396c1f6$exports, "name", () => $fc461b869396c1f6$export$a8ff84c12d48cfa6, (v) => $fc461b869396c1f6$export$a8ff84c12d48cfa6 = v);
$parcel$export($fc461b869396c1f6$exports, "parse", () => $fc461b869396c1f6$export$98e6a39c04603d36, (v) => $fc461b869396c1f6$export$98e6a39c04603d36 = v);
$parcel$export($fc461b869396c1f6$exports, "structure", () => $fc461b869396c1f6$export$46a2a563c28afca0, (v) => $fc461b869396c1f6$export$46a2a563c28afca0 = v);
var $fc461b869396c1f6$export$80d376111cc09ad7;
var $fc461b869396c1f6$export$a8ff84c12d48cfa6;
var $fc461b869396c1f6$export$98e6a39c04603d36;
var $fc461b869396c1f6$export$46a2a563c28afca0;
'use strict';
// '/' | '*' | ',' | ':' | '+' | '-'
const $fc461b869396c1f6$var$name = 'Operator';
const $fc461b869396c1f6$var$structure = {
    value: String
};
function $fc461b869396c1f6$var$parse() {
    const start = this.tokenStart;
    this.next();
    return {
        type: 'Operator',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start)
    };
}
function $fc461b869396c1f6$var$generate(node) {
    this.tokenize(node.value);
}
$fc461b869396c1f6$export$80d376111cc09ad7 = $fc461b869396c1f6$var$generate;
$fc461b869396c1f6$export$a8ff84c12d48cfa6 = $fc461b869396c1f6$var$name;
$fc461b869396c1f6$export$98e6a39c04603d36 = $fc461b869396c1f6$var$parse;
$fc461b869396c1f6$export$46a2a563c28afca0 = $fc461b869396c1f6$var$structure;


var $88f18f478c6a60fe$exports = {};
$parcel$export($88f18f478c6a60fe$exports, "generate", () => $88f18f478c6a60fe$export$80d376111cc09ad7, (v) => $88f18f478c6a60fe$export$80d376111cc09ad7 = v);
$parcel$export($88f18f478c6a60fe$exports, "name", () => $88f18f478c6a60fe$export$a8ff84c12d48cfa6, (v) => $88f18f478c6a60fe$export$a8ff84c12d48cfa6 = v);
$parcel$export($88f18f478c6a60fe$exports, "parse", () => $88f18f478c6a60fe$export$98e6a39c04603d36, (v) => $88f18f478c6a60fe$export$98e6a39c04603d36 = v);
$parcel$export($88f18f478c6a60fe$exports, "structure", () => $88f18f478c6a60fe$export$46a2a563c28afca0, (v) => $88f18f478c6a60fe$export$46a2a563c28afca0 = v);
var $88f18f478c6a60fe$export$80d376111cc09ad7;
var $88f18f478c6a60fe$export$a8ff84c12d48cfa6;
var $88f18f478c6a60fe$export$98e6a39c04603d36;
var $88f18f478c6a60fe$export$46a2a563c28afca0;
'use strict';

const $88f18f478c6a60fe$var$name = 'Parentheses';
const $88f18f478c6a60fe$var$structure = {
    children: [
        []
    ]
};
function $88f18f478c6a60fe$var$parse(readSequence, recognizer) {
    const start = this.tokenStart;
    let children = null;
    this.eat($926ff4544e512db5$export$b5a25f132cb53de6);
    children = readSequence.call(this, recognizer);
    if (!this.eof) this.eat($926ff4544e512db5$export$773d33972c6279ed);
    return {
        type: 'Parentheses',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $88f18f478c6a60fe$var$generate(node) {
    this.token($926ff4544e512db5$export$b5a25f132cb53de6, '(');
    this.children(node);
    this.token($926ff4544e512db5$export$773d33972c6279ed, ')');
}
$88f18f478c6a60fe$export$80d376111cc09ad7 = $88f18f478c6a60fe$var$generate;
$88f18f478c6a60fe$export$a8ff84c12d48cfa6 = $88f18f478c6a60fe$var$name;
$88f18f478c6a60fe$export$98e6a39c04603d36 = $88f18f478c6a60fe$var$parse;
$88f18f478c6a60fe$export$46a2a563c28afca0 = $88f18f478c6a60fe$var$structure;


var $3fb545a8ac7e157a$exports = {};
$parcel$export($3fb545a8ac7e157a$exports, "generate", () => $3fb545a8ac7e157a$export$80d376111cc09ad7, (v) => $3fb545a8ac7e157a$export$80d376111cc09ad7 = v);
$parcel$export($3fb545a8ac7e157a$exports, "name", () => $3fb545a8ac7e157a$export$a8ff84c12d48cfa6, (v) => $3fb545a8ac7e157a$export$a8ff84c12d48cfa6 = v);
$parcel$export($3fb545a8ac7e157a$exports, "parse", () => $3fb545a8ac7e157a$export$98e6a39c04603d36, (v) => $3fb545a8ac7e157a$export$98e6a39c04603d36 = v);
$parcel$export($3fb545a8ac7e157a$exports, "structure", () => $3fb545a8ac7e157a$export$46a2a563c28afca0, (v) => $3fb545a8ac7e157a$export$46a2a563c28afca0 = v);
var $3fb545a8ac7e157a$export$80d376111cc09ad7;
var $3fb545a8ac7e157a$export$a8ff84c12d48cfa6;
var $3fb545a8ac7e157a$export$98e6a39c04603d36;
var $3fb545a8ac7e157a$export$46a2a563c28afca0;
'use strict';

const $3fb545a8ac7e157a$var$name = 'Percentage';
const $3fb545a8ac7e157a$var$structure = {
    value: String
};
function $3fb545a8ac7e157a$var$parse() {
    return {
        type: 'Percentage',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: this.consumeNumber($926ff4544e512db5$export$d11913f8a6922aea)
    };
}
function $3fb545a8ac7e157a$var$generate(node) {
    this.token($926ff4544e512db5$export$d11913f8a6922aea, node.value + '%');
}
$3fb545a8ac7e157a$export$80d376111cc09ad7 = $3fb545a8ac7e157a$var$generate;
$3fb545a8ac7e157a$export$a8ff84c12d48cfa6 = $3fb545a8ac7e157a$var$name;
$3fb545a8ac7e157a$export$98e6a39c04603d36 = $3fb545a8ac7e157a$var$parse;
$3fb545a8ac7e157a$export$46a2a563c28afca0 = $3fb545a8ac7e157a$var$structure;


var $6d5501c22d88d5ea$exports = {};
$parcel$export($6d5501c22d88d5ea$exports, "generate", () => $6d5501c22d88d5ea$export$80d376111cc09ad7, (v) => $6d5501c22d88d5ea$export$80d376111cc09ad7 = v);
$parcel$export($6d5501c22d88d5ea$exports, "name", () => $6d5501c22d88d5ea$export$a8ff84c12d48cfa6, (v) => $6d5501c22d88d5ea$export$a8ff84c12d48cfa6 = v);
$parcel$export($6d5501c22d88d5ea$exports, "parse", () => $6d5501c22d88d5ea$export$98e6a39c04603d36, (v) => $6d5501c22d88d5ea$export$98e6a39c04603d36 = v);
$parcel$export($6d5501c22d88d5ea$exports, "structure", () => $6d5501c22d88d5ea$export$46a2a563c28afca0, (v) => $6d5501c22d88d5ea$export$46a2a563c28afca0 = v);
$parcel$export($6d5501c22d88d5ea$exports, "walkContext", () => $6d5501c22d88d5ea$export$f7e0bb689fefb8c2, (v) => $6d5501c22d88d5ea$export$f7e0bb689fefb8c2 = v);
var $6d5501c22d88d5ea$export$80d376111cc09ad7;
var $6d5501c22d88d5ea$export$a8ff84c12d48cfa6;
var $6d5501c22d88d5ea$export$98e6a39c04603d36;
var $6d5501c22d88d5ea$export$46a2a563c28afca0;
var $6d5501c22d88d5ea$export$f7e0bb689fefb8c2;
'use strict';

const $6d5501c22d88d5ea$var$name = 'PseudoClassSelector';
const $6d5501c22d88d5ea$var$walkContext = 'function';
const $6d5501c22d88d5ea$var$structure = {
    name: String,
    children: [
        [
            'Raw'
        ],
        null
    ]
};
// : [ <ident> | <function-token> <any-value>? ) ]
function $6d5501c22d88d5ea$var$parse() {
    const start = this.tokenStart;
    let children = null;
    let name;
    let nameLowerCase;
    this.eat($926ff4544e512db5$export$e20ebb298016f6);
    if (this.tokenType === $926ff4544e512db5$export$f3890eeaf6851387) {
        name = this.consumeFunctionName();
        nameLowerCase = name.toLowerCase();
        if (hasOwnProperty.call(this.pseudo, nameLowerCase)) {
            this.skipSC();
            children = this.pseudo[nameLowerCase].call(this);
            this.skipSC();
        } else {
            children = this.createList();
            children.push(this.Raw(this.tokenIndex, null, false));
        }
        this.eat($926ff4544e512db5$export$773d33972c6279ed);
    } else name = this.consume($926ff4544e512db5$export$331e9b6bdecaac5f);
    return {
        type: 'PseudoClassSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $6d5501c22d88d5ea$var$generate(node) {
    this.token($926ff4544e512db5$export$e20ebb298016f6, ':');
    if (node.children === null) this.token($926ff4544e512db5$export$331e9b6bdecaac5f, node.name);
    else {
        this.token($926ff4544e512db5$export$f3890eeaf6851387, node.name + '(');
        this.children(node);
        this.token($926ff4544e512db5$export$773d33972c6279ed, ')');
    }
}
$6d5501c22d88d5ea$export$80d376111cc09ad7 = $6d5501c22d88d5ea$var$generate;
$6d5501c22d88d5ea$export$a8ff84c12d48cfa6 = $6d5501c22d88d5ea$var$name;
$6d5501c22d88d5ea$export$98e6a39c04603d36 = $6d5501c22d88d5ea$var$parse;
$6d5501c22d88d5ea$export$46a2a563c28afca0 = $6d5501c22d88d5ea$var$structure;
$6d5501c22d88d5ea$export$f7e0bb689fefb8c2 = $6d5501c22d88d5ea$var$walkContext;


var $b8dc75efd0b10b81$exports = {};
$parcel$export($b8dc75efd0b10b81$exports, "generate", () => $b8dc75efd0b10b81$export$80d376111cc09ad7, (v) => $b8dc75efd0b10b81$export$80d376111cc09ad7 = v);
$parcel$export($b8dc75efd0b10b81$exports, "name", () => $b8dc75efd0b10b81$export$a8ff84c12d48cfa6, (v) => $b8dc75efd0b10b81$export$a8ff84c12d48cfa6 = v);
$parcel$export($b8dc75efd0b10b81$exports, "parse", () => $b8dc75efd0b10b81$export$98e6a39c04603d36, (v) => $b8dc75efd0b10b81$export$98e6a39c04603d36 = v);
$parcel$export($b8dc75efd0b10b81$exports, "structure", () => $b8dc75efd0b10b81$export$46a2a563c28afca0, (v) => $b8dc75efd0b10b81$export$46a2a563c28afca0 = v);
$parcel$export($b8dc75efd0b10b81$exports, "walkContext", () => $b8dc75efd0b10b81$export$f7e0bb689fefb8c2, (v) => $b8dc75efd0b10b81$export$f7e0bb689fefb8c2 = v);
var $b8dc75efd0b10b81$export$80d376111cc09ad7;
var $b8dc75efd0b10b81$export$a8ff84c12d48cfa6;
var $b8dc75efd0b10b81$export$98e6a39c04603d36;
var $b8dc75efd0b10b81$export$46a2a563c28afca0;
var $b8dc75efd0b10b81$export$f7e0bb689fefb8c2;
'use strict';

const $b8dc75efd0b10b81$var$name = 'PseudoElementSelector';
const $b8dc75efd0b10b81$var$walkContext = 'function';
const $b8dc75efd0b10b81$var$structure = {
    name: String,
    children: [
        [
            'Raw'
        ],
        null
    ]
};
// :: [ <ident> | <function-token> <any-value>? ) ]
function $b8dc75efd0b10b81$var$parse() {
    const start = this.tokenStart;
    let children = null;
    let name;
    let nameLowerCase;
    this.eat($926ff4544e512db5$export$e20ebb298016f6);
    this.eat($926ff4544e512db5$export$e20ebb298016f6);
    if (this.tokenType === $926ff4544e512db5$export$f3890eeaf6851387) {
        name = this.consumeFunctionName();
        nameLowerCase = name.toLowerCase();
        if (hasOwnProperty.call(this.pseudo, nameLowerCase)) {
            this.skipSC();
            children = this.pseudo[nameLowerCase].call(this);
            this.skipSC();
        } else {
            children = this.createList();
            children.push(this.Raw(this.tokenIndex, null, false));
        }
        this.eat($926ff4544e512db5$export$773d33972c6279ed);
    } else name = this.consume($926ff4544e512db5$export$331e9b6bdecaac5f);
    return {
        type: 'PseudoElementSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: name,
        children: children
    };
}
function $b8dc75efd0b10b81$var$generate(node) {
    this.token($926ff4544e512db5$export$e20ebb298016f6, ':');
    this.token($926ff4544e512db5$export$e20ebb298016f6, ':');
    if (node.children === null) this.token($926ff4544e512db5$export$331e9b6bdecaac5f, node.name);
    else {
        this.token($926ff4544e512db5$export$f3890eeaf6851387, node.name + '(');
        this.children(node);
        this.token($926ff4544e512db5$export$773d33972c6279ed, ')');
    }
}
$b8dc75efd0b10b81$export$80d376111cc09ad7 = $b8dc75efd0b10b81$var$generate;
$b8dc75efd0b10b81$export$a8ff84c12d48cfa6 = $b8dc75efd0b10b81$var$name;
$b8dc75efd0b10b81$export$98e6a39c04603d36 = $b8dc75efd0b10b81$var$parse;
$b8dc75efd0b10b81$export$46a2a563c28afca0 = $b8dc75efd0b10b81$var$structure;
$b8dc75efd0b10b81$export$f7e0bb689fefb8c2 = $b8dc75efd0b10b81$var$walkContext;


var $8970060801e336e8$exports = {};
$parcel$export($8970060801e336e8$exports, "generate", () => $8970060801e336e8$export$80d376111cc09ad7, (v) => $8970060801e336e8$export$80d376111cc09ad7 = v);
$parcel$export($8970060801e336e8$exports, "name", () => $8970060801e336e8$export$a8ff84c12d48cfa6, (v) => $8970060801e336e8$export$a8ff84c12d48cfa6 = v);
$parcel$export($8970060801e336e8$exports, "parse", () => $8970060801e336e8$export$98e6a39c04603d36, (v) => $8970060801e336e8$export$98e6a39c04603d36 = v);
$parcel$export($8970060801e336e8$exports, "structure", () => $8970060801e336e8$export$46a2a563c28afca0, (v) => $8970060801e336e8$export$46a2a563c28afca0 = v);
var $8970060801e336e8$export$80d376111cc09ad7;
var $8970060801e336e8$export$a8ff84c12d48cfa6;
var $8970060801e336e8$export$98e6a39c04603d36;
var $8970060801e336e8$export$46a2a563c28afca0;
'use strict';


const $8970060801e336e8$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $8970060801e336e8$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
// Terms of <ratio> should be a positive numbers (not zero or negative)
// (see https://drafts.csswg.org/mediaqueries-3/#values)
// However, -o-min-device-pixel-ratio takes fractional values as a ratio's term
// and this is using by various sites. Therefore we relax checking on parse
// to test a term is unsigned number without an exponent part.
// Additional checking may be applied on lexer validation.
function $8970060801e336e8$var$consumeNumber() {
    this.skipSC();
    const value = this.consume($926ff4544e512db5$export$fffa67e515d04022);
    for(let i = 0; i < value.length; i++){
        const code = value.charCodeAt(i);
        if (!$401d24d35b6b69df$export$727d9dbc4fbb948f(code) && code !== $8970060801e336e8$var$FULLSTOP) this.error('Unsigned number is expected', this.tokenStart - value.length + i);
    }
    if (Number(value) === 0) this.error('Zero number is not allowed', this.tokenStart - value.length);
    return value;
}
const $8970060801e336e8$var$name = 'Ratio';
const $8970060801e336e8$var$structure = {
    left: String,
    right: String
};
// <positive-integer> S* '/' S* <positive-integer>
function $8970060801e336e8$var$parse() {
    const start = this.tokenStart;
    const left = $8970060801e336e8$var$consumeNumber.call(this);
    let right;
    this.skipSC();
    this.eatDelim($8970060801e336e8$var$SOLIDUS);
    right = $8970060801e336e8$var$consumeNumber.call(this);
    return {
        type: 'Ratio',
        loc: this.getLocation(start, this.tokenStart),
        left: left,
        right: right
    };
}
function $8970060801e336e8$var$generate(node) {
    this.token($926ff4544e512db5$export$fffa67e515d04022, node.left);
    this.token($926ff4544e512db5$export$a918ca49ff4337a3, '/');
    this.token($926ff4544e512db5$export$fffa67e515d04022, node.right);
}
$8970060801e336e8$export$80d376111cc09ad7 = $8970060801e336e8$var$generate;
$8970060801e336e8$export$a8ff84c12d48cfa6 = $8970060801e336e8$var$name;
$8970060801e336e8$export$98e6a39c04603d36 = $8970060801e336e8$var$parse;
$8970060801e336e8$export$46a2a563c28afca0 = $8970060801e336e8$var$structure;


var $588b9c88485e2c7b$exports = {};
$parcel$export($588b9c88485e2c7b$exports, "generate", () => $588b9c88485e2c7b$export$80d376111cc09ad7, (v) => $588b9c88485e2c7b$export$80d376111cc09ad7 = v);
$parcel$export($588b9c88485e2c7b$exports, "name", () => $588b9c88485e2c7b$export$a8ff84c12d48cfa6, (v) => $588b9c88485e2c7b$export$a8ff84c12d48cfa6 = v);
$parcel$export($588b9c88485e2c7b$exports, "parse", () => $588b9c88485e2c7b$export$98e6a39c04603d36, (v) => $588b9c88485e2c7b$export$98e6a39c04603d36 = v);
$parcel$export($588b9c88485e2c7b$exports, "structure", () => $588b9c88485e2c7b$export$46a2a563c28afca0, (v) => $588b9c88485e2c7b$export$46a2a563c28afca0 = v);
var $588b9c88485e2c7b$export$80d376111cc09ad7;
var $588b9c88485e2c7b$export$a8ff84c12d48cfa6;
var $588b9c88485e2c7b$export$98e6a39c04603d36;
var $588b9c88485e2c7b$export$46a2a563c28afca0;
'use strict';

function $588b9c88485e2c7b$var$getOffsetExcludeWS() {
    if (this.tokenIndex > 0) {
        if (this.lookupType(-1) === $926ff4544e512db5$export$fb98946286ab4c97) return this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset;
    }
    return this.tokenStart;
}
const $588b9c88485e2c7b$var$name = 'Raw';
const $588b9c88485e2c7b$var$structure = {
    value: String
};
function $588b9c88485e2c7b$var$parse(startToken, consumeUntil, excludeWhiteSpace) {
    const startOffset = this.getTokenStart(startToken);
    let endOffset;
    this.skipUntilBalanced(startToken, consumeUntil || this.consumeUntilBalanceEnd);
    if (excludeWhiteSpace && this.tokenStart > startOffset) endOffset = $588b9c88485e2c7b$var$getOffsetExcludeWS.call(this);
    else endOffset = this.tokenStart;
    return {
        type: 'Raw',
        loc: this.getLocation(startOffset, endOffset),
        value: this.substring(startOffset, endOffset)
    };
}
function $588b9c88485e2c7b$var$generate(node) {
    this.tokenize(node.value);
}
$588b9c88485e2c7b$export$80d376111cc09ad7 = $588b9c88485e2c7b$var$generate;
$588b9c88485e2c7b$export$a8ff84c12d48cfa6 = $588b9c88485e2c7b$var$name;
$588b9c88485e2c7b$export$98e6a39c04603d36 = $588b9c88485e2c7b$var$parse;
$588b9c88485e2c7b$export$46a2a563c28afca0 = $588b9c88485e2c7b$var$structure;


var $22bc3627751e8d49$exports = {};
$parcel$export($22bc3627751e8d49$exports, "generate", () => $22bc3627751e8d49$export$80d376111cc09ad7, (v) => $22bc3627751e8d49$export$80d376111cc09ad7 = v);
$parcel$export($22bc3627751e8d49$exports, "name", () => $22bc3627751e8d49$export$a8ff84c12d48cfa6, (v) => $22bc3627751e8d49$export$a8ff84c12d48cfa6 = v);
$parcel$export($22bc3627751e8d49$exports, "parse", () => $22bc3627751e8d49$export$98e6a39c04603d36, (v) => $22bc3627751e8d49$export$98e6a39c04603d36 = v);
$parcel$export($22bc3627751e8d49$exports, "structure", () => $22bc3627751e8d49$export$46a2a563c28afca0, (v) => $22bc3627751e8d49$export$46a2a563c28afca0 = v);
$parcel$export($22bc3627751e8d49$exports, "walkContext", () => $22bc3627751e8d49$export$f7e0bb689fefb8c2, (v) => $22bc3627751e8d49$export$f7e0bb689fefb8c2 = v);
var $22bc3627751e8d49$export$80d376111cc09ad7;
var $22bc3627751e8d49$export$a8ff84c12d48cfa6;
var $22bc3627751e8d49$export$98e6a39c04603d36;
var $22bc3627751e8d49$export$46a2a563c28afca0;
var $22bc3627751e8d49$export$f7e0bb689fefb8c2;
'use strict';

function $22bc3627751e8d49$var$consumeRaw(startToken) {
    return this.Raw(startToken, this.consumeUntilLeftCurlyBracket, true);
}
function $22bc3627751e8d49$var$consumePrelude() {
    const prelude = this.SelectorList();
    if (prelude.type !== 'Raw' && this.eof === false && this.tokenType !== $926ff4544e512db5$export$ccdce7304ac66390) this.error();
    return prelude;
}
const $22bc3627751e8d49$var$name = 'Rule';
const $22bc3627751e8d49$var$walkContext = 'rule';
const $22bc3627751e8d49$var$structure = {
    prelude: [
        'SelectorList',
        'Raw'
    ],
    block: [
        'Block'
    ]
};
function $22bc3627751e8d49$var$parse() {
    const startToken = this.tokenIndex;
    const startOffset = this.tokenStart;
    let prelude;
    let block;
    if (this.parseRulePrelude) prelude = this.parseWithFallback($22bc3627751e8d49$var$consumePrelude, $22bc3627751e8d49$var$consumeRaw);
    else prelude = $22bc3627751e8d49$var$consumeRaw.call(this, startToken);
    block = this.Block(true);
    return {
        type: 'Rule',
        loc: this.getLocation(startOffset, this.tokenStart),
        prelude: prelude,
        block: block
    };
}
function $22bc3627751e8d49$var$generate(node) {
    this.node(node.prelude);
    this.node(node.block);
}
$22bc3627751e8d49$export$80d376111cc09ad7 = $22bc3627751e8d49$var$generate;
$22bc3627751e8d49$export$a8ff84c12d48cfa6 = $22bc3627751e8d49$var$name;
$22bc3627751e8d49$export$98e6a39c04603d36 = $22bc3627751e8d49$var$parse;
$22bc3627751e8d49$export$46a2a563c28afca0 = $22bc3627751e8d49$var$structure;
$22bc3627751e8d49$export$f7e0bb689fefb8c2 = $22bc3627751e8d49$var$walkContext;


var $fcbbce62876d9ee8$exports = {};
$parcel$export($fcbbce62876d9ee8$exports, "generate", () => $fcbbce62876d9ee8$export$80d376111cc09ad7, (v) => $fcbbce62876d9ee8$export$80d376111cc09ad7 = v);
$parcel$export($fcbbce62876d9ee8$exports, "name", () => $fcbbce62876d9ee8$export$a8ff84c12d48cfa6, (v) => $fcbbce62876d9ee8$export$a8ff84c12d48cfa6 = v);
$parcel$export($fcbbce62876d9ee8$exports, "parse", () => $fcbbce62876d9ee8$export$98e6a39c04603d36, (v) => $fcbbce62876d9ee8$export$98e6a39c04603d36 = v);
$parcel$export($fcbbce62876d9ee8$exports, "structure", () => $fcbbce62876d9ee8$export$46a2a563c28afca0, (v) => $fcbbce62876d9ee8$export$46a2a563c28afca0 = v);
var $fcbbce62876d9ee8$export$80d376111cc09ad7;
var $fcbbce62876d9ee8$export$a8ff84c12d48cfa6;
var $fcbbce62876d9ee8$export$98e6a39c04603d36;
var $fcbbce62876d9ee8$export$46a2a563c28afca0;
'use strict';
const $fcbbce62876d9ee8$var$name = 'Selector';
const $fcbbce62876d9ee8$var$structure = {
    children: [
        [
            'TypeSelector',
            'IdSelector',
            'ClassSelector',
            'AttributeSelector',
            'PseudoClassSelector',
            'PseudoElementSelector',
            'Combinator',
            'WhiteSpace'
        ]
    ]
};
function $fcbbce62876d9ee8$var$parse() {
    const children = this.readSequence(this.scope.Selector);
    // nothing were consumed
    if (this.getFirstListNode(children) === null) this.error('Selector is expected');
    return {
        type: 'Selector',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $fcbbce62876d9ee8$var$generate(node) {
    this.children(node);
}
$fcbbce62876d9ee8$export$80d376111cc09ad7 = $fcbbce62876d9ee8$var$generate;
$fcbbce62876d9ee8$export$a8ff84c12d48cfa6 = $fcbbce62876d9ee8$var$name;
$fcbbce62876d9ee8$export$98e6a39c04603d36 = $fcbbce62876d9ee8$var$parse;
$fcbbce62876d9ee8$export$46a2a563c28afca0 = $fcbbce62876d9ee8$var$structure;


var $a19998960a858969$exports = {};
$parcel$export($a19998960a858969$exports, "generate", () => $a19998960a858969$export$80d376111cc09ad7, (v) => $a19998960a858969$export$80d376111cc09ad7 = v);
$parcel$export($a19998960a858969$exports, "name", () => $a19998960a858969$export$a8ff84c12d48cfa6, (v) => $a19998960a858969$export$a8ff84c12d48cfa6 = v);
$parcel$export($a19998960a858969$exports, "parse", () => $a19998960a858969$export$98e6a39c04603d36, (v) => $a19998960a858969$export$98e6a39c04603d36 = v);
$parcel$export($a19998960a858969$exports, "structure", () => $a19998960a858969$export$46a2a563c28afca0, (v) => $a19998960a858969$export$46a2a563c28afca0 = v);
$parcel$export($a19998960a858969$exports, "walkContext", () => $a19998960a858969$export$f7e0bb689fefb8c2, (v) => $a19998960a858969$export$f7e0bb689fefb8c2 = v);
var $a19998960a858969$export$80d376111cc09ad7;
var $a19998960a858969$export$a8ff84c12d48cfa6;
var $a19998960a858969$export$98e6a39c04603d36;
var $a19998960a858969$export$46a2a563c28afca0;
var $a19998960a858969$export$f7e0bb689fefb8c2;
'use strict';

const $a19998960a858969$var$name = 'SelectorList';
const $a19998960a858969$var$walkContext = 'selector';
const $a19998960a858969$var$structure = {
    children: [
        [
            'Selector',
            'Raw'
        ]
    ]
};
function $a19998960a858969$var$parse() {
    const children = this.createList();
    while(!this.eof){
        children.push(this.Selector());
        if (this.tokenType === $926ff4544e512db5$export$c06e3ee3b4d233fa) {
            this.next();
            continue;
        }
        break;
    }
    return {
        type: 'SelectorList',
        loc: this.getLocationFromList(children),
        children: children
    };
}
function $a19998960a858969$var$generate(node) {
    this.children(node, ()=>this.token($926ff4544e512db5$export$c06e3ee3b4d233fa, ','));
}
$a19998960a858969$export$80d376111cc09ad7 = $a19998960a858969$var$generate;
$a19998960a858969$export$a8ff84c12d48cfa6 = $a19998960a858969$var$name;
$a19998960a858969$export$98e6a39c04603d36 = $a19998960a858969$var$parse;
$a19998960a858969$export$46a2a563c28afca0 = $a19998960a858969$var$structure;
$a19998960a858969$export$f7e0bb689fefb8c2 = $a19998960a858969$var$walkContext;


var $db24483ec655fb74$exports = {};
$parcel$export($db24483ec655fb74$exports, "generate", () => $db24483ec655fb74$export$80d376111cc09ad7, (v) => $db24483ec655fb74$export$80d376111cc09ad7 = v);
$parcel$export($db24483ec655fb74$exports, "name", () => $db24483ec655fb74$export$a8ff84c12d48cfa6, (v) => $db24483ec655fb74$export$a8ff84c12d48cfa6 = v);
$parcel$export($db24483ec655fb74$exports, "parse", () => $db24483ec655fb74$export$98e6a39c04603d36, (v) => $db24483ec655fb74$export$98e6a39c04603d36 = v);
$parcel$export($db24483ec655fb74$exports, "structure", () => $db24483ec655fb74$export$46a2a563c28afca0, (v) => $db24483ec655fb74$export$46a2a563c28afca0 = v);
var $db24483ec655fb74$export$80d376111cc09ad7;
var $db24483ec655fb74$export$a8ff84c12d48cfa6;
var $db24483ec655fb74$export$98e6a39c04603d36;
var $db24483ec655fb74$export$46a2a563c28afca0;
'use strict';
var $04140284bd5c6270$exports = {};
$parcel$export($04140284bd5c6270$exports, "decode", () => $04140284bd5c6270$export$2f872c0f2117be69, (v) => $04140284bd5c6270$export$2f872c0f2117be69 = v);
$parcel$export($04140284bd5c6270$exports, "encode", () => $04140284bd5c6270$export$c564cdbbe6da493, (v) => $04140284bd5c6270$export$c564cdbbe6da493 = v);
var $04140284bd5c6270$export$2f872c0f2117be69;
var $04140284bd5c6270$export$c564cdbbe6da493;
'use strict';


const $04140284bd5c6270$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
const $04140284bd5c6270$var$QUOTATION_MARK = 0x0022; // "
const $04140284bd5c6270$var$APOSTROPHE = 0x0027; // '
function $04140284bd5c6270$var$decode(str) {
    const len = str.length;
    const firstChar = str.charCodeAt(0);
    const start = firstChar === $04140284bd5c6270$var$QUOTATION_MARK || firstChar === $04140284bd5c6270$var$APOSTROPHE ? 1 : 0;
    const end = start === 1 && len > 1 && str.charCodeAt(len - 1) === firstChar ? len - 2 : len - 1;
    let decoded = '';
    for(let i = start; i <= end; i++){
        let code = str.charCodeAt(i);
        if (code === $04140284bd5c6270$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) {
                // if the next input code point is EOF, do nothing
                // otherwise include last quote as escaped
                if (i !== len - 1) decoded = str.substr(i + 1);
                break;
            }
            code = str.charCodeAt(++i);
            // consume escaped
            if ($401d24d35b6b69df$export$352e2c1d24776bfb($04140284bd5c6270$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = $96eb8038f2b3ef39$export$1cf8ac3f090cf48a(str, escapeStart);
                i = escapeEnd - 1;
                decoded += $96eb8038f2b3ef39$export$5ed93187f4ce070a(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
// https://drafts.csswg.org/cssom/#serialize-a-string
// § 2.1. Common Serializing Idioms
function $04140284bd5c6270$var$encode(str, apostrophe) {
    const quote = apostrophe ? '\'' : '"';
    const quoteCode = apostrophe ? $04140284bd5c6270$var$APOSTROPHE : $04140284bd5c6270$var$QUOTATION_MARK;
    let encoded = '';
    let wsBeforeHexIsNeeded = false;
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        // If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F,
        // the character escaped as code point.
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        if (code <= 0x001f || code === 0x007F) {
            encoded += '\\' + code.toString(16);
            wsBeforeHexIsNeeded = true;
            continue;
        }
        // If the character is '"' (U+0022) or "\" (U+005C), the escaped character.
        if (code === quoteCode || code === $04140284bd5c6270$var$REVERSE_SOLIDUS) {
            encoded += '\\' + str.charAt(i);
            wsBeforeHexIsNeeded = false;
        } else {
            if (wsBeforeHexIsNeeded && ($401d24d35b6b69df$export$2a81dc4d1a2f9334(code) || $401d24d35b6b69df$export$3c52dd84024ae72c(code))) encoded += ' ';
            // Otherwise, the character itself.
            encoded += str.charAt(i);
            wsBeforeHexIsNeeded = false;
        }
    }
    return quote + encoded + quote;
}
$04140284bd5c6270$export$2f872c0f2117be69 = $04140284bd5c6270$var$decode;
$04140284bd5c6270$export$c564cdbbe6da493 = $04140284bd5c6270$var$encode;



const $db24483ec655fb74$var$name = 'String';
const $db24483ec655fb74$var$structure = {
    value: String
};
function $db24483ec655fb74$var$parse() {
    return {
        type: 'String',
        loc: this.getLocation(this.tokenStart, this.tokenEnd),
        value: $04140284bd5c6270$export$2f872c0f2117be69(this.consume($926ff4544e512db5$export$89b8e0fa65f6a914))
    };
}
function $db24483ec655fb74$var$generate(node) {
    this.token($926ff4544e512db5$export$89b8e0fa65f6a914, $04140284bd5c6270$export$c564cdbbe6da493(node.value));
}
$db24483ec655fb74$export$80d376111cc09ad7 = $db24483ec655fb74$var$generate;
$db24483ec655fb74$export$a8ff84c12d48cfa6 = $db24483ec655fb74$var$name;
$db24483ec655fb74$export$98e6a39c04603d36 = $db24483ec655fb74$var$parse;
$db24483ec655fb74$export$46a2a563c28afca0 = $db24483ec655fb74$var$structure;


var $3602872a2c18d9d5$exports = {};
$parcel$export($3602872a2c18d9d5$exports, "generate", () => $3602872a2c18d9d5$export$80d376111cc09ad7, (v) => $3602872a2c18d9d5$export$80d376111cc09ad7 = v);
$parcel$export($3602872a2c18d9d5$exports, "name", () => $3602872a2c18d9d5$export$a8ff84c12d48cfa6, (v) => $3602872a2c18d9d5$export$a8ff84c12d48cfa6 = v);
$parcel$export($3602872a2c18d9d5$exports, "parse", () => $3602872a2c18d9d5$export$98e6a39c04603d36, (v) => $3602872a2c18d9d5$export$98e6a39c04603d36 = v);
$parcel$export($3602872a2c18d9d5$exports, "structure", () => $3602872a2c18d9d5$export$46a2a563c28afca0, (v) => $3602872a2c18d9d5$export$46a2a563c28afca0 = v);
$parcel$export($3602872a2c18d9d5$exports, "walkContext", () => $3602872a2c18d9d5$export$f7e0bb689fefb8c2, (v) => $3602872a2c18d9d5$export$f7e0bb689fefb8c2 = v);
var $3602872a2c18d9d5$export$80d376111cc09ad7;
var $3602872a2c18d9d5$export$a8ff84c12d48cfa6;
var $3602872a2c18d9d5$export$98e6a39c04603d36;
var $3602872a2c18d9d5$export$46a2a563c28afca0;
var $3602872a2c18d9d5$export$f7e0bb689fefb8c2;
'use strict';

const $3602872a2c18d9d5$var$EXCLAMATIONMARK = 0x0021; // U+0021 EXCLAMATION MARK (!)
function $3602872a2c18d9d5$var$consumeRaw(startToken) {
    return this.Raw(startToken, null, false);
}
const $3602872a2c18d9d5$var$name = 'StyleSheet';
const $3602872a2c18d9d5$var$walkContext = 'stylesheet';
const $3602872a2c18d9d5$var$structure = {
    children: [
        [
            'Comment',
            'CDO',
            'CDC',
            'Atrule',
            'Rule',
            'Raw'
        ]
    ]
};
function $3602872a2c18d9d5$var$parse() {
    const start = this.tokenStart;
    const children = this.createList();
    let child;
    while(!this.eof){
        switch(this.tokenType){
            case $926ff4544e512db5$export$fb98946286ab4c97:
                this.next();
                continue;
            case $926ff4544e512db5$export$4d299b491347818a:
                // ignore comments except exclamation comments (i.e. /*! .. */) on top level
                if (this.charCodeAt(this.tokenStart + 2) !== $3602872a2c18d9d5$var$EXCLAMATIONMARK) {
                    this.next();
                    continue;
                }
                child = this.Comment();
                break;
            case $926ff4544e512db5$export$521ef26a3002003b:
                child = this.CDO();
                break;
            case $926ff4544e512db5$export$b0b2bd2d1777c179:
                child = this.CDC();
                break;
            // CSS Syntax Module Level 3
            // §2.2 Error handling
            // At the "top level" of a stylesheet, an <at-keyword-token> starts an at-rule.
            case $926ff4544e512db5$export$21bfcb60d1b5ccac:
                child = this.parseWithFallback(this.Atrule, $3602872a2c18d9d5$var$consumeRaw);
                break;
            // Anything else starts a qualified rule ...
            default:
                child = this.parseWithFallback(this.Rule, $3602872a2c18d9d5$var$consumeRaw);
        }
        children.push(child);
    }
    return {
        type: 'StyleSheet',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $3602872a2c18d9d5$var$generate(node) {
    this.children(node);
}
$3602872a2c18d9d5$export$80d376111cc09ad7 = $3602872a2c18d9d5$var$generate;
$3602872a2c18d9d5$export$a8ff84c12d48cfa6 = $3602872a2c18d9d5$var$name;
$3602872a2c18d9d5$export$98e6a39c04603d36 = $3602872a2c18d9d5$var$parse;
$3602872a2c18d9d5$export$46a2a563c28afca0 = $3602872a2c18d9d5$var$structure;
$3602872a2c18d9d5$export$f7e0bb689fefb8c2 = $3602872a2c18d9d5$var$walkContext;


var $d2f05fef0aedabf1$exports = {};
$parcel$export($d2f05fef0aedabf1$exports, "generate", () => $d2f05fef0aedabf1$export$80d376111cc09ad7, (v) => $d2f05fef0aedabf1$export$80d376111cc09ad7 = v);
$parcel$export($d2f05fef0aedabf1$exports, "name", () => $d2f05fef0aedabf1$export$a8ff84c12d48cfa6, (v) => $d2f05fef0aedabf1$export$a8ff84c12d48cfa6 = v);
$parcel$export($d2f05fef0aedabf1$exports, "parse", () => $d2f05fef0aedabf1$export$98e6a39c04603d36, (v) => $d2f05fef0aedabf1$export$98e6a39c04603d36 = v);
$parcel$export($d2f05fef0aedabf1$exports, "structure", () => $d2f05fef0aedabf1$export$46a2a563c28afca0, (v) => $d2f05fef0aedabf1$export$46a2a563c28afca0 = v);
var $d2f05fef0aedabf1$export$80d376111cc09ad7;
var $d2f05fef0aedabf1$export$a8ff84c12d48cfa6;
var $d2f05fef0aedabf1$export$98e6a39c04603d36;
var $d2f05fef0aedabf1$export$46a2a563c28afca0;
'use strict';

const $d2f05fef0aedabf1$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $d2f05fef0aedabf1$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
function $d2f05fef0aedabf1$var$eatIdentifierOrAsterisk() {
    if (this.tokenType !== $926ff4544e512db5$export$331e9b6bdecaac5f && this.isDelim($d2f05fef0aedabf1$var$ASTERISK) === false) this.error('Identifier or asterisk is expected');
    this.next();
}
const $d2f05fef0aedabf1$var$name = 'TypeSelector';
const $d2f05fef0aedabf1$var$structure = {
    name: String
};
// ident
// ident|ident
// ident|*
// *
// *|ident
// *|*
// |ident
// |*
function $d2f05fef0aedabf1$var$parse() {
    const start = this.tokenStart;
    if (this.isDelim($d2f05fef0aedabf1$var$VERTICALLINE)) {
        this.next();
        $d2f05fef0aedabf1$var$eatIdentifierOrAsterisk.call(this);
    } else {
        $d2f05fef0aedabf1$var$eatIdentifierOrAsterisk.call(this);
        if (this.isDelim($d2f05fef0aedabf1$var$VERTICALLINE)) {
            this.next();
            $d2f05fef0aedabf1$var$eatIdentifierOrAsterisk.call(this);
        }
    }
    return {
        type: 'TypeSelector',
        loc: this.getLocation(start, this.tokenStart),
        name: this.substrToCursor(start)
    };
}
function $d2f05fef0aedabf1$var$generate(node) {
    this.tokenize(node.name);
}
$d2f05fef0aedabf1$export$80d376111cc09ad7 = $d2f05fef0aedabf1$var$generate;
$d2f05fef0aedabf1$export$a8ff84c12d48cfa6 = $d2f05fef0aedabf1$var$name;
$d2f05fef0aedabf1$export$98e6a39c04603d36 = $d2f05fef0aedabf1$var$parse;
$d2f05fef0aedabf1$export$46a2a563c28afca0 = $d2f05fef0aedabf1$var$structure;


var $077cf9138d35de73$exports = {};
$parcel$export($077cf9138d35de73$exports, "generate", () => $077cf9138d35de73$export$80d376111cc09ad7, (v) => $077cf9138d35de73$export$80d376111cc09ad7 = v);
$parcel$export($077cf9138d35de73$exports, "name", () => $077cf9138d35de73$export$a8ff84c12d48cfa6, (v) => $077cf9138d35de73$export$a8ff84c12d48cfa6 = v);
$parcel$export($077cf9138d35de73$exports, "parse", () => $077cf9138d35de73$export$98e6a39c04603d36, (v) => $077cf9138d35de73$export$98e6a39c04603d36 = v);
$parcel$export($077cf9138d35de73$exports, "structure", () => $077cf9138d35de73$export$46a2a563c28afca0, (v) => $077cf9138d35de73$export$46a2a563c28afca0 = v);
var $077cf9138d35de73$export$80d376111cc09ad7;
var $077cf9138d35de73$export$a8ff84c12d48cfa6;
var $077cf9138d35de73$export$98e6a39c04603d36;
var $077cf9138d35de73$export$46a2a563c28afca0;
'use strict';


const $077cf9138d35de73$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $077cf9138d35de73$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $077cf9138d35de73$var$QUESTIONMARK = 0x003F; // U+003F QUESTION MARK (?)
function $077cf9138d35de73$var$eatHexSequence(offset, allowDash) {
    let len = 0;
    for(let pos = this.tokenStart + offset; pos < this.tokenEnd; pos++){
        const code = this.charCodeAt(pos);
        if (code === $077cf9138d35de73$var$HYPHENMINUS && allowDash && len !== 0) {
            $077cf9138d35de73$var$eatHexSequence.call(this, offset + len + 1, false);
            return -1;
        }
        if (!$401d24d35b6b69df$export$2a81dc4d1a2f9334(code)) this.error(allowDash && len !== 0 ? 'Hyphen minus' + (len < 6 ? ' or hex digit' : '') + ' is expected' : len < 6 ? 'Hex digit is expected' : 'Unexpected input', pos);
        if (++len > 6) this.error('Too many hex digits', pos);
    }
    this.next();
    return len;
}
function $077cf9138d35de73$var$eatQuestionMarkSequence(max) {
    let count = 0;
    while(this.isDelim($077cf9138d35de73$var$QUESTIONMARK)){
        if (++count > max) this.error('Too many question marks');
        this.next();
    }
}
function $077cf9138d35de73$var$startsWith(code) {
    if (this.charCodeAt(this.tokenStart) !== code) this.error((code === $077cf9138d35de73$var$PLUSSIGN ? 'Plus sign' : 'Hyphen minus') + ' is expected');
}
// https://drafts.csswg.org/css-syntax/#urange
// Informally, the <urange> production has three forms:
// U+0001
//      Defines a range consisting of a single code point, in this case the code point "1".
// U+0001-00ff
//      Defines a range of codepoints between the first and the second value, in this case
//      the range between "1" and "ff" (255 in decimal) inclusive.
// U+00??
//      Defines a range of codepoints where the "?" characters range over all hex digits,
//      in this case defining the same as the value U+0000-00ff.
// In each form, a maximum of 6 digits is allowed for each hexadecimal number (if you treat "?" as a hexadecimal digit).
//
// <urange> =
//   u '+' <ident-token> '?'* |
//   u <dimension-token> '?'* |
//   u <number-token> '?'* |
//   u <number-token> <dimension-token> |
//   u <number-token> <number-token> |
//   u '+' '?'+
function $077cf9138d35de73$var$scanUnicodeRange() {
    let hexLength = 0;
    switch(this.tokenType){
        case $926ff4544e512db5$export$fffa67e515d04022:
            // u <number-token> '?'*
            // u <number-token> <dimension-token>
            // u <number-token> <number-token>
            hexLength = $077cf9138d35de73$var$eatHexSequence.call(this, 1, true);
            if (this.isDelim($077cf9138d35de73$var$QUESTIONMARK)) {
                $077cf9138d35de73$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
                break;
            }
            if (this.tokenType === $926ff4544e512db5$export$c940ece961bc43c6 || this.tokenType === $926ff4544e512db5$export$fffa67e515d04022) {
                $077cf9138d35de73$var$startsWith.call(this, $077cf9138d35de73$var$HYPHENMINUS);
                $077cf9138d35de73$var$eatHexSequence.call(this, 1, false);
                break;
            }
            break;
        case $926ff4544e512db5$export$c940ece961bc43c6:
            // u <dimension-token> '?'*
            hexLength = $077cf9138d35de73$var$eatHexSequence.call(this, 1, true);
            if (hexLength > 0) $077cf9138d35de73$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
            break;
        default:
            // u '+' <ident-token> '?'*
            // u '+' '?'+
            this.eatDelim($077cf9138d35de73$var$PLUSSIGN);
            if (this.tokenType === $926ff4544e512db5$export$331e9b6bdecaac5f) {
                hexLength = $077cf9138d35de73$var$eatHexSequence.call(this, 0, true);
                if (hexLength > 0) $077cf9138d35de73$var$eatQuestionMarkSequence.call(this, 6 - hexLength);
                break;
            }
            if (this.isDelim($077cf9138d35de73$var$QUESTIONMARK)) {
                this.next();
                $077cf9138d35de73$var$eatQuestionMarkSequence.call(this, 5);
                break;
            }
            this.error('Hex digit or question mark is expected');
    }
}
const $077cf9138d35de73$var$name = 'UnicodeRange';
const $077cf9138d35de73$var$structure = {
    value: String
};
function $077cf9138d35de73$var$parse() {
    const start = this.tokenStart;
    // U or u
    this.eatIdent('u');
    $077cf9138d35de73$var$scanUnicodeRange.call(this);
    return {
        type: 'UnicodeRange',
        loc: this.getLocation(start, this.tokenStart),
        value: this.substrToCursor(start)
    };
}
function $077cf9138d35de73$var$generate(node) {
    this.tokenize(node.value);
}
$077cf9138d35de73$export$80d376111cc09ad7 = $077cf9138d35de73$var$generate;
$077cf9138d35de73$export$a8ff84c12d48cfa6 = $077cf9138d35de73$var$name;
$077cf9138d35de73$export$98e6a39c04603d36 = $077cf9138d35de73$var$parse;
$077cf9138d35de73$export$46a2a563c28afca0 = $077cf9138d35de73$var$structure;


var $026e77112f597904$exports = {};
$parcel$export($026e77112f597904$exports, "generate", () => $026e77112f597904$export$80d376111cc09ad7, (v) => $026e77112f597904$export$80d376111cc09ad7 = v);
$parcel$export($026e77112f597904$exports, "name", () => $026e77112f597904$export$a8ff84c12d48cfa6, (v) => $026e77112f597904$export$a8ff84c12d48cfa6 = v);
$parcel$export($026e77112f597904$exports, "parse", () => $026e77112f597904$export$98e6a39c04603d36, (v) => $026e77112f597904$export$98e6a39c04603d36 = v);
$parcel$export($026e77112f597904$exports, "structure", () => $026e77112f597904$export$46a2a563c28afca0, (v) => $026e77112f597904$export$46a2a563c28afca0 = v);
var $026e77112f597904$export$80d376111cc09ad7;
var $026e77112f597904$export$a8ff84c12d48cfa6;
var $026e77112f597904$export$98e6a39c04603d36;
var $026e77112f597904$export$46a2a563c28afca0;
'use strict';
var $67024a06c2d82851$exports = {};
$parcel$export($67024a06c2d82851$exports, "decode", () => $67024a06c2d82851$export$2f872c0f2117be69, (v) => $67024a06c2d82851$export$2f872c0f2117be69 = v);
$parcel$export($67024a06c2d82851$exports, "encode", () => $67024a06c2d82851$export$c564cdbbe6da493, (v) => $67024a06c2d82851$export$c564cdbbe6da493 = v);
var $67024a06c2d82851$export$2f872c0f2117be69;
var $67024a06c2d82851$export$c564cdbbe6da493;
'use strict';


const $67024a06c2d82851$var$SPACE = 0x0020; // U+0020 SPACE
const $67024a06c2d82851$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
const $67024a06c2d82851$var$QUOTATION_MARK = 0x0022; // "
const $67024a06c2d82851$var$APOSTROPHE = 0x0027; // '
const $67024a06c2d82851$var$LEFTPARENTHESIS = 0x0028; // U+0028 LEFT PARENTHESIS (()
const $67024a06c2d82851$var$RIGHTPARENTHESIS = 0x0029; // U+0029 RIGHT PARENTHESIS ())
function $67024a06c2d82851$var$decode(str) {
    const len = str.length;
    let start = 4; // length of "url("
    let end = str.charCodeAt(len - 1) === $67024a06c2d82851$var$RIGHTPARENTHESIS ? len - 2 : len - 1;
    let decoded = '';
    while(start < end && $401d24d35b6b69df$export$3c52dd84024ae72c(str.charCodeAt(start)))start++;
    while(start < end && $401d24d35b6b69df$export$3c52dd84024ae72c(str.charCodeAt(end)))end--;
    for(let i = start; i <= end; i++){
        let code = str.charCodeAt(i);
        if (code === $67024a06c2d82851$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) {
                // if the next input code point is EOF, do nothing
                // otherwise include last left parenthesis as escaped
                if (i !== len - 1) decoded = str.substr(i + 1);
                break;
            }
            code = str.charCodeAt(++i);
            // consume escaped
            if ($401d24d35b6b69df$export$352e2c1d24776bfb($67024a06c2d82851$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = $96eb8038f2b3ef39$export$1cf8ac3f090cf48a(str, escapeStart);
                i = escapeEnd - 1;
                decoded += $96eb8038f2b3ef39$export$5ed93187f4ce070a(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
function $67024a06c2d82851$var$encode(str) {
    let encoded = '';
    let wsBeforeHexIsNeeded = false;
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        // If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F,
        // the character escaped as code point.
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        if (code <= 0x001f || code === 0x007F) {
            encoded += '\\' + code.toString(16);
            wsBeforeHexIsNeeded = true;
            continue;
        }
        if (code === $67024a06c2d82851$var$SPACE || code === $67024a06c2d82851$var$REVERSE_SOLIDUS || code === $67024a06c2d82851$var$QUOTATION_MARK || code === $67024a06c2d82851$var$APOSTROPHE || code === $67024a06c2d82851$var$LEFTPARENTHESIS || code === $67024a06c2d82851$var$RIGHTPARENTHESIS) {
            encoded += '\\' + str.charAt(i);
            wsBeforeHexIsNeeded = false;
        } else {
            if (wsBeforeHexIsNeeded && $401d24d35b6b69df$export$2a81dc4d1a2f9334(code)) encoded += ' ';
            encoded += str.charAt(i);
            wsBeforeHexIsNeeded = false;
        }
    }
    return 'url(' + encoded + ')';
}
$67024a06c2d82851$export$2f872c0f2117be69 = $67024a06c2d82851$var$decode;
$67024a06c2d82851$export$c564cdbbe6da493 = $67024a06c2d82851$var$encode;




const $026e77112f597904$var$name = 'Url';
const $026e77112f597904$var$structure = {
    value: String
};
// <url-token> | <function-token> <string> )
function $026e77112f597904$var$parse() {
    const start = this.tokenStart;
    let value;
    switch(this.tokenType){
        case $926ff4544e512db5$export$59d795186a5d3f58:
            value = $67024a06c2d82851$export$2f872c0f2117be69(this.consume($926ff4544e512db5$export$59d795186a5d3f58));
            break;
        case $926ff4544e512db5$export$f3890eeaf6851387:
            if (!this.cmpStr(this.tokenStart, this.tokenEnd, 'url(')) this.error('Function name must be `url`');
            this.eat($926ff4544e512db5$export$f3890eeaf6851387);
            this.skipSC();
            value = $04140284bd5c6270$export$2f872c0f2117be69(this.consume($926ff4544e512db5$export$89b8e0fa65f6a914));
            this.skipSC();
            if (!this.eof) this.eat($926ff4544e512db5$export$773d33972c6279ed);
            break;
        default:
            this.error('Url or Function is expected');
    }
    return {
        type: 'Url',
        loc: this.getLocation(start, this.tokenStart),
        value: value
    };
}
function $026e77112f597904$var$generate(node) {
    this.token($926ff4544e512db5$export$59d795186a5d3f58, $67024a06c2d82851$export$c564cdbbe6da493(node.value));
}
$026e77112f597904$export$80d376111cc09ad7 = $026e77112f597904$var$generate;
$026e77112f597904$export$a8ff84c12d48cfa6 = $026e77112f597904$var$name;
$026e77112f597904$export$98e6a39c04603d36 = $026e77112f597904$var$parse;
$026e77112f597904$export$46a2a563c28afca0 = $026e77112f597904$var$structure;


var $86fff190b1288170$exports = {};
$parcel$export($86fff190b1288170$exports, "generate", () => $86fff190b1288170$export$80d376111cc09ad7, (v) => $86fff190b1288170$export$80d376111cc09ad7 = v);
$parcel$export($86fff190b1288170$exports, "name", () => $86fff190b1288170$export$a8ff84c12d48cfa6, (v) => $86fff190b1288170$export$a8ff84c12d48cfa6 = v);
$parcel$export($86fff190b1288170$exports, "parse", () => $86fff190b1288170$export$98e6a39c04603d36, (v) => $86fff190b1288170$export$98e6a39c04603d36 = v);
$parcel$export($86fff190b1288170$exports, "structure", () => $86fff190b1288170$export$46a2a563c28afca0, (v) => $86fff190b1288170$export$46a2a563c28afca0 = v);
var $86fff190b1288170$export$80d376111cc09ad7;
var $86fff190b1288170$export$a8ff84c12d48cfa6;
var $86fff190b1288170$export$98e6a39c04603d36;
var $86fff190b1288170$export$46a2a563c28afca0;
'use strict';
const $86fff190b1288170$var$name = 'Value';
const $86fff190b1288170$var$structure = {
    children: [
        []
    ]
};
function $86fff190b1288170$var$parse() {
    const start = this.tokenStart;
    const children = this.readSequence(this.scope.Value);
    return {
        type: 'Value',
        loc: this.getLocation(start, this.tokenStart),
        children: children
    };
}
function $86fff190b1288170$var$generate(node) {
    this.children(node);
}
$86fff190b1288170$export$80d376111cc09ad7 = $86fff190b1288170$var$generate;
$86fff190b1288170$export$a8ff84c12d48cfa6 = $86fff190b1288170$var$name;
$86fff190b1288170$export$98e6a39c04603d36 = $86fff190b1288170$var$parse;
$86fff190b1288170$export$46a2a563c28afca0 = $86fff190b1288170$var$structure;


var $8496a801e336d1cc$exports = {};
$parcel$export($8496a801e336d1cc$exports, "generate", () => $8496a801e336d1cc$export$80d376111cc09ad7, (v) => $8496a801e336d1cc$export$80d376111cc09ad7 = v);
$parcel$export($8496a801e336d1cc$exports, "name", () => $8496a801e336d1cc$export$a8ff84c12d48cfa6, (v) => $8496a801e336d1cc$export$a8ff84c12d48cfa6 = v);
$parcel$export($8496a801e336d1cc$exports, "parse", () => $8496a801e336d1cc$export$98e6a39c04603d36, (v) => $8496a801e336d1cc$export$98e6a39c04603d36 = v);
$parcel$export($8496a801e336d1cc$exports, "structure", () => $8496a801e336d1cc$export$46a2a563c28afca0, (v) => $8496a801e336d1cc$export$46a2a563c28afca0 = v);
var $8496a801e336d1cc$export$80d376111cc09ad7;
var $8496a801e336d1cc$export$a8ff84c12d48cfa6;
var $8496a801e336d1cc$export$98e6a39c04603d36;
var $8496a801e336d1cc$export$46a2a563c28afca0;
'use strict';

const $8496a801e336d1cc$var$SPACE = Object.freeze({
    type: 'WhiteSpace',
    loc: null,
    value: ' '
});
const $8496a801e336d1cc$var$name = 'WhiteSpace';
const $8496a801e336d1cc$var$structure = {
    value: String
};
function $8496a801e336d1cc$var$parse() {
    this.eat($926ff4544e512db5$export$fb98946286ab4c97);
    return $8496a801e336d1cc$var$SPACE;
// return {
//     type: 'WhiteSpace',
//     loc: this.getLocation(this.tokenStart, this.tokenEnd),
//     value: this.consume(WHITESPACE)
// };
}
function $8496a801e336d1cc$var$generate(node) {
    this.token($926ff4544e512db5$export$fb98946286ab4c97, node.value);
}
$8496a801e336d1cc$export$80d376111cc09ad7 = $8496a801e336d1cc$var$generate;
$8496a801e336d1cc$export$a8ff84c12d48cfa6 = $8496a801e336d1cc$var$name;
$8496a801e336d1cc$export$98e6a39c04603d36 = $8496a801e336d1cc$var$parse;
$8496a801e336d1cc$export$46a2a563c28afca0 = $8496a801e336d1cc$var$structure;


$ec83dd3af9a58624$export$29d22f23fc62deec = $99d9b650dc26e4b6$exports;
$ec83dd3af9a58624$export$b0e869c28ebe2686 = $fd0f87093eed036b$exports;
$ec83dd3af9a58624$export$a551ca711e9f0de7 = $1a6e0f4f495e21e5$exports;
$ec83dd3af9a58624$export$8170b1e1b2558dd5 = $6a4a944c6364bfde$exports;
$ec83dd3af9a58624$export$d96a8827a60d6b69 = $a56929a80fe5fba4$exports;
$ec83dd3af9a58624$export$27f9608f5b4a4cfa = $bf89e1bb9b85384e$exports;
$ec83dd3af9a58624$export$b0b2bd2d1777c179 = $eaa7aa9b4b73ca52$exports;
$ec83dd3af9a58624$export$521ef26a3002003b = $03db947d83d4b4cf$exports;
$ec83dd3af9a58624$export$208720b1a4408baf = $d308a4f21a3e2a3c$exports;
$ec83dd3af9a58624$export$3cbfd7ee92c4e2ca = $7279f71602175e81$exports;
$ec83dd3af9a58624$export$4d299b491347818a = $db90df25217d7def$exports;
$ec83dd3af9a58624$export$48f3d9e786303b67 = $cba42d248bcc1907$exports;
$ec83dd3af9a58624$export$b8d0a768b241031f = $0e086e8c57e8deab$exports;
$ec83dd3af9a58624$export$c940ece961bc43c6 = $5451298cec146216$exports;
$ec83dd3af9a58624$export$f3890eeaf6851387 = $36f4bb9e2a32a1da$exports;
$ec83dd3af9a58624$export$ab85ecd77ce6a5cd = $d582d94e39da803c$exports;
$ec83dd3af9a58624$export$989167234458594d = $c4e2cd839b327e68$exports;
$ec83dd3af9a58624$export$31c96e959895721d = $f4c0ccbed8fbd0e7$exports;
$ec83dd3af9a58624$export$a38b0f36e6ad18cf = $eefd2500d36c6130$exports;
$ec83dd3af9a58624$export$b745838c41029eb3 = $4fa1fa8572359f69$exports;
$ec83dd3af9a58624$export$789660f679e96cab = $d9c170cb81a09b3c$exports;
$ec83dd3af9a58624$export$69f042d6c338d0d = $662407265d143d7e$exports;
$ec83dd3af9a58624$export$fffa67e515d04022 = $488e8a5e1132bc56$exports;
$ec83dd3af9a58624$export$fa5f90bfb4dbdbcd = $fc461b869396c1f6$exports;
$ec83dd3af9a58624$export$f9c1f512ab2b4a4c = $88f18f478c6a60fe$exports;
$ec83dd3af9a58624$export$d11913f8a6922aea = $3fb545a8ac7e157a$exports;
$ec83dd3af9a58624$export$4a1f3470168c60fe = $6d5501c22d88d5ea$exports;
$ec83dd3af9a58624$export$fcc96471f1c8a2f3 = $b8dc75efd0b10b81$exports;
$ec83dd3af9a58624$export$438ad6fc467f929b = $8970060801e336e8$exports;
$ec83dd3af9a58624$export$6f88fe47d32c9c94 = $588b9c88485e2c7b$exports;
$ec83dd3af9a58624$export$f1ff2a90c38ff669 = $22bc3627751e8d49$exports;
$ec83dd3af9a58624$export$d15f4cd5286f9b1e = $fcbbce62876d9ee8$exports;
$ec83dd3af9a58624$export$d2c5a04859a7aa8c = $a19998960a858969$exports;
$ec83dd3af9a58624$export$89b8e0fa65f6a914 = $db24483ec655fb74$exports;
$ec83dd3af9a58624$export$9d753cd7ae895cce = $3602872a2c18d9d5$exports;
$ec83dd3af9a58624$export$1cbeb7199b91dfe2 = $d2f05fef0aedabf1$exports;
$ec83dd3af9a58624$export$3f8e011aa996e1b4 = $077cf9138d35de73$exports;
$ec83dd3af9a58624$export$59d795186a5d3f58 = $026e77112f597904$exports;
$ec83dd3af9a58624$export$4c8d1a57a761ef94 = $86fff190b1288170$exports;
$ec83dd3af9a58624$export$fb98946286ab4c97 = $8496a801e336d1cc$exports;


const $cf6fa3818b31b6ea$var$lexerConfig = {
    generic: true,
    ...$a47e5819577d822d$exports,
    node: $ec83dd3af9a58624$exports
};
$cf6fa3818b31b6ea$exports = $cf6fa3818b31b6ea$var$lexerConfig;


var $4e397f00f08b9a54$exports = {};
'use strict';
var $0c0ce98dd188732e$exports = {};
$parcel$export($0c0ce98dd188732e$exports, "AtrulePrelude", () => $0c0ce98dd188732e$export$a551ca711e9f0de7, (v) => $0c0ce98dd188732e$export$a551ca711e9f0de7 = v);
$parcel$export($0c0ce98dd188732e$exports, "Selector", () => $0c0ce98dd188732e$export$d15f4cd5286f9b1e, (v) => $0c0ce98dd188732e$export$d15f4cd5286f9b1e = v);
$parcel$export($0c0ce98dd188732e$exports, "Value", () => $0c0ce98dd188732e$export$4c8d1a57a761ef94, (v) => $0c0ce98dd188732e$export$4c8d1a57a761ef94 = v);
var $0c0ce98dd188732e$export$a551ca711e9f0de7;
var $0c0ce98dd188732e$export$d15f4cd5286f9b1e;
var $0c0ce98dd188732e$export$4c8d1a57a761ef94;
'use strict';
var $c5e05e1eca09e965$exports = {};
'use strict';
var $93e28e519fb66554$exports = {};
'use strict';

const $93e28e519fb66554$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $93e28e519fb66554$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $93e28e519fb66554$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $93e28e519fb66554$var$HYPHENMINUS = 0x002D; // U+002D HYPHEN-MINUS (-)
const $93e28e519fb66554$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $93e28e519fb66554$var$U = 0x0075; // U+0075 LATIN SMALL LETTER U (u)
function $93e28e519fb66554$var$defaultRecognizer(context) {
    switch(this.tokenType){
        case $926ff4544e512db5$export$ab85ecd77ce6a5cd:
            return this.Hash();
        case $926ff4544e512db5$export$c06e3ee3b4d233fa:
            return this.Operator();
        case $926ff4544e512db5$export$b5a25f132cb53de6:
            return this.Parentheses(this.readSequence, context.recognizer);
        case $926ff4544e512db5$export$cd363bb53c2bb:
            return this.Brackets(this.readSequence, context.recognizer);
        case $926ff4544e512db5$export$89b8e0fa65f6a914:
            return this.String();
        case $926ff4544e512db5$export$c940ece961bc43c6:
            return this.Dimension();
        case $926ff4544e512db5$export$d11913f8a6922aea:
            return this.Percentage();
        case $926ff4544e512db5$export$fffa67e515d04022:
            return this.Number();
        case $926ff4544e512db5$export$f3890eeaf6851387:
            return this.cmpStr(this.tokenStart, this.tokenEnd, 'url(') ? this.Url() : this.Function(this.readSequence, context.recognizer);
        case $926ff4544e512db5$export$59d795186a5d3f58:
            return this.Url();
        case $926ff4544e512db5$export$331e9b6bdecaac5f:
            // check for unicode range, it should start with u+ or U+
            if (this.cmpChar(this.tokenStart, $93e28e519fb66554$var$U) && this.cmpChar(this.tokenStart + 1, $93e28e519fb66554$var$PLUSSIGN)) return this.UnicodeRange();
            else return this.Identifier();
        case $926ff4544e512db5$export$a918ca49ff4337a3:
            {
                const code = this.charCodeAt(this.tokenStart);
                if (code === $93e28e519fb66554$var$SOLIDUS || code === $93e28e519fb66554$var$ASTERISK || code === $93e28e519fb66554$var$PLUSSIGN || code === $93e28e519fb66554$var$HYPHENMINUS) return this.Operator(); // TODO: replace with Delim
                // TODO: produce a node with Delim node type
                if (code === $93e28e519fb66554$var$NUMBERSIGN) this.error('Hex or identifier is expected', this.tokenStart + 1);
                break;
            }
    }
}
$93e28e519fb66554$exports = $93e28e519fb66554$var$defaultRecognizer;


const $c5e05e1eca09e965$var$atrulePrelude = {
    getNode: $93e28e519fb66554$exports
};
$c5e05e1eca09e965$exports = $c5e05e1eca09e965$var$atrulePrelude;


var $c457bd961234c95d$exports = {};
'use strict';

const $c457bd961234c95d$var$NUMBERSIGN = 0x0023; // U+0023 NUMBER SIGN (#)
const $c457bd961234c95d$var$ASTERISK = 0x002A; // U+002A ASTERISK (*)
const $c457bd961234c95d$var$PLUSSIGN = 0x002B; // U+002B PLUS SIGN (+)
const $c457bd961234c95d$var$SOLIDUS = 0x002F; // U+002F SOLIDUS (/)
const $c457bd961234c95d$var$FULLSTOP = 0x002E; // U+002E FULL STOP (.)
const $c457bd961234c95d$var$GREATERTHANSIGN = 0x003E; // U+003E GREATER-THAN SIGN (>)
const $c457bd961234c95d$var$VERTICALLINE = 0x007C; // U+007C VERTICAL LINE (|)
const $c457bd961234c95d$var$TILDE = 0x007E; // U+007E TILDE (~)
function $c457bd961234c95d$var$onWhiteSpace(next, children) {
    if (children.last !== null && children.last.type !== 'Combinator' && next !== null && next.type !== 'Combinator') children.push({
        type: 'Combinator',
        loc: null,
        name: ' '
    });
}
function $c457bd961234c95d$var$getNode() {
    switch(this.tokenType){
        case $926ff4544e512db5$export$cd363bb53c2bb:
            return this.AttributeSelector();
        case $926ff4544e512db5$export$ab85ecd77ce6a5cd:
            return this.IdSelector();
        case $926ff4544e512db5$export$e20ebb298016f6:
            if (this.lookupType(1) === $926ff4544e512db5$export$e20ebb298016f6) return this.PseudoElementSelector();
            else return this.PseudoClassSelector();
        case $926ff4544e512db5$export$331e9b6bdecaac5f:
            return this.TypeSelector();
        case $926ff4544e512db5$export$fffa67e515d04022:
        case $926ff4544e512db5$export$d11913f8a6922aea:
            return this.Percentage();
        case $926ff4544e512db5$export$c940ece961bc43c6:
            // throws when .123ident
            if (this.charCodeAt(this.tokenStart) === $c457bd961234c95d$var$FULLSTOP) this.error('Identifier is expected', this.tokenStart + 1);
            break;
        case $926ff4544e512db5$export$a918ca49ff4337a3:
            {
                const code = this.charCodeAt(this.tokenStart);
                switch(code){
                    case $c457bd961234c95d$var$PLUSSIGN:
                    case $c457bd961234c95d$var$GREATERTHANSIGN:
                    case $c457bd961234c95d$var$TILDE:
                    case $c457bd961234c95d$var$SOLIDUS:
                        return this.Combinator();
                    case $c457bd961234c95d$var$FULLSTOP:
                        return this.ClassSelector();
                    case $c457bd961234c95d$var$ASTERISK:
                    case $c457bd961234c95d$var$VERTICALLINE:
                        return this.TypeSelector();
                    case $c457bd961234c95d$var$NUMBERSIGN:
                        return this.IdSelector();
                }
                break;
            }
    }
}
const $c457bd961234c95d$var$Selector = {
    onWhiteSpace: $c457bd961234c95d$var$onWhiteSpace,
    getNode: $c457bd961234c95d$var$getNode
};
$c457bd961234c95d$exports = $c457bd961234c95d$var$Selector;


var $419db7fb5e165f4e$exports = {};
'use strict';

var $4a9409cce16cfc4f$exports = {};
'use strict';
// legacy IE function
// expression( <any-value> )
function $4a9409cce16cfc4f$var$expressionFn() {
    return this.createSingleNodeList(this.Raw(this.tokenIndex, null, false));
}
$4a9409cce16cfc4f$exports = $4a9409cce16cfc4f$var$expressionFn;


var $5321725051e6ca40$exports = {};
'use strict';

// var( <ident> , <value>? )
function $5321725051e6ca40$var$varFn() {
    const children = this.createList();
    this.skipSC();
    // NOTE: Don't check more than a first argument is an ident, rest checks are for lexer
    children.push(this.Identifier());
    this.skipSC();
    if (this.tokenType === $926ff4544e512db5$export$c06e3ee3b4d233fa) {
        children.push(this.Operator());
        const startIndex = this.tokenIndex;
        const value = this.parseCustomProperty ? this.Value(null) : this.Raw(this.tokenIndex, this.consumeUntilExclamationMarkOrSemicolon, false);
        if (value.type === 'Value' && value.children.isEmpty) {
            for(let offset = startIndex - this.tokenIndex; offset <= 0; offset++)if (this.lookupType(offset) === $926ff4544e512db5$export$fb98946286ab4c97) {
                value.children.appendData({
                    type: 'WhiteSpace',
                    loc: null,
                    value: ' '
                });
                break;
            }
        }
        children.push(value);
    }
    return children;
}
$5321725051e6ca40$exports = $5321725051e6ca40$var$varFn;


function $419db7fb5e165f4e$var$isPlusMinusOperator(node) {
    return node !== null && node.type === 'Operator' && (node.value[node.value.length - 1] === '-' || node.value[node.value.length - 1] === '+');
}
const $419db7fb5e165f4e$var$value = {
    getNode: $93e28e519fb66554$exports,
    onWhiteSpace (next, children) {
        if ($419db7fb5e165f4e$var$isPlusMinusOperator(next)) next.value = ' ' + next.value;
        if ($419db7fb5e165f4e$var$isPlusMinusOperator(children.last)) children.last.value += ' ';
    },
    'expression': $4a9409cce16cfc4f$exports,
    'var': $5321725051e6ca40$exports
};
$419db7fb5e165f4e$exports = $419db7fb5e165f4e$var$value;


$0c0ce98dd188732e$export$a551ca711e9f0de7 = $c5e05e1eca09e965$exports;
$0c0ce98dd188732e$export$d15f4cd5286f9b1e = $c457bd961234c95d$exports;
$0c0ce98dd188732e$export$4c8d1a57a761ef94 = $419db7fb5e165f4e$exports;


var $011948e0e6143816$exports = {};
'use strict';
var $8f0ae99237e0cccc$exports = {};
'use strict';
const $8f0ae99237e0cccc$var$fontFace = {
    parse: {
        prelude: null,
        block () {
            return this.Block(true);
        }
    }
};
$8f0ae99237e0cccc$exports = $8f0ae99237e0cccc$var$fontFace;


var $435fd176cb715be7$exports = {};
'use strict';

const $435fd176cb715be7$var$importAtrule = {
    parse: {
        prelude () {
            const children = this.createList();
            this.skipSC();
            switch(this.tokenType){
                case $926ff4544e512db5$export$89b8e0fa65f6a914:
                    children.push(this.String());
                    break;
                case $926ff4544e512db5$export$59d795186a5d3f58:
                case $926ff4544e512db5$export$f3890eeaf6851387:
                    children.push(this.Url());
                    break;
                default:
                    this.error('String or url() is expected');
            }
            if (this.lookupNonWSType(0) === $926ff4544e512db5$export$331e9b6bdecaac5f || this.lookupNonWSType(0) === $926ff4544e512db5$export$b5a25f132cb53de6) children.push(this.MediaQueryList());
            return children;
        },
        block: null
    }
};
$435fd176cb715be7$exports = $435fd176cb715be7$var$importAtrule;


var $5d8029654c79ed63$exports = {};
'use strict';
const $5d8029654c79ed63$var$media = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.MediaQueryList());
        },
        block () {
            return this.Block(false);
        }
    }
};
$5d8029654c79ed63$exports = $5d8029654c79ed63$var$media;


var $78da2b28135304aa$exports = {};
'use strict';
const $78da2b28135304aa$var$page = {
    parse: {
        prelude () {
            return this.createSingleNodeList(this.SelectorList());
        },
        block () {
            return this.Block(true);
        }
    }
};
$78da2b28135304aa$exports = $78da2b28135304aa$var$page;


var $a3cda32110241d0a$exports = {};
'use strict';

function $a3cda32110241d0a$var$consumeRaw() {
    return this.createSingleNodeList(this.Raw(this.tokenIndex, null, false));
}
function $a3cda32110241d0a$var$parentheses() {
    this.skipSC();
    if (this.tokenType === $926ff4544e512db5$export$331e9b6bdecaac5f && this.lookupNonWSType(1) === $926ff4544e512db5$export$e20ebb298016f6) return this.createSingleNodeList(this.Declaration());
    return $a3cda32110241d0a$var$readSequence.call(this);
}
function $a3cda32110241d0a$var$readSequence() {
    const children = this.createList();
    let child;
    this.skipSC();
    scan: while(!this.eof){
        switch(this.tokenType){
            case $926ff4544e512db5$export$4d299b491347818a:
            case $926ff4544e512db5$export$fb98946286ab4c97:
                this.next();
                continue;
            case $926ff4544e512db5$export$f3890eeaf6851387:
                child = this.Function($a3cda32110241d0a$var$consumeRaw, this.scope.AtrulePrelude);
                break;
            case $926ff4544e512db5$export$331e9b6bdecaac5f:
                child = this.Identifier();
                break;
            case $926ff4544e512db5$export$b5a25f132cb53de6:
                child = this.Parentheses($a3cda32110241d0a$var$parentheses, this.scope.AtrulePrelude);
                break;
            default:
                break scan;
        }
        children.push(child);
    }
    return children;
}
const $a3cda32110241d0a$var$supports = {
    parse: {
        prelude () {
            const children = $a3cda32110241d0a$var$readSequence.call(this);
            if (this.getFirstListNode(children) === null) this.error('Condition is expected');
            return children;
        },
        block () {
            return this.Block(false);
        }
    }
};
$a3cda32110241d0a$exports = $a3cda32110241d0a$var$supports;


const $011948e0e6143816$var$atrule = {
    'font-face': $8f0ae99237e0cccc$exports,
    'import': $435fd176cb715be7$exports,
    media: $5d8029654c79ed63$exports,
    page: $78da2b28135304aa$exports,
    supports: $a3cda32110241d0a$exports
};
$011948e0e6143816$exports = $011948e0e6143816$var$atrule;


var $130bc677c32714b9$exports = {};
'use strict';
const $130bc677c32714b9$var$selectorList = {
    parse () {
        return this.createSingleNodeList(this.SelectorList());
    }
};
const $130bc677c32714b9$var$selector = {
    parse () {
        return this.createSingleNodeList(this.Selector());
    }
};
const $130bc677c32714b9$var$identList = {
    parse () {
        return this.createSingleNodeList(this.Identifier());
    }
};
const $130bc677c32714b9$var$nth = {
    parse () {
        return this.createSingleNodeList(this.Nth());
    }
};
const $130bc677c32714b9$var$pseudo = {
    'dir': $130bc677c32714b9$var$identList,
    'has': $130bc677c32714b9$var$selectorList,
    'lang': $130bc677c32714b9$var$identList,
    'matches': $130bc677c32714b9$var$selectorList,
    'is': $130bc677c32714b9$var$selectorList,
    '-moz-any': $130bc677c32714b9$var$selectorList,
    '-webkit-any': $130bc677c32714b9$var$selectorList,
    'where': $130bc677c32714b9$var$selectorList,
    'not': $130bc677c32714b9$var$selectorList,
    'nth-child': $130bc677c32714b9$var$nth,
    'nth-last-child': $130bc677c32714b9$var$nth,
    'nth-last-of-type': $130bc677c32714b9$var$nth,
    'nth-of-type': $130bc677c32714b9$var$nth,
    'slotted': $130bc677c32714b9$var$selector
};
$130bc677c32714b9$exports = $130bc677c32714b9$var$pseudo;


var $ea12be5e51557e4f$exports = {};
$parcel$export($ea12be5e51557e4f$exports, "AnPlusB", () => $ea12be5e51557e4f$export$29d22f23fc62deec, (v) => $ea12be5e51557e4f$export$29d22f23fc62deec = v);
$parcel$export($ea12be5e51557e4f$exports, "Atrule", () => $ea12be5e51557e4f$export$b0e869c28ebe2686, (v) => $ea12be5e51557e4f$export$b0e869c28ebe2686 = v);
$parcel$export($ea12be5e51557e4f$exports, "AtrulePrelude", () => $ea12be5e51557e4f$export$a551ca711e9f0de7, (v) => $ea12be5e51557e4f$export$a551ca711e9f0de7 = v);
$parcel$export($ea12be5e51557e4f$exports, "AttributeSelector", () => $ea12be5e51557e4f$export$8170b1e1b2558dd5, (v) => $ea12be5e51557e4f$export$8170b1e1b2558dd5 = v);
$parcel$export($ea12be5e51557e4f$exports, "Block", () => $ea12be5e51557e4f$export$d96a8827a60d6b69, (v) => $ea12be5e51557e4f$export$d96a8827a60d6b69 = v);
$parcel$export($ea12be5e51557e4f$exports, "Brackets", () => $ea12be5e51557e4f$export$27f9608f5b4a4cfa, (v) => $ea12be5e51557e4f$export$27f9608f5b4a4cfa = v);
$parcel$export($ea12be5e51557e4f$exports, "CDC", () => $ea12be5e51557e4f$export$b0b2bd2d1777c179, (v) => $ea12be5e51557e4f$export$b0b2bd2d1777c179 = v);
$parcel$export($ea12be5e51557e4f$exports, "CDO", () => $ea12be5e51557e4f$export$521ef26a3002003b, (v) => $ea12be5e51557e4f$export$521ef26a3002003b = v);
$parcel$export($ea12be5e51557e4f$exports, "ClassSelector", () => $ea12be5e51557e4f$export$208720b1a4408baf, (v) => $ea12be5e51557e4f$export$208720b1a4408baf = v);
$parcel$export($ea12be5e51557e4f$exports, "Combinator", () => $ea12be5e51557e4f$export$3cbfd7ee92c4e2ca, (v) => $ea12be5e51557e4f$export$3cbfd7ee92c4e2ca = v);
$parcel$export($ea12be5e51557e4f$exports, "Comment", () => $ea12be5e51557e4f$export$4d299b491347818a, (v) => $ea12be5e51557e4f$export$4d299b491347818a = v);
$parcel$export($ea12be5e51557e4f$exports, "Declaration", () => $ea12be5e51557e4f$export$48f3d9e786303b67, (v) => $ea12be5e51557e4f$export$48f3d9e786303b67 = v);
$parcel$export($ea12be5e51557e4f$exports, "DeclarationList", () => $ea12be5e51557e4f$export$b8d0a768b241031f, (v) => $ea12be5e51557e4f$export$b8d0a768b241031f = v);
$parcel$export($ea12be5e51557e4f$exports, "Dimension", () => $ea12be5e51557e4f$export$c940ece961bc43c6, (v) => $ea12be5e51557e4f$export$c940ece961bc43c6 = v);
$parcel$export($ea12be5e51557e4f$exports, "Function", () => $ea12be5e51557e4f$export$f3890eeaf6851387, (v) => $ea12be5e51557e4f$export$f3890eeaf6851387 = v);
$parcel$export($ea12be5e51557e4f$exports, "Hash", () => $ea12be5e51557e4f$export$ab85ecd77ce6a5cd, (v) => $ea12be5e51557e4f$export$ab85ecd77ce6a5cd = v);
$parcel$export($ea12be5e51557e4f$exports, "Identifier", () => $ea12be5e51557e4f$export$989167234458594d, (v) => $ea12be5e51557e4f$export$989167234458594d = v);
$parcel$export($ea12be5e51557e4f$exports, "IdSelector", () => $ea12be5e51557e4f$export$31c96e959895721d, (v) => $ea12be5e51557e4f$export$31c96e959895721d = v);
$parcel$export($ea12be5e51557e4f$exports, "MediaFeature", () => $ea12be5e51557e4f$export$a38b0f36e6ad18cf, (v) => $ea12be5e51557e4f$export$a38b0f36e6ad18cf = v);
$parcel$export($ea12be5e51557e4f$exports, "MediaQuery", () => $ea12be5e51557e4f$export$b745838c41029eb3, (v) => $ea12be5e51557e4f$export$b745838c41029eb3 = v);
$parcel$export($ea12be5e51557e4f$exports, "MediaQueryList", () => $ea12be5e51557e4f$export$789660f679e96cab, (v) => $ea12be5e51557e4f$export$789660f679e96cab = v);
$parcel$export($ea12be5e51557e4f$exports, "Nth", () => $ea12be5e51557e4f$export$69f042d6c338d0d, (v) => $ea12be5e51557e4f$export$69f042d6c338d0d = v);
$parcel$export($ea12be5e51557e4f$exports, "Number", () => $ea12be5e51557e4f$export$fffa67e515d04022, (v) => $ea12be5e51557e4f$export$fffa67e515d04022 = v);
$parcel$export($ea12be5e51557e4f$exports, "Operator", () => $ea12be5e51557e4f$export$fa5f90bfb4dbdbcd, (v) => $ea12be5e51557e4f$export$fa5f90bfb4dbdbcd = v);
$parcel$export($ea12be5e51557e4f$exports, "Parentheses", () => $ea12be5e51557e4f$export$f9c1f512ab2b4a4c, (v) => $ea12be5e51557e4f$export$f9c1f512ab2b4a4c = v);
$parcel$export($ea12be5e51557e4f$exports, "Percentage", () => $ea12be5e51557e4f$export$d11913f8a6922aea, (v) => $ea12be5e51557e4f$export$d11913f8a6922aea = v);
$parcel$export($ea12be5e51557e4f$exports, "PseudoClassSelector", () => $ea12be5e51557e4f$export$4a1f3470168c60fe, (v) => $ea12be5e51557e4f$export$4a1f3470168c60fe = v);
$parcel$export($ea12be5e51557e4f$exports, "PseudoElementSelector", () => $ea12be5e51557e4f$export$fcc96471f1c8a2f3, (v) => $ea12be5e51557e4f$export$fcc96471f1c8a2f3 = v);
$parcel$export($ea12be5e51557e4f$exports, "Ratio", () => $ea12be5e51557e4f$export$438ad6fc467f929b, (v) => $ea12be5e51557e4f$export$438ad6fc467f929b = v);
$parcel$export($ea12be5e51557e4f$exports, "Raw", () => $ea12be5e51557e4f$export$6f88fe47d32c9c94, (v) => $ea12be5e51557e4f$export$6f88fe47d32c9c94 = v);
$parcel$export($ea12be5e51557e4f$exports, "Rule", () => $ea12be5e51557e4f$export$f1ff2a90c38ff669, (v) => $ea12be5e51557e4f$export$f1ff2a90c38ff669 = v);
$parcel$export($ea12be5e51557e4f$exports, "Selector", () => $ea12be5e51557e4f$export$d15f4cd5286f9b1e, (v) => $ea12be5e51557e4f$export$d15f4cd5286f9b1e = v);
$parcel$export($ea12be5e51557e4f$exports, "SelectorList", () => $ea12be5e51557e4f$export$d2c5a04859a7aa8c, (v) => $ea12be5e51557e4f$export$d2c5a04859a7aa8c = v);
$parcel$export($ea12be5e51557e4f$exports, "String", () => $ea12be5e51557e4f$export$89b8e0fa65f6a914, (v) => $ea12be5e51557e4f$export$89b8e0fa65f6a914 = v);
$parcel$export($ea12be5e51557e4f$exports, "StyleSheet", () => $ea12be5e51557e4f$export$9d753cd7ae895cce, (v) => $ea12be5e51557e4f$export$9d753cd7ae895cce = v);
$parcel$export($ea12be5e51557e4f$exports, "TypeSelector", () => $ea12be5e51557e4f$export$1cbeb7199b91dfe2, (v) => $ea12be5e51557e4f$export$1cbeb7199b91dfe2 = v);
$parcel$export($ea12be5e51557e4f$exports, "UnicodeRange", () => $ea12be5e51557e4f$export$3f8e011aa996e1b4, (v) => $ea12be5e51557e4f$export$3f8e011aa996e1b4 = v);
$parcel$export($ea12be5e51557e4f$exports, "Url", () => $ea12be5e51557e4f$export$59d795186a5d3f58, (v) => $ea12be5e51557e4f$export$59d795186a5d3f58 = v);
$parcel$export($ea12be5e51557e4f$exports, "Value", () => $ea12be5e51557e4f$export$4c8d1a57a761ef94, (v) => $ea12be5e51557e4f$export$4c8d1a57a761ef94 = v);
$parcel$export($ea12be5e51557e4f$exports, "WhiteSpace", () => $ea12be5e51557e4f$export$fb98946286ab4c97, (v) => $ea12be5e51557e4f$export$fb98946286ab4c97 = v);
var $ea12be5e51557e4f$export$29d22f23fc62deec;
var $ea12be5e51557e4f$export$b0e869c28ebe2686;
var $ea12be5e51557e4f$export$a551ca711e9f0de7;
var $ea12be5e51557e4f$export$8170b1e1b2558dd5;
var $ea12be5e51557e4f$export$d96a8827a60d6b69;
var $ea12be5e51557e4f$export$27f9608f5b4a4cfa;
var $ea12be5e51557e4f$export$b0b2bd2d1777c179;
var $ea12be5e51557e4f$export$521ef26a3002003b;
var $ea12be5e51557e4f$export$208720b1a4408baf;
var $ea12be5e51557e4f$export$3cbfd7ee92c4e2ca;
var $ea12be5e51557e4f$export$4d299b491347818a;
var $ea12be5e51557e4f$export$48f3d9e786303b67;
var $ea12be5e51557e4f$export$b8d0a768b241031f;
var $ea12be5e51557e4f$export$c940ece961bc43c6;
var $ea12be5e51557e4f$export$f3890eeaf6851387;
var $ea12be5e51557e4f$export$ab85ecd77ce6a5cd;
var $ea12be5e51557e4f$export$989167234458594d;
var $ea12be5e51557e4f$export$31c96e959895721d;
var $ea12be5e51557e4f$export$a38b0f36e6ad18cf;
var $ea12be5e51557e4f$export$b745838c41029eb3;
var $ea12be5e51557e4f$export$789660f679e96cab;
var $ea12be5e51557e4f$export$69f042d6c338d0d;
var $ea12be5e51557e4f$export$fffa67e515d04022;
var $ea12be5e51557e4f$export$fa5f90bfb4dbdbcd;
var $ea12be5e51557e4f$export$f9c1f512ab2b4a4c;
var $ea12be5e51557e4f$export$d11913f8a6922aea;
var $ea12be5e51557e4f$export$4a1f3470168c60fe;
var $ea12be5e51557e4f$export$fcc96471f1c8a2f3;
var $ea12be5e51557e4f$export$438ad6fc467f929b;
var $ea12be5e51557e4f$export$6f88fe47d32c9c94;
var $ea12be5e51557e4f$export$f1ff2a90c38ff669;
var $ea12be5e51557e4f$export$d15f4cd5286f9b1e;
var $ea12be5e51557e4f$export$d2c5a04859a7aa8c;
var $ea12be5e51557e4f$export$89b8e0fa65f6a914;
var $ea12be5e51557e4f$export$9d753cd7ae895cce;
var $ea12be5e51557e4f$export$1cbeb7199b91dfe2;
var $ea12be5e51557e4f$export$3f8e011aa996e1b4;
var $ea12be5e51557e4f$export$59d795186a5d3f58;
var $ea12be5e51557e4f$export$4c8d1a57a761ef94;
var $ea12be5e51557e4f$export$fb98946286ab4c97;
'use strict';








































$ea12be5e51557e4f$export$29d22f23fc62deec = $99d9b650dc26e4b6$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$b0e869c28ebe2686 = $fd0f87093eed036b$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$a551ca711e9f0de7 = $1a6e0f4f495e21e5$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$8170b1e1b2558dd5 = $6a4a944c6364bfde$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$d96a8827a60d6b69 = $a56929a80fe5fba4$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$27f9608f5b4a4cfa = $bf89e1bb9b85384e$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$b0b2bd2d1777c179 = $eaa7aa9b4b73ca52$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$521ef26a3002003b = $03db947d83d4b4cf$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$208720b1a4408baf = $d308a4f21a3e2a3c$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$3cbfd7ee92c4e2ca = $7279f71602175e81$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$4d299b491347818a = $db90df25217d7def$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$48f3d9e786303b67 = $cba42d248bcc1907$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$b8d0a768b241031f = $0e086e8c57e8deab$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$c940ece961bc43c6 = $5451298cec146216$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$f3890eeaf6851387 = $36f4bb9e2a32a1da$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$ab85ecd77ce6a5cd = $d582d94e39da803c$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$989167234458594d = $c4e2cd839b327e68$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$31c96e959895721d = $f4c0ccbed8fbd0e7$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$a38b0f36e6ad18cf = $eefd2500d36c6130$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$b745838c41029eb3 = $4fa1fa8572359f69$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$789660f679e96cab = $d9c170cb81a09b3c$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$69f042d6c338d0d = $662407265d143d7e$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$fffa67e515d04022 = $488e8a5e1132bc56$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$fa5f90bfb4dbdbcd = $fc461b869396c1f6$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$f9c1f512ab2b4a4c = $88f18f478c6a60fe$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$d11913f8a6922aea = $3fb545a8ac7e157a$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$4a1f3470168c60fe = $6d5501c22d88d5ea$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$fcc96471f1c8a2f3 = $b8dc75efd0b10b81$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$438ad6fc467f929b = $8970060801e336e8$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$6f88fe47d32c9c94 = $588b9c88485e2c7b$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$f1ff2a90c38ff669 = $22bc3627751e8d49$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$d15f4cd5286f9b1e = $fcbbce62876d9ee8$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$d2c5a04859a7aa8c = $a19998960a858969$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$89b8e0fa65f6a914 = $db24483ec655fb74$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$9d753cd7ae895cce = $3602872a2c18d9d5$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$1cbeb7199b91dfe2 = $d2f05fef0aedabf1$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$3f8e011aa996e1b4 = $077cf9138d35de73$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$59d795186a5d3f58 = $026e77112f597904$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$4c8d1a57a761ef94 = $86fff190b1288170$export$98e6a39c04603d36;
$ea12be5e51557e4f$export$fb98946286ab4c97 = $8496a801e336d1cc$export$98e6a39c04603d36;


const $4e397f00f08b9a54$var$config = {
    parseContext: {
        default: 'StyleSheet',
        stylesheet: 'StyleSheet',
        atrule: 'Atrule',
        atrulePrelude (options) {
            return this.AtrulePrelude(options.atrule ? String(options.atrule) : null);
        },
        mediaQueryList: 'MediaQueryList',
        mediaQuery: 'MediaQuery',
        rule: 'Rule',
        selectorList: 'SelectorList',
        selector: 'Selector',
        block () {
            return this.Block(true);
        },
        declarationList: 'DeclarationList',
        declaration: 'Declaration',
        value: 'Value'
    },
    scope: $0c0ce98dd188732e$exports,
    atrule: $011948e0e6143816$exports,
    pseudo: $130bc677c32714b9$exports,
    node: $ea12be5e51557e4f$exports
};
$4e397f00f08b9a54$exports = $4e397f00f08b9a54$var$config;


var $a0f5b9c4ca05f0ec$exports = {};
'use strict';

const $a0f5b9c4ca05f0ec$var$config = {
    node: $ec83dd3af9a58624$exports
};
$a0f5b9c4ca05f0ec$exports = $a0f5b9c4ca05f0ec$var$config;


const $d6be594cc9af5262$var$syntax = $92105e36fb3855b0$exports({
    ...$cf6fa3818b31b6ea$exports,
    ...$4e397f00f08b9a54$exports,
    ...$a0f5b9c4ca05f0ec$exports
});
$d6be594cc9af5262$exports = $d6be594cc9af5262$var$syntax;


var $a8d8b7b76594a5dd$exports = {};
$a8d8b7b76594a5dd$exports = "2.2.1";





var $b0bd23edf239898a$exports = {};
$parcel$export($b0bd23edf239898a$exports, "SyntaxError", () => $b0bd23edf239898a$export$f21cea08b0dd60e8, (v) => $b0bd23edf239898a$export$f21cea08b0dd60e8 = v);
$parcel$export($b0bd23edf239898a$exports, "generate", () => $b0bd23edf239898a$export$80d376111cc09ad7, (v) => $b0bd23edf239898a$export$80d376111cc09ad7 = v);
$parcel$export($b0bd23edf239898a$exports, "parse", () => $b0bd23edf239898a$export$98e6a39c04603d36, (v) => $b0bd23edf239898a$export$98e6a39c04603d36 = v);
$parcel$export($b0bd23edf239898a$exports, "walk", () => $b0bd23edf239898a$export$588732934346abbf, (v) => $b0bd23edf239898a$export$588732934346abbf = v);
var $b0bd23edf239898a$export$f21cea08b0dd60e8;
var $b0bd23edf239898a$export$80d376111cc09ad7;
var $b0bd23edf239898a$export$98e6a39c04603d36;
var $b0bd23edf239898a$export$588732934346abbf;
'use strict';




$b0bd23edf239898a$export$f21cea08b0dd60e8 = $33d51d9401bbcbe5$export$f21cea08b0dd60e8;
$b0bd23edf239898a$export$80d376111cc09ad7 = $98e942a2f6e618f5$export$80d376111cc09ad7;
$b0bd23edf239898a$export$98e6a39c04603d36 = $34919e392962fcd2$export$98e6a39c04603d36;
$b0bd23edf239898a$export$588732934346abbf = $40c4f52b975be836$export$588732934346abbf;


var $cd9da62e2156dac7$export$9cd59f9826255e47;
'use strict';

function $cd9da62e2156dac7$var$clone(node) {
    const result = {};
    for(const key in node){
        let value = node[key];
        if (value) {
            if (Array.isArray(value) || value instanceof $22e84e429477a95a$export$54c2e3dc7acea9f5) value = value.map($cd9da62e2156dac7$var$clone);
            else if (value.constructor === Object) value = $cd9da62e2156dac7$var$clone(value);
        }
        result[key] = value;
    }
    return result;
}
$cd9da62e2156dac7$export$9cd59f9826255e47 = $cd9da62e2156dac7$var$clone;



var $b485a1520043ba7a$exports = {};
$parcel$export($b485a1520043ba7a$exports, "decode", () => $b485a1520043ba7a$export$2f872c0f2117be69, (v) => $b485a1520043ba7a$export$2f872c0f2117be69 = v);
$parcel$export($b485a1520043ba7a$exports, "encode", () => $b485a1520043ba7a$export$c564cdbbe6da493, (v) => $b485a1520043ba7a$export$c564cdbbe6da493 = v);
var $b485a1520043ba7a$export$2f872c0f2117be69;
var $b485a1520043ba7a$export$c564cdbbe6da493;
'use strict';


const $b485a1520043ba7a$var$REVERSE_SOLIDUS = 0x005c; // U+005C REVERSE SOLIDUS (\)
function $b485a1520043ba7a$var$decode(str) {
    const end = str.length - 1;
    let decoded = '';
    for(let i = 0; i < str.length; i++){
        let code = str.charCodeAt(i);
        if (code === $b485a1520043ba7a$var$REVERSE_SOLIDUS) {
            // special case at the ending
            if (i === end) break;
            code = str.charCodeAt(++i);
            // consume escaped
            if ($401d24d35b6b69df$export$352e2c1d24776bfb($b485a1520043ba7a$var$REVERSE_SOLIDUS, code)) {
                const escapeStart = i - 1;
                const escapeEnd = $96eb8038f2b3ef39$export$1cf8ac3f090cf48a(str, escapeStart);
                i = escapeEnd - 1;
                decoded += $96eb8038f2b3ef39$export$5ed93187f4ce070a(str.substring(escapeStart + 1, escapeEnd));
            } else // \r\n
            if (code === 0x000d && str.charCodeAt(i + 1) === 0x000a) i++;
        } else decoded += str[i];
    }
    return decoded;
}
// https://drafts.csswg.org/cssom/#serialize-an-identifier
// § 2.1. Common Serializing Idioms
function $b485a1520043ba7a$var$encode(str) {
    let encoded = '';
    // If the character is the first character and is a "-" (U+002D),
    // and there is no second character, then the escaped character.
    // Note: That's means a single dash string "-" return as escaped dash,
    // so move the condition out of the main loop
    if (str.length === 1 && str.charCodeAt(0) === 0x002D) return '\\-';
    // To serialize an identifier means to create a string represented
    // by the concatenation of, for each character of the identifier:
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        // If the character is NULL (U+0000), then the REPLACEMENT CHARACTER (U+FFFD).
        if (code === 0x0000) {
            encoded += '\uFFFD';
            continue;
        }
        if (// If the character is in the range [\1-\1f] (U+0001 to U+001F) or is U+007F ...
        // Note: Do not compare with 0x0001 since 0x0000 is precessed before
        code <= 0x001F || code === 0x007F || // [or] ... is in the range [0-9] (U+0030 to U+0039),
        code >= 0x0030 && code <= 0x0039 && // If the character is the first character ...
        (i === 0 || // If the character is the second character ... and the first character is a "-" (U+002D)
        i === 1 && str.charCodeAt(0) === 0x002D)) {
            // ... then the character escaped as code point.
            encoded += '\\' + code.toString(16) + ' ';
            continue;
        }
        // If the character is not handled by one of the above rules and is greater
        // than or equal to U+0080, is "-" (U+002D) or "_" (U+005F), or is in one
        // of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to U+005A),
        // or \[a-z] (U+0061 to U+007A), then the character itself.
        if ($401d24d35b6b69df$export$998d7ff9801e90bb(code)) encoded += str.charAt(i);
        else // Otherwise, the escaped character.
        encoded += '\\' + str.charAt(i);
    }
    return encoded;
}
$b485a1520043ba7a$export$2f872c0f2117be69 = $b485a1520043ba7a$var$decode;
$b485a1520043ba7a$export$c564cdbbe6da493 = $b485a1520043ba7a$var$encode;







const { tokenize: $4e097574aea5443c$var$tokenize, parse: $4e097574aea5443c$var$parse, generate: $4e097574aea5443c$var$generate, lexer: $4e097574aea5443c$var$lexer, createLexer: $4e097574aea5443c$var$createLexer, walk: $4e097574aea5443c$var$walk, find: $4e097574aea5443c$var$find, findLast: $4e097574aea5443c$var$findLast, findAll: $4e097574aea5443c$var$findAll, toPlainObject: $4e097574aea5443c$var$toPlainObject, fromPlainObject: $4e097574aea5443c$var$fromPlainObject, fork: $4e097574aea5443c$var$fork } = $d6be594cc9af5262$exports;
$4e097574aea5443c$export$83d89fbfd8236492 = $a8d8b7b76594a5dd$exports.version;
$4e097574aea5443c$export$ef7698fd92a0afb9 = $92105e36fb3855b0$exports;
$4e097574aea5443c$export$54c2e3dc7acea9f5 = $22e84e429477a95a$export$54c2e3dc7acea9f5;
$4e097574aea5443c$export$6168dc8908a6c652 = $60f3ad1b8871cde1$export$6168dc8908a6c652;
$4e097574aea5443c$export$1d94185c187dec3 = $b0bd23edf239898a$exports;
$4e097574aea5443c$export$9cd59f9826255e47 = $cd9da62e2156dac7$export$9cd59f9826255e47;
$4e097574aea5443c$export$15cf667f7f91c461 = $ffbc3ade873552d0$export$15cf667f7f91c461;
$4e097574aea5443c$export$2e81050496d0e63e = $ffbc3ade873552d0$export$2e81050496d0e63e;
$4e097574aea5443c$export$d541bacb2bda4494 = $ffbc3ade873552d0$export$d541bacb2bda4494;
$4e097574aea5443c$export$5150dd39c4b2a5da = $ffbc3ade873552d0$export$5150dd39c4b2a5da;
$4e097574aea5443c$export$7b66c250b210a314 = $b485a1520043ba7a$exports;
$4e097574aea5443c$export$22b082955e083ec3 = $04140284bd5c6270$exports;
$4e097574aea5443c$export$128fa18b7194ef = $67024a06c2d82851$exports;
$4e097574aea5443c$export$a60b91545d7e19fc = $926ff4544e512db5$exports;
$4e097574aea5443c$export$a5f6079b5a0c262e = $9730c97b105b5f1f$exports;
$4e097574aea5443c$export$b55edb69cfa7ac57 = $88761db79c6a77c6$export$b55edb69cfa7ac57;
$4e097574aea5443c$export$542413421c3f8a82 = $4e097574aea5443c$var$createLexer;
$4e097574aea5443c$export$71aa6c912b956294 = $4e097574aea5443c$var$find;
$4e097574aea5443c$export$18200ea6c8035394 = $4e097574aea5443c$var$findAll;
$4e097574aea5443c$export$296de88ccac4bedb = $4e097574aea5443c$var$findLast;
$4e097574aea5443c$export$7a5058c6b79333e0 = $4e097574aea5443c$var$fork;
$4e097574aea5443c$export$208fdd74c481bdd3 = $4e097574aea5443c$var$fromPlainObject;
$4e097574aea5443c$export$80d376111cc09ad7 = $4e097574aea5443c$var$generate;
$4e097574aea5443c$export$43feed32102720d2 = $4e097574aea5443c$var$lexer;
$4e097574aea5443c$export$98e6a39c04603d36 = $4e097574aea5443c$var$parse;
$4e097574aea5443c$export$8530f7b85295aab2 = $4e097574aea5443c$var$toPlainObject;
$4e097574aea5443c$export$660b2ee2d4fb4eff = $4e097574aea5443c$var$tokenize;
$4e097574aea5443c$export$588732934346abbf = $4e097574aea5443c$var$walk;


var $936a09a259590431$exports = {};
'use strict';

var $b6dc50b5b1b8bc90$export$234f5dac53d1ad9a;
'use strict';
const { hasOwnProperty: $b6dc50b5b1b8bc90$var$hasOwnProperty } = Object.prototype;
function $b6dc50b5b1b8bc90$var$buildMap(list, caseInsensitive) {
    const map = Object.create(null);
    if (!Array.isArray(list)) return null;
    for (let name of list){
        if (caseInsensitive) name = name.toLowerCase();
        map[name] = true;
    }
    return map;
}
function $b6dc50b5b1b8bc90$var$buildList(data) {
    if (!data) return null;
    const tags = $b6dc50b5b1b8bc90$var$buildMap(data.tags, true);
    const ids = $b6dc50b5b1b8bc90$var$buildMap(data.ids);
    const classes = $b6dc50b5b1b8bc90$var$buildMap(data.classes);
    if (tags === null && ids === null && classes === null) return null;
    return {
        tags: tags,
        ids: ids,
        classes: classes
    };
}
function $b6dc50b5b1b8bc90$var$buildIndex(data) {
    let scopes = false;
    if (data.scopes && Array.isArray(data.scopes)) {
        scopes = Object.create(null);
        for(let i = 0; i < data.scopes.length; i++){
            const list = data.scopes[i];
            if (!list || !Array.isArray(list)) throw new Error('Wrong usage format');
            for (const name of list){
                if ($b6dc50b5b1b8bc90$var$hasOwnProperty.call(scopes, name)) throw new Error(`Class can't be used for several scopes: ${name}`);
                scopes[name] = i + 1;
            }
        }
    }
    return {
        whitelist: $b6dc50b5b1b8bc90$var$buildList(data),
        blacklist: $b6dc50b5b1b8bc90$var$buildList(data.blacklist),
        scopes: scopes
    };
}
$b6dc50b5b1b8bc90$export$234f5dac53d1ad9a = $b6dc50b5b1b8bc90$var$buildIndex;


var $87789b0a5349c046$exports = {};
'use strict';

var $c6f4617b4968dcf5$exports = {};
'use strict';

var $117894f0e2b5e437$export$4ae8c0b0b49712f0;
var $117894f0e2b5e437$export$3a3f2495309887d7;
'use strict';
function $117894f0e2b5e437$var$hasNoChildren(node) {
    return !node || !node.children || node.children.isEmpty;
}
function $117894f0e2b5e437$var$isNodeChildrenList(node, list) {
    return node !== null && node.children === list;
}
$117894f0e2b5e437$export$4ae8c0b0b49712f0 = $117894f0e2b5e437$var$hasNoChildren;
$117894f0e2b5e437$export$3a3f2495309887d7 = $117894f0e2b5e437$var$isNodeChildrenList;


function $c6f4617b4968dcf5$var$cleanAtrule(node, item, list) {
    if (node.block) {
        // otherwise removed at-rule don't prevent @import for removal
        if (this.stylesheet !== null) this.stylesheet.firstAtrulesAllowed = false;
        if ($117894f0e2b5e437$export$4ae8c0b0b49712f0(node.block)) {
            list.remove(item);
            return;
        }
    }
    switch(node.name){
        case 'charset':
            if ($117894f0e2b5e437$export$4ae8c0b0b49712f0(node.prelude)) {
                list.remove(item);
                return;
            }
            // if there is any rule before @charset -> remove it
            if (item.prev) {
                list.remove(item);
                return;
            }
            break;
        case 'import':
            if (this.stylesheet === null || !this.stylesheet.firstAtrulesAllowed) {
                list.remove(item);
                return;
            }
            // if there are some rules that not an @import or @charset before @import
            // remove it
            list.prevUntil(item.prev, function(rule) {
                if (rule.type === 'Atrule') {
                    if (rule.name === 'import' || rule.name === 'charset') return;
                }
                this.root.firstAtrulesAllowed = false;
                list.remove(item);
                return true;
            }, this);
            break;
        default:
            {
                const name = $4e097574aea5443c$export$2e81050496d0e63e(node.name).basename;
                if (name === 'keyframes' || name === 'media' || name === 'supports') // drop at-rule with no prelude
                {
                    if ($117894f0e2b5e437$export$4ae8c0b0b49712f0(node.prelude) || $117894f0e2b5e437$export$4ae8c0b0b49712f0(node.block)) list.remove(item);
                }
            }
    }
}
$c6f4617b4968dcf5$exports = $c6f4617b4968dcf5$var$cleanAtrule;


var $e22bb75491c51f9c$exports = {};
'use strict';
function $e22bb75491c51f9c$var$cleanComment(data, item, list) {
    list.remove(item);
}
$e22bb75491c51f9c$exports = $e22bb75491c51f9c$var$cleanComment;


var $526f7214bbe67358$exports = {};
'use strict';

function $526f7214bbe67358$var$cleanDeclartion(node, item, list) {
    if (node.value.children && node.value.children.isEmpty) {
        list.remove(item);
        return;
    }
    if ($4e097574aea5443c$export$d541bacb2bda4494(node.property).custom) {
        if (/\S/.test(node.value.value)) node.value.value = node.value.value.trim();
    }
}
$526f7214bbe67358$exports = $526f7214bbe67358$var$cleanDeclartion;


var $8027a063a356490e$exports = {};
'use strict';

function $8027a063a356490e$var$cleanRaw(node, item, list) {
    // raw in stylesheet or block children
    if ($117894f0e2b5e437$export$3a3f2495309887d7(this.stylesheet, list) || $117894f0e2b5e437$export$3a3f2495309887d7(this.block, list)) list.remove(item);
}
$8027a063a356490e$exports = $8027a063a356490e$var$cleanRaw;


var $222f0604500ed718$exports = {};
'use strict';


const { hasOwnProperty: $222f0604500ed718$var$hasOwnProperty } = Object.prototype;
const $222f0604500ed718$var$skipUsageFilteringAtrule = new Set([
    'keyframes'
]);
function $222f0604500ed718$var$cleanUnused(selectorList, usageData) {
    selectorList.children.forEach((selector, item, list)=>{
        let shouldRemove = false;
        $4e097574aea5443c$export$588732934346abbf(selector, function(node) {
            // ignore nodes in nested selectors
            if (this.selector === null || this.selector === selectorList) switch(node.type){
                case 'SelectorList':
                    // TODO: remove toLowerCase when pseudo selectors will be normalized
                    // ignore selectors inside :not()
                    if (this.function === null || this.function.name.toLowerCase() !== 'not') {
                        if ($222f0604500ed718$var$cleanUnused(node, usageData)) shouldRemove = true;
                    }
                    break;
                case 'ClassSelector':
                    if (usageData.whitelist !== null && usageData.whitelist.classes !== null && !$222f0604500ed718$var$hasOwnProperty.call(usageData.whitelist.classes, node.name)) shouldRemove = true;
                    if (usageData.blacklist !== null && usageData.blacklist.classes !== null && $222f0604500ed718$var$hasOwnProperty.call(usageData.blacklist.classes, node.name)) shouldRemove = true;
                    break;
                case 'IdSelector':
                    if (usageData.whitelist !== null && usageData.whitelist.ids !== null && !$222f0604500ed718$var$hasOwnProperty.call(usageData.whitelist.ids, node.name)) shouldRemove = true;
                    if (usageData.blacklist !== null && usageData.blacklist.ids !== null && $222f0604500ed718$var$hasOwnProperty.call(usageData.blacklist.ids, node.name)) shouldRemove = true;
                    break;
                case 'TypeSelector':
                    // TODO: remove toLowerCase when type selectors will be normalized
                    // ignore universal selectors
                    if (node.name.charAt(node.name.length - 1) !== '*') {
                        if (usageData.whitelist !== null && usageData.whitelist.tags !== null && !$222f0604500ed718$var$hasOwnProperty.call(usageData.whitelist.tags, node.name.toLowerCase())) shouldRemove = true;
                        if (usageData.blacklist !== null && usageData.blacklist.tags !== null && $222f0604500ed718$var$hasOwnProperty.call(usageData.blacklist.tags, node.name.toLowerCase())) shouldRemove = true;
                    }
                    break;
            }
        });
        if (shouldRemove) list.remove(item);
    });
    return selectorList.children.isEmpty;
}
function $222f0604500ed718$var$cleanRule(node, item, list, options) {
    if ($117894f0e2b5e437$export$4ae8c0b0b49712f0(node.prelude) || $117894f0e2b5e437$export$4ae8c0b0b49712f0(node.block)) {
        list.remove(item);
        return;
    }
    // avoid usage filtering for some at-rules
    if (this.atrule && $222f0604500ed718$var$skipUsageFilteringAtrule.has($4e097574aea5443c$export$2e81050496d0e63e(this.atrule.name).basename)) return;
    const { usage: usage } = options;
    if (usage && (usage.whitelist !== null || usage.blacklist !== null)) {
        $222f0604500ed718$var$cleanUnused(node.prelude, usage);
        if ($117894f0e2b5e437$export$4ae8c0b0b49712f0(node.prelude)) {
            list.remove(item);
            return;
        }
    }
}
$222f0604500ed718$exports = $222f0604500ed718$var$cleanRule;


var $767031e0d14c0fe2$exports = {};
'use strict';
// remove useless universal selector
function $767031e0d14c0fe2$var$cleanTypeSelector(node, item, list) {
    const name = item.data.name;
    // check it's a non-namespaced universal selector
    if (name !== '*') return;
    // remove when universal selector before other selectors
    const nextType = item.next && item.next.data.type;
    if (nextType === 'IdSelector' || nextType === 'ClassSelector' || nextType === 'AttributeSelector' || nextType === 'PseudoClassSelector' || nextType === 'PseudoElementSelector') list.remove(item);
}
$767031e0d14c0fe2$exports = $767031e0d14c0fe2$var$cleanTypeSelector;


var $89187fa5d5ab149e$exports = {};
'use strict';
function $89187fa5d5ab149e$var$cleanWhitespace(node, item, list) {
    list.remove(item);
}
$89187fa5d5ab149e$exports = $89187fa5d5ab149e$var$cleanWhitespace;


const $87789b0a5349c046$var$handlers = {
    Atrule: $c6f4617b4968dcf5$exports,
    Comment: $e22bb75491c51f9c$exports,
    Declaration: $526f7214bbe67358$exports,
    Raw: $8027a063a356490e$exports,
    Rule: $222f0604500ed718$exports,
    TypeSelector: $767031e0d14c0fe2$exports,
    WhiteSpace: $89187fa5d5ab149e$exports
};
function $87789b0a5349c046$var$clean(ast, options) {
    $4e097574aea5443c$export$588732934346abbf(ast, {
        leave (node, item, list) {
            if ($87789b0a5349c046$var$handlers.hasOwnProperty(node.type)) $87789b0a5349c046$var$handlers[node.type].call(this, node, item, list, options);
        }
    });
}
$87789b0a5349c046$exports = $87789b0a5349c046$var$clean;


var $5287e7e5721db4ab$exports = {};
'use strict';

var $bc207cdb7e35f529$exports = {};
'use strict';

var $ffece248fb119dce$exports = {};
'use strict';
function $ffece248fb119dce$var$compressKeyframes(node) {
    node.block.children.forEach((rule)=>{
        rule.prelude.children.forEach((simpleselector)=>{
            simpleselector.children.forEach((data, item)=>{
                if (data.type === 'Percentage' && data.value === '100') item.data = {
                    type: 'TypeSelector',
                    loc: data.loc,
                    name: 'to'
                };
                else if (data.type === 'TypeSelector' && data.name === 'from') item.data = {
                    type: 'Percentage',
                    loc: data.loc,
                    value: '0'
                };
            });
        });
    });
}
$ffece248fb119dce$exports = $ffece248fb119dce$var$compressKeyframes;


function $bc207cdb7e35f529$var$Atrule(node) {
    // compress @keyframe selectors
    if ($4e097574aea5443c$export$2e81050496d0e63e(node.name).basename === 'keyframes') $ffece248fb119dce$exports(node);
}
$bc207cdb7e35f529$exports = $bc207cdb7e35f529$var$Atrule;


var $cc1de1c0b574eaf7$exports = {};
'use strict';
// Can unquote attribute detection
// Adopted implementation of Mathias Bynens
// https://github.com/mathiasbynens/mothereff.in/blob/master/unquoted-attributes/eff.js
const $cc1de1c0b574eaf7$var$blockUnquoteRx = /^(-?\d|--)|[\u0000-\u002c\u002e\u002f\u003A-\u0040\u005B-\u005E\u0060\u007B-\u009f]/;
function $cc1de1c0b574eaf7$var$canUnquote(value) {
    if (value === '' || value === '-') return false;
    return !$cc1de1c0b574eaf7$var$blockUnquoteRx.test(value);
}
function $cc1de1c0b574eaf7$var$AttributeSelector(node) {
    const attrValue = node.value;
    if (!attrValue || attrValue.type !== 'String') return;
    if ($cc1de1c0b574eaf7$var$canUnquote(attrValue.value)) node.value = {
        type: 'Identifier',
        loc: attrValue.loc,
        name: attrValue.value
    };
}
$cc1de1c0b574eaf7$exports = $cc1de1c0b574eaf7$var$AttributeSelector;


var $29beb5a03b9ab6e4$exports = {};
'use strict';

var $0725172b834e32e4$exports = {};
'use strict';
function $0725172b834e32e4$var$compressFont(node) {
    const list = node.children;
    list.forEachRight(function(node, item) {
        if (node.type === 'Identifier') {
            if (node.name === 'bold') item.data = {
                type: 'Number',
                loc: node.loc,
                value: '700'
            };
            else if (node.name === 'normal') {
                const prev = item.prev;
                if (prev && prev.data.type === 'Operator' && prev.data.value === '/') this.remove(prev);
                this.remove(item);
            }
        }
    });
    if (list.isEmpty) list.insert(list.createItem({
        type: 'Identifier',
        name: 'normal'
    }));
}
$0725172b834e32e4$exports = $0725172b834e32e4$var$compressFont;


var $d74844a41267eb99$exports = {};
'use strict';
function $d74844a41267eb99$var$compressFontWeight(node) {
    const value = node.children.head.data;
    if (value.type === 'Identifier') switch(value.name){
        case 'normal':
            node.children.head.data = {
                type: 'Number',
                loc: value.loc,
                value: '400'
            };
            break;
        case 'bold':
            node.children.head.data = {
                type: 'Number',
                loc: value.loc,
                value: '700'
            };
            break;
    }
}
$d74844a41267eb99$exports = $d74844a41267eb99$var$compressFontWeight;


var $a9efc6ef93309b27$exports = {};
'use strict';

function $a9efc6ef93309b27$var$compressBackground(node) {
    function flush() {
        if (!buffer.length) buffer.unshift({
            type: 'Number',
            loc: null,
            value: '0'
        }, {
            type: 'Number',
            loc: null,
            value: '0'
        });
        newValue.push.apply(newValue, buffer);
        buffer = [];
    }
    let newValue = [];
    let buffer = [];
    node.children.forEach((node)=>{
        if (node.type === 'Operator' && node.value === ',') {
            flush();
            newValue.push(node);
            return;
        }
        // remove defaults
        if (node.type === 'Identifier') {
            if (node.name === 'transparent' || node.name === 'none' || node.name === 'repeat' || node.name === 'scroll') return;
        }
        buffer.push(node);
    });
    flush();
    node.children = new $4e097574aea5443c$export$54c2e3dc7acea9f5().fromArray(newValue);
}
$a9efc6ef93309b27$exports = $a9efc6ef93309b27$var$compressBackground;


var $c8d70435e4ff8234$exports = {};
'use strict';
function $c8d70435e4ff8234$var$compressBorder(node) {
    node.children.forEach((node, item, list)=>{
        if (node.type === 'Identifier' && node.name.toLowerCase() === 'none') {
            if (list.head === list.tail) // replace `none` for zero when `none` is a single term
            item.data = {
                type: 'Number',
                loc: node.loc,
                value: '0'
            };
            else list.remove(item);
        }
    });
}
$c8d70435e4ff8234$exports = $c8d70435e4ff8234$var$compressBorder;


const $29beb5a03b9ab6e4$var$handlers = {
    'font': $0725172b834e32e4$exports,
    'font-weight': $d74844a41267eb99$exports,
    'background': $a9efc6ef93309b27$exports,
    'border': $c8d70435e4ff8234$exports,
    'outline': $c8d70435e4ff8234$exports
};
function $29beb5a03b9ab6e4$var$compressValue(node) {
    if (!this.declaration) return;
    const property = $4e097574aea5443c$export$d541bacb2bda4494(this.declaration.property);
    if ($29beb5a03b9ab6e4$var$handlers.hasOwnProperty(property.basename)) $29beb5a03b9ab6e4$var$handlers[property.basename](node);
}
$29beb5a03b9ab6e4$exports = $29beb5a03b9ab6e4$var$compressValue;


var $41798b87b775c9f9$exports = {};
'use strict';
var $8a92120bf1b50153$export$fffa67e515d04022;
var $8a92120bf1b50153$export$ac6f31934831a099;
'use strict';
const $8a92120bf1b50153$var$OMIT_PLUSSIGN = /^(?:\+|(-))?0*(\d*)(?:\.0*|(\.\d*?)0*)?$/;
const $8a92120bf1b50153$var$KEEP_PLUSSIGN = /^([\+\-])?0*(\d*)(?:\.0*|(\.\d*?)0*)?$/;
const $8a92120bf1b50153$var$unsafeToRemovePlusSignAfter = new Set([
    'Dimension',
    'Hash',
    'Identifier',
    'Number',
    'Raw',
    'UnicodeRange'
]);
function $8a92120bf1b50153$var$packNumber(value, item) {
    // omit plus sign only if no prev or prev is safe type
    const regexp = item && item.prev !== null && $8a92120bf1b50153$var$unsafeToRemovePlusSignAfter.has(item.prev.data.type) ? $8a92120bf1b50153$var$KEEP_PLUSSIGN : $8a92120bf1b50153$var$OMIT_PLUSSIGN;
    // 100 -> '100'
    // 00100 -> '100'
    // +100 -> '100'
    // -100 -> '-100'
    // 0.123 -> '.123'
    // 0.12300 -> '.123'
    // 0.0 -> ''
    // 0 -> ''
    // -0 -> '-'
    value = String(value).replace(regexp, '$1$2$3');
    if (value === '' || value === '-') value = '0';
    // FIXME: is it solution simplier?
    // value = String(Number(value)).replace(/^(-?)0+\./, '$1.');
    return value;
}
function $8a92120bf1b50153$var$Number(node) {
    node.value = $8a92120bf1b50153$var$packNumber(node.value);
}
$8a92120bf1b50153$export$fffa67e515d04022 = $8a92120bf1b50153$var$Number;
$8a92120bf1b50153$export$ac6f31934831a099 = $8a92120bf1b50153$var$packNumber;


const $41798b87b775c9f9$var$MATH_FUNCTIONS = new Set([
    'calc',
    'min',
    'max',
    'clamp'
]);
const $41798b87b775c9f9$var$LENGTH_UNIT = new Set([
    // absolute length units
    'px',
    'mm',
    'cm',
    'in',
    'pt',
    'pc',
    // relative length units
    'em',
    'ex',
    'ch',
    'rem',
    // viewport-percentage lengths
    'vh',
    'vw',
    'vmin',
    'vmax',
    'vm'
]);
function $41798b87b775c9f9$var$compressDimension(node, item) {
    const value = $8a92120bf1b50153$export$ac6f31934831a099(node.value);
    node.value = value;
    if (value === '0' && this.declaration !== null && this.atrulePrelude === null) {
        const unit = node.unit.toLowerCase();
        // only length values can be compressed
        if (!$41798b87b775c9f9$var$LENGTH_UNIT.has(unit)) return;
        // issue #362: shouldn't remove unit in -ms-flex since it breaks flex in IE10/11
        // issue #200: shouldn't remove unit in flex since it breaks flex in IE10/11
        if (this.declaration.property === '-ms-flex' || this.declaration.property === 'flex') return;
        // issue #222: don't remove units inside calc
        if (this.function && $41798b87b775c9f9$var$MATH_FUNCTIONS.has(this.function.name)) return;
        item.data = {
            type: 'Number',
            loc: node.loc,
            value: value
        };
    }
}
$41798b87b775c9f9$exports = $41798b87b775c9f9$var$compressDimension;


var $a79dca12055c965d$exports = {};
'use strict';


const $a79dca12055c965d$var$blacklist = new Set([
    // see https://github.com/jakubpawlowicz/clean-css/issues/957
    'width',
    'min-width',
    'max-width',
    'height',
    'min-height',
    'max-height',
    // issue #410: Don’t remove units in flex-basis value for (-ms-)flex shorthand
    // issue #362: shouldn't remove unit in -ms-flex since it breaks flex in IE10/11
    // issue #200: shouldn't remove unit in flex since it breaks flex in IE10/11
    'flex',
    '-ms-flex'
]);
function $a79dca12055c965d$var$compressPercentage(node, item) {
    node.value = $8a92120bf1b50153$export$ac6f31934831a099(node.value);
    if (node.value === '0' && this.declaration && !$a79dca12055c965d$var$blacklist.has(this.declaration.property)) {
        // try to convert a number
        item.data = {
            type: 'Number',
            loc: node.loc,
            value: node.value
        };
        // that's ok only when new value matches on length
        if (!$4e097574aea5443c$export$43feed32102720d2.matchDeclaration(this.declaration).isType(item.data, 'length')) // otherwise rollback changes
        item.data = node;
    }
}
$a79dca12055c965d$exports = $a79dca12055c965d$var$compressPercentage;



var $d8527136bcd1201e$exports = {};
'use strict';
function $d8527136bcd1201e$var$Url(node) {
    // convert `\\` to `/`
    node.value = node.value.replace(/\\/g, '/');
}
$d8527136bcd1201e$exports = $d8527136bcd1201e$var$Url;


var $48d9ee6aa92297be$export$ee70891f659cb665;
var $48d9ee6aa92297be$export$d070e3da4f1ec57e;
var $48d9ee6aa92297be$export$dd6ac38a204d62ea;
'use strict';


// http://www.w3.org/TR/css3-color/#svg-color
const $48d9ee6aa92297be$var$NAME_TO_HEX = {
    'aliceblue': 'f0f8ff',
    'antiquewhite': 'faebd7',
    'aqua': '0ff',
    'aquamarine': '7fffd4',
    'azure': 'f0ffff',
    'beige': 'f5f5dc',
    'bisque': 'ffe4c4',
    'black': '000',
    'blanchedalmond': 'ffebcd',
    'blue': '00f',
    'blueviolet': '8a2be2',
    'brown': 'a52a2a',
    'burlywood': 'deb887',
    'cadetblue': '5f9ea0',
    'chartreuse': '7fff00',
    'chocolate': 'd2691e',
    'coral': 'ff7f50',
    'cornflowerblue': '6495ed',
    'cornsilk': 'fff8dc',
    'crimson': 'dc143c',
    'cyan': '0ff',
    'darkblue': '00008b',
    'darkcyan': '008b8b',
    'darkgoldenrod': 'b8860b',
    'darkgray': 'a9a9a9',
    'darkgrey': 'a9a9a9',
    'darkgreen': '006400',
    'darkkhaki': 'bdb76b',
    'darkmagenta': '8b008b',
    'darkolivegreen': '556b2f',
    'darkorange': 'ff8c00',
    'darkorchid': '9932cc',
    'darkred': '8b0000',
    'darksalmon': 'e9967a',
    'darkseagreen': '8fbc8f',
    'darkslateblue': '483d8b',
    'darkslategray': '2f4f4f',
    'darkslategrey': '2f4f4f',
    'darkturquoise': '00ced1',
    'darkviolet': '9400d3',
    'deeppink': 'ff1493',
    'deepskyblue': '00bfff',
    'dimgray': '696969',
    'dimgrey': '696969',
    'dodgerblue': '1e90ff',
    'firebrick': 'b22222',
    'floralwhite': 'fffaf0',
    'forestgreen': '228b22',
    'fuchsia': 'f0f',
    'gainsboro': 'dcdcdc',
    'ghostwhite': 'f8f8ff',
    'gold': 'ffd700',
    'goldenrod': 'daa520',
    'gray': '808080',
    'grey': '808080',
    'green': '008000',
    'greenyellow': 'adff2f',
    'honeydew': 'f0fff0',
    'hotpink': 'ff69b4',
    'indianred': 'cd5c5c',
    'indigo': '4b0082',
    'ivory': 'fffff0',
    'khaki': 'f0e68c',
    'lavender': 'e6e6fa',
    'lavenderblush': 'fff0f5',
    'lawngreen': '7cfc00',
    'lemonchiffon': 'fffacd',
    'lightblue': 'add8e6',
    'lightcoral': 'f08080',
    'lightcyan': 'e0ffff',
    'lightgoldenrodyellow': 'fafad2',
    'lightgray': 'd3d3d3',
    'lightgrey': 'd3d3d3',
    'lightgreen': '90ee90',
    'lightpink': 'ffb6c1',
    'lightsalmon': 'ffa07a',
    'lightseagreen': '20b2aa',
    'lightskyblue': '87cefa',
    'lightslategray': '789',
    'lightslategrey': '789',
    'lightsteelblue': 'b0c4de',
    'lightyellow': 'ffffe0',
    'lime': '0f0',
    'limegreen': '32cd32',
    'linen': 'faf0e6',
    'magenta': 'f0f',
    'maroon': '800000',
    'mediumaquamarine': '66cdaa',
    'mediumblue': '0000cd',
    'mediumorchid': 'ba55d3',
    'mediumpurple': '9370db',
    'mediumseagreen': '3cb371',
    'mediumslateblue': '7b68ee',
    'mediumspringgreen': '00fa9a',
    'mediumturquoise': '48d1cc',
    'mediumvioletred': 'c71585',
    'midnightblue': '191970',
    'mintcream': 'f5fffa',
    'mistyrose': 'ffe4e1',
    'moccasin': 'ffe4b5',
    'navajowhite': 'ffdead',
    'navy': '000080',
    'oldlace': 'fdf5e6',
    'olive': '808000',
    'olivedrab': '6b8e23',
    'orange': 'ffa500',
    'orangered': 'ff4500',
    'orchid': 'da70d6',
    'palegoldenrod': 'eee8aa',
    'palegreen': '98fb98',
    'paleturquoise': 'afeeee',
    'palevioletred': 'db7093',
    'papayawhip': 'ffefd5',
    'peachpuff': 'ffdab9',
    'peru': 'cd853f',
    'pink': 'ffc0cb',
    'plum': 'dda0dd',
    'powderblue': 'b0e0e6',
    'purple': '800080',
    'rebeccapurple': '639',
    'red': 'f00',
    'rosybrown': 'bc8f8f',
    'royalblue': '4169e1',
    'saddlebrown': '8b4513',
    'salmon': 'fa8072',
    'sandybrown': 'f4a460',
    'seagreen': '2e8b57',
    'seashell': 'fff5ee',
    'sienna': 'a0522d',
    'silver': 'c0c0c0',
    'skyblue': '87ceeb',
    'slateblue': '6a5acd',
    'slategray': '708090',
    'slategrey': '708090',
    'snow': 'fffafa',
    'springgreen': '00ff7f',
    'steelblue': '4682b4',
    'tan': 'd2b48c',
    'teal': '008080',
    'thistle': 'd8bfd8',
    'tomato': 'ff6347',
    'turquoise': '40e0d0',
    'violet': 'ee82ee',
    'wheat': 'f5deb3',
    'white': 'fff',
    'whitesmoke': 'f5f5f5',
    'yellow': 'ff0',
    'yellowgreen': '9acd32'
};
const $48d9ee6aa92297be$var$HEX_TO_NAME = {
    '800000': 'maroon',
    '800080': 'purple',
    '808000': 'olive',
    '808080': 'gray',
    '00ffff': 'cyan',
    'f0ffff': 'azure',
    'f5f5dc': 'beige',
    'ffe4c4': 'bisque',
    '000000': 'black',
    '0000ff': 'blue',
    'a52a2a': 'brown',
    'ff7f50': 'coral',
    'ffd700': 'gold',
    '008000': 'green',
    '4b0082': 'indigo',
    'fffff0': 'ivory',
    'f0e68c': 'khaki',
    '00ff00': 'lime',
    'faf0e6': 'linen',
    '000080': 'navy',
    'ffa500': 'orange',
    'da70d6': 'orchid',
    'cd853f': 'peru',
    'ffc0cb': 'pink',
    'dda0dd': 'plum',
    'f00': 'red',
    'ff0000': 'red',
    'fa8072': 'salmon',
    'a0522d': 'sienna',
    'c0c0c0': 'silver',
    'fffafa': 'snow',
    'd2b48c': 'tan',
    '008080': 'teal',
    'ff6347': 'tomato',
    'ee82ee': 'violet',
    'f5deb3': 'wheat',
    'ffffff': 'white',
    'ffff00': 'yellow'
};
function $48d9ee6aa92297be$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $48d9ee6aa92297be$var$hslToRgb(h, s, l, a) {
    let r;
    let g;
    let b;
    if (s === 0) r = g = b = l; // achromatic
    else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = $48d9ee6aa92297be$var$hueToRgb(p, q, h + 1 / 3);
        g = $48d9ee6aa92297be$var$hueToRgb(p, q, h);
        b = $48d9ee6aa92297be$var$hueToRgb(p, q, h - 1 / 3);
    }
    return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255),
        a
    ];
}
function $48d9ee6aa92297be$var$toHex(value) {
    value = value.toString(16);
    return value.length === 1 ? '0' + value : value;
}
function $48d9ee6aa92297be$var$parseFunctionArgs(functionArgs, count, rgb) {
    let cursor = functionArgs.head;
    let args = [];
    let wasValue = false;
    while(cursor !== null){
        const { type: type, value: value } = cursor.data;
        switch(type){
            case 'Number':
            case 'Percentage':
                if (wasValue) return;
                wasValue = true;
                args.push({
                    type: type,
                    value: Number(value)
                });
                break;
            case 'Operator':
                if (value === ',') {
                    if (!wasValue) return;
                    wasValue = false;
                } else if (wasValue || value !== '+') return;
                break;
            default:
                // something we couldn't understand
                return;
        }
        cursor = cursor.next;
    }
    if (args.length !== count) // invalid arguments count
    // TODO: remove those tokens
    return;
    if (args.length === 4) {
        if (args[3].type !== 'Number') // 4th argument should be a number
        // TODO: remove those tokens
        return;
        args[3].type = 'Alpha';
    }
    if (rgb) {
        if (args[0].type !== args[1].type || args[0].type !== args[2].type) // invalid color, numbers and percentage shouldn't be mixed
        // TODO: remove those tokens
        return;
    } else {
        if (args[0].type !== 'Number' || args[1].type !== 'Percentage' || args[2].type !== 'Percentage') // invalid color, for hsl values should be: number, percentage, percentage
        // TODO: remove those tokens
        return;
        args[0].type = 'Angle';
    }
    return args.map(function(arg) {
        let value = Math.max(0, arg.value);
        switch(arg.type){
            case 'Number':
                // fit value to [0..255] range
                value = Math.min(value, 255);
                break;
            case 'Percentage':
                // convert 0..100% to value in [0..255] range
                value = Math.min(value, 100) / 100;
                if (!rgb) return value;
                value = 255 * value;
                break;
            case 'Angle':
                // fit value to (-360..360) range
                return (value % 360 + 360) % 360 / 360;
            case 'Alpha':
                // fit value to [0..1] range
                return Math.min(value, 1);
        }
        return Math.round(value);
    });
}
function $48d9ee6aa92297be$var$compressFunction(node, item) {
    let functionName = node.name;
    let args;
    if (functionName === 'rgba' || functionName === 'hsla') {
        args = $48d9ee6aa92297be$var$parseFunctionArgs(node.children, 4, functionName === 'rgba');
        if (!args) // something went wrong
        return;
        if (functionName === 'hsla') {
            args = $48d9ee6aa92297be$var$hslToRgb(...args);
            node.name = 'rgba';
        }
        if (args[3] === 0) {
            // try to replace `rgba(x, x, x, 0)` to `transparent`
            // always replace `rgba(0, 0, 0, 0)` to `transparent`
            // otherwise avoid replacement in gradients since it may break color transition
            // http://stackoverflow.com/questions/11829410/css3-gradient-rendering-issues-from-transparent-to-white
            const scopeFunctionName = this.function && this.function.name;
            if (args[0] === 0 && args[1] === 0 && args[2] === 0 || !/^(?:to|from|color-stop)$|gradient$/i.test(scopeFunctionName)) {
                item.data = {
                    type: 'Identifier',
                    loc: node.loc,
                    name: 'transparent'
                };
                return;
            }
        }
        if (args[3] !== 1) {
            // replace argument values for normalized/interpolated
            node.children.forEach((node, item, list)=>{
                if (node.type === 'Operator') {
                    if (node.value !== ',') list.remove(item);
                    return;
                }
                item.data = {
                    type: 'Number',
                    loc: node.loc,
                    value: $8a92120bf1b50153$export$ac6f31934831a099(args.shift())
                };
            });
            return;
        }
        // otherwise convert to rgb, i.e. rgba(255, 0, 0, 1) -> rgb(255, 0, 0)
        functionName = 'rgb';
    }
    if (functionName === 'hsl') {
        args = args || $48d9ee6aa92297be$var$parseFunctionArgs(node.children, 3, false);
        if (!args) // something went wrong
        return;
        // convert to rgb
        args = $48d9ee6aa92297be$var$hslToRgb(...args);
        functionName = 'rgb';
    }
    if (functionName === 'rgb') {
        args = args || $48d9ee6aa92297be$var$parseFunctionArgs(node.children, 3, true);
        if (!args) // something went wrong
        return;
        item.data = {
            type: 'Hash',
            loc: node.loc,
            value: $48d9ee6aa92297be$var$toHex(args[0]) + $48d9ee6aa92297be$var$toHex(args[1]) + $48d9ee6aa92297be$var$toHex(args[2])
        };
        $48d9ee6aa92297be$var$compressHex(item.data, item);
    }
}
function $48d9ee6aa92297be$var$compressIdent(node, item) {
    if (this.declaration === null) return;
    let color = node.name.toLowerCase();
    if ($48d9ee6aa92297be$var$NAME_TO_HEX.hasOwnProperty(color) && $4e097574aea5443c$export$43feed32102720d2.matchDeclaration(this.declaration).isType(node, 'color')) {
        const hex = $48d9ee6aa92297be$var$NAME_TO_HEX[color];
        if (hex.length + 1 <= color.length) // replace for shorter hex value
        item.data = {
            type: 'Hash',
            loc: node.loc,
            value: hex
        };
        else {
            // special case for consistent colors
            if (color === 'grey') color = 'gray';
            // just replace value for lower cased name
            node.name = color;
        }
    }
}
function $48d9ee6aa92297be$var$compressHex(node, item) {
    let color = node.value.toLowerCase();
    // #112233 -> #123
    if (color.length === 6 && color[0] === color[1] && color[2] === color[3] && color[4] === color[5]) color = color[0] + color[2] + color[4];
    if ($48d9ee6aa92297be$var$HEX_TO_NAME[color]) item.data = {
        type: 'Identifier',
        loc: node.loc,
        name: $48d9ee6aa92297be$var$HEX_TO_NAME[color]
    };
    else node.value = color;
}
$48d9ee6aa92297be$export$ee70891f659cb665 = $48d9ee6aa92297be$var$compressFunction;
$48d9ee6aa92297be$export$d070e3da4f1ec57e = $48d9ee6aa92297be$var$compressHex;
$48d9ee6aa92297be$export$dd6ac38a204d62ea = $48d9ee6aa92297be$var$compressIdent;


const $5287e7e5721db4ab$var$handlers = {
    Atrule: $bc207cdb7e35f529$exports,
    AttributeSelector: $cc1de1c0b574eaf7$exports,
    Value: $29beb5a03b9ab6e4$exports,
    Dimension: $41798b87b775c9f9$exports,
    Percentage: $a79dca12055c965d$exports,
    Number: $8a92120bf1b50153$export$fffa67e515d04022,
    Url: $d8527136bcd1201e$exports,
    Hash: $48d9ee6aa92297be$export$d070e3da4f1ec57e,
    Identifier: $48d9ee6aa92297be$export$dd6ac38a204d62ea,
    Function: $48d9ee6aa92297be$export$ee70891f659cb665
};
function $5287e7e5721db4ab$var$replace(ast) {
    $4e097574aea5443c$export$588732934346abbf(ast, {
        leave (node, item, list) {
            if ($5287e7e5721db4ab$var$handlers.hasOwnProperty(node.type)) $5287e7e5721db4ab$var$handlers[node.type].call(this, node, item, list);
        }
    });
}
$5287e7e5721db4ab$exports = $5287e7e5721db4ab$var$replace;


var $ec0a7c2781f1af39$exports = {};
'use strict';
var $810880b1b3b1dc96$exports = {};
'use strict';

var $e20748dc00cc710c$exports = {};
'use strict';

class $e20748dc00cc710c$var$Index {
    resolve(str) {
        let index = this.map.get(str);
        if (index === undefined) {
            index = this.map.size + 1;
            this.map.set(str, index);
        }
        return index;
    }
    constructor(){
        this.map = new Map();
    }
}
function $e20748dc00cc710c$var$createDeclarationIndexer() {
    const ids = new $e20748dc00cc710c$var$Index();
    return function markDeclaration(node) {
        const id = $4e097574aea5443c$export$80d376111cc09ad7(node);
        node.id = ids.resolve(id);
        node.length = id.length;
        node.fingerprint = null;
        return node;
    };
}
$e20748dc00cc710c$exports = $e20748dc00cc710c$var$createDeclarationIndexer;


var $7385ea7e14135d6f$exports = {};
'use strict';

var $949975549d611fa5$exports = {};
'use strict';

function $949975549d611fa5$var$ensureSelectorList(node) {
    if (node.type === 'Raw') return $4e097574aea5443c$export$98e6a39c04603d36(node.value, {
        context: 'selectorList'
    });
    return node;
}
function $949975549d611fa5$var$maxSpecificity(a, b) {
    for(let i = 0; i < 3; i++){
        if (a[i] !== b[i]) return a[i] > b[i] ? a : b;
    }
    return a;
}
function $949975549d611fa5$var$maxSelectorListSpecificity(selectorList) {
    return $949975549d611fa5$var$ensureSelectorList(selectorList).children.reduce((result, node)=>$949975549d611fa5$var$maxSpecificity($949975549d611fa5$var$specificity(node), result), [
        0,
        0,
        0
    ]);
}
// §16. Calculating a selector’s specificity
// https://www.w3.org/TR/selectors-4/#specificity-rules
function $949975549d611fa5$var$specificity(simpleSelector) {
    let A = 0;
    let B = 0;
    let C = 0;
    // A selector’s specificity is calculated for a given element as follows:
    simpleSelector.children.forEach((node)=>{
        switch(node.type){
            // count the number of ID selectors in the selector (= A)
            case 'IdSelector':
                A++;
                break;
            // count the number of class selectors, attributes selectors, ...
            case 'ClassSelector':
            case 'AttributeSelector':
                B++;
                break;
            // ... and pseudo-classes in the selector (= B)
            case 'PseudoClassSelector':
                switch(node.name.toLowerCase()){
                    // The specificity of an :is(), :not(), or :has() pseudo-class is replaced
                    // by the specificity of the most specific complex selector in its selector list argument.
                    case 'not':
                    case 'has':
                    case 'is':
                    // :matches() is used before it was renamed to :is()
                    // https://github.com/w3c/csswg-drafts/issues/3258
                    case 'matches':
                    // Older browsers support :is() functionality as prefixed pseudo-class :any()
                    // https://developer.mozilla.org/en-US/docs/Web/CSS/:is
                    case '-webkit-any':
                    case '-moz-any':
                        {
                            const [a, b, c] = $949975549d611fa5$var$maxSelectorListSpecificity(node.children.first);
                            A += a;
                            B += b;
                            C += c;
                            break;
                        }
                    // Analogously, the specificity of an :nth-child() or :nth-last-child() selector
                    // is the specificity of the pseudo class itself (counting as one pseudo-class selector)
                    // plus the specificity of the most specific complex selector in its selector list argument (if any).
                    case 'nth-child':
                    case 'nth-last-child':
                        {
                            const arg = node.children.first;
                            if (arg.type === 'Nth' && arg.selector) {
                                const [a, b, c] = $949975549d611fa5$var$maxSelectorListSpecificity(arg.selector);
                                A += a;
                                B += b + 1;
                                C += c;
                            } else B++;
                            break;
                        }
                    // The specificity of a :where() pseudo-class is replaced by zero.
                    case 'where':
                        break;
                    // The four Level 2 pseudo-elements (::before, ::after, ::first-line, and ::first-letter) may,
                    // for legacy reasons, be represented using the <pseudo-class-selector> grammar,
                    // with only a single ":" character at their start.
                    // https://www.w3.org/TR/selectors-4/#single-colon-pseudos
                    case 'before':
                    case 'after':
                    case 'first-line':
                    case 'first-letter':
                        C++;
                        break;
                    default:
                        B++;
                }
                break;
            // count the number of type selectors ...
            case 'TypeSelector':
                // ignore the universal selector
                if (!node.name.endsWith('*')) C++;
                break;
            // ... and pseudo-elements in the selector (= C)
            case 'PseudoElementSelector':
                C++;
                break;
        }
    });
    return [
        A,
        B,
        C
    ];
}
$949975549d611fa5$exports = $949975549d611fa5$var$specificity;


const $7385ea7e14135d6f$var$nonFreezePseudoElements = new Set([
    'first-letter',
    'first-line',
    'after',
    'before'
]);
const $7385ea7e14135d6f$var$nonFreezePseudoClasses = new Set([
    'link',
    'visited',
    'hover',
    'active',
    'first-letter',
    'first-line',
    'after',
    'before'
]);
function $7385ea7e14135d6f$var$processSelector(node, usageData) {
    const pseudos = new Set();
    node.prelude.children.forEach(function(simpleSelector) {
        let tagName = '*';
        let scope = 0;
        simpleSelector.children.forEach(function(node) {
            switch(node.type){
                case 'ClassSelector':
                    if (usageData && usageData.scopes) {
                        const classScope = usageData.scopes[node.name] || 0;
                        if (scope !== 0 && classScope !== scope) throw new Error('Selector can\'t has classes from different scopes: ' + $4e097574aea5443c$export$80d376111cc09ad7(simpleSelector));
                        scope = classScope;
                    }
                    break;
                case 'PseudoClassSelector':
                    {
                        const name = node.name.toLowerCase();
                        if (!$7385ea7e14135d6f$var$nonFreezePseudoClasses.has(name)) pseudos.add(`:${name}`);
                        break;
                    }
                case 'PseudoElementSelector':
                    {
                        const name = node.name.toLowerCase();
                        if (!$7385ea7e14135d6f$var$nonFreezePseudoElements.has(name)) pseudos.add(`::${name}`);
                        break;
                    }
                case 'TypeSelector':
                    tagName = node.name.toLowerCase();
                    break;
                case 'AttributeSelector':
                    if (node.flags) pseudos.add(`[${node.flags.toLowerCase()}]`);
                    break;
                case 'Combinator':
                    tagName = '*';
                    break;
            }
        });
        simpleSelector.compareMarker = $949975549d611fa5$exports(simpleSelector).toString();
        simpleSelector.id = null; // pre-init property to avoid multiple hidden class
        simpleSelector.id = $4e097574aea5443c$export$80d376111cc09ad7(simpleSelector);
        if (scope) simpleSelector.compareMarker += ':' + scope;
        if (tagName !== '*') simpleSelector.compareMarker += ',' + tagName;
    });
    // add property to all rule nodes to avoid multiple hidden class
    node.pseudoSignature = pseudos.size > 0 ? [
        ...pseudos
    ].sort().join(',') : false;
}
$7385ea7e14135d6f$exports = $7385ea7e14135d6f$var$processSelector;


function $810880b1b3b1dc96$var$prepare(ast, options) {
    const markDeclaration = $e20748dc00cc710c$exports();
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Rule',
        enter (node) {
            node.block.children.forEach(markDeclaration);
            $7385ea7e14135d6f$exports(node, options.usage);
        }
    });
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Atrule',
        enter (node) {
            if (node.prelude) {
                node.prelude.id = null; // pre-init property to avoid multiple hidden class for generate
                node.prelude.id = $4e097574aea5443c$export$80d376111cc09ad7(node.prelude);
            }
            // compare keyframe selectors by its values
            // NOTE: still no clarification about problems with keyframes selector grouping (issue #197)
            if ($4e097574aea5443c$export$2e81050496d0e63e(node.name).basename === 'keyframes') {
                node.block.avoidRulesMerge = true; /* probably we don't need to prevent those merges for @keyframes
                                                       TODO: need to be checked */ 
                node.block.children.forEach(function(rule) {
                    rule.prelude.children.forEach(function(simpleselector) {
                        simpleselector.compareMarker = simpleselector.id;
                    });
                });
            }
        }
    });
    return {
        declaration: markDeclaration
    };
}
$810880b1b3b1dc96$exports = $810880b1b3b1dc96$var$prepare;


var $a437f30fe88af420$exports = {};
'use strict';

const { hasOwnProperty: $a437f30fe88af420$var$hasOwnProperty } = Object.prototype;
function $a437f30fe88af420$var$addRuleToMap(map, item, list, single) {
    const node = item.data;
    const name = $4e097574aea5443c$export$2e81050496d0e63e(node.name).basename;
    const id = node.name.toLowerCase() + '/' + (node.prelude ? node.prelude.id : null);
    if (!$a437f30fe88af420$var$hasOwnProperty.call(map, name)) map[name] = Object.create(null);
    if (single) delete map[name][id];
    if (!$a437f30fe88af420$var$hasOwnProperty.call(map[name], id)) map[name][id] = new $4e097574aea5443c$export$54c2e3dc7acea9f5();
    map[name][id].append(list.remove(item));
}
function $a437f30fe88af420$var$relocateAtrules(ast, options) {
    const collected = Object.create(null);
    let topInjectPoint = null;
    ast.children.forEach(function(node, item, list) {
        if (node.type === 'Atrule') {
            const name = $4e097574aea5443c$export$2e81050496d0e63e(node.name).basename;
            switch(name){
                case 'keyframes':
                    $a437f30fe88af420$var$addRuleToMap(collected, item, list, true);
                    return;
                case 'media':
                    if (options.forceMediaMerge) {
                        $a437f30fe88af420$var$addRuleToMap(collected, item, list, false);
                        return;
                    }
                    break;
            }
            if (topInjectPoint === null && name !== 'charset' && name !== 'import') topInjectPoint = item;
        } else if (topInjectPoint === null) topInjectPoint = item;
    });
    for(const atrule in collected)for(const id in collected[atrule])ast.children.insertList(collected[atrule][id], atrule === 'media' ? null : topInjectPoint);
}
function $a437f30fe88af420$var$isMediaRule(node) {
    return node.type === 'Atrule' && node.name === 'media';
}
function $a437f30fe88af420$var$processAtrule(node, item, list) {
    if (!$a437f30fe88af420$var$isMediaRule(node)) return;
    const prev = item.prev && item.prev.data;
    if (!prev || !$a437f30fe88af420$var$isMediaRule(prev)) return;
    // merge @media with same query
    if (node.prelude && prev.prelude && node.prelude.id === prev.prelude.id) {
        prev.block.children.appendList(node.block.children);
        list.remove(item);
    // TODO: use it when we can refer to several points in source
    // prev.loc = {
    //     primary: prev.loc,
    //     merged: node.loc
    // };
    }
}
function $a437f30fe88af420$var$rejoinAtrule(ast, options) {
    $a437f30fe88af420$var$relocateAtrules(ast, options);
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Atrule',
        reverse: true,
        enter: $a437f30fe88af420$var$processAtrule
    });
}
$a437f30fe88af420$exports = $a437f30fe88af420$var$rejoinAtrule;


var $272d1196fcb68a30$exports = {};
'use strict';

var $cadfd1547627fb1a$export$f19b2de7003025a4;
var $cadfd1547627fb1a$export$c33c6bd7b1b33115;
var $cadfd1547627fb1a$export$17616afcba2c76fe;
var $cadfd1547627fb1a$export$e33504c5cd20a712;
var $cadfd1547627fb1a$export$82fb32fe5b82c40b;
var $cadfd1547627fb1a$export$a048038cc2a3b0e2;
'use strict';
const { hasOwnProperty: $cadfd1547627fb1a$var$hasOwnProperty } = Object.prototype;
function $cadfd1547627fb1a$var$isEqualSelectors(a, b) {
    let cursor1 = a.head;
    let cursor2 = b.head;
    while(cursor1 !== null && cursor2 !== null && cursor1.data.id === cursor2.data.id){
        cursor1 = cursor1.next;
        cursor2 = cursor2.next;
    }
    return cursor1 === null && cursor2 === null;
}
function $cadfd1547627fb1a$var$isEqualDeclarations(a, b) {
    let cursor1 = a.head;
    let cursor2 = b.head;
    while(cursor1 !== null && cursor2 !== null && cursor1.data.id === cursor2.data.id){
        cursor1 = cursor1.next;
        cursor2 = cursor2.next;
    }
    return cursor1 === null && cursor2 === null;
}
function $cadfd1547627fb1a$var$compareDeclarations(declarations1, declarations2) {
    const result = {
        eq: [],
        ne1: [],
        ne2: [],
        ne2overrided: []
    };
    const fingerprints = Object.create(null);
    const declarations2hash = Object.create(null);
    for(let cursor = declarations2.head; cursor; cursor = cursor.next)declarations2hash[cursor.data.id] = true;
    for(let cursor = declarations1.head; cursor; cursor = cursor.next){
        const data = cursor.data;
        if (data.fingerprint) fingerprints[data.fingerprint] = data.important;
        if (declarations2hash[data.id]) {
            declarations2hash[data.id] = false;
            result.eq.push(data);
        } else result.ne1.push(data);
    }
    for(let cursor = declarations2.head; cursor; cursor = cursor.next){
        const data = cursor.data;
        if (declarations2hash[data.id]) {
            // when declarations1 has an overriding declaration, this is not a difference
            // unless no !important is used on prev and !important is used on the following
            if (!$cadfd1547627fb1a$var$hasOwnProperty.call(fingerprints, data.fingerprint) || !fingerprints[data.fingerprint] && data.important) result.ne2.push(data);
            result.ne2overrided.push(data);
        }
    }
    return result;
}
function $cadfd1547627fb1a$var$addSelectors(dest, source) {
    source.forEach((sourceData)=>{
        const newStr = sourceData.id;
        let cursor = dest.head;
        while(cursor){
            const nextStr = cursor.data.id;
            if (nextStr === newStr) return;
            if (nextStr > newStr) break;
            cursor = cursor.next;
        }
        dest.insert(dest.createItem(sourceData), cursor);
    });
    return dest;
}
// check if simpleselectors has no equal specificity and element selector
function $cadfd1547627fb1a$var$hasSimilarSelectors(selectors1, selectors2) {
    let cursor1 = selectors1.head;
    while(cursor1 !== null){
        let cursor2 = selectors2.head;
        while(cursor2 !== null){
            if (cursor1.data.compareMarker === cursor2.data.compareMarker) return true;
            cursor2 = cursor2.next;
        }
        cursor1 = cursor1.next;
    }
    return false;
}
// test node can't to be skipped
function $cadfd1547627fb1a$var$unsafeToSkipNode(node) {
    switch(node.type){
        case 'Rule':
            // unsafe skip ruleset with selector similarities
            return $cadfd1547627fb1a$var$hasSimilarSelectors(node.prelude.children, this);
        case 'Atrule':
            // can skip at-rules with blocks
            if (node.block) // unsafe skip at-rule if block contains something unsafe to skip
            return node.block.children.some($cadfd1547627fb1a$var$unsafeToSkipNode, this);
            break;
        case 'Declaration':
            return false;
    }
    // unsafe by default
    return true;
}
$cadfd1547627fb1a$export$f19b2de7003025a4 = $cadfd1547627fb1a$var$addSelectors;
$cadfd1547627fb1a$export$c33c6bd7b1b33115 = $cadfd1547627fb1a$var$compareDeclarations;
$cadfd1547627fb1a$export$17616afcba2c76fe = $cadfd1547627fb1a$var$hasSimilarSelectors;
$cadfd1547627fb1a$export$e33504c5cd20a712 = $cadfd1547627fb1a$var$isEqualDeclarations;
$cadfd1547627fb1a$export$82fb32fe5b82c40b = $cadfd1547627fb1a$var$isEqualSelectors;
$cadfd1547627fb1a$export$a048038cc2a3b0e2 = $cadfd1547627fb1a$var$unsafeToSkipNode;


function $272d1196fcb68a30$var$processRule(node, item, list) {
    const selectors = node.prelude.children;
    const declarations = node.block.children;
    list.prevUntil(item.prev, function(prev) {
        // skip non-ruleset node if safe
        if (prev.type !== 'Rule') return $cadfd1547627fb1a$export$a048038cc2a3b0e2.call(selectors, prev);
        const prevSelectors = prev.prelude.children;
        const prevDeclarations = prev.block.children;
        // try to join rulesets with equal pseudo signature
        if (node.pseudoSignature === prev.pseudoSignature) {
            // try to join by selectors
            if ($cadfd1547627fb1a$export$82fb32fe5b82c40b(prevSelectors, selectors)) {
                prevDeclarations.appendList(declarations);
                list.remove(item);
                return true;
            }
            // try to join by declarations
            if ($cadfd1547627fb1a$export$e33504c5cd20a712(declarations, prevDeclarations)) {
                $cadfd1547627fb1a$export$f19b2de7003025a4(prevSelectors, selectors);
                list.remove(item);
                return true;
            }
        }
        // go to prev ruleset if has no selector similarities
        return $cadfd1547627fb1a$export$17616afcba2c76fe(selectors, prevSelectors);
    });
}
// NOTE: direction should be left to right, since rulesets merge to left
// ruleset. When direction right to left unmerged rulesets may prevent lookup
// TODO: remove initial merge
function $272d1196fcb68a30$var$initialMergeRule(ast) {
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Rule',
        enter: $272d1196fcb68a30$var$processRule
    });
}
$272d1196fcb68a30$exports = $272d1196fcb68a30$var$initialMergeRule;


var $4252eac49ad0e297$exports = {};
'use strict';

function $4252eac49ad0e297$var$processRule(node, item, list) {
    const selectors = node.prelude.children;
    // generate new rule sets:
    // .a, .b { color: red; }
    // ->
    // .a { color: red; }
    // .b { color: red; }
    // while there are more than 1 simple selector split for rulesets
    while(selectors.head !== selectors.tail){
        const newSelectors = new $4e097574aea5443c$export$54c2e3dc7acea9f5();
        newSelectors.insert(selectors.remove(selectors.head));
        list.insert(list.createItem({
            type: 'Rule',
            loc: node.loc,
            prelude: {
                type: 'SelectorList',
                loc: node.prelude.loc,
                children: newSelectors
            },
            block: {
                type: 'Block',
                loc: node.block.loc,
                children: node.block.children.copy()
            },
            pseudoSignature: node.pseudoSignature
        }), item);
    }
}
function $4252eac49ad0e297$var$disjoinRule(ast) {
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Rule',
        reverse: true,
        enter: $4252eac49ad0e297$var$processRule
    });
}
$4252eac49ad0e297$exports = $4252eac49ad0e297$var$disjoinRule;


var $49f997870fd12d6a$exports = {};
'use strict';

const $49f997870fd12d6a$var$REPLACE = 1;
const $49f997870fd12d6a$var$REMOVE = 2;
const $49f997870fd12d6a$var$TOP = 0;
const $49f997870fd12d6a$var$RIGHT = 1;
const $49f997870fd12d6a$var$BOTTOM = 2;
const $49f997870fd12d6a$var$LEFT = 3;
const $49f997870fd12d6a$var$SIDES = [
    'top',
    'right',
    'bottom',
    'left'
];
const $49f997870fd12d6a$var$SIDE = {
    'margin-top': 'top',
    'margin-right': 'right',
    'margin-bottom': 'bottom',
    'margin-left': 'left',
    'padding-top': 'top',
    'padding-right': 'right',
    'padding-bottom': 'bottom',
    'padding-left': 'left',
    'border-top-color': 'top',
    'border-right-color': 'right',
    'border-bottom-color': 'bottom',
    'border-left-color': 'left',
    'border-top-width': 'top',
    'border-right-width': 'right',
    'border-bottom-width': 'bottom',
    'border-left-width': 'left',
    'border-top-style': 'top',
    'border-right-style': 'right',
    'border-bottom-style': 'bottom',
    'border-left-style': 'left'
};
const $49f997870fd12d6a$var$MAIN_PROPERTY = {
    'margin': 'margin',
    'margin-top': 'margin',
    'margin-right': 'margin',
    'margin-bottom': 'margin',
    'margin-left': 'margin',
    'padding': 'padding',
    'padding-top': 'padding',
    'padding-right': 'padding',
    'padding-bottom': 'padding',
    'padding-left': 'padding',
    'border-color': 'border-color',
    'border-top-color': 'border-color',
    'border-right-color': 'border-color',
    'border-bottom-color': 'border-color',
    'border-left-color': 'border-color',
    'border-width': 'border-width',
    'border-top-width': 'border-width',
    'border-right-width': 'border-width',
    'border-bottom-width': 'border-width',
    'border-left-width': 'border-width',
    'border-style': 'border-style',
    'border-top-style': 'border-style',
    'border-right-style': 'border-style',
    'border-bottom-style': 'border-style',
    'border-left-style': 'border-style'
};
class $49f997870fd12d6a$var$TRBL {
    getValueSequence(declaration, count) {
        const values = [];
        let iehack = '';
        const hasBadValues = declaration.value.type !== 'Value' || declaration.value.children.some(function(child) {
            let special = false;
            switch(child.type){
                case 'Identifier':
                    switch(child.name){
                        case '\\0':
                        case '\\9':
                            iehack = child.name;
                            return;
                        case 'inherit':
                        case 'initial':
                        case 'unset':
                        case 'revert':
                            special = child.name;
                            break;
                    }
                    break;
                case 'Dimension':
                    switch(child.unit){
                        // is not supported until IE11
                        case 'rem':
                        // v* units is too buggy across browsers and better
                        // don't merge values with those units
                        case 'vw':
                        case 'vh':
                        case 'vmin':
                        case 'vmax':
                        case 'vm':
                            special = child.unit;
                            break;
                    }
                    break;
                case 'Hash':
                case 'Number':
                case 'Percentage':
                    break;
                case 'Function':
                    if (child.name === 'var') return true;
                    special = child.name;
                    break;
                default:
                    return true; // bad value
            }
            values.push({
                node: child,
                special: special,
                important: declaration.important
            });
        });
        if (hasBadValues || values.length > count) return false;
        if (typeof this.iehack === 'string' && this.iehack !== iehack) return false;
        this.iehack = iehack; // move outside
        return values;
    }
    canOverride(side, value) {
        const currentValue = this.sides[side];
        return !currentValue || value.important && !currentValue.important;
    }
    add(name, declaration) {
        function attemptToAdd() {
            const sides = this.sides;
            const side = $49f997870fd12d6a$var$SIDE[name];
            if (side) {
                if (side in sides === false) return false;
                const values = this.getValueSequence(declaration, 1);
                if (!values || !values.length) return false;
                // can mix only if specials are equal
                for(const key in sides){
                    if (sides[key] !== null && sides[key].special !== values[0].special) return false;
                }
                if (!this.canOverride(side, values[0])) return true;
                sides[side] = values[0];
                return true;
            } else if (name === this.name) {
                const values = this.getValueSequence(declaration, 4);
                if (!values || !values.length) return false;
                switch(values.length){
                    case 1:
                        values[$49f997870fd12d6a$var$RIGHT] = values[$49f997870fd12d6a$var$TOP];
                        values[$49f997870fd12d6a$var$BOTTOM] = values[$49f997870fd12d6a$var$TOP];
                        values[$49f997870fd12d6a$var$LEFT] = values[$49f997870fd12d6a$var$TOP];
                        break;
                    case 2:
                        values[$49f997870fd12d6a$var$BOTTOM] = values[$49f997870fd12d6a$var$TOP];
                        values[$49f997870fd12d6a$var$LEFT] = values[$49f997870fd12d6a$var$RIGHT];
                        break;
                    case 3:
                        values[$49f997870fd12d6a$var$LEFT] = values[$49f997870fd12d6a$var$RIGHT];
                        break;
                }
                // can mix only if specials are equal
                for(let i = 0; i < 4; i++)for(const key in sides){
                    if (sides[key] !== null && sides[key].special !== values[i].special) return false;
                }
                for(let i = 0; i < 4; i++)if (this.canOverride($49f997870fd12d6a$var$SIDES[i], values[i])) sides[$49f997870fd12d6a$var$SIDES[i]] = values[i];
                return true;
            }
        }
        if (!attemptToAdd.call(this)) return false;
        // TODO: use it when we can refer to several points in source
        // if (this.loc) {
        //     this.loc = {
        //         primary: this.loc,
        //         merged: declaration.loc
        //     };
        // } else {
        //     this.loc = declaration.loc;
        // }
        if (!this.loc) this.loc = declaration.loc;
        return true;
    }
    isOkToMinimize() {
        const top = this.sides.top;
        const right = this.sides.right;
        const bottom = this.sides.bottom;
        const left = this.sides.left;
        if (top && right && bottom && left) {
            const important = top.important + right.important + bottom.important + left.important;
            return important === 0 || important === 4;
        }
        return false;
    }
    getValue() {
        const result = new $4e097574aea5443c$export$54c2e3dc7acea9f5();
        const sides = this.sides;
        const values = [
            sides.top,
            sides.right,
            sides.bottom,
            sides.left
        ];
        const stringValues = [
            $4e097574aea5443c$export$80d376111cc09ad7(sides.top.node),
            $4e097574aea5443c$export$80d376111cc09ad7(sides.right.node),
            $4e097574aea5443c$export$80d376111cc09ad7(sides.bottom.node),
            $4e097574aea5443c$export$80d376111cc09ad7(sides.left.node)
        ];
        if (stringValues[$49f997870fd12d6a$var$LEFT] === stringValues[$49f997870fd12d6a$var$RIGHT]) {
            values.pop();
            if (stringValues[$49f997870fd12d6a$var$BOTTOM] === stringValues[$49f997870fd12d6a$var$TOP]) {
                values.pop();
                if (stringValues[$49f997870fd12d6a$var$RIGHT] === stringValues[$49f997870fd12d6a$var$TOP]) values.pop();
            }
        }
        for(let i = 0; i < values.length; i++)result.appendData(values[i].node);
        if (this.iehack) result.appendData({
            type: 'Identifier',
            loc: null,
            name: this.iehack
        });
        return {
            type: 'Value',
            loc: null,
            children: result
        };
    }
    getDeclaration() {
        return {
            type: 'Declaration',
            loc: this.loc,
            important: this.sides.top.important,
            property: this.name,
            value: this.getValue()
        };
    }
    constructor(name){
        this.name = name;
        this.loc = null;
        this.iehack = undefined;
        this.sides = {
            'top': null,
            'right': null,
            'bottom': null,
            'left': null
        };
    }
}
function $49f997870fd12d6a$var$processRule(rule, shorts, shortDeclarations, lastShortSelector) {
    const declarations = rule.block.children;
    const selector = rule.prelude.children.first.id;
    rule.block.children.forEachRight(function(declaration, item) {
        const property = declaration.property;
        if (!$49f997870fd12d6a$var$MAIN_PROPERTY.hasOwnProperty(property)) return;
        const key = $49f997870fd12d6a$var$MAIN_PROPERTY[property];
        let shorthand;
        let operation;
        if (!lastShortSelector || selector === lastShortSelector) {
            if (key in shorts) {
                operation = $49f997870fd12d6a$var$REMOVE;
                shorthand = shorts[key];
            }
        }
        if (!shorthand || !shorthand.add(property, declaration)) {
            operation = $49f997870fd12d6a$var$REPLACE;
            shorthand = new $49f997870fd12d6a$var$TRBL(key);
            // if can't parse value ignore it and break shorthand children
            if (!shorthand.add(property, declaration)) {
                lastShortSelector = null;
                return;
            }
        }
        shorts[key] = shorthand;
        shortDeclarations.push({
            operation: operation,
            block: declarations,
            item: item,
            shorthand: shorthand
        });
        lastShortSelector = selector;
    });
    return lastShortSelector;
}
function $49f997870fd12d6a$var$processShorthands(shortDeclarations, markDeclaration) {
    shortDeclarations.forEach(function(item) {
        const shorthand = item.shorthand;
        if (!shorthand.isOkToMinimize()) return;
        if (item.operation === $49f997870fd12d6a$var$REPLACE) item.item.data = markDeclaration(shorthand.getDeclaration());
        else item.block.remove(item.item);
    });
}
function $49f997870fd12d6a$var$restructBlock(ast, indexer) {
    const stylesheetMap = {};
    const shortDeclarations = [];
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Rule',
        reverse: true,
        enter (node) {
            const stylesheet = this.block || this.stylesheet;
            const ruleId = (node.pseudoSignature || '') + '|' + node.prelude.children.first.id;
            let ruleMap;
            let shorts;
            if (!stylesheetMap.hasOwnProperty(stylesheet.id)) {
                ruleMap = {
                    lastShortSelector: null
                };
                stylesheetMap[stylesheet.id] = ruleMap;
            } else ruleMap = stylesheetMap[stylesheet.id];
            if (ruleMap.hasOwnProperty(ruleId)) shorts = ruleMap[ruleId];
            else {
                shorts = {};
                ruleMap[ruleId] = shorts;
            }
            ruleMap.lastShortSelector = $49f997870fd12d6a$var$processRule.call(this, node, shorts, shortDeclarations, ruleMap.lastShortSelector);
        }
    });
    $49f997870fd12d6a$var$processShorthands(shortDeclarations, indexer.declaration);
}
$49f997870fd12d6a$exports = $49f997870fd12d6a$var$restructBlock;


var $96dd53f7ce221476$exports = {};
'use strict';

let $96dd53f7ce221476$var$fingerprintId = 1;
const $96dd53f7ce221476$var$dontRestructure = new Set([
    'src' // https://github.com/afelix/csso/issues/50
]);
const $96dd53f7ce221476$var$DONT_MIX_VALUE = {
    // https://developer.mozilla.org/en-US/docs/Web/CSS/display#Browser_compatibility
    'display': /table|ruby|flex|-(flex)?box$|grid|contents|run-in/i,
    // https://developer.mozilla.org/en/docs/Web/CSS/text-align
    'text-align': /^(start|end|match-parent|justify-all)$/i
};
const $96dd53f7ce221476$var$SAFE_VALUES = {
    cursor: [
        'auto',
        'crosshair',
        'default',
        'move',
        'text',
        'wait',
        'help',
        'n-resize',
        'e-resize',
        's-resize',
        'w-resize',
        'ne-resize',
        'nw-resize',
        'se-resize',
        'sw-resize',
        'pointer',
        'progress',
        'not-allowed',
        'no-drop',
        'vertical-text',
        'all-scroll',
        'col-resize',
        'row-resize'
    ],
    overflow: [
        'hidden',
        'visible',
        'scroll',
        'auto'
    ],
    position: [
        'static',
        'relative',
        'absolute',
        'fixed'
    ]
};
const $96dd53f7ce221476$var$NEEDLESS_TABLE = {
    'border-width': [
        'border'
    ],
    'border-style': [
        'border'
    ],
    'border-color': [
        'border'
    ],
    'border-top': [
        'border'
    ],
    'border-right': [
        'border'
    ],
    'border-bottom': [
        'border'
    ],
    'border-left': [
        'border'
    ],
    'border-top-width': [
        'border-top',
        'border-width',
        'border'
    ],
    'border-right-width': [
        'border-right',
        'border-width',
        'border'
    ],
    'border-bottom-width': [
        'border-bottom',
        'border-width',
        'border'
    ],
    'border-left-width': [
        'border-left',
        'border-width',
        'border'
    ],
    'border-top-style': [
        'border-top',
        'border-style',
        'border'
    ],
    'border-right-style': [
        'border-right',
        'border-style',
        'border'
    ],
    'border-bottom-style': [
        'border-bottom',
        'border-style',
        'border'
    ],
    'border-left-style': [
        'border-left',
        'border-style',
        'border'
    ],
    'border-top-color': [
        'border-top',
        'border-color',
        'border'
    ],
    'border-right-color': [
        'border-right',
        'border-color',
        'border'
    ],
    'border-bottom-color': [
        'border-bottom',
        'border-color',
        'border'
    ],
    'border-left-color': [
        'border-left',
        'border-color',
        'border'
    ],
    'margin-top': [
        'margin'
    ],
    'margin-right': [
        'margin'
    ],
    'margin-bottom': [
        'margin'
    ],
    'margin-left': [
        'margin'
    ],
    'padding-top': [
        'padding'
    ],
    'padding-right': [
        'padding'
    ],
    'padding-bottom': [
        'padding'
    ],
    'padding-left': [
        'padding'
    ],
    'font-style': [
        'font'
    ],
    'font-variant': [
        'font'
    ],
    'font-weight': [
        'font'
    ],
    'font-size': [
        'font'
    ],
    'font-family': [
        'font'
    ],
    'list-style-type': [
        'list-style'
    ],
    'list-style-position': [
        'list-style'
    ],
    'list-style-image': [
        'list-style'
    ]
};
function $96dd53f7ce221476$var$getPropertyFingerprint(propertyName, declaration, fingerprints) {
    const realName = $4e097574aea5443c$export$d541bacb2bda4494(propertyName).basename;
    if (realName === 'background') return propertyName + ':' + $4e097574aea5443c$export$80d376111cc09ad7(declaration.value);
    const declarationId = declaration.id;
    let fingerprint = fingerprints[declarationId];
    if (!fingerprint) {
        switch(declaration.value.type){
            case 'Value':
                const special = {};
                let vendorId = '';
                let iehack = '';
                let raw = false;
                declaration.value.children.forEach(function walk(node) {
                    switch(node.type){
                        case 'Value':
                        case 'Brackets':
                        case 'Parentheses':
                            node.children.forEach(walk);
                            break;
                        case 'Raw':
                            raw = true;
                            break;
                        case 'Identifier':
                            {
                                const { name: name } = node;
                                if (!vendorId) vendorId = $4e097574aea5443c$export$2e81050496d0e63e(name).vendor;
                                if (/\\[09]/.test(name)) iehack = RegExp.lastMatch;
                                if ($96dd53f7ce221476$var$SAFE_VALUES.hasOwnProperty(realName)) {
                                    if ($96dd53f7ce221476$var$SAFE_VALUES[realName].indexOf(name) === -1) special[name] = true;
                                } else if ($96dd53f7ce221476$var$DONT_MIX_VALUE.hasOwnProperty(realName)) {
                                    if ($96dd53f7ce221476$var$DONT_MIX_VALUE[realName].test(name)) special[name] = true;
                                }
                                break;
                            }
                        case 'Function':
                            {
                                let { name: name } = node;
                                if (!vendorId) vendorId = $4e097574aea5443c$export$2e81050496d0e63e(name).vendor;
                                if (name === 'rect') {
                                    // there are 2 forms of rect:
                                    //   rect(<top>, <right>, <bottom>, <left>) - standart
                                    //   rect(<top> <right> <bottom> <left>) – backwards compatible syntax
                                    // only the same form values can be merged
                                    const hasComma = node.children.some((node)=>node.type === 'Operator' && node.value === ',');
                                    if (!hasComma) name = 'rect-backward';
                                }
                                special[name + '()'] = true;
                                // check nested tokens too
                                node.children.forEach(walk);
                                break;
                            }
                        case 'Dimension':
                            {
                                const { unit: unit } = node;
                                if (/\\[09]/.test(unit)) iehack = RegExp.lastMatch;
                                switch(unit){
                                    // is not supported until IE11
                                    case 'rem':
                                    // v* units is too buggy across browsers and better
                                    // don't merge values with those units
                                    case 'vw':
                                    case 'vh':
                                    case 'vmin':
                                    case 'vmax':
                                    case 'vm':
                                        special[unit] = true;
                                        break;
                                }
                                break;
                            }
                    }
                });
                fingerprint = raw ? '!' + $96dd53f7ce221476$var$fingerprintId++ : '!' + Object.keys(special).sort() + '|' + iehack + vendorId;
                break;
            case 'Raw':
                fingerprint = '!' + declaration.value.value;
                break;
            default:
                fingerprint = $4e097574aea5443c$export$80d376111cc09ad7(declaration.value);
        }
        fingerprints[declarationId] = fingerprint;
    }
    return propertyName + fingerprint;
}
function $96dd53f7ce221476$var$needless(props, declaration, fingerprints) {
    const property = $4e097574aea5443c$export$d541bacb2bda4494(declaration.property);
    if ($96dd53f7ce221476$var$NEEDLESS_TABLE.hasOwnProperty(property.basename)) {
        const table = $96dd53f7ce221476$var$NEEDLESS_TABLE[property.basename];
        for (const entry of table){
            const ppre = $96dd53f7ce221476$var$getPropertyFingerprint(property.prefix + entry, declaration, fingerprints);
            const prev = props.hasOwnProperty(ppre) ? props[ppre] : null;
            if (prev && (!declaration.important || prev.item.data.important)) return prev;
        }
    }
}
function $96dd53f7ce221476$var$processRule(rule, item, list, props, fingerprints) {
    const declarations = rule.block.children;
    declarations.forEachRight(function(declaration, declarationItem) {
        const { property: property } = declaration;
        const fingerprint = $96dd53f7ce221476$var$getPropertyFingerprint(property, declaration, fingerprints);
        const prev = props[fingerprint];
        if (prev && !$96dd53f7ce221476$var$dontRestructure.has(property)) {
            if (declaration.important && !prev.item.data.important) {
                props[fingerprint] = {
                    block: declarations,
                    item: declarationItem
                };
                prev.block.remove(prev.item);
            // TODO: use it when we can refer to several points in source
            // declaration.loc = {
            //     primary: declaration.loc,
            //     merged: prev.item.data.loc
            // };
            } else declarations.remove(declarationItem);
        } else {
            const prev = $96dd53f7ce221476$var$needless(props, declaration, fingerprints);
            if (prev) declarations.remove(declarationItem);
            else {
                declaration.fingerprint = fingerprint;
                props[fingerprint] = {
                    block: declarations,
                    item: declarationItem
                };
            }
        }
    });
    if (declarations.isEmpty) list.remove(item);
}
function $96dd53f7ce221476$var$restructBlock(ast) {
    const stylesheetMap = {};
    const fingerprints = Object.create(null);
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Rule',
        reverse: true,
        enter (node, item, list) {
            const stylesheet = this.block || this.stylesheet;
            const ruleId = (node.pseudoSignature || '') + '|' + node.prelude.children.first.id;
            let ruleMap;
            let props;
            if (!stylesheetMap.hasOwnProperty(stylesheet.id)) {
                ruleMap = {};
                stylesheetMap[stylesheet.id] = ruleMap;
            } else ruleMap = stylesheetMap[stylesheet.id];
            if (ruleMap.hasOwnProperty(ruleId)) props = ruleMap[ruleId];
            else {
                props = {};
                ruleMap[ruleId] = props;
            }
            $96dd53f7ce221476$var$processRule.call(this, node, item, list, props, fingerprints);
        }
    });
}
$96dd53f7ce221476$exports = $96dd53f7ce221476$var$restructBlock;


var $7e569ef991520179$exports = {};
'use strict';


/*
    At this step all rules has single simple selector. We try to join by equal
    declaration blocks to first rule, e.g.

    .a { color: red }
    b { ... }
    .b { color: red }
    ->
    .a, .b { color: red }
    b { ... }
*/ function $7e569ef991520179$var$processRule(node, item, list) {
    const selectors = node.prelude.children;
    const declarations = node.block.children;
    const nodeCompareMarker = selectors.first.compareMarker;
    const skippedCompareMarkers = {};
    list.nextUntil(item.next, function(next, nextItem) {
        // skip non-ruleset node if safe
        if (next.type !== 'Rule') return $cadfd1547627fb1a$export$a048038cc2a3b0e2.call(selectors, next);
        if (node.pseudoSignature !== next.pseudoSignature) return true;
        const nextFirstSelector = next.prelude.children.head;
        const nextDeclarations = next.block.children;
        const nextCompareMarker = nextFirstSelector.data.compareMarker;
        // if next ruleset has same marked as one of skipped then stop joining
        if (nextCompareMarker in skippedCompareMarkers) return true;
        // try to join by selectors
        if (selectors.head === selectors.tail) {
            if (selectors.first.id === nextFirstSelector.data.id) {
                declarations.appendList(nextDeclarations);
                list.remove(nextItem);
                return;
            }
        }
        // try to join by properties
        if ($cadfd1547627fb1a$export$e33504c5cd20a712(declarations, nextDeclarations)) {
            const nextStr = nextFirstSelector.data.id;
            selectors.some((data, item)=>{
                const curStr = data.id;
                if (nextStr < curStr) {
                    selectors.insert(nextFirstSelector, item);
                    return true;
                }
                if (!item.next) {
                    selectors.insert(nextFirstSelector);
                    return true;
                }
            });
            list.remove(nextItem);
            return;
        }
        // go to next ruleset if current one can be skipped (has no equal specificity nor element selector)
        if (nextCompareMarker === nodeCompareMarker) return true;
        skippedCompareMarkers[nextCompareMarker] = true;
    });
}
function $7e569ef991520179$var$mergeRule(ast) {
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Rule',
        enter: $7e569ef991520179$var$processRule
    });
}
$7e569ef991520179$exports = $7e569ef991520179$var$mergeRule;


var $1680971c799310f4$exports = {};
'use strict';


function $1680971c799310f4$var$calcSelectorLength(list) {
    return list.reduce((res, data)=>res + data.id.length + 1, 0) - 1;
}
function $1680971c799310f4$var$calcDeclarationsLength(tokens) {
    let length = 0;
    for (const token of tokens)length += token.length;
    return length + // declarations
    tokens.length - 1 // delimeters
    ;
}
function $1680971c799310f4$var$processRule(node, item, list) {
    const avoidRulesMerge = this.block !== null ? this.block.avoidRulesMerge : false;
    const selectors = node.prelude.children;
    const block = node.block;
    const disallowDownMarkers = Object.create(null);
    let allowMergeUp = true;
    let allowMergeDown = true;
    list.prevUntil(item.prev, function(prev, prevItem) {
        const prevBlock = prev.block;
        const prevType = prev.type;
        if (prevType !== 'Rule') {
            const unsafe = $cadfd1547627fb1a$export$a048038cc2a3b0e2.call(selectors, prev);
            if (!unsafe && prevType === 'Atrule' && prevBlock) $4e097574aea5443c$export$588732934346abbf(prevBlock, {
                visit: 'Rule',
                enter (node) {
                    node.prelude.children.forEach((data)=>{
                        disallowDownMarkers[data.compareMarker] = true;
                    });
                }
            });
            return unsafe;
        }
        if (node.pseudoSignature !== prev.pseudoSignature) return true;
        const prevSelectors = prev.prelude.children;
        allowMergeDown = !prevSelectors.some((selector)=>selector.compareMarker in disallowDownMarkers);
        // try prev ruleset if simpleselectors has no equal specifity and element selector
        if (!allowMergeDown && !allowMergeUp) return true;
        // try to join by selectors
        if (allowMergeUp && $cadfd1547627fb1a$export$82fb32fe5b82c40b(prevSelectors, selectors)) {
            prevBlock.children.appendList(block.children);
            list.remove(item);
            return true;
        }
        // try to join by properties
        const diff = $cadfd1547627fb1a$export$c33c6bd7b1b33115(block.children, prevBlock.children);
        // console.log(diff.eq, diff.ne1, diff.ne2);
        if (diff.eq.length) {
            if (!diff.ne1.length && !diff.ne2.length) {
                // equal blocks
                if (allowMergeDown) {
                    $cadfd1547627fb1a$export$f19b2de7003025a4(selectors, prevSelectors);
                    list.remove(prevItem);
                }
                return true;
            } else if (!avoidRulesMerge) {
                if (diff.ne1.length && !diff.ne2.length) {
                    // prevBlock is subset block
                    const selectorLength = $1680971c799310f4$var$calcSelectorLength(selectors);
                    const blockLength = $1680971c799310f4$var$calcDeclarationsLength(diff.eq); // declarations length
                    if (allowMergeUp && selectorLength < blockLength) {
                        $cadfd1547627fb1a$export$f19b2de7003025a4(prevSelectors, selectors);
                        block.children.fromArray(diff.ne1);
                    }
                } else if (!diff.ne1.length && diff.ne2.length) {
                    // node is subset of prevBlock
                    const selectorLength = $1680971c799310f4$var$calcSelectorLength(prevSelectors);
                    const blockLength = $1680971c799310f4$var$calcDeclarationsLength(diff.eq); // declarations length
                    if (allowMergeDown && selectorLength < blockLength) {
                        $cadfd1547627fb1a$export$f19b2de7003025a4(selectors, prevSelectors);
                        prevBlock.children.fromArray(diff.ne2);
                    }
                } else {
                    // diff.ne1.length && diff.ne2.length
                    // extract equal block
                    const newSelector = {
                        type: 'SelectorList',
                        loc: null,
                        children: $cadfd1547627fb1a$export$f19b2de7003025a4(prevSelectors.copy(), selectors)
                    };
                    const newBlockLength = $1680971c799310f4$var$calcSelectorLength(newSelector.children) + 2; // selectors length + curly braces length
                    const blockLength = $1680971c799310f4$var$calcDeclarationsLength(diff.eq); // declarations length
                    // create new ruleset if declarations length greater than
                    // ruleset description overhead
                    if (blockLength >= newBlockLength) {
                        const newItem = list.createItem({
                            type: 'Rule',
                            loc: null,
                            prelude: newSelector,
                            block: {
                                type: 'Block',
                                loc: null,
                                children: new $4e097574aea5443c$export$54c2e3dc7acea9f5().fromArray(diff.eq)
                            },
                            pseudoSignature: node.pseudoSignature
                        });
                        block.children.fromArray(diff.ne1);
                        prevBlock.children.fromArray(diff.ne2overrided);
                        if (allowMergeUp) list.insert(newItem, prevItem);
                        else list.insert(newItem, item);
                        return true;
                    }
                }
            }
        }
        if (allowMergeUp) // TODO: disallow up merge only if any property interception only (i.e. diff.ne2overrided.length > 0);
        // await property families to find property interception correctly
        allowMergeUp = !prevSelectors.some((prevSelector)=>selectors.some((selector)=>selector.compareMarker === prevSelector.compareMarker));
        prevSelectors.forEach((data)=>{
            disallowDownMarkers[data.compareMarker] = true;
        });
    });
}
function $1680971c799310f4$var$restructRule(ast) {
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Rule',
        reverse: true,
        enter: $1680971c799310f4$var$processRule
    });
}
$1680971c799310f4$exports = $1680971c799310f4$var$restructRule;


function $ec0a7c2781f1af39$var$restructure(ast, options) {
    // prepare ast for restructing
    const indexer = $810880b1b3b1dc96$exports(ast, options);
    options.logger('prepare', ast);
    $a437f30fe88af420$exports(ast, options);
    options.logger('mergeAtrule', ast);
    $272d1196fcb68a30$exports(ast);
    options.logger('initialMergeRuleset', ast);
    $4252eac49ad0e297$exports(ast);
    options.logger('disjoinRuleset', ast);
    $49f997870fd12d6a$exports(ast, indexer);
    options.logger('restructShorthand', ast);
    $96dd53f7ce221476$exports(ast);
    options.logger('restructBlock', ast);
    $7e569ef991520179$exports(ast);
    options.logger('mergeRuleset', ast);
    $1680971c799310f4$exports(ast);
    options.logger('restructRuleset', ast);
}
$ec0a7c2781f1af39$exports = $ec0a7c2781f1af39$var$restructure;


function $936a09a259590431$var$readChunk(input, specialComments) {
    const children = new $4e097574aea5443c$export$54c2e3dc7acea9f5();
    let nonSpaceTokenInBuffer = false;
    let protectedComment;
    input.nextUntil(input.head, (node, item, list)=>{
        if (node.type === 'Comment') {
            if (!specialComments || node.value.charAt(0) !== '!') {
                list.remove(item);
                return;
            }
            if (nonSpaceTokenInBuffer || protectedComment) return true;
            list.remove(item);
            protectedComment = node;
            return;
        }
        if (node.type !== 'WhiteSpace') nonSpaceTokenInBuffer = true;
        children.insert(list.remove(item));
    });
    return {
        comment: protectedComment,
        stylesheet: {
            type: 'StyleSheet',
            loc: null,
            children: children
        }
    };
}
function $936a09a259590431$var$compressChunk(ast, firstAtrulesAllowed, num, options) {
    options.logger(`Compress block #${num}`, null, true);
    let seed = 1;
    if (ast.type === 'StyleSheet') {
        ast.firstAtrulesAllowed = firstAtrulesAllowed;
        ast.id = seed++;
    }
    $4e097574aea5443c$export$588732934346abbf(ast, {
        visit: 'Atrule',
        enter (node) {
            if (node.block !== null) node.block.id = seed++;
        }
    });
    options.logger('init', ast);
    // remove redundant
    $87789b0a5349c046$exports(ast, options);
    options.logger('clean', ast);
    // replace nodes for shortened forms
    $5287e7e5721db4ab$exports(ast);
    options.logger('replace', ast);
    // structure optimisations
    if (options.restructuring) $ec0a7c2781f1af39$exports(ast, options);
    return ast;
}
function $936a09a259590431$var$getCommentsOption(options) {
    let comments = 'comments' in options ? options.comments : 'exclamation';
    if (typeof comments === 'boolean') comments = comments ? 'exclamation' : false;
    else if (comments !== 'exclamation' && comments !== 'first-exclamation') comments = false;
    return comments;
}
function $936a09a259590431$var$getRestructureOption(options) {
    if ('restructure' in options) return options.restructure;
    return 'restructuring' in options ? options.restructuring : true;
}
function $936a09a259590431$var$wrapBlock(block) {
    return new $4e097574aea5443c$export$54c2e3dc7acea9f5().appendData({
        type: 'Rule',
        loc: null,
        prelude: {
            type: 'SelectorList',
            loc: null,
            children: new $4e097574aea5443c$export$54c2e3dc7acea9f5().appendData({
                type: 'Selector',
                loc: null,
                children: new $4e097574aea5443c$export$54c2e3dc7acea9f5().appendData({
                    type: 'TypeSelector',
                    loc: null,
                    name: 'x'
                })
            })
        },
        block: block
    });
}
function $936a09a259590431$var$compress(ast, options) {
    ast = ast || {
        type: 'StyleSheet',
        loc: null,
        children: new $4e097574aea5443c$export$54c2e3dc7acea9f5()
    };
    options = options || {};
    const compressOptions = {
        logger: typeof options.logger === 'function' ? options.logger : function() {},
        restructuring: $936a09a259590431$var$getRestructureOption(options),
        forceMediaMerge: Boolean(options.forceMediaMerge),
        usage: options.usage ? $b6dc50b5b1b8bc90$export$234f5dac53d1ad9a(options.usage) : false
    };
    const output = new $4e097574aea5443c$export$54c2e3dc7acea9f5();
    let specialComments = $936a09a259590431$var$getCommentsOption(options);
    let firstAtrulesAllowed = true;
    let input;
    let chunk;
    let chunkNum = 1;
    let chunkChildren;
    if (options.clone) ast = $4e097574aea5443c$export$9cd59f9826255e47(ast);
    if (ast.type === 'StyleSheet') {
        input = ast.children;
        ast.children = output;
    } else input = $936a09a259590431$var$wrapBlock(ast);
    do {
        chunk = $936a09a259590431$var$readChunk(input, Boolean(specialComments));
        $936a09a259590431$var$compressChunk(chunk.stylesheet, firstAtrulesAllowed, chunkNum++, compressOptions);
        chunkChildren = chunk.stylesheet.children;
        if (chunk.comment) {
            // add \n before comment if there is another content in output
            if (!output.isEmpty) output.insert($4e097574aea5443c$export$54c2e3dc7acea9f5.createItem({
                type: 'Raw',
                value: '\n'
            }));
            output.insert($4e097574aea5443c$export$54c2e3dc7acea9f5.createItem(chunk.comment));
            // add \n after comment if chunk is not empty
            if (!chunkChildren.isEmpty) output.insert($4e097574aea5443c$export$54c2e3dc7acea9f5.createItem({
                type: 'Raw',
                value: '\n'
            }));
        }
        if (firstAtrulesAllowed && !chunkChildren.isEmpty) {
            const lastRule = chunkChildren.last;
            if (lastRule.type !== 'Atrule' || lastRule.name !== 'import' && lastRule.name !== 'charset') firstAtrulesAllowed = false;
        }
        if (specialComments !== 'exclamation') specialComments = false;
        output.appendList(chunkChildren);
    }while (!input.isEmpty);
    return {
        ast: ast
    };
}
$936a09a259590431$exports = $936a09a259590431$var$compress;



function $1f2bc7e7745d853e$var$encodeString(value) {
    const stringApostrophe = $4e097574aea5443c$export$22b082955e083ec3.encode(value, true);
    const stringQuote = $4e097574aea5443c$export$22b082955e083ec3.encode(value);
    return stringApostrophe.length < stringQuote.length ? stringApostrophe : stringQuote;
}
const { lexer: $1f2bc7e7745d853e$var$lexer, tokenize: $1f2bc7e7745d853e$var$tokenize, parse: $1f2bc7e7745d853e$var$parse, generate: $1f2bc7e7745d853e$var$generate, walk: $1f2bc7e7745d853e$var$walk, find: $1f2bc7e7745d853e$var$find, findLast: $1f2bc7e7745d853e$var$findLast, findAll: $1f2bc7e7745d853e$var$findAll, fromPlainObject: $1f2bc7e7745d853e$var$fromPlainObject, toPlainObject: $1f2bc7e7745d853e$var$toPlainObject } = $4e097574aea5443c$export$7a5058c6b79333e0({
    node: {
        String: {
            generate (node) {
                this.token($4e097574aea5443c$export$a60b91545d7e19fc.String, $1f2bc7e7745d853e$var$encodeString(node.value));
            }
        },
        Url: {
            generate (node) {
                const encodedUrl = $4e097574aea5443c$export$128fa18b7194ef.encode(node.value);
                const string = $1f2bc7e7745d853e$var$encodeString(node.value);
                this.token($4e097574aea5443c$export$a60b91545d7e19fc.Url, encodedUrl.length <= string.length + 5 /* "url()".length */  ? encodedUrl : 'url(' + string + ')');
            }
        }
    }
});
$1f2bc7e7745d853e$export$80908c17a05abbe5 = $936a09a259590431$exports;
$1f2bc7e7745d853e$export$37de5b62848a0d8 = $949975549d611fa5$exports;
$1f2bc7e7745d853e$export$71aa6c912b956294 = $1f2bc7e7745d853e$var$find;
$1f2bc7e7745d853e$export$18200ea6c8035394 = $1f2bc7e7745d853e$var$findAll;
$1f2bc7e7745d853e$export$296de88ccac4bedb = $1f2bc7e7745d853e$var$findLast;
$1f2bc7e7745d853e$export$208fdd74c481bdd3 = $1f2bc7e7745d853e$var$fromPlainObject;
$1f2bc7e7745d853e$export$80d376111cc09ad7 = $1f2bc7e7745d853e$var$generate;
$1f2bc7e7745d853e$export$43feed32102720d2 = $1f2bc7e7745d853e$var$lexer;
$1f2bc7e7745d853e$export$98e6a39c04603d36 = $1f2bc7e7745d853e$var$parse;
$1f2bc7e7745d853e$export$8530f7b85295aab2 = $1f2bc7e7745d853e$var$toPlainObject;
$1f2bc7e7745d853e$export$660b2ee2d4fb4eff = $1f2bc7e7745d853e$var$tokenize;
$1f2bc7e7745d853e$export$588732934346abbf = $1f2bc7e7745d853e$var$walk;


var $5e9526878fb455ab$exports = {};
$parcel$export($5e9526878fb455ab$exports, "processSelector", () => $5e9526878fb455ab$export$1710f6b3fa7159fa, (v) => $5e9526878fb455ab$export$1710f6b3fa7159fa = v);
$parcel$export($5e9526878fb455ab$exports, "addSelectors", () => $5e9526878fb455ab$export$f19b2de7003025a4, (v) => $5e9526878fb455ab$export$f19b2de7003025a4 = v);
$parcel$export($5e9526878fb455ab$exports, "compareDeclarations", () => $5e9526878fb455ab$export$c33c6bd7b1b33115, (v) => $5e9526878fb455ab$export$c33c6bd7b1b33115 = v);
$parcel$export($5e9526878fb455ab$exports, "hasSimilarSelectors", () => $5e9526878fb455ab$export$17616afcba2c76fe, (v) => $5e9526878fb455ab$export$17616afcba2c76fe = v);
$parcel$export($5e9526878fb455ab$exports, "isEqualDeclarations", () => $5e9526878fb455ab$export$e33504c5cd20a712, (v) => $5e9526878fb455ab$export$e33504c5cd20a712 = v);
$parcel$export($5e9526878fb455ab$exports, "isEqualSelectors", () => $5e9526878fb455ab$export$82fb32fe5b82c40b, (v) => $5e9526878fb455ab$export$82fb32fe5b82c40b = v);
$parcel$export($5e9526878fb455ab$exports, "unsafeToSkipNode", () => $5e9526878fb455ab$export$a048038cc2a3b0e2, (v) => $5e9526878fb455ab$export$a048038cc2a3b0e2 = v);
var $5e9526878fb455ab$export$1710f6b3fa7159fa;
var $5e9526878fb455ab$export$f19b2de7003025a4;
var $5e9526878fb455ab$export$c33c6bd7b1b33115;
var $5e9526878fb455ab$export$17616afcba2c76fe;
var $5e9526878fb455ab$export$e33504c5cd20a712;
var $5e9526878fb455ab$export$82fb32fe5b82c40b;
var $5e9526878fb455ab$export$a048038cc2a3b0e2;
'use strict';


$5e9526878fb455ab$export$1710f6b3fa7159fa = $7385ea7e14135d6f$exports;
$5e9526878fb455ab$export$f19b2de7003025a4 = $cadfd1547627fb1a$export$f19b2de7003025a4;
$5e9526878fb455ab$export$c33c6bd7b1b33115 = $cadfd1547627fb1a$export$c33c6bd7b1b33115;
$5e9526878fb455ab$export$17616afcba2c76fe = $cadfd1547627fb1a$export$17616afcba2c76fe;
$5e9526878fb455ab$export$e33504c5cd20a712 = $cadfd1547627fb1a$export$e33504c5cd20a712;
$5e9526878fb455ab$export$82fb32fe5b82c40b = $cadfd1547627fb1a$export$82fb32fe5b82c40b;
$5e9526878fb455ab$export$a048038cc2a3b0e2 = $cadfd1547627fb1a$export$a048038cc2a3b0e2;


const { parse: $b31733134ac815c5$var$parse, generate: $b31733134ac815c5$var$generate, compress: $b31733134ac815c5$var$compress } = $1f2bc7e7745d853e$exports;
function $b31733134ac815c5$var$debugOutput(name, options, startTime, data) {
    if (options.debug) console.error(`## ${name} done in %d ms\n`, Date.now() - startTime);
    return data;
}
function $b31733134ac815c5$var$createDefaultLogger(level) {
    let lastDebug;
    return function logger(title, ast) {
        let line = title;
        if (ast) line = `[${((Date.now() - lastDebug) / 1000).toFixed(3)}s] ${line}`;
        if (level > 1 && ast) {
            let css = $b31733134ac815c5$var$generate(ast);
            // when level 2, limit css to 256 symbols
            if (level === 2 && css.length > 256) css = css.substr(0, 256) + '...';
            line += `\n  ${css}\n`;
        }
        console.error(line);
        lastDebug = Date.now();
    };
}
function $b31733134ac815c5$var$buildCompressOptions(options) {
    options = {
        ...options
    };
    if (typeof options.logger !== 'function' && options.debug) options.logger = $b31733134ac815c5$var$createDefaultLogger(options.debug);
    return options;
}
function $b31733134ac815c5$var$runHandler(ast, options, handlers) {
    if (!Array.isArray(handlers)) handlers = [
        handlers
    ];
    handlers.forEach((fn)=>fn(ast, options));
}
function $b31733134ac815c5$var$minify(context, source, options) {
    options = options || {};
    const filename = options.filename || '<unknown>';
    let result;
    // parse
    const ast = $b31733134ac815c5$var$debugOutput('parsing', options, Date.now(), $b31733134ac815c5$var$parse(source, {
        context: context,
        filename: filename,
        positions: Boolean(options.sourceMap)
    }));
    // before compress handlers
    if (options.beforeCompress) $b31733134ac815c5$var$debugOutput('beforeCompress', options, Date.now(), $b31733134ac815c5$var$runHandler(ast, options, options.beforeCompress));
    // compress
    const compressResult = $b31733134ac815c5$var$debugOutput('compress', options, Date.now(), $b31733134ac815c5$var$compress(ast, $b31733134ac815c5$var$buildCompressOptions(options)));
    // after compress handlers
    if (options.afterCompress) $b31733134ac815c5$var$debugOutput('afterCompress', options, Date.now(), $b31733134ac815c5$var$runHandler(compressResult, options, options.afterCompress));
    // generate
    if (options.sourceMap) result = $b31733134ac815c5$var$debugOutput('generate(sourceMap: true)', options, Date.now(), (()=>{
        const tmp = $b31733134ac815c5$var$generate(compressResult.ast, {
            sourceMap: true
        });
        tmp.map._file = filename; // since other tools can relay on file in source map transform chain
        tmp.map.setSourceContent(filename, source);
        return tmp;
    })());
    else result = $b31733134ac815c5$var$debugOutput('generate', options, Date.now(), {
        css: $b31733134ac815c5$var$generate(compressResult.ast),
        map: null
    });
    return result;
}
function $b31733134ac815c5$var$minifyStylesheet(source, options) {
    return $b31733134ac815c5$var$minify('stylesheet', source, options);
}
function $b31733134ac815c5$var$minifyBlock(source, options) {
    return $b31733134ac815c5$var$minify('declarationList', source, options);
}
$b31733134ac815c5$export$83d89fbfd8236492 = $31447649b066984b$exports.version;
$b31733134ac815c5$export$e07e737eb4e4eeba = $1f2bc7e7745d853e$exports;
$b31733134ac815c5$export$eab97d15b1788b8d = $5e9526878fb455ab$exports;
$b31733134ac815c5$export$8e388a857ed0c062 = $b31733134ac815c5$var$minifyStylesheet;
$b31733134ac815c5$export$50c32ca09add9a32 = $b31733134ac815c5$var$minifyBlock;


var $9fad9b244fc806cb$require$minify = $b31733134ac815c5$export$8e388a857ed0c062;
var $9fad9b244fc806cb$require$syntax = $b31733134ac815c5$export$e07e737eb4e4eeba;
const $9fad9b244fc806cb$var$styleMacroBoundryCSSSelectors = [
    {
        name: 'main-content',
        type: 'IdSelector'
    },
    {
        name: 'content',
        type: 'IdSelector'
    },
    {
        name: 'wiki-content',
        type: 'ClassSelector'
    }
];
const $9fad9b244fc806cb$export$ff57b14bf41d4f9d = '#main-content';
const $9fad9b244fc806cb$var$styleMacroRegex = /(<style[^>]*data-macro-name="style"[^>]*>)((.|\n|\r)*?)(<\/style>)/gm;
function $9fad9b244fc806cb$var$addScopeBoundry(css, scope) {
    const ast = $9fad9b244fc806cb$require$syntax.parse(css);
    const combinatorObj = {
        type: 'Combinator',
        loc: null,
        name: ' '
    };
    $9fad9b244fc806cb$require$syntax.walk(ast, (node)=>{
        // Remove CSS imported from URL as thet can't be scoped and styles can leak to entire application
        if (node.type === 'Atrule' && node.name === 'import') node.prelude?.children.forEach((child)=>{
            if (child.type === 'Url') child.value = '';
        });
        if (node.type === 'Selector') {
            const isFirstChildPseudoClass = node.children?.first.type === 'PseudoClassSelector';
            const isFirstChildCombinator = node.children?.first.type === 'Combinator';
            const existingBoundry = $9fad9b244fc806cb$require$syntax.find(node, (n)=>$9fad9b244fc806cb$var$styleMacroBoundryCSSSelectors.find((selector)=>selector.name === n.name && selector.type === n.type));
            if (!Boolean(existingBoundry) && !Boolean(isFirstChildPseudoClass) && !Boolean(isFirstChildCombinator)) {
                const styleMacroBoundryAST = $9fad9b244fc806cb$require$syntax.parse(scope, {
                    context: 'selector'
                });
                const styleMacroBoundryNode = node.children.createItem(styleMacroBoundryAST.children.first);
                const combinatorNode = node.children.createItem($9fad9b244fc806cb$require$syntax.fromPlainObject(combinatorObj));
                node.children.prepend(combinatorNode);
                node.children.prepend(styleMacroBoundryNode);
            }
        }
    });
    const scopedCSS = $9fad9b244fc806cb$require$syntax.generate(ast);
    let minified = '';
    try {
        minified = $9fad9b244fc806cb$require$minify(scopedCSS).css;
    } finally{
        return minified || scopedCSS;
    }
}
function $9fad9b244fc806cb$export$506216bb8c62ec77(html) {
    const matches = html.matchAll($9fad9b244fc806cb$var$styleMacroRegex);
    const matchedCSS = [];
    for (const match of matches)if (match[2]) matchedCSS.push(match[2]);
    return matchedCSS;
}
function $9fad9b244fc806cb$export$5cc9f764c97a719a(html = '', scopeSelector = $9fad9b244fc806cb$export$ff57b14bf41d4f9d, regex = $9fad9b244fc806cb$var$styleMacroRegex) {
    const matches = html.matchAll(regex);
    const CSSForAnalytics = [];
    for (const match of matches)if (match[2]) {
        const originalCSS = match[2];
        const scopedCSS = $9fad9b244fc806cb$var$addScopeBoundry(originalCSS, scopeSelector);
        CSSForAnalytics.push({
            originalCSS: originalCSS,
            scopedCSS: scopedCSS
        });
        html = html.replace(match[2], scopedCSS);
    }
    return {
        contentWithScopedCSS: html,
        CSSForAnalytics: CSSForAnalytics
    };
}
module.exports["mainContentSelector"] = $9fad9b244fc806cb$export$ff57b14bf41d4f9d;
module.exports["extractCSS"] = $9fad9b244fc806cb$export$506216bb8c62ec77;
module.exports["scopeCSS"] = $9fad9b244fc806cb$export$5cc9f764c97a719a;

});

parcelRegister("hMRhJ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $14a9ee80cba83190$export$4eaca3ef6119646c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({});
module.exports["RendererExtensionContext"] = $14a9ee80cba83190$export$4eaca3ef6119646c;

});

parcelRegister("euF5O", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("isEtk", function(module, exports) {

var $FOT9i = parcelRequire("FOT9i");

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0cd4a5fc89cb5961$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        isContentReady: false,
        contentLoading: {}
    },
    actions: {
        onContentRendered: ()=>({ setState: setState })=>{
                setState({
                    isContentReady: true
                });
            },
        addContentToBeLoaded: (content, value)=>({ setState: setState, getState: getState })=>{
                const newContentLoading = getState().contentLoading;
                newContentLoading[content] = value;
                setState({
                    contentLoading: newContentLoading
                });
            },
        removeContentFromLoading: (content)=>({ setState: setState, getState: getState })=>{
                const existingContentLoading = getState().contentLoading;
                existingContentLoading[content] && delete existingContentLoading[content];
                setState({
                    contentLoading: existingContentLoading
                });
            }
    },
    name: 'isContentReady'
});
const $0cd4a5fc89cb5961$export$fce89f7e653f0af5 = (0, $FOT9i.createContainer)($0cd4a5fc89cb5961$var$Store);
const $0cd4a5fc89cb5961$export$b49d63386d42e7ce = (0, $9zUhf.createHook)($0cd4a5fc89cb5961$var$Store);
module.exports["ContentStateContainer"] = $0cd4a5fc89cb5961$export$fce89f7e653f0af5;
module.exports["useContentState"] = $0cd4a5fc89cb5961$export$b49d63386d42e7ce;

});

parcelRegister("ZugQS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kGwvc = parcelRequire("kGwvc");


var $4u5NT = parcelRequire("4u5NT");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $dPJCf = parcelRequire("dPJCf");

/**
 * Marks FMP (First Meaningful Paint) on UFO transition interactions.
 *
 * When we are in a transition, this component places an
 * `addUFOCustomMark('fmp', timestamp)` call. Unlike `PageLoadMarkFMP` which is
 * meant for initial page loads, this component is specifically designed for SPA
 * transitions where the platform UFO library does not natively track FMP.
 *
 * The corresponding `metric:fmp` value is computed in `additionalPayloadData.ts` by
 * reading this mark from the interaction and calculating the offset from interaction start.
 */ const $70ecb93741312159$var$UFOTransitionMarkFMPComponent = ({ timestamp: timestamp })=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    (0, $42omo.useEffect)(()=>{
        if (isTransition) {
            (0, $kGwvc.addUFOCustomMark)('fmp', timestamp);
            // The code below unfortunately relies on internals of the UFO library and on some
            // knowledge of how the UFO event data (especially FMP) are processed by the analytics
            // pipeline. This is relatively stable "private API", but it has to be sorted out with
            // the UFO team, as a follow up to https://product-fabric.atlassian.net/browse/CCP-7117.
            const interaction = (0, $4u5NT.getActiveInteraction)();
            if (!interaction) return;
            // In UFO realm, there's no concept of FMP, and by design it is defaulted to TTAI. While
            // in Confluence we rely on FMP for transitions, so emulating the legacy behavior here.
            interaction.legacyMetrics = interaction.legacyMetrics || [];
            interaction.legacyMetrics.push({
                key: 'fmp',
                config: {
                    type: 'PAGE_LOAD'
                },
                start: 0,
                stop: timestamp ?? null,
                type: 'PAGE_LOAD',
                custom: {}
            });
        }
    }, [
        isTransition,
        timestamp
    ]);
    return null;
};
const $70ecb93741312159$export$f881402a7a312ba4 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($70ecb93741312159$var$UFOTransitionMarkFMPComponent);
module.exports["UFOTransitionMarkFMP"] = $70ecb93741312159$export$f881402a7a312ba4;

});

parcelRegister("hl0fg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $42omo.useState)(getSize);
    (0, $42omo.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("e8Lxy", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cEgMD = parcelRequire("cEgMD");


var $c4PY4 = parcelRequire("c4PY4");


var $8VcPj = parcelRequire("8VcPj");


var $l6Xaz = parcelRequire("l6Xaz");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $2BQQi = parcelRequire("2BQQi");


var $jOLle = parcelRequire("jOLle");

const $f9f6687b35a7b641$export$41987981af6ac15b = new (0, $jOLle.ResourceRecorder)();
const $f9f6687b35a7b641$export$59d25f12f6b98bee = new (0, $jOLle.ResourceRecorder)();



var $iHLZT = parcelRequire("iHLZT");



var $7QM6o = parcelRequire("7QM6o");


var $hMRhJ = parcelRequire("hMRhJ");


var $6AplS = parcelRequire("6AplS");


var $frIzR = parcelRequire("frIzR");








var $e99bn = parcelRequire("e99bn");


var $isEtk = parcelRequire("isEtk");

const $74c95c7ec1db6c9c$export$445f82ada6475b92 = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { contentId: contentId, isFabric: isFabric, appearance: appearance, revision: revision, isRenderTTIMark: t1, isAutoConverted: t2, lastModifiedDate: t3, customPerfData: t4 } = t0;
    const isRenderTTIMark = t1 === undefined ? false : t1;
    const isAutoConverted = t2 === undefined ? false : t2;
    const lastModifiedDate = t3 === undefined ? "" : t3;
    let t5;
    if ($[0] !== t4) {
        t5 = t4 === undefined ? {} : t4;
        $[0] = t4;
        $[1] = t5;
    } else t5 = $[1];
    const customPerfData = t5;
    const [, actions] = (0, $isEtk.useContentState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t6;
    let t7;
    if ($[2] !== actions || $[3] !== isRenderTTIMark) {
        t6 = ()=>{
            if (!isRenderTTIMark) actions?.onContentRendered();
        };
        t7 = [
            actions,
            isRenderTTIMark
        ];
        $[2] = actions;
        $[3] = isRenderTTIMark;
        $[4] = t6;
        $[5] = t7;
    } else {
        t6 = $[4];
        t7 = $[5];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[6] !== createAnalyticsEvent || $[7] !== lastModifiedDate) {
        t8 = ()=>{
            if (lastModifiedDate) {
                const timeSinceLastPublished = Date.now() - Date.parse(lastModifiedDate);
                const shouldSendEvent = timeSinceLastPublished > 15000;
                if (shouldSendEvent) createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "viewed",
                        actionSubject: "performanceTrigger",
                        source: "viewPage",
                        attributes: {
                            timeSinceLastPublished: timeSinceLastPublished
                        }
                    }
                }).fire();
            }
        };
        t9 = [
            createAnalyticsEvent,
            lastModifiedDate
        ];
        $[6] = createAnalyticsEvent;
        $[7] = lastModifiedDate;
        $[8] = t8;
        $[9] = t9;
    } else {
        t8 = $[8];
        t9 = $[9];
    }
    (0, $42omo.useEffect)(t8, t9);
    const renderPerformanceMetrics = !isFabric || isRenderTTIMark;
    let t10;
    if ($[10] !== appearance || $[11] !== contentId || $[12] !== customPerfData || $[13] !== isAutoConverted || $[14] !== isFabric || $[15] !== renderPerformanceMetrics || $[16] !== revision) {
        t10 = renderPerformanceMetrics ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e99bn.PerformanceMetrics), {
            appearance: appearance,
            contentId: contentId,
            fabric: isFabric,
            revision: revision,
            isAutoConverted: isAutoConverted,
            customPerfData: customPerfData
        }) : null;
        $[10] = appearance;
        $[11] = contentId;
        $[12] = customPerfData;
        $[13] = isAutoConverted;
        $[14] = isFabric;
        $[15] = renderPerformanceMetrics;
        $[16] = revision;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
};









var $7zgzO = parcelRequire("7zgzO");


var $19aF3 = parcelRequire("19aF3");


var $6Ywr0 = parcelRequire("6Ywr0");


var $cpjd2 = parcelRequire("cpjd2");

let $c0955bfbe6e215ce$var$LOADED = false;
const $c0955bfbe6e215ce$export$2411ebb4ead9b550 = (contentId)=>{
    const $ = (0, $frIzR.c)(4);
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams) {
        t0 = ()=>{
            if (!contentId) return;
            const params = getQueryParams();
            const previewParams = params.preview;
            if (previewParams === undefined) return;
            (0, $cpjd2.requireLegacyWRM)([
                "wr!com.atlassian.confluence.plugins.confluence-previews:confluence-previews-jquery"
            ], ()=>{
                if ($c0955bfbe6e215ce$var$LOADED) {
                    const confluencePreviewsFilePreviewLoader = (0, $19aF3.globalRequire)("cp/confluence/file-preview-loader");
                    confluencePreviewsFilePreviewLoader?.resetPreviewFileList();
                    let viewMode = "full";
                    if (previewParams?.split("/")?.length === 6) viewMode = "comment";
                    confluencePreviewsFilePreviewLoader?.setupPreviewerForSPA(undefined, undefined, viewMode, viewMode === "comment");
                } else (0, $6Ywr0.waitForRequiredModule)({
                    listener: "useConfluencePreviewsForceLoad",
                    module: "cp/confluence/preview"
                }, $c0955bfbe6e215ce$var$_temp);
            }, $c0955bfbe6e215ce$var$_temp2);
        };
        t1 = [
            getQueryParams,
            contentId
        ];
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    return null;
};
function $c0955bfbe6e215ce$var$_temp() {
    const confluencePreviewsModule = (0, $19aF3.globalRequire)("cp/confluence/preview");
    confluencePreviewsModule?.loadConfluencePreviews();
    confluencePreviewsModule?.loadConfluencePreviews();
    $c0955bfbe6e215ce$var$LOADED = true;
}
function $c0955bfbe6e215ce$var$_temp2() {}



var $3Xfhj = parcelRequire("3Xfhj");







// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $id4ij = parcelRequire("id4ij");





var $hl0fg = parcelRequire("hl0fg");

const $4c31822c830c0eb9$export$c4b6046fa101cea2 = 'confluence-macro-resources-container';





var $k5ycH = parcelRequire("k5ycH");


var $8SfNq = parcelRequire("8SfNq");

const $e892729346bc6a39$export$c27b36ba5743ef1e = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { contentBody: contentBody } = t0;
    const isFabric = contentBody?.representation === "atlas_doc_format";
    const webresource = contentBody?.webresource;
    const cssMarkup = webresource?.tags?.css || "";
    let t1;
    if ($[0] !== webresource?.tags?.js) {
        t1 = (webresource?.tags?.js || "").replaceAll?.("&amp;", "&");
        $[0] = webresource?.tags?.js;
        $[1] = t1;
    } else t1 = $[1];
    const jsMarkup = t1;
    const hasGloballyDefinedResourcesForMacros = Boolean(cssMarkup || jsMarkup);
    let t2;
    let t3;
    if ($[2] !== cssMarkup || $[3] !== hasGloballyDefinedResourcesForMacros || $[4] !== isFabric || $[5] !== jsMarkup) {
        t2 = ()=>{
            if (isFabric && hasGloballyDefinedResourcesForMacros) {
                (0, $id4ij.replaceDomElementContent)((0, $4c31822c830c0eb9$export$c4b6046fa101cea2), cssMarkup);
                (0, $8SfNq.requireSuperBatch)().then(()=>{
                    const el = document.getElementById((0, $4c31822c830c0eb9$export$c4b6046fa101cea2));
                    if (!el) return;
                    (0, $k5ycH.loadResources)(el, jsMarkup);
                });
            }
            return $e892729346bc6a39$var$_temp;
        };
        t3 = [
            hasGloballyDefinedResourcesForMacros,
            cssMarkup,
            jsMarkup,
            isFabric
        ];
        $[2] = cssMarkup;
        $[3] = hasGloballyDefinedResourcesForMacros;
        $[4] = isFabric;
        $[5] = jsMarkup;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $42omo.useEffect)(t2, t3);
};
function $e892729346bc6a39$var$_temp() {
    (0, $id4ij.replaceDomElementContent)((0, $4c31822c830c0eb9$export$c4b6046fa101cea2), "");
}


const $000d501fa1139661$var$renderPerformanceMetrics = (0, $2XqLN.default)((props)=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $74c95c7ec1db6c9c$export$445f82ada6475b92), props), (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
/**
 * Record superbatch to be included into HTML on the server
 * @param webresource -- superbatch CSS/JS links from monolith
 */ const $000d501fa1139661$var$recordSuperbatch = (webresource)=>{
    const superbatchJs = webresource?.superbatch?.tags?.js || '';
    const superbatchCss = webresource?.superbatch?.tags?.css || '';
    if (superbatchJs) {
        (0, $iHLZT.superbatchJSRecorder).includeSuperBatchResources();
        if (!(0, $iHLZT.superbatchJSRecorder).get()) (0, $iHLZT.superbatchJSRecorder).add((0, $l6Xaz.removeJquery)(superbatchJs));
    }
    if (superbatchCss) {
        (0, $iHLZT.superbatchCSSRecorder).includeSuperBatchResources();
        if (!(0, $iHLZT.superbatchCSSRecorder).get()) (0, $iHLZT.superbatchCSSRecorder).add(superbatchCss);
    }
};
/**
 * Record monolith-defined JS and CSS files for macros
 * @param webresource -- tags CSS/JS links from monolith
 */ const $000d501fa1139661$var$recordGlobalJsAndCSS = (webresource)=>{
    const js = webresource?.tags?.js || '';
    const css = webresource?.tags?.css || '';
    if (!(0, $f9f6687b35a7b641$export$41987981af6ac15b).get()) (0, $f9f6687b35a7b641$export$41987981af6ac15b).add(css);
    if (!(0, $f9f6687b35a7b641$export$59d25f12f6b98bee).get()) (0, $f9f6687b35a7b641$export$59d25f12f6b98bee).addDeferTags(js);
};
const $000d501fa1139661$export$87c886692a0ffdb5 = (contentBody, macroRenderedOutput)=>{
    return;
};
const $000d501fa1139661$var$DEFAULT_EVENT_HANDLER_OVERRIDES = {};
/**
 * Component that renders content for Confluence Page
 * WARN: it must be renamed to PageContentRenderer to avoid confusion
 *
 * This uses the AtlasKit renderer component for rendering, and configures the
 * renderer to handle Confluence content (media, macros, etc.).
 *
 * The difference between this and `ContentRenderer` is that this utilizes the
 * dynamic content query, while `ContentRenderer` attempts to fetch ADF. This
 * an experiment and will be removed when finished.
 */ const $000d501fa1139661$var$PageContentRendererComponent = /*#__PURE__*/ (0, $42omo.memo)(({ appearance: appearance, contentId: contentId, data: data, error: error, eventHandlerOverrides: eventHandlerOverrides = $000d501fa1139661$var$DEFAULT_EVENT_HANDLER_OVERRIDES, hasInlineComments: hasInlineComments = true, isPreviewMode: isPreviewMode, isSpaceOverview: isSpaceOverview = false, isTemplateEditorRenderer: isTemplateEditorRenderer, queryHash: queryHash, spaceKey: spaceKey, isArchived: isArchived, contentStatusError: contentStatusError, isEmbeddedPage: isEmbeddedPage, customPerfData: customPerfData, document: document, ...rest })=>{
    // need to check space hasTheme to determine whether the page header is always fixed at the top
    const hasTheme = Boolean(data?.space?.theme?.themeKey);
    const content = data?.content?.nodes?.[0] || null;
    const contentBody = content?.body?.dynamic || null;
    const isFabric = contentBody?.representation === 'atlas_doc_format';
    const webresource = contentBody?.webresource;
    /* useInlineHighlights is custom hook that queries for markerRefs only if Inline Highlights performance is Enabled */ const { markerRefs: markerRefs } = (0, $2BQQi.useInlineHighlights)({
        pageId: contentId,
        shouldFireQuery: !isFabric && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) && hasInlineComments // fabric pages don't need to fire query for markerRefs
    });
    const { getLegacyContentExtensions: getLegacyContentExtensions } = (0, $42omo.useContext)((0, $hMRhJ.RendererExtensionContext));
    const [rootEl, setRootEl] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    (0, $e892729346bc6a39$export$c27b36ba5743ef1e)({
        contentBody: contentBody
    });
    (0, $c0955bfbe6e215ce$export$2411ebb4ead9b550)(contentId);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    // Page content should not be rendered when there is no data or no document, and also when
    // extension providers/handlers are not yet ready which can lead to content
    // flickering and thrashing. but we can't exit earlier as hooks can't be conditional
    if (!contentId || !data && !!document) return null;
    // With https://app.launchdarkly.com/confluence/staging/features/confluence.macro.execution.adf.extension.macroNames/targeting
    // the output is not put into macroRenderedOutput, and is included on top level.
    // We use the resourceRecorder only in SSR environment.
    const revision = content?.version?.confRev || '';
    const lastModifiedDate = content?.metadata?.lastModifiedDate;
    let contentAppearance = appearance;
    if (!contentAppearance && content) contentAppearance = (0, $c4PY4.getContentAppearanceForAtlaskit)((0, $8VcPj.getContentAppearancePublished)(content).appearance);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub) // Company Hub editors no longer have the option of changing page width,
    // as content topper is removed. For users who had previously set Company
    // Hub page to 'full-width' and can no longer change it back, we force it to
    // 'full-page' to fix unexpected layout issues.
    contentAppearance = 'full-page';
    window.performance.mark('CFP-63.next.content-renderer.rendered');
    if (isFabric) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Xfhj.PageContentRendererFabric), {
        content: content,
        contentAppearance: contentAppearance,
        contentBody: contentBody,
        contentId: contentId,
        eventHandlerOverrides: eventHandlerOverrides,
        hasInlineComments: hasInlineComments,
        isPreviewMode: isPreviewMode,
        isSpaceOverview: isSpaceOverview,
        isTemplateEditorRenderer: isTemplateEditorRenderer,
        markerRefs: markerRefs,
        queryHash: queryHash,
        renderPerformanceMetrics: $000d501fa1139661$var$renderPerformanceMetrics,
        revision: revision,
        rootEl: rootEl,
        setRootEl: setRootEl,
        spaceKey: spaceKey,
        spaceId: spaceId,
        isArchived: isArchived,
        contentStatusError: contentStatusError,
        isEmbeddedPage: isEmbeddedPage,
        //this is to correct a bug in nav4 where sticky table headers are incorrectly offset in nav4
        //this should also be false in Nav3 however:
        //the issue is that bannerState is incorrectly reporting a height of 0px in preview mode because it uses WithoutBanners because I guess at one point it didn't have top nav
        //the hardcoded isContentHeaderFixedAtTop and the banner state hardcoded top nav height happen to be 1px different and this failure just happened to have worked all this time.
        //TODO:in nav4 remove bannerContext entirely and simply offset the scroll container naturally to remove these complicated calculations
        isContentHeaderFixedAtTop: !hasTheme && !isEmbeddedPage && !isPreviewMode,
        customPerfData: customPerfData,
        document: document,
        ...rest
    });
    // Scope Style Macros CSS for Tiny Page
    try {
        const { CSSForAnalytics: CSSForAnalytics, contentWithScopedCSS: contentWithScopedCSS } = (0, $6AplS.scopeCSS)(contentBody?.value || '');
        // The component can load multiple times, contentWithScopedCSS with the same contentBody.value to prevent sending multiple events
        if (CSSForAnalytics && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true && contentWithScopedCSS !== contentBody?.value) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'scoped',
                actionSubject: 'legacyStyleMacro',
                source: 'PageContentRenderer',
                attributes: {
                    CSSForAnalytics: CSSForAnalytics
                }
            }
        }).fire();
        if (contentBody) contentBody.value = contentWithScopedCSS;
    } catch (error_0) {
        const extractedCSS = (0, $6AplS.extractCSS)(contentBody?.value || '');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'error',
                actionSubject: 'legacyStyleMacro',
                source: 'PageContentRenderer',
                attributes: {
                    error: error_0,
                    extractedCSS: extractedCSS
                }
            }
        }).fire();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Xfhj.PageContentRendererTiny), {
        contentAppearance: contentAppearance,
        contentBody: contentBody,
        contentId: contentId,
        spaceKey: spaceKey,
        getLegacyContentExtensions: getLegacyContentExtensions,
        markerRefs: markerRefs,
        queryHash: queryHash,
        renderPerformanceMetrics: $000d501fa1139661$var$renderPerformanceMetrics,
        revision: revision,
        setRootEl: setRootEl,
        lastModifiedDate: lastModifiedDate
    });
});
const $000d501fa1139661$export$312be6b2bc0b02b3 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($000d501fa1139661$var$PageContentRendererComponent);
$000d501fa1139661$export$312be6b2bc0b02b3.displayName = 'PageContentRenderer';
module.exports["includeSuperbatchForFabricMacro"] = $000d501fa1139661$export$87c886692a0ffdb5;
module.exports["PageContentRenderer"] = $000d501fa1139661$export$312be6b2bc0b02b3;

});

parcelRegister("c4PY4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $6mKj3 = parcelRequire("6mKj3");


var $1d2ww = parcelRequire("1d2ww");

const $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: 'full-page',
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: 'full-width',
    [(0, $1d2ww.ContentAppearanceType).MAX]: 'max'
};
const $e67a3bdaba93e18b$export$4ca444f48395eebe = (0, $2XqLN.default)((contentAppearance)=>{
    const appearanceForAtlaskit = $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[contentAppearance];
    // Fallback to 'full-width' if 'max' and experiment is off
    if (appearanceForAtlaskit === 'max' && !(0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return 'full-width';
    if (appearanceForAtlaskit) return appearanceForAtlaskit;
    return $e67a3bdaba93e18b$export$e79a6aa49fcbdebe();
});
const $e67a3bdaba93e18b$export$e79a6aa49fcbdebe = ()=>{
    return $e67a3bdaba93e18b$var$_contentAppearanceToAtlaskitMap[(0, $1d2ww.ContentAppearanceType).DEFAULT];
};
module.exports["getContentAppearanceForAtlaskit"] = $e67a3bdaba93e18b$export$4ca444f48395eebe;

});

parcelRegister("2BQQi", function(module, exports) {
/**
 * @generated SignedSource<<50c53551550a7a21ac5b3668efbdbabe>>
 * @relayHash 1d98f028d17ad9f621bdfdae3f304d7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d
const $e084fe268cd37421$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v5 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInlineHighlightsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1d98f028d17ad9f621bdfdae3f304d7b",
            "id": "4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d",
            "metadata": {},
            "name": "useInlineHighlightsQuery",
            "operationKind": "query",
            "text": "query useInlineHighlightsQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}},replies{id}}}}"
        }
    };
}();
$e084fe268cd37421$var$node.hash = "2fb3b51eea98e2fd2a940548824e472b";
var $e084fe268cd37421$export$2e2bcd8739ae039 = $e084fe268cd37421$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $513635d9ade3aacb$var$UseInlineHighlightsQuery = (0, $e084fe268cd37421$export$2e2bcd8739ae039);
const $513635d9ade3aacb$export$7a17e81d6650ad94 = ({ pageId: pageId, shouldFireQuery: shouldFireQuery = true })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($513635d9ade3aacb$var$UseInlineHighlightsQuery, {
        variables: {
            pageId: pageId
        },
        skip: !Boolean(shouldFireQuery),
        __callerPackage__: "@confluence/inline-highlights-query"
    });
    let markerRefs = [];
    let markerRefMap = {};
    const comments = data?.comments?.nodes;
    if (comments && Array.isArray(comments)) {
        // We need to create a map that connects markerRefs to commentId, we need commentId to fire analytic event
        // https://github.com/microsoft/TypeScript/issues/17002 - for type casting
        markerRefMap = comments.reduce((inlineRefAccumulator, comment)=>{
            if (!comment) return inlineRefAccumulator;
            const { inlineMarkerRef: inlineMarkerRef } = comment.location;
            // We should always get top-level inline comments, but if this doesn't exist, just return
            if (!inlineMarkerRef) return inlineRefAccumulator;
            inlineRefAccumulator[comment?.id] = inlineMarkerRef;
            comment?.replies?.forEach((reply)=>{
                if (reply) {
                    const { id: replyId } = reply;
                    inlineRefAccumulator[replyId] = inlineMarkerRef;
                }
            });
            return inlineRefAccumulator;
        }, {});
        markerRefs = [
            ...new Set(Object.values(markerRefMap))
        ];
    }
    return {
        markerRefs: markerRefs,
        markerRefMap: markerRefMap,
        loading: loading
    };
};
module.exports["useInlineHighlights"] = $513635d9ade3aacb$export$7a17e81d6650ad94;

});

parcelRegister("e99bn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $fwDOR = parcelRequire("fwDOR");


var $ZugQS = parcelRequire("ZugQS");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $kvJHJ = parcelRequire("kvJHJ");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");





var $ep3mz = parcelRequire("ep3mz");


var $9eE57 = parcelRequire("9eE57");


var $7zgzO = parcelRequire("7zgzO");


var $5YLPl = parcelRequire("5YLPl");

const $1bb00e1d603d03ad$var$contentViews = new Set();
const $1bb00e1d603d03ad$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
const $1bb00e1d603d03ad$var$createRendererMeasure = ()=>{
    try {
        performance.mark('rendererRendered.end');
        performance.measure('browser-metric:ContentRenderer', (0, $6VdZc.isInitial)() ? undefined : 'browser-metric.start', 'rendererRendered.end');
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
const $1bb00e1d603d03ad$var$augmentWithNewTTI = (customData)=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (!(0, $6VdZc.isInitial)()) return customData;
    // Since TTI is not yet available at this point, use rendererRendered as the closest
    // approximation, and take actual measurement of FMP. Here FMP is defined and available
    // when page is successfully SSR'ed. Otherwise FMP *will be* evaluated as TTI later on.
    const tti = performance.getEntriesByName('rendererRendered.end').pop()?.startTime || 0;
    const fmp = performance.getEntriesByName('browser-metric:fmp').pop()?.duration || 0;
    const macroFailures = (0, $4JC0x.getPreloadFailedMacros)();
    // nTTI is considered equal to FMP in the following cases:
    //  - page is successfully server-rendered;
    //  - fmp is already known at the given point;
    //  - all requested macros preloaded before preloading is cut off by timeout.
    // In all other cases nTTI = TTI.
    let ntti = tti;
    if (window.__SSR_RENDERED__ && !macroFailures && fmp > 0) ntti = fmp;
    return {
        ...customData,
        macroFailures: macroFailures,
        // Both `fmp` and `tti` metrics are rounded to 1ms by BM library
        nTTI: Math.round(ntti)
    };
};
const $1bb00e1d603d03ad$var$PerformanceMetricsComponent = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { revision: revision, appearance: appearance, contentId: contentId, fabric: fabric, loadedFromCache: loadedFromCache, isAutoConverted: isAutoConverted, customPerfData: customPerfData } = t0;
    const [t1] = (0, $ep3mz.usePageState)();
    const { isLite: isLite, routeName: routeName } = t1;
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [rendererMeasureCreated, setRendererMeasureCreated] = (0, $42omo.useState)(false);
    let t2;
    if ($[0] !== getQueryParams) {
        t2 = getQueryParams();
        $[0] = getQueryParams;
        $[1] = t2;
    } else t2 = $[1];
    const { ccProxyTarget: ccProxyTarget, ccProxyStaticApp: ccProxyStaticApp, homepageId: homepageId } = t2;
    const hasHomepageId = Boolean(routeName === "SPACE_OVERVIEW" && homepageId);
    const isPublicLink = routeName === "EXTERNAL_SHARE";
    const experienceName = isPublicLink ? (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE) : (0, $irVI7.VIEW_CONTENT_EXPERIENCE);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        const macroFailures = (0, $4JC0x.getPreloadFailedMacros)();
        t3 = (0, $4JC0x.macrosPreloadPerformed)() && !macroFailures ? (0, $9eE57.getMark)("CFP-63.ssr-ttr") : undefined;
        $[2] = t3;
    } else t3 = $[2];
    const endMarkWhenMacrosSSRed = t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            $1bb00e1d603d03ad$var$createRendererMeasure();
            setRendererMeasureCreated(true);
        };
        $[3] = t4;
    } else t4 = $[3];
    const createRendererMeasureOnComplete = t4;
    const t5 = Boolean(isLite);
    const t6 = Boolean(ccProxyTarget || ccProxyStaticApp);
    let t7;
    if ($[4] !== appearance || $[5] !== contentId || $[6] !== customPerfData || $[7] !== fabric || $[8] !== hasHomepageId || $[9] !== isAutoConverted || $[10] !== loadedFromCache || $[11] !== t5 || $[12] !== t6) {
        t7 = {
            appearance: appearance,
            contentId: contentId,
            fabric: fabric,
            isLite: t5,
            ccProxyTarget: t6,
            loadedFromCache: loadedFromCache,
            isAutoConverted: isAutoConverted,
            hasHomepageId: hasHomepageId,
            ...customPerfData
        };
        $[4] = appearance;
        $[5] = contentId;
        $[6] = customPerfData;
        $[7] = fabric;
        $[8] = hasHomepageId;
        $[9] = isAutoConverted;
        $[10] = loadedFromCache;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    const customData = t7;
    const t8 = !rendererMeasureCreated;
    let t9;
    if ($[14] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
            name: "CreateRendererMeasure",
            hold: t8
        });
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ZugQS.UFOTransitionMarkFMP), null);
        $[16] = t10;
    } else t10 = $[16];
    const t11 = `es${contentId}_${revision}`;
    let t12;
    if ($[17] !== fabric) {
        t12 = {
            fabric: fabric
        };
        $[17] = fabric;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== experienceName || $[20] !== t11 || $[21] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            key: t11,
            name: experienceName,
            attributes: t12
        });
        $[19] = experienceName;
        $[20] = t11;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    const t14 = `psle${contentId}`;
    let t15;
    if ($[23] !== customData || $[24] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: t14,
            metric: (0, $5YLPl.CONTENT_RENDERER_METRIC),
            customData: customData,
            stopTime: endMarkWhenMacrosSSRed,
            onComplete: createRendererMeasureOnComplete,
            augmentCustomDataAfterComplete: $1bb00e1d603d03ad$var$augmentWithNewTTI
        });
        $[23] = customData;
        $[24] = t14;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== t13 || $[27] !== t15 || $[28] !== t9) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t9, t10, t13, t15);
        $[26] = t13;
        $[27] = t15;
        $[28] = t9;
        $[29] = t16;
    } else t16 = $[29];
    return t16;
};
const $1bb00e1d603d03ad$export$68015ba807c17f26 = /*#__PURE__*/ (0, $42omo.memo)(({ appearance: appearance, fabric: fabric, contentId: contentId, revision: revision, isAutoConverted: isAutoConverted, customPerfData: customPerfData })=>{
    // This is a heuristic allowing to tell more or less accurately whether page has been loaded
    // from cache or from network. Heuristic is based on assumption that if any given contentId
    // was visited the corresponding content will be cached.
    // The only exception to that heuristic is transition from editor to renderer, which can be
    // identified and filtered out when querying data.
    // WARN: this is temp solution to figure out how much benefit our customers get from cached
    // pages content.
    const loadedFromCacheRef = (0, $42omo.useRef)($1bb00e1d603d03ad$var$contentViews.has(contentId));
    const loadedFromCache = loadedFromCacheRef.current;
    (0, $42omo.useEffect)(()=>{
        $1bb00e1d603d03ad$var$contentViews.add(contentId);
    }, [
        contentId
    ]);
    // Only gather metrics if the content revision has changed since the last render.
    // This tracks transitions more accurately and also prevents metrics miss-firing
    // if the PageContentRenderer component re-renders for any reason.
    const prevRevision = $1bb00e1d603d03ad$export$5cae361ad82dce8b(revision) ?? null;
    const revisionChanged = revision !== prevRevision;
    if (revisionChanged) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1bb00e1d603d03ad$var$PerformanceMetricsComponent, {
        revision: revision,
        appearance: appearance,
        contentId: contentId,
        isAutoConverted: isAutoConverted,
        fabric: fabric,
        loadedFromCache: loadedFromCache,
        customPerfData: customPerfData
    }));
    else return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
module.exports["PerformanceMetrics"] = $1bb00e1d603d03ad$export$68015ba807c17f26;

});

parcelRegister("5YLPl", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $2c444e667b08d230$export$67a466ba61e2b23c = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_RENDERER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    timings: [
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
module.exports["CONTENT_RENDERER_METRIC"] = $2c444e667b08d230$export$67a466ba61e2b23c;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("iXOtO"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("cubWh"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("iXOtO", function(module, exports) {

let $dce4e4ea560ee45e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dce4e4ea560ee45e$var$load("h3ABO"),
    $dce4e4ea560ee45e$var$load("iJF2W"),
    $dce4e4ea560ee45e$var$load("f95iu"),
    $dce4e4ea560ee45e$var$load("7k1ns"),
    $dce4e4ea560ee45e$var$load("7DH2V"),
    $dce4e4ea560ee45e$var$load("7YBKb"),
    $dce4e4ea560ee45e$var$load("6wr18"),
    $dce4e4ea560ee45e$var$load("ipX6x"),
    $dce4e4ea560ee45e$var$load("3dgpH"),
    $dce4e4ea560ee45e$var$load("2F69B"),
    $dce4e4ea560ee45e$var$load("fz7UG"),
    $dce4e4ea560ee45e$var$load("2lK0h"),
    $dce4e4ea560ee45e$var$load("5vNAf"),
    $dce4e4ea560ee45e$var$load("1YS9Y"),
    $dce4e4ea560ee45e$var$load("a9w2G"),
    $dce4e4ea560ee45e$var$load("9anPW"),
    $dce4e4ea560ee45e$var$load("c0qAG"),
    $dce4e4ea560ee45e$var$load("4bHZP"),
    $dce4e4ea560ee45e$var$load("lkOIY"),
    $dce4e4ea560ee45e$var$load("5CkG5"),
    $dce4e4ea560ee45e$var$load("j1p8s"),
    $dce4e4ea560ee45e$var$load("hvE36"),
    $dce4e4ea560ee45e$var$load("3IszV"),
    $dce4e4ea560ee45e$var$load("lTK3c"),
    $dce4e4ea560ee45e$var$load("1WXdc"),
    $dce4e4ea560ee45e$var$load("3GuOt"),
    $dce4e4ea560ee45e$var$load("5NQgH"),
    $dce4e4ea560ee45e$var$load("daVOf"),
    $dce4e4ea560ee45e$var$load("dI1Cd"),
    $dce4e4ea560ee45e$var$load("iFSKq"),
    $dce4e4ea560ee45e$var$load("4Luke"),
    $dce4e4ea560ee45e$var$load("8Fbef"),
    $dce4e4ea560ee45e$var$load("cyGuT"),
    $dce4e4ea560ee45e$var$load("ffEVr"),
    $dce4e4ea560ee45e$var$load("6bVVs"),
    $dce4e4ea560ee45e$var$load("7mo6o"),
    $dce4e4ea560ee45e$var$load("6VoH9"),
    $dce4e4ea560ee45e$var$load("fNa2t"),
    $dce4e4ea560ee45e$var$load("e1RjR"),
    $dce4e4ea560ee45e$var$load("4iy7m"),
    $dce4e4ea560ee45e$var$load("lOhGw"),
    $dce4e4ea560ee45e$var$load("5GaTI"),
    $dce4e4ea560ee45e$var$load("gepVN"),
    $dce4e4ea560ee45e$var$load("cj0Rr"),
    $dce4e4ea560ee45e$var$load("7cWko"),
    $dce4e4ea560ee45e$var$load("gKGOl"),
    $dce4e4ea560ee45e$var$load("kbwlB"),
    $dce4e4ea560ee45e$var$load("aFko5"),
    $dce4e4ea560ee45e$var$load("78ryW"),
    $dce4e4ea560ee45e$var$load("iDERe"),
    $dce4e4ea560ee45e$var$load("Wowvf"),
    $dce4e4ea560ee45e$var$load("etEYy"),
    $dce4e4ea560ee45e$var$load("jgDEy"),
    $dce4e4ea560ee45e$var$load("8ublV"),
    $dce4e4ea560ee45e$var$load("e4iP9"),
    $dce4e4ea560ee45e$var$load("hhss7"),
    $dce4e4ea560ee45e$var$load("kBGuE"),
    $dce4e4ea560ee45e$var$load("5soxI"),
    $dce4e4ea560ee45e$var$load("7EorR"),
    $dce4e4ea560ee45e$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("cubWh", function(module, exports) {

let $91718c398e932c5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $91718c398e932c5f$var$load("jhgNc"),
    $91718c398e932c5f$var$load("jgDEy"),
    $91718c398e932c5f$var$load("e4iP9"),
    $91718c398e932c5f$var$load("6wr18"),
    $91718c398e932c5f$var$load("j104l"),
    $91718c398e932c5f$var$load("9OQNK"),
    $91718c398e932c5f$var$load("1H5IN"),
    $91718c398e932c5f$var$load("5CkG5"),
    $91718c398e932c5f$var$load("j1p8s"),
    $91718c398e932c5f$var$load("ffEVr"),
    $91718c398e932c5f$var$load("h4Nf7"),
    $91718c398e932c5f$var$load("cj0Rr"),
    $91718c398e932c5f$var$load("iDERe"),
    $91718c398e932c5f$var$load("Wowvf"),
    $91718c398e932c5f$var$load("8ublV"),
    $91718c398e932c5f$var$load("hhss7"),
    $91718c398e932c5f$var$load("7EorR"),
    $91718c398e932c5f$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("bbu3f", function(module, exports) {
$parcel$export(module.exports, "getArg", () => $824808648eb0d524$export$6e45e70adce70bb2, (v) => $824808648eb0d524$export$6e45e70adce70bb2 = v);
$parcel$export(module.exports, "isAbsolute", () => $824808648eb0d524$export$e434c7255acda994, (v) => $824808648eb0d524$export$e434c7255acda994 = v);
$parcel$export(module.exports, "join", () => $824808648eb0d524$export$f7e2c8231c57a8bd, (v) => $824808648eb0d524$export$f7e2c8231c57a8bd = v);
$parcel$export(module.exports, "relative", () => $824808648eb0d524$export$f0e7d1106eeabbe6, (v) => $824808648eb0d524$export$f0e7d1106eeabbe6 = v);
$parcel$export(module.exports, "toSetString", () => $824808648eb0d524$export$be0fa1163fa7a4c, (v) => $824808648eb0d524$export$be0fa1163fa7a4c = v);
$parcel$export(module.exports, "compareByGeneratedPositionsInflated", () => $824808648eb0d524$export$f9c43907549d61f1, (v) => $824808648eb0d524$export$f9c43907549d61f1 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $824808648eb0d524$export$6e45e70adce70bb2;
var $824808648eb0d524$export$d6e833647f7f5f17;
var $824808648eb0d524$export$2ec9abc2d2cac192;
var $824808648eb0d524$export$a3295358bff77e;
var $824808648eb0d524$export$f7e2c8231c57a8bd;
var $824808648eb0d524$export$e434c7255acda994;
var $824808648eb0d524$export$f0e7d1106eeabbe6;
var $824808648eb0d524$export$be0fa1163fa7a4c;
var $824808648eb0d524$export$1fc47c3d4c3302a1;
var $824808648eb0d524$export$273077902de92ff2;
var $824808648eb0d524$export$6af840b44a9241f3;
var $824808648eb0d524$export$b7acf533941302f6;
var $824808648eb0d524$export$4d81ca1117b6e802;
var $824808648eb0d524$export$f9c43907549d61f1;
var $824808648eb0d524$export$b49e2de2ad542732;
var $824808648eb0d524$export$659a1aa8f1cdc036;
function $824808648eb0d524$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$824808648eb0d524$export$6e45e70adce70bb2 = $824808648eb0d524$var$getArg;
var $824808648eb0d524$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var $824808648eb0d524$var$dataUrlRegexp = /^data:.+\,.+$/;
function $824808648eb0d524$var$urlParse(aUrl) {
    var match = aUrl.match($824808648eb0d524$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$824808648eb0d524$export$d6e833647f7f5f17 = $824808648eb0d524$var$urlParse;
function $824808648eb0d524$var$urlGenerate(aParsedUrl) {
    var url = '';
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ':';
    url += '//';
    if (aParsedUrl.auth) url += aParsedUrl.auth + '@';
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$824808648eb0d524$export$2ec9abc2d2cac192 = $824808648eb0d524$var$urlGenerate;
var $824808648eb0d524$var$MAX_CACHED_INPUTS = 32;
/**
 * Takes some function `f(input) -> result` and returns a memoized version of
 * `f`.
 *
 * We keep at most `MAX_CACHED_INPUTS` memoized results of `f` alive. The
 * memoization is a dumb-simple, linear least-recently-used cache.
 */ function $824808648eb0d524$var$lruMemoize(f) {
    var cache = [];
    return function(input) {
        for(var i = 0; i < cache.length; i++)if (cache[i].input === input) {
            var temp = cache[0];
            cache[0] = cache[i];
            cache[i] = temp;
            return cache[0].result;
        }
        var result = f(input);
        cache.unshift({
            input: input,
            result: result
        });
        if (cache.length > $824808648eb0d524$var$MAX_CACHED_INPUTS) cache.pop();
        return result;
    };
}
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ var $824808648eb0d524$var$normalize = $824808648eb0d524$var$lruMemoize(function normalize(aPath) {
    var path = aPath;
    var url = $824808648eb0d524$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $824808648eb0d524$export$e434c7255acda994(path);
    // Split the path into parts between `/` characters. This is much faster than
    // using `.split(/\/+/g)`.
    var parts = [];
    var start = 0;
    var i = 0;
    while(true){
        start = i;
        i = path.indexOf("/", start);
        if (i === -1) {
            parts.push(path.slice(start));
            break;
        } else {
            parts.push(path.slice(start, i));
            while(i < path.length && path[i] === "/")i++;
        }
    }
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === '.') parts.splice(i, 1);
        else if (part === '..') up++;
        else if (up > 0) {
            if (part === '') {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join('/');
    if (path === '') path = isAbsolute ? '/' : '.';
    if (url) {
        url.path = path;
        return $824808648eb0d524$var$urlGenerate(url);
    }
    return path;
});
$824808648eb0d524$export$a3295358bff77e = $824808648eb0d524$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $824808648eb0d524$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $824808648eb0d524$var$urlParse(aPath);
    var aRootUrl = $824808648eb0d524$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || '/';
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $824808648eb0d524$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($824808648eb0d524$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $824808648eb0d524$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === '/' ? aPath : $824808648eb0d524$var$normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $824808648eb0d524$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$824808648eb0d524$export$f7e2c8231c57a8bd = $824808648eb0d524$var$join;
$824808648eb0d524$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === '/' || $824808648eb0d524$var$urlRegexp.test(aPath);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $824808648eb0d524$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, '');
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + '/') !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$824808648eb0d524$export$f0e7d1106eeabbe6 = $824808648eb0d524$var$relative;
var $824808648eb0d524$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !('__proto__' in obj);
}();
function $824808648eb0d524$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $824808648eb0d524$var$toSetString(aStr) {
    if ($824808648eb0d524$var$isProtoString(aStr)) return '$' + aStr;
    return aStr;
}
$824808648eb0d524$export$be0fa1163fa7a4c = $824808648eb0d524$var$supportsNullProto ? $824808648eb0d524$var$identity : $824808648eb0d524$var$toSetString;
function $824808648eb0d524$var$fromSetString(aStr) {
    if ($824808648eb0d524$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$824808648eb0d524$export$1fc47c3d4c3302a1 = $824808648eb0d524$var$supportsNullProto ? $824808648eb0d524$var$identity : $824808648eb0d524$var$fromSetString;
function $824808648eb0d524$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $824808648eb0d524$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = $824808648eb0d524$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $824808648eb0d524$var$strcmp(mappingA.name, mappingB.name);
}
$824808648eb0d524$export$273077902de92ff2 = $824808648eb0d524$var$compareByOriginalPositions;
function $824808648eb0d524$var$compareByOriginalPositionsNoSource(mappingA, mappingB, onlyCompareOriginal) {
    var cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $824808648eb0d524$var$strcmp(mappingA.name, mappingB.name);
}
$824808648eb0d524$export$6af840b44a9241f3 = $824808648eb0d524$var$compareByOriginalPositionsNoSource;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $824808648eb0d524$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $824808648eb0d524$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $824808648eb0d524$var$strcmp(mappingA.name, mappingB.name);
}
$824808648eb0d524$export$b7acf533941302f6 = $824808648eb0d524$var$compareByGeneratedPositionsDeflated;
function $824808648eb0d524$var$compareByGeneratedPositionsDeflatedNoLine(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $824808648eb0d524$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $824808648eb0d524$var$strcmp(mappingA.name, mappingB.name);
}
$824808648eb0d524$export$4d81ca1117b6e802 = $824808648eb0d524$var$compareByGeneratedPositionsDeflatedNoLine;
function $824808648eb0d524$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 === null) return 1; // aStr2 !== null
    if (aStr2 === null) return -1; // aStr1 !== null
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $824808648eb0d524$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $824808648eb0d524$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $824808648eb0d524$var$strcmp(mappingA.name, mappingB.name);
}
$824808648eb0d524$export$f9c43907549d61f1 = $824808648eb0d524$var$compareByGeneratedPositionsInflated;
/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */ function $824808648eb0d524$var$parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
}
$824808648eb0d524$export$b49e2de2ad542732 = $824808648eb0d524$var$parseSourceMapInput;
/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */ function $824808648eb0d524$var$computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || '';
    if (sourceRoot) {
        // This follows what Chrome does.
        if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') sourceRoot += '/';
        // The spec says:
        //   Line 4: An optional source root, useful for relocating source
        //   files on a server or removing repeated values in the
        //   “sources” entry.  This value is prepended to the individual
        //   entries in the “source” field.
        sourceURL = sourceRoot + sourceURL;
    }
    // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).
    if (sourceMapURL) {
        var parsed = $824808648eb0d524$var$urlParse(sourceMapURL);
        if (!parsed) throw new Error("sourceMapURL could not be parsed");
        if (parsed.path) {
            // Strip the last path component, but keep the "/".
            var index = parsed.path.lastIndexOf('/');
            if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
        }
        sourceURL = $824808648eb0d524$var$join($824808648eb0d524$var$urlGenerate(parsed), sourceURL);
    }
    return $824808648eb0d524$var$normalize(sourceURL);
}
$824808648eb0d524$export$659a1aa8f1cdc036 = $824808648eb0d524$var$computeSourceURL;

});

parcelRegister("jOLle", function(module, exports) {

var $l6Xaz = parcelRequire("l6Xaz");

class $fefe82051b0a8f7f$export$cfb6f987101ffbc9 {
    reset() {
        this.resource = '';
    }
    add(resource) {
        this.resource += resource;
        return this;
    }
    addDeferTags(tags) {
        this.resource += (0, $l6Xaz.deferScript)(tags);
        return this;
    }
    get() {
        return this.resource;
    }
    constructor(){
        this.resource = void 0;
        this.resource = '';
    }
}
module.exports["ResourceRecorder"] = $fefe82051b0a8f7f$export$cfb6f987101ffbc9;

});


$parcel$global.rlb("jgDEy")
//# sourceMappingURL=FullPageEditorComponent.12b35265.js.map
